// @ts-nocheck — звичайний JavaScript для браузера, без типів TypeScript
/* ============================================================
   MINIBRICK — Редактор рамок (внутрішня версія)
   Залежності: fabric.js 5.x, constructor-data.js (SPRITE_MAP)
   ============================================================ */

// ============================================================
// КОНФІГУРАЦІЯ
// ============================================================
const FE_CODE = '5456';

const FE_FRAME_COLORS = [
  { id: 'black', name: 'Чорна', hex: '#1B1B1B' },
  { id: 'white', name: 'Біла',  hex: '#FFFFFF' },
];

// ============================================================
// ЯК ЗАДУМАНО — підказки до окремих фонів
// Деякі фони мальовані під конкретне розміщення фігурок: наприклад,
// на підставці по центру. Людина цього не знає й ставить як вийде, а
// потім виходить не те, що на вітрині. Тому при виборі такого фону
// одразу показуємо знімок задуму.
// Ключ — id фону. Додаєш новий: впиши id і посилання на картинку.
// ============================================================
const FE_TPL_HINTS = {
  'tplmt7pczpy': 'https://cdn.shopify.com/s/files/1/0830/7395/8141/files/zadumka_ramka_1.png?v=1788214226', // 21×21 Долоні
  'sex':        'https://cdn.shopify.com/s/files/1/0830/7395/8141/files/zadumka_ramka_3.png?v=1788214232',  // 21×21 S*X MACHINE
  'sex-12':     'https://cdn.shopify.com/s/files/1/0830/7395/8141/files/zadumka_ramka_2.png?v=1788214228',  // 12×12 S*X
  'tplmt8ix70l':'https://cdn.shopify.com/s/files/1/0830/7395/8141/files/zadumka_ramka_4.png?v=1788214988',  // 15×21 День народження
};

// wMm/hMm — РОБОЧА ЗОНА (фон) у міліметрах, книжкова орієнтація
// maxFigs — вертикально, maxFigsLand — горизонтально. price — рамка з 1 фігуркою
const FE_SIZES = [
  { id: '12x12', name: '12×12 см', wMm: 93,  hMm: 93,    maxFigs: 3,  maxFigsLand: 3,  price: 900  },
  { id: '15x21', name: '15×21 см', wMm: 124, hMm: 184,   maxFigs: 5,  maxFigsLand: 4,  price: 1150 },
  { id: '21x21', name: '21×21 см', wMm: 183, hMm: 183,   maxFigs: 8,  maxFigsLand: 8,  price: 1300 },
  { id: '21x30', name: '21×30 см', wMm: 183, hMm: 272.5, maxFigs: 16, maxFigsLand: 12, price: 1500 },
  { id: '30x40', name: '30×40 см', wMm: 274, hMm: 374,   maxFigs: 26, maxFigsLand: 26, price: 2100 },
];
// Доплати
const FE_PRICE = {
  figure:    100,  // додаткова фігурка-людина (перша — в ціні рамки)
  animal:     50,  // тваринка
  customPaint: 250, // покраска тваринки за фото улюбленця
  accessory:  50,  // аксесуар (у руці фігурки або на фоні)
  print:      30,  // принт на торсі
  extra:      50,  // інший аксесуар: дитина, велосипед тощо
};
function feMaxFigs() {
  const s = feSize();
  return FE.orient === 'landscape' ? (s.maxFigsLand || s.maxFigs) : s.maxFigs;
}

const FE_MAT_COLORS = ['#FFFFFF','#FAF3E7','#F3F4F6','#E5E7EB','#111827','#1B2433','#FDE68A','#FCA5A5','#A7F3D0','#BFDBFE','#DDD6FE','#FBCFE8','#FDBA74','#FCD34D','#7C3AED','#22C55E','#00B4D8','#EF4444','#8B5E3C','#0E1422'];
const FE_GRADIENTS = [
  ['#3B82F6','#22D3EE'], ['#F472B6','#FBBF24'], ['#7C3AED','#EC4899'],
  ['#FDE68A','#FCA5A5'], ['#FAF3E7','#E7D8BE'], ['#0E1422','#334155'],
];

const FIG_HEIGHT_MM  = 42;        // реальна висота фігурки-людини (42×26 мм)
const FIG_SPRITE_FILL = 30 / 42;  // яку частку висоти спрайта займає сама фігурка
const FIG_SPRITE_W   = 480;
const FIG_SPRITE_H   = 590;
// Оригінали спрайтів — 2500×3084 (≈31 МБ у пам'яті кожен), хоча фігурка тут
// збирається на полотні 480×590 і все одно стискається. Тому просимо в Shopify
// зменшену копію: якість та сама, пам'яті у два десятки разів менше.
// Фігурки й аксесуари у файл для друку не потрапляють (їх клеять фізично),
// тож повний розмір тут не потрібен узагалі.
const FE_SPRITE_PX = 600;
function feSpx(url, w) {
  if (!url || !w) return url;
  if (url.indexOf('cdn.shopify.com') < 0 && url.indexOf('/cdn/shop/') < 0) return url;
  if (/[?&]width=/.test(url)) return url;
  return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w;
}
// Скільки міліметрів припадає на один піксель спрайта — однаково для людей і тваринок,
// тому тваринки зберігають свої природні пропорції відносно фігурок
const MM_PER_SPRITE_PX = (FIG_HEIGHT_MM / FIG_SPRITE_FILL) / FIG_SPRITE_H;
const SAFE_INSET_MM = 5;   // відступ безпечної лінії від краю фону, мм
const FE_PRINT_DPI  = 300; // роздільність файлу фону для друку
const CANVAS_LONG_PX = 950;

// Google-шрифти (підключені в snippets/frame-editor.liquid)
const FE_GOOGLE_FONTS = ['Inter','Nunito','Montserrat','Playfair Display','Cormorant Garamond','Oswald',
  'Bebas Neue','Comfortaa','Righteous','Lobster','Pacifico','Great Vibes','Caveat',
  'Rubik Puddles','Rubik Beastly','Rubik Wet Paint','Kablammo',
  'Georgia','Times New Roman','Arial','Courier New','Verdana'];
// Власні шрифти підключаються у snippets/frame-editor.liquid (рядок fe_fonts) —
// сюди вони потрапляють автоматично, редагувати цей файл не потрібно.
const FE_FONTS = (window.FE_CUSTOM_FONTS || []).concat(FE_GOOGLE_FONTS);

// Шрифти, у яких є лише одне накреслення. Якщо просити в них жирний,
// браузер «намальовує» його сам — розмазує контур, і в декоративних шрифтів
// зникають внутрішні отвори в літерах. Тому для них тримаємо звичайну вагу.
const FE_SINGLE_WEIGHT = ['Rubik Puddles','Rubik Beastly','Rubik Wet Paint','Kablammo',
  'Pacifico','Great Vibes','Lobster','Bebas Neue','Righteous']
  .concat(window.FE_CUSTOM_FONTS || []);
// Товщина за замовчуванням: у таких шрифтів беремо легку, щоб браузер
// не домальовував жирність сам. Змінити її вручну можна як і раніше.
function feFontWeight(family, w) {
  return FE_SINGLE_WEIGHT.includes(family) ? '300' : (w || 'normal');
}
function feIsSingleWeight(f) { return FE_SINGLE_WEIGHT.includes(f); }
// Зміна шрифту: якщо новий має одне накреслення — скидаємо товщину на легку
function feSetFont(v) {
  const o = feAct(); if (!o) return;
  const single = feIsSingleWeight(v);
  // Власні шрифти позначені як «одне накреслення» і раніше йшли через повну
  // перебудову напису, яка виділення не бачить — тому шрифт застосовувався
  // до всього тексту. Якщо виділено слово, працюємо через звичайний шлях.
  if (feTextSel(o)) {
    feObjSet('fontFamily', v);
    if (single) feObjSet('fontWeight', '300');
    return;
  }
  if (single) feReplaceText({ fontFamily:v, fontWeight:'300' });
  else feObjSet('fontFamily', v);
  // після зміни шрифту на весь напис ширину блоку теж треба перевірити
  const cur = feAct();
  if (cur && cur.type === 'textbox') { feUnwrapText(cur); cur.setCoords(); feC().requestRenderAll(); }
}
// Для підписів беремо перше введене імʼя — щоб бачити шрифт саме на ньому
function feCapSampleText() {
  const n = FE.captions && FE.captions.names;
  if (n) { const v = Object.values(n).find(x => x && x.trim()); if (v) return v; }
  return 'Імʼя';
}
function feCapFont(v) {
  feCapSet('font', v);
  if (feIsSingleWeight(v)) feCapSet('weight', '300');
}

// Сховище браузера може бути переповнене або вимкнене (приватний режим).
// Тоді звичайний setItem кидає помилку й обриває функцію, з якої його викликали —
// а це вже схоже на «конструктор вилетів». Тому всі записи йдуть через ці обгортки.
function feLSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
function feLGet(k)    { try { return localStorage.getItem(k); } catch (e) { return null; } }
function feLDel(k)    { try { localStorage.removeItem(k); } catch (e) {} }

// ---- обрані шрифти ----
function feFavFonts() {
  try { return JSON.parse(localStorage.getItem('fe_fav_fonts') || '[]'); } catch (e) { return []; }
}
function feToggleFav(name) {
  const f = feFavFonts();
  const i = f.indexOf(name);
  if (i >= 0) f.splice(i, 1); else f.unshift(name);
  feLSet('fe_fav_fonts', JSON.stringify(f.slice(0, 12)));
  feRefreshPanel();
  feToast(i >= 0 ? 'Прибрано з обраних' : 'Додано в обрані');
}
// <select> зі списком: спочатку обрані, потім решта
// Власний список шрифтів: кожен пункт показано його ж шрифтом.
// Рідний <select> для цього не годиться — Safari ігнорує стилі в <option>.
let _feFontN = 0;
const FE_FONT_CB = {};
function feFontSelect(current, onchange, sample) {
  const id = 'fefont' + (++_feFontN);
  try { FE_FONT_CB[id] = new Function('return function(){' + onchange + '}')(); }
  catch (e) { FE_FONT_CB[id] = function () {}; }

  const fav = feFavFonts().filter(f => FE_FONTS.includes(f));
  const rest = FE_FONTS.filter(f => !fav.includes(f));
  const esc = s => String(s).replace(/'/g, "\\'");
  const safe = s => String(s).replace(/[<>&]/g, m => ({'<':'&lt;','>':'&gt;','&':'&amp;'}[m]));
  // показуємо саме той напис, який людина зараз редагує
  let txt = String(sample || '').replace(/\s+/g, ' ').trim();
  if (txt.length > 18) txt = txt.slice(0, 18) + '…';
  if (!txt) txt = 'Аа Bb 123';
  const shown = safe(txt);

  const item = f => `<button type="button" class="fe-fo ${current === f ? 'on' : ''}"
      onclick="feFontPick('${id}','${esc(f)}')">
      <span class="fe-fo-text" style="font-family:'${f}'">${shown}</span>
      <span class="fe-fo-name">${f}</span></button>`;

  return `<div class="fe-fontsel" id="${id}">
    <button type="button" class="fe-fontsel-btn" onclick="feFontOpen('${id}')">
      <span style="font-family:'${current}'">${current}</span><i>▾</i></button>
    <div class="fe-fontsel-list">
      ${fav.length ? `<div class="fe-fo-grp">★ Обрані</div>${fav.map(item).join('')}` : ''}
      <div class="fe-fo-grp">Усі шрифти</div>${rest.map(item).join('')}
    </div></div>`;
}
// Браузер завантажує шрифт лише тоді, коли ним щось малюється, і робить це
// ліниво. Через це частина рядків у списку показувалась стандартним шрифтом.
// Просимо завантажити всі одразу — список сам перемалюється, щойно вони прийдуть.
const FE_FONT_MISSING = {};
function fePreloadFonts() {
  if (FE._fontsPreloaded || !document.fonts) return;
  FE._fontsPreloaded = true;
  const custom = window.FE_CUSTOM_FONTS || [];
  FE_FONTS.forEach(f => {
    try {
      document.fonts.load(`16px "${f}"`).then(list => {
        if (!custom.includes(f)) return;
        // Перевіряємо двічі. Порожній список означає, що правила @font-face
        // з таким імʼям немає взагалі. Але коли файл не завантажився (інша
        // назва чи регістр у назві файлу), браузер усе одно віддає правило —
        // тому додатково міряємо, чи текст справді малюється цим шрифтом.
        if ((!list || !list.length) || !feFontRenders(f)) {
          FE_FONT_MISSING[f] = true;
          feMarkMissingFont(f);
          console.warn('[MiniBrick] Шрифт не застосувався:', f,
            '— перевірте назву файлу в assets (враховуючи великі/малі літери)');
        }
      }).catch(() => {});
    } catch (e) {}
  });
}
// Чи справді браузер малює цим шрифтом? Порівнюємо ширину напису з тією,
// що дають стандартні шрифти: якщо збігається з обома — застосувався запасний.
function feFontRenders(f) {
  try {
    const cv = feFontRenders._cv || (feFontRenders._cv = document.createElement('canvas'));
    const ctx = cv.getContext('2d');
    const txt = 'AaBbSsЖж123';
    const w = (fam) => { ctx.font = `32px ${fam}`; return ctx.measureText(txt).width; };
    const mono = w('monospace'), serif = w('serif');
    const test = w(`"${f}", monospace`), test2 = w(`"${f}", serif`);
    return !(test === mono && test2 === serif);
  } catch (e) { return true; }   // не змогли перевірити — не чіпаємо
}
// Помічаємо шрифт, файл якого не знайшовся — щоб було видно, що правити
function feMarkMissingFont(f) {
  document.querySelectorAll('.fe-fontsel-list .fe-fo').forEach(b => {
    const n = b.querySelector('.fe-fo-name');
    if (n && n.textContent.trim() === f && !b.classList.contains('missing')) {
      b.classList.add('missing');
      n.textContent = f + ' — не завантажився';
    }
  });
}
function feFontOpen(id) {
  const el = document.getElementById(id);
  if (!el) return;
  const open = el.classList.contains('open');
  document.querySelectorAll('.fe-fontsel.open').forEach(x => x.classList.remove('open'));
  if (open) return;
  el.classList.add('open');
  fePreloadFonts();          // без цього частина превʼю показується стандартним шрифтом
  const list = el.querySelector('.fe-fontsel-list');
  const cur = el.querySelector('.fe-fo.on');
  // всередині списку — до поточного шрифту, а сам список — у видиму зону панелі
  if (list && cur) list.scrollTop = Math.max(0, cur.offsetTop - list.clientHeight / 2);
  if (list) setTimeout(() => list.scrollIntoView({ block:'nearest' }), 10);
  setTimeout(() => document.addEventListener('mousedown', feFontOutside, true), 0);
  setTimeout(() => document.addEventListener('touchstart', feFontOutside, true), 0);
}
function feFontOutside(e) {
  const box = e.target && e.target.closest && e.target.closest('.fe-fontsel');
  if (box) return;
  document.querySelectorAll('.fe-fontsel.open').forEach(x => x.classList.remove('open'));
  document.removeEventListener('mousedown', feFontOutside, true);
  document.removeEventListener('touchstart', feFontOutside, true);
}
function feFontPick(id, font) {
  const el = document.getElementById(id);
  if (el) {
    el.classList.remove('open');
    // одразу оновлюємо підпис кнопки й позначку — панель могла й не перемалюватись
    const lbl = el.querySelector('.fe-fontsel-btn span');
    if (lbl) { lbl.textContent = font; lbl.style.fontFamily = "'" + font + "'"; }
    el.querySelectorAll('.fe-fo').forEach(b => {
      const n = b.querySelector('.fe-fo-name');
      b.classList.toggle('on', !!n && n.textContent.trim() === font);
    });
  }
  const cb = FE_FONT_CB[id];
  if (cb) cb.call({ value: font });     // обробник очікує this.value
}

// ============================================================
// СТАН
// ============================================================
const FE = {
  color: 'black', size: '15x21', orient: 'portrait', figures: [],
  canvas: null, baseW: 0, baseH: 0,
  zoom: 1, fitZoom: 1,
  history: [], hIndex: -1, hLock: false,
  clipboard: null,
  uploads: [], uploadPage: 0, uploadSel: null, _idc: 0, figsHidden: false,
  // Шлях етапами: _maxStep — найдальший пройдений крок, _frameOk — чи людина
  // визначилась із рамкою. Задаємо явно, щоб перевірки не працювали
  // з невизначеними значеннями під час першого малювання екрана.
  _maxStep: 0, _frameOk: false, bgSaved: {},
  // Прилипання за замовчуванням ВИМКНЕНЕ. Воно різке: забрав літеру з
  // готового шаблона — і поставити її назад на місце вже морока, бо
  // притягує не туди. Кому треба рівняти — вмикає магнітом у смузі.
  _snapOff: true,
  captions: { names: {}, s: null },
};
// Чорний для нових написів і підписів. Раніше стояв темно-синій #1B2433 —
// на друці він читався як «майже чорний», хоча люди чекали справжній чорний.
// Режим адміністратора. Кнопки експорту фону й генерації превʼю потрібні
// тільки для поповнення бібліотеки — клієнту вони нічого не дають: готовий
// запис може важити мільйони символів, надіслати його нікуди.
// Вмикається в snippets/frame-editor.liquid: window.FE_ADMIN = true.
const feIsAdmin = () => window.FE_ADMIN === true;
const FE_INK = '#000000';
const FE_CAP_DEFAULTS = {
  font:'Inter', weight:'600', italic:false, underline:false, upper:false,
  align:'center', size:3.0, spacing:0, offset:3, moveWith:true, color:FE_INK,
  // підписи стоять на спільній лінії — так рівніше, коли зріст фігурок різний
  oneLine:true,
};
function feCapS() {
  if (!FE.captions.s) FE.captions.s = { ...FE_CAP_DEFAULTS };
  return FE.captions.s;
}
function feSize()  { return FE_SIZES.find(s => s.id === FE.size) || FE_SIZES[0]; }
// Робоча зона з урахуванням орієнтації (у мм і см)
function feDims() {
  const s = feSize();
  const square = s.wMm === s.hMm;
  const land = !square && FE.orient === 'landscape';
  const wMm = land ? s.hMm : s.wMm, hMm = land ? s.wMm : s.hMm;
  return { wMm, hMm, wCm: wMm / 10, hCm: hMm / 10, square };
}
function feColor() { return FE_FRAME_COLORS.find(c => c.id === FE.color) || FE_FRAME_COLORS[0]; }
function feSM()    { return window.SPRITE_MAP || {}; }
function feC()     { return FE.canvas; }

// ============================================================
// НАБІР ІКОНОК
// Кожна — SVG без розмірів і з кольором currentColor, тому вона
// підлаштовується під розмір кнопки й підсвічується разом із нею.
// Ставити так: ${feIco('trash')} — усередині будь-якої розмітки.
// ============================================================
const FE_ICO = {
  templates: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path opacity="0.4" d="M22 8.52V3.98C22 2.57 21.36 2 19.77 2H15.73C14.14 2 13.5 2.57 13.5 3.98V8.51C13.5 9.93 14.14 10.49 15.73 10.49H19.77C21.36 10.5 22 9.93 22 8.52Z" fill="currentColor"/><path d="M22 19.77V15.73C22 14.14 21.36 13.5 19.77 13.5H15.73C14.14 13.5 13.5 14.14 13.5 15.73V19.77C13.5 21.36 14.14 22 15.73 22H19.77C21.36 22 22 21.36 22 19.77Z" fill="currentColor"/><path d="M10.5 8.52V3.98C10.5 2.57 9.86 2 8.27 2H4.23C2.64 2 2 2.57 2 3.98V8.51C2 9.93 2.64 10.49 4.23 10.49H8.27C9.86 10.5 10.5 9.93 10.5 8.52Z" fill="currentColor"/><path opacity="0.4" d="M10.5 19.77V15.73C10.5 14.14 9.86 13.5 8.27 13.5H4.23C2.64 13.5 2 14.14 2 15.73V19.77C2 21.36 2.64 22 4.23 22H8.27C9.86 22 10.5 21.36 10.5 19.77Z" fill="currentColor"/></svg>`,
  bg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M2 5.15997C3.67 5.15997 3.67 5.93997 5.33 5.93997C6.99 5.93997 7 5.15997 8.66 5.15997C10.32 5.15997 10.33 5.93997 11.99 5.93997C13.65 5.93997 13.66 5.15997 15.32 5.15997C16.98 5.15997 16.99 5.93997 18.65 5.93997C20.31 5.93997 20.32 5.15997 21.98 5.15997" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><path d="M5.33008 7.7V5.94" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><path d="M8.66992 5.16002V3.40002" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><path d="M15.3301 5.16002V3.40002" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><path d="M12 7.7V5.94" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><path d="M18.6699 7.7V5.94" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><path d="M22.0007 9.46002C20.3307 9.46002 20.3307 10.24 18.6707 10.24C17.0107 10.24 17.0007 9.46002 15.3307 9.46002C13.6607 9.46002 13.6707 10.24 12.0007 10.24C10.3307 10.24 10.3307 9.46002 8.6707 9.46002C7.9807 9.46002 7.5807 9.60002 7.2207 9.75002" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><path d="M3.13 9.62002C2.84 9.53002 2.5 9.46002 2 9.46002" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><path d="M8.66992 9.46001V7.70001" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><path d="M15.3301 9.46001V7.70001" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><path d="M12 12V10.24" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><path d="M18.6699 12V10.24" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><path d="M2 13.76C3.67 13.76 3.67 14.54 5.33 14.54C6.99 14.54 7 13.76 8.66 13.76C10.32 13.76 10.33 14.54 11.99 14.54C13.65 14.54 13.66 13.76 15.32 13.76C16.98 13.76 16.99 14.54 18.65 14.54C20.31 14.54 20.32 13.76 21.98 13.76" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><path d="M5.33008 16.3V14.54" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><path d="M8.66992 13.76V12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><path d="M15.3301 13.76V12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><path d="M12 16.3V14.54" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><path d="M18.6699 16.3V14.54" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><path d="M2 18.05C3.67 18.05 3.67 18.83 5.33 18.83C6.99 18.83 7 18.05 8.66 18.05C10.32 18.05 10.33 18.83 11.99 18.83C13.65 18.83 13.66 18.05 15.32 18.05C16.98 18.05 16.99 18.83 18.65 18.83C20.31 18.83 20.32 18.05 21.98 18.05" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><path d="M5.33008 20.59V18.83" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><path d="M8.66992 18.05V16.29" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><path d="M15.3301 18.05V16.29" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><path d="M12 20.59V18.83" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><path d="M18.6699 20.59V18.83" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>`,
  text: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M20.95 4.13C20.66 3.71 20.29 3.34 19.87 3.05C18.92 2.36 17.68 2 16.19 2H7.81C7.61 2 7.41 2.01 7.22 2.03C3.94 2.24 2 4.37 2 7.81V16.19C2 17.68 2.36 18.92 3.05 19.87C3.34 20.29 3.71 20.66 4.13 20.95C4.95 21.55 5.99 21.9 7.22 21.98C7.41 21.99 7.61 22 7.81 22H16.19C19.83 22 22 19.83 22 16.19V7.81C22 6.32 21.64 5.08 20.95 4.13ZM18.75 8.9C18.75 9.31 18.41 9.65 18 9.65C17.59 9.65 17.25 9.31 17.25 8.9V7.72C17.25 7.4 16.99 7.14 16.67 7.14H12.75V16.86H14.53C14.94 16.86 15.28 17.2 15.28 17.61C15.28 18.02 14.94 18.36 14.53 18.36H9.47C9.06 18.36 8.72 18.02 8.72 17.61C8.72 17.2 9.06 16.86 9.47 16.86H11.25V7.14H7.33C7.01 7.14 6.75 7.4 6.75 7.72V8.9C6.75 9.31 6.41 9.65 6 9.65C5.59 9.65 5.25 9.31 5.25 8.9V7.72C5.25 6.57 6.18 5.64 7.33 5.64H16.66C17.81 5.64 18.74 6.57 18.74 7.72V8.9H18.75Z" fill="currentColor"/></svg>`,
  captions: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M16 22.75H3C2.04 22.75 1.25 21.96 1.25 21V8C1.25 3.58 3.58 1.25 8 1.25H16C20.42 1.25 22.75 3.58 22.75 8V16C22.75 20.42 20.42 22.75 16 22.75ZM8 2.75C4.42 2.75 2.75 4.42 2.75 8V21C2.75 21.14 2.86 21.25 3 21.25H16C19.58 21.25 21.25 19.58 21.25 16V8C21.25 4.42 19.58 2.75 16 2.75H8Z" fill="currentColor"/><path d="M7.94975 17.7498C7.47975 17.7498 7.04975 17.5798 6.72975 17.2698C6.34975 16.8898 6.17972 16.3498 6.26972 15.7698L6.54972 13.7898C6.60972 13.3598 6.87974 12.8098 7.18974 12.4998L12.3797 7.30981C14.1597 5.52981 15.7097 6.32981 16.6897 7.30981C17.4597 8.07981 17.8097 8.88981 17.7297 9.69981C17.6697 10.3598 17.3197 10.9798 16.6897 11.6198L11.4997 16.8098C11.1897 17.1198 10.6497 17.3898 10.2097 17.4598L8.22975 17.7398C8.13975 17.7398 8.03975 17.7498 7.94975 17.7498ZM14.5297 7.74981C14.1597 7.74981 13.8297 7.98981 13.4497 8.35981L8.25974 13.5498C8.17974 13.6298 8.05974 13.8798 8.03974 13.9898L7.75974 15.9698C7.74974 16.0698 7.75972 16.1598 7.79972 16.1998C7.83972 16.2398 7.92973 16.2498 8.02973 16.2398L10.0097 15.9598C10.1297 15.9398 10.3697 15.8198 10.4497 15.7398L15.6397 10.5498C16.0197 10.1698 16.2197 9.83981 16.2497 9.53981C16.2797 9.19981 16.0797 8.79981 15.6397 8.35981C15.1997 7.93981 14.8497 7.74981 14.5297 7.74981Z" fill="currentColor"/><path d="M15.4198 12.5797C15.3498 12.5797 15.2798 12.5697 15.2198 12.5497C13.4098 12.0397 11.9598 10.5997 11.4498 8.77972C11.3398 8.37972 11.5698 7.96972 11.9698 7.84972C12.3698 7.73972 12.7798 7.96972 12.8898 8.36972C13.2598 9.67972 14.3098 10.7297 15.6198 11.0997C16.0198 11.2097 16.2498 11.6297 16.1398 12.0297C16.0498 12.3597 15.7498 12.5797 15.4198 12.5797Z" fill="currentColor"/></svg>`,
  accessories: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M4.72006 12.46C4.32006 12.46 3.98006 12.19 3.89006 11.79L3.68006 10.87C3.59006 10.48 3.28006 10.17 2.90006 10.09L1.96006 9.87001C1.58006 9.79001 1.31006 9.45002 1.31006 9.05001C1.31006 8.65001 1.58006 8.31001 1.98006 8.22002L2.90006 8.01002C3.29006 7.92002 3.60006 7.61001 3.68006 7.23001L3.90006 6.29001C3.98006 5.91001 4.32006 5.64001 4.72006 5.64001C5.12006 5.64001 5.46006 5.92001 5.55006 6.31001L5.76006 7.23001C5.85006 7.62001 6.16006 7.93002 6.54006 8.01002L7.48006 8.23001C7.86006 8.31001 8.13006 8.65002 8.13006 9.06002C8.13006 9.46002 7.86006 9.80001 7.47006 9.88001L6.54006 10.09C6.15006 10.18 5.84006 10.49 5.76006 10.87L5.54006 11.81C5.46006 12.19 5.12006 12.46 4.72006 12.46ZM4.16006 9.06002C4.38006 9.22002 4.57006 9.41001 4.73006 9.63001C4.89006 9.41001 5.08006 9.22002 5.30006 9.06002C5.08006 8.90002 4.89006 8.71001 4.73006 8.49001C4.57006 8.71001 4.38006 8.90002 4.16006 9.06002Z" fill="currentColor"/><path d="M19.8301 8.11999C19.6401 8.11999 19.4501 8.04999 19.3001 7.89999C19.0101 7.60999 19.0101 7.12999 19.3001 6.83999L20.6501 5.48999C21.0401 5.09999 21.0401 4.47999 20.6501 4.08999C20.2601 3.69999 19.6401 3.69999 19.2501 4.08999L17.9001 5.43999C17.6101 5.72999 17.1301 5.72999 16.8401 5.43999C16.5501 5.14999 16.5501 4.66999 16.8401 4.37999L18.1901 3.02999C19.1601 2.05999 20.7401 2.05999 21.7101 3.02999C22.6801 3.99999 22.6801 5.57999 21.7101 6.54999L20.3601 7.89999C20.2101 8.04999 20.0201 8.11999 19.8301 8.11999Z" fill="currentColor"/><path d="M4.60007 22.7401C3.94007 22.7401 3.27007 22.4901 2.77007 21.9801C1.76007 20.9701 1.76007 19.3301 2.77007 18.3201L10.3601 10.7301C10.6501 10.4401 11.1301 10.4401 11.4201 10.7301C11.7101 11.0201 11.7101 11.5001 11.4201 11.7901L3.83007 19.3801C3.41007 19.8001 3.41007 20.5001 3.83007 20.9201C4.25007 21.3401 4.94007 21.3401 5.37007 20.9201L12.9601 13.3301C13.2501 13.0401 13.7301 13.0401 14.0201 13.3301C14.3101 13.6201 14.3101 14.1001 14.0201 14.3901L6.43007 21.9801C5.93007 22.4801 5.26007 22.7401 4.60007 22.7401Z" fill="currentColor"/><path d="M21.6301 18.52C21.1501 18.52 20.6901 18.34 20.3501 17.99L16.3601 14L15.7401 14.62C15.1201 15.28 13.8901 15.31 13.2001 14.62L10.1601 11.58C9.46006 10.88 9.46006 9.73002 10.1601 9.03002L10.7701 8.42002L6.77006 4.42002C6.28006 3.95002 6.11006 3.21002 6.33006 2.56002C6.55006 1.91002 7.11006 1.44002 7.79006 1.34002C10.0101 1.02002 12.2701 1.77002 13.8601 3.36002L14.8401 4.34002L15.0801 4.10002C15.7801 3.40002 16.9301 3.40002 17.6301 4.10002L20.6701 7.14002C21.0001 7.45002 21.2001 7.92002 21.2001 8.41002C21.2001 8.90002 21.0101 9.34002 20.6701 9.68002L20.4301 9.92002L21.4101 10.9C23.0001 12.49 23.7501 14.75 23.4301 16.97C23.3301 17.65 22.8601 18.21 22.2101 18.43C22.0201 18.49 21.8201 18.52 21.6301 18.52ZM16.3601 12.19C16.5501 12.19 16.7401 12.26 16.8801 12.4L21.4101 16.93C21.5001 17.02 21.6201 17.04 21.7401 17.01C21.8401 16.97 21.9301 16.88 21.9401 16.76C22.1901 15.02 21.6001 13.22 20.3401 11.97L18.8301 10.46C18.6901 10.32 18.6101 10.13 18.6101 9.93002C18.6101 9.73002 18.6901 9.54002 18.8301 9.40002L19.6001 8.63002C19.6601 8.57002 19.6901 8.50002 19.6901 8.42002C19.6901 8.34002 19.6601 8.27002 19.6101 8.22002L16.5601 5.17002C16.4401 5.05002 16.2501 5.05002 16.1301 5.17002L15.3601 5.94002C15.0801 6.22002 14.5801 6.22002 14.3001 5.94002L12.7901 4.43002C11.5301 3.17002 9.74006 2.58002 8.00006 2.83002C7.88006 2.85002 7.78006 2.93002 7.74006 3.05002C7.70006 3.16002 7.74006 3.28002 7.81006 3.36002L12.3501 7.90002C12.6401 8.19002 12.6401 8.67002 12.3501 8.96002L11.2101 10.1C11.0901 10.22 11.0901 10.41 11.2101 10.53L14.2501 13.57C14.3701 13.69 14.5601 13.68 14.6601 13.58L15.7601 12.48C15.8401 12.38 15.9401 12.3 16.0601 12.25C16.1601 12.21 16.2601 12.19 16.3601 12.19Z" fill="currentColor"/></svg>`,
  items: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6.7002 9.25977L12.0002 12.3298L17.2602 9.27976" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><path d="M12 17.7703V12.3203" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><path d="M10.7603 6.28986L7.56024 8.06986C6.84024 8.46986 6.24023 9.47985 6.24023 10.3099V13.6999C6.24023 14.5299 6.83024 15.5399 7.56024 15.9399L10.7603 17.7199C11.4403 18.0999 12.5602 18.0999 13.2502 17.7199L16.4503 15.9399C17.1703 15.5399 17.7702 14.5299 17.7702 13.6999V10.2999C17.7702 9.46986 17.1803 8.45985 16.4503 8.05985L13.2502 6.27985C12.5602 5.89985 11.4403 5.89986 10.7603 6.28986Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><path opacity="0.4" d="M22 15C22 18.87 18.87 22 15 22L16.05 20.25" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><path opacity="0.4" d="M2 9C2 5.13 5.13 2 9 2L7.95001 3.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>`,
  files: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M9 22.75H7C2.59 22.75 1.25 21.41 1.25 17V7C1.25 2.59 2.59 1.25 7 1.25H8.5C10.25 1.25 10.8 1.82 11.5 2.75L13 4.75C13.33 5.19 13.38 5.25 14 5.25H17C21.41 5.25 22.75 6.59 22.75 11V13C22.75 13.41 22.41 13.75 22 13.75C21.59 13.75 21.25 13.41 21.25 13V11C21.25 7.43 20.58 6.75 17 6.75H14C12.72 6.75 12.3 6.30999 11.8 5.64999L10.3 3.64999C9.77999 2.95999 9.62 2.75 8.5 2.75H7C3.42 2.75 2.75 3.43 2.75 7V17C2.75 20.57 3.42 21.25 7 21.25H9C9.41 21.25 9.75 21.59 9.75 22C9.75 22.41 9.41 22.75 9 22.75Z" fill="currentColor"/><path d="M19.3403 22.81C19.3303 22.81 19.3202 22.81 19.3102 22.81H13.7502C12.0802 22.69 11.2402 21.41 11.2402 20.19C11.2402 19.21 11.7902 18.18 12.8502 17.76C12.6302 16.51 12.9503 15.35 13.7803 14.48C14.8003 13.41 16.4402 12.98 17.8602 13.41C19.1002 13.79 19.9902 14.77 20.3602 16.13C21.4102 16.45 22.2403 17.28 22.5803 18.41C22.9803 19.72 22.6102 21.06 21.6202 21.92C21.0202 22.49 20.2003 22.81 19.3403 22.81ZM13.7902 19.07C13.0302 19.14 12.7502 19.71 12.7502 20.19C12.7502 20.67 13.0302 21.25 13.8102 21.31H19.3203C19.8003 21.35 20.2803 21.13 20.6403 20.81C21.2903 20.24 21.3302 19.43 21.1602 18.85C20.9902 18.27 20.4903 17.62 19.6503 17.51C19.3203 17.47 19.0602 17.22 19.0002 16.89C18.7802 15.54 18.0202 15.04 17.4302 14.85C16.5502 14.58 15.5102 14.86 14.8802 15.52C14.4502 15.97 14.0302 16.78 14.5002 18.07C14.6402 18.46 14.4402 18.89 14.0502 19.03C13.9602 19.06 13.8702 19.07 13.7902 19.07Z" fill="currentColor"/></svg>`,
  shapes: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M13.43 14.9995H4.39997C2.57997 14.9995 1.41997 13.0495 2.29997 11.4495L4.62997 7.20945L6.80997 3.23945C7.71997 1.58945 10.1 1.58945 11.01 3.23945L13.2 7.20945L14.25 9.11946L15.53 11.4495C16.41 13.0495 15.25 14.9995 13.43 14.9995Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><path d="M22 15.5C22 19.09 19.09 22 15.5 22C11.91 22 9 19.09 9 15.5C9 15.33 9.01 15.17 9.02 15H13.43C15.25 15 16.41 13.05 15.53 11.45L14.25 9.12C14.65 9.04 15.07 9 15.5 9C19.09 9 22 11.91 22 15.5Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>`,
  stickers: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M21.93 12.8608C21.91 13.0508 21.88 13.2308 21.83 13.4108C20.79 12.5308 19.44 12.0008 17.97 12.0008C14.66 12.0008 11.97 14.6908 11.97 18.0008C11.97 19.4708 12.5 20.8208 13.38 21.8608C13.2 21.9108 13.02 21.9408 12.83 21.9608C11.98 22.0408 11.11 22.0008 10.21 21.8508C6.09999 21.1508 2.78999 17.8208 2.10999 13.7008C0.97999 6.85075 6.81999 1.01075 13.67 2.14075C17.79 2.82075 21.12 6.13075 21.82 10.2408C21.97 11.1408 22.01 12.0108 21.93 12.8608Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><path d="M21.83 13.41C21.69 13.9 21.43 14.34 21.06 14.71L14.68 21.09C14.31 21.46 13.87 21.72 13.38 21.86C12.5 20.82 11.97 19.47 11.97 18C11.97 14.69 14.66 12 17.97 12C19.44 12 20.79 12.53 21.83 13.41Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>`,
  layers: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M13.01 2.92031L18.91 5.54031C20.61 6.29031 20.61 7.53031 18.91 8.28031L13.01 10.9003C12.34 11.2003 11.24 11.2003 10.57 10.9003L4.67002 8.28031C2.97002 7.53031 2.97002 6.29031 4.67002 5.54031L10.57 2.92031C11.24 2.62031 12.34 2.62031 13.01 2.92031Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><path d="M3 11C3 11.84 3.63 12.81 4.4 13.15L11.19 16.17C11.71 16.4 12.3 16.4 12.81 16.17L19.6 13.15C20.37 12.81 21 11.84 21 11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><path d="M3 16C3 16.93 3.55 17.77 4.4 18.15L11.19 21.17C11.71 21.4 12.3 21.4 12.81 21.17L19.6 18.15C20.45 17.77 21 16.93 21 16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>`,
  up: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M18.0701 10.3204C17.8801 10.3204 17.6901 10.2504 17.5401 10.1004L12.0001 4.56043L6.46012 10.1004C6.17012 10.3904 5.69012 10.3904 5.40012 10.1004C5.11012 9.81043 5.11012 9.33043 5.40012 9.04043L11.4701 2.97043C11.7601 2.68043 12.2401 2.68043 12.5301 2.97043L18.6001 9.04043C18.8901 9.33043 18.8901 9.81043 18.6001 10.1004C18.4601 10.2504 18.2601 10.3204 18.0701 10.3204Z" fill="currentColor"/><path d="M12 21.2499C11.59 21.2499 11.25 20.9099 11.25 20.4999V3.66992C11.25 3.25992 11.59 2.91992 12 2.91992C12.41 2.91992 12.75 3.25992 12.75 3.66992V20.4999C12.75 20.9099 12.41 21.2499 12 21.2499Z" fill="currentColor"/></svg>`,
  down: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 21.2501C11.81 21.2501 11.62 21.1801 11.47 21.0301L5.4 14.9601C5.11 14.6701 5.11 14.1901 5.4 13.9001C5.69 13.6101 6.17 13.6101 6.46 13.9001L12 19.4401L17.54 13.9001C17.83 13.6101 18.31 13.6101 18.6 13.9001C18.89 14.1901 18.89 14.6701 18.6 14.9601L12.53 21.0301C12.38 21.1801 12.19 21.2501 12 21.2501Z" fill="currentColor"/><path d="M12 21.08C11.59 21.08 11.25 20.74 11.25 20.33V3.5C11.25 3.09 11.59 2.75 12 2.75C12.41 2.75 12.75 3.09 12.75 3.5V20.33C12.75 20.74 12.41 21.08 12 21.08Z" fill="currentColor"/></svg>`,
  eye: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M15.58 11.9999C15.58 13.9799 13.98 15.5799 12 15.5799C10.02 15.5799 8.42004 13.9799 8.42004 11.9999C8.42004 10.0199 10.02 8.41992 12 8.41992C13.98 8.41992 15.58 10.0199 15.58 11.9999Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><path d="M12 20.2707C15.53 20.2707 18.82 18.1907 21.11 14.5907C22.01 13.1807 22.01 10.8107 21.11 9.4007C18.82 5.8007 15.53 3.7207 12 3.7207C8.46997 3.7207 5.17997 5.8007 2.88997 9.4007C1.98997 10.8107 1.98997 13.1807 2.88997 14.5907C5.17997 18.1907 8.46997 20.2707 12 20.2707Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>`,
  eyeOff: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M9.46992 15.2799C9.27992 15.2799 9.08992 15.2099 8.93992 15.0599C8.11992 14.2399 7.66992 13.1499 7.66992 11.9999C7.66992 9.60992 9.60992 7.66992 11.9999 7.66992C13.1499 7.66992 14.2399 8.11992 15.0599 8.93992C15.1999 9.07992 15.2799 9.26992 15.2799 9.46992C15.2799 9.66992 15.1999 9.85992 15.0599 9.99992L9.99992 15.0599C9.84992 15.2099 9.65992 15.2799 9.46992 15.2799ZM11.9999 9.16992C10.4399 9.16992 9.16992 10.4399 9.16992 11.9999C9.16992 12.4999 9.29992 12.9799 9.53992 13.3999L13.3999 9.53992C12.9799 9.29992 12.4999 9.16992 11.9999 9.16992Z" fill="currentColor"/><path d="M5.60009 18.5105C5.43009 18.5105 5.25009 18.4505 5.11009 18.3305C4.04009 17.4205 3.08009 16.3005 2.26009 15.0005C1.20009 13.3505 1.20009 10.6605 2.26009 9.00047C4.70009 5.18047 8.25009 2.98047 12.0001 2.98047C14.2001 2.98047 16.3701 3.74047 18.2701 5.17047C18.6001 5.42047 18.6701 5.89047 18.4201 6.22047C18.1701 6.55047 17.7001 6.62047 17.3701 6.37047C15.7301 5.13047 13.8701 4.48047 12.0001 4.48047C8.77009 4.48047 5.68009 6.42047 3.52009 9.81047C2.77009 10.9805 2.77009 13.0205 3.52009 14.1905C4.27009 15.3605 5.13009 16.3705 6.08009 17.1905C6.39009 17.4605 6.43009 17.9305 6.16009 18.2505C6.02009 18.4205 5.81009 18.5105 5.60009 18.5105Z" fill="currentColor"/><path d="M12.0001 21.0195C10.6701 21.0195 9.37006 20.7495 8.12006 20.2195C7.74006 20.0595 7.56006 19.6195 7.72006 19.2395C7.88006 18.8595 8.32006 18.6795 8.70006 18.8395C9.76006 19.2895 10.8701 19.5195 11.9901 19.5195C15.2201 19.5195 18.3101 17.5795 20.4701 14.1895C21.2201 13.0195 21.2201 10.9795 20.4701 9.80951C20.1601 9.31951 19.8201 8.84951 19.4601 8.40951C19.2001 8.08951 19.2501 7.61951 19.5701 7.34951C19.8901 7.08951 20.3601 7.12951 20.6301 7.45951C21.0201 7.93951 21.4001 8.45951 21.7401 8.99951C22.8001 10.6495 22.8001 13.3395 21.7401 14.9995C19.3001 18.8195 15.7501 21.0195 12.0001 21.0195Z" fill="currentColor"/><path d="M12.6901 16.2703C12.3401 16.2703 12.0201 16.0203 11.9501 15.6603C11.8701 15.2503 12.1401 14.8603 12.5501 14.7903C13.6501 14.5903 14.5701 13.6703 14.7701 12.5703C14.8501 12.1603 15.2401 11.9003 15.6501 11.9703C16.0601 12.0503 16.3301 12.4403 16.2501 12.8503C15.9301 14.5803 14.5501 15.9503 12.8301 16.2703C12.7801 16.2603 12.7401 16.2703 12.6901 16.2703Z" fill="currentColor"/><path d="M1.99994 22.7507C1.80994 22.7507 1.61994 22.6807 1.46994 22.5307C1.17994 22.2407 1.17994 21.7607 1.46994 21.4707L8.93994 14.0007C9.22994 13.7107 9.70994 13.7107 9.99994 14.0007C10.2899 14.2907 10.2899 14.7707 9.99994 15.0607L2.52994 22.5307C2.37994 22.6807 2.18994 22.7507 1.99994 22.7507Z" fill="currentColor"/><path d="M14.53 10.2195C14.34 10.2195 14.15 10.1495 14 9.99945C13.71 9.70945 13.71 9.22945 14 8.93945L21.47 1.46945C21.76 1.17945 22.24 1.17945 22.53 1.46945C22.82 1.75945 22.82 2.23945 22.53 2.52945L15.06 9.99945C14.91 10.1495 14.72 10.2195 14.53 10.2195Z" fill="currentColor"/></svg>`,
  locked: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M17 22.75H7C2.59 22.75 1.25 21.41 1.25 17V15C1.25 10.59 2.59 9.25 7 9.25H17C21.41 9.25 22.75 10.59 22.75 15V17C22.75 21.41 21.41 22.75 17 22.75ZM7 10.75C3.42 10.75 2.75 11.43 2.75 15V17C2.75 20.57 3.42 21.25 7 21.25H17C20.58 21.25 21.25 20.57 21.25 17V15C21.25 11.43 20.58 10.75 17 10.75H7Z" fill="currentColor"/><path d="M6 10.75C5.59 10.75 5.25 10.41 5.25 10V8C5.25 5.1 5.95 1.25 12 1.25C16.48 1.25 18.75 3.18 18.75 7C18.75 7.41 18.41 7.75 18 7.75C17.59 7.75 17.25 7.41 17.25 7C17.25 5.02 16.65 2.75 12 2.75C7.64 2.75 6.75 4.85 6.75 8V10C6.75 10.41 6.41 10.75 6 10.75Z" fill="currentColor"/><path d="M12 19.25C10.21 19.25 8.75 17.79 8.75 16C8.75 14.21 10.21 12.75 12 12.75C13.79 12.75 15.25 14.21 15.25 16C15.25 17.79 13.79 19.25 12 19.25ZM12 14.25C11.04 14.25 10.25 15.04 10.25 16C10.25 16.96 11.04 17.75 12 17.75C12.96 17.75 13.75 16.96 13.75 16C13.75 15.04 12.96 14.25 12 14.25Z" fill="currentColor"/></svg>`,
  unlocked: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12.0001 19.2503C10.9801 19.2503 10.0401 18.7903 9.42005 17.9803C9.17005 17.6503 9.23005 17.1803 9.56005 16.9303C9.89005 16.6803 10.3601 16.7403 10.6101 17.0703C10.9401 17.5103 11.4501 17.7503 12.0001 17.7503C12.9601 17.7503 13.7501 16.9603 13.7501 16.0003C13.7501 15.6103 13.6301 15.2403 13.3901 14.9403C13.1401 14.6103 13.2001 14.1403 13.5301 13.8903C13.8601 13.6403 14.3301 13.7003 14.5801 14.0303C15.0201 14.6003 15.2501 15.2803 15.2501 16.0003C15.2501 17.7903 13.7901 19.2503 12.0001 19.2503Z" fill="currentColor"/><path d="M17 22.75H7C6.63 22.75 6.28 22.74 5.95 22.72C5.54 22.7 5.22 22.34 5.24 21.93C5.26 21.52 5.61 21.22 6.03 21.22C6.33 21.24 6.65 21.24 6.99 21.24H16.99C20.56 21.24 21.24 20.56 21.24 16.99V14.99C21.24 11.48 20.5 10.91 17.95 10.76C17.65 10.74 17.33 10.74 16.99 10.74H7C3.43 10.74 2.75 11.42 2.75 14.99V16.99C2.75 18.73 2.95 19.76 3.41 20.32C3.67 20.64 3.62 21.12 3.29 21.37C2.97 21.63 2.5 21.58 2.24 21.25C1.54 20.4 1.25 19.16 1.25 17V15C1.25 10.59 2.59 9.25 7 9.25H17C17.37 9.25 17.72 9.26 18.04 9.28C22 9.5 22.75 11.46 22.75 15V17C22.75 21.41 21.41 22.75 17 22.75Z" fill="currentColor"/><path d="M6 10.75C5.59 10.75 5.25 10.41 5.25 10V8C5.25 5.1 5.95 1.25 12 1.25C16.07 1.25 18.18 2.58 18.64 5.44C18.71 5.85 18.43 6.23 18.02 6.3C17.61 6.37 17.23 6.09 17.16 5.68C16.91 4.16 16.12 2.75 12 2.75C7.64 2.75 6.75 4.85 6.75 8V10C6.75 10.41 6.41 10.75 6 10.75Z" fill="currentColor"/><path d="M1.99994 22.7495C1.80994 22.7495 1.61994 22.6795 1.46994 22.5295C1.17994 22.2395 1.17994 21.7595 1.46994 21.4695L21.4699 1.46945C21.7599 1.17945 22.2399 1.17945 22.5299 1.46945C22.8199 1.75945 22.8199 2.23945 22.5299 2.52945L2.52994 22.5295C2.37994 22.6795 2.18994 22.7495 1.99994 22.7495Z" fill="currentColor"/></svg>`,
  trash: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M21 5.98047C17.67 5.65047 14.32 5.48047 10.98 5.48047C9 5.48047 7.02 5.58047 5.04 5.78047L3 5.98047" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><path d="M8.5 4.97L8.72 3.66C8.88 2.71 9 2 10.69 2H13.31C15 2 15.13 2.75 15.28 3.67L15.5 4.97" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><path d="M18.85 9.14062L18.2 19.2106C18.09 20.7806 18 22.0006 15.21 22.0006H8.79002C6.00002 22.0006 5.91002 20.7806 5.80002 19.2106L5.15002 9.14062" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><path d="M10.33 16.5H13.66" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><path d="M9.5 12.5H14.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>`,
  expand: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z" fill="currentColor"/><path d="M5.99994 18.7504C5.80994 18.7504 5.61994 18.6804 5.46994 18.5304C5.17994 18.2404 5.17994 17.7604 5.46994 17.4704L17.4699 5.47043C17.7599 5.18043 18.2399 5.18043 18.5299 5.47043C18.8199 5.76043 18.8199 6.24043 18.5299 6.53043L6.52994 18.5304C6.37994 18.6804 6.18994 18.7504 5.99994 18.7504Z" fill="currentColor"/><path d="M18 10.75C17.59 10.75 17.25 10.41 17.25 10V6.75H14C13.59 6.75 13.25 6.41 13.25 6C13.25 5.59 13.59 5.25 14 5.25H18C18.41 5.25 18.75 5.59 18.75 6V10C18.75 10.41 18.41 10.75 18 10.75Z" fill="currentColor"/><path d="M10 18.75H6C5.59 18.75 5.25 18.41 5.25 18V14C5.25 13.59 5.59 13.25 6 13.25C6.41 13.25 6.75 13.59 6.75 14V17.25H10C10.41 17.25 10.75 17.59 10.75 18C10.75 18.41 10.41 18.75 10 18.75Z" fill="currentColor"/><path d="M17.9999 18.7504C17.8099 18.7504 17.6199 18.6804 17.4699 18.5304L5.46994 6.53043C5.17994 6.24043 5.17994 5.76043 5.46994 5.47043C5.75994 5.18043 6.23994 5.18043 6.52994 5.47043L18.5299 17.4704C18.8199 17.7604 18.8199 18.2404 18.5299 18.5304C18.3799 18.6804 18.1899 18.7504 17.9999 18.7504Z" fill="currentColor"/><path d="M6 10.75C5.59 10.75 5.25 10.41 5.25 10V6C5.25 5.59 5.59 5.25 6 5.25H10C10.41 5.25 10.75 5.59 10.75 6C10.75 6.41 10.41 6.75 10 6.75H6.75V10C6.75 10.41 6.41 10.75 6 10.75Z" fill="currentColor"/><path d="M18 18.75H14C13.59 18.75 13.25 18.41 13.25 18C13.25 17.59 13.59 17.25 14 17.25H17.25V14C17.25 13.59 17.59 13.25 18 13.25C18.41 13.25 18.75 13.59 18.75 14V18C18.75 18.41 18.41 18.75 18 18.75Z" fill="currentColor"/></svg>`,
  picker: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M4.99988 21.8709C4.25988 21.8709 3.52988 21.5909 2.96988 21.0309C2.42988 20.4909 2.12988 19.7709 2.12988 19.0009C2.12988 18.2309 2.42988 17.5109 2.96988 16.9709L15.9699 3.97086C17.0899 2.85086 18.9099 2.85086 20.0299 3.97086C20.5699 4.51086 20.8699 5.23086 20.8699 6.00086C20.8699 6.77086 20.5699 7.49086 20.0299 8.03086L7.02988 21.0309C6.46988 21.5909 5.73988 21.8709 4.99988 21.8709ZM17.9999 4.63086C17.6499 4.63086 17.2999 4.76086 17.0299 5.03086L4.02988 18.0309C3.76988 18.2909 3.62988 18.6309 3.62988 19.0009C3.62988 19.3709 3.76988 19.7109 4.02988 19.9709C4.55988 20.5009 5.43988 20.5009 5.96988 19.9709L18.9699 6.97086C19.2299 6.71086 19.3699 6.37086 19.3699 6.00086C19.3699 5.63086 19.2299 5.29086 18.9699 5.03086C18.6999 4.76086 18.3499 4.63086 17.9999 4.63086Z" fill="currentColor"/><path d="M18.01 9.73969C17.82 9.73969 17.63 9.66969 17.48 9.51969L14.48 6.51969C14.19 6.22969 14.19 5.74969 14.48 5.45969C14.77 5.16969 15.25 5.16969 15.54 5.45969L18.54 8.45969C18.83 8.74969 18.83 9.22969 18.54 9.51969C18.39 9.66969 18.2 9.73969 18.01 9.73969Z" fill="currentColor"/><path d="M10.0001 5.49907C9.95005 5.49907 9.91005 5.48907 9.86005 5.47907L8.50005 5.07907L7.14005 5.47907C6.96005 5.52908 6.77005 5.47907 6.65005 5.34907C6.52005 5.21907 6.47005 5.03908 6.52005 4.85908L6.92005 3.49907L6.52005 2.13907C6.47005 1.95907 6.52005 1.76907 6.65005 1.64907C6.78005 1.51907 6.97005 1.46907 7.14005 1.51907L8.50005 1.91907L9.86005 1.51907C10.0401 1.46907 10.2201 1.51907 10.3501 1.64907C10.4801 1.77907 10.5301 1.96907 10.4801 2.13907L10.0801 3.49907L10.4801 4.85908C10.5301 5.03908 10.4801 5.22907 10.3501 5.34907C10.2601 5.44907 10.1301 5.49907 10.0001 5.49907ZM8.50005 4.05907C8.55005 4.05907 8.59005 4.06907 8.64005 4.07907L9.26005 4.25908L9.08005 3.63908C9.05005 3.54908 9.05005 3.44907 9.08005 3.35907L9.26005 2.73907L8.64005 2.91907C8.55005 2.94907 8.45005 2.94907 8.36005 2.91907L7.74005 2.73907L7.92005 3.35907C7.95005 3.44907 7.95005 3.54908 7.92005 3.63908L7.74005 4.25908L8.36005 4.07907C8.41005 4.06907 8.45005 4.05907 8.50005 4.05907Z" fill="currentColor"/><path d="M6.00005 11.4991C5.95005 11.4991 5.91005 11.4891 5.86005 11.4791L4.50005 11.0791L3.14005 11.4791C2.96005 11.5291 2.78005 11.4791 2.65005 11.3491C2.52005 11.2191 2.47005 11.0291 2.52005 10.8591L2.92005 9.49907L2.52005 8.13908C2.47005 7.95908 2.52005 7.76907 2.65005 7.64907C2.78005 7.52907 2.97005 7.46907 3.14005 7.51907L4.50005 7.91907L5.86005 7.51907C6.03005 7.46907 6.22005 7.51907 6.35005 7.64907C6.48005 7.77907 6.53005 7.96908 6.48005 8.13908L6.08005 9.49907L6.48005 10.8591C6.53005 11.0391 6.48005 11.2291 6.35005 11.3491C6.26005 11.4491 6.13005 11.4991 6.00005 11.4991ZM4.50005 10.0591C4.55005 10.0591 4.59005 10.0691 4.64005 10.0791L5.26005 10.2591L5.08005 9.63908C5.05005 9.54908 5.05005 9.44907 5.08005 9.35907L5.26005 8.73907L4.64005 8.91907C4.55005 8.94907 4.45005 8.94907 4.36005 8.91907L3.74005 8.73907L3.92005 9.35907C3.95005 9.44907 3.95005 9.54908 3.92005 9.63908L3.74005 10.2591L4.36005 10.0791C4.41005 10.0691 4.45005 10.0591 4.50005 10.0591Z" fill="currentColor"/><path d="M21.0001 16.4991C20.9501 16.4991 20.9101 16.4891 20.8601 16.4791L19.5001 16.0791L18.1401 16.4791C17.9601 16.5291 17.7801 16.4791 17.6501 16.3491C17.5201 16.2191 17.4701 16.0291 17.5201 15.8591L17.9201 14.4991L17.5201 13.1391C17.4701 12.9591 17.5201 12.7691 17.6501 12.6491C17.7801 12.5291 17.9701 12.4691 18.1401 12.5191L19.5001 12.9191L20.8601 12.5191C21.0301 12.4691 21.2201 12.5191 21.3501 12.6491C21.4801 12.7791 21.5301 12.9691 21.4801 13.1391L21.0801 14.4991L21.4801 15.8591C21.5301 16.0391 21.4801 16.2291 21.3501 16.3491C21.2601 16.4491 21.1301 16.4991 21.0001 16.4991ZM19.5001 15.0591C19.5501 15.0591 19.5901 15.0691 19.6401 15.0791L20.2601 15.2591L20.0801 14.6391C20.0501 14.5491 20.0501 14.4491 20.0801 14.3591L20.2601 13.7391L19.6401 13.9191C19.5501 13.9491 19.4501 13.9491 19.3601 13.9191L18.7401 13.7391L18.9201 14.3591C18.9501 14.4491 18.9501 14.5491 18.9201 14.6391L18.7401 15.2591L19.3601 15.0791C19.4101 15.0691 19.4501 15.0591 19.5001 15.0591Z" fill="currentColor"/></svg>`,
  italic: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9.62 3H18.87" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><path d="M5.12 21H14.37" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><path d="M14.25 3L9.75 21" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>`,
  bold: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M13.75 12.75H12.25H8.5V16.74C8.5 17.02 8.73 17.25 9.01 17.25H13.75C14.99 17.25 16 16.24 16 15C16 13.76 14.99 12.75 13.75 12.75Z" fill="currentColor"/><path d="M14.5 9C14.5 7.76 13.49 6.75 12.25 6.75H9.01C8.73 6.75 8.5 6.98 8.5 7.26V11.25H12.25C13.49 11.25 14.5 10.24 14.5 9Z" fill="currentColor"/><path d="M20.95 4.13C20.66 3.71 20.29 3.34 19.87 3.05C18.92 2.36 17.68 2 16.19 2H7.81C7.61 2 7.41 2.01 7.22 2.03C3.94 2.24 2 4.37 2 7.81V16.19C2 17.68 2.36 18.92 3.05 19.87C3.34 20.29 3.71 20.66 4.13 20.95C4.95 21.55 5.99 21.9 7.22 21.98C7.41 21.99 7.61 22 7.81 22H16.19C19.83 22 22 19.83 22 16.19V7.81C22 6.32 21.64 5.08 20.95 4.13ZM13.75 18.75H9.01C7.9 18.75 7 17.85 7 16.74V12V7.26C7 6.15 7.9 5.25 9.01 5.25H12.25C14.32 5.25 16 6.93 16 9C16 9.96 15.63 10.83 15.03 11.49C16.46 12.02 17.5 13.38 17.5 15C17.5 17.07 15.82 18.75 13.75 18.75Z" fill="currentColor"/></svg>`,
  underline: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 21H19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><path d="M5 3V10C5 13.87 8.13 17 12 17C15.87 17 19 13.87 19 10V3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>`,
  letterCase: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M1.99023 5.93031V4.42031C1.99023 3.40031 2.82023 2.57031 3.84023 2.57031H16.7602C17.7802 2.57031 18.6102 3.40031 18.6102 4.42031V5.93031" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><path d="M10.2998 18.1003V3.32031" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><path d="M6.8999 18.0996H12.4799" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><g opacity="0.4"><path d="M13.6797 10.3398H20.6897C21.4197 10.3398 22.0097 10.9298 22.0097 11.6598V12.4598" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><path d="M16.0801 21.4301V10.8701" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><path d="M13.9395 21.4297H18.2195" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></g></svg>`,
  // Дзеркало: стрілки з осями. Вертикальні — перевернути згори вниз,
  // ті самі, повернуті на 90°, — відзеркалити зліва направо.
  mirrorY: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M6.90012 9.09914L11.6701 6.97914C11.8801 6.88914 12.1201 6.88914 12.3201 6.97914L17.0901 9.09914C17.5101 9.28914 17.9001 8.77914 17.6101 8.41914L12.6101 2.30914C12.2701 1.88914 11.7101 1.88914 11.3701 2.30914L6.37009 8.41914C6.09009 8.77914 6.48012 9.28914 6.90012 9.09914Z" fill="currentColor"/><path d="M6.90007 14.9005L11.68 17.0205C11.89 17.1105 12.1301 17.1105 12.3301 17.0205L17.11 14.9005C17.53 14.7105 17.92 15.2205 17.63 15.5805L12.63 21.6905C12.29 22.1105 11.7301 22.1105 11.3901 21.6905L6.39006 15.5805C6.09006 15.2205 6.47007 14.7105 6.90007 14.9005Z" fill="currentColor"/><path d="M11.7801 9.49L7.65006 11.55C7.28006 11.73 7.28006 12.26 7.65006 12.44L11.7801 14.5C11.9201 14.57 12.09 14.57 12.23 14.5L16.36 12.44C16.73 12.26 16.73 11.73 16.36 11.55L12.23 9.49C12.08 9.42 11.9201 9.42 11.7801 9.49Z" fill="currentColor"/></svg>`,
  mirrorX: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><g transform="rotate(90 12 12)"><path d="M6.90012 9.09914L11.6701 6.97914C11.8801 6.88914 12.1201 6.88914 12.3201 6.97914L17.0901 9.09914C17.5101 9.28914 17.9001 8.77914 17.6101 8.41914L12.6101 2.30914C12.2701 1.88914 11.7101 1.88914 11.3701 2.30914L6.37009 8.41914C6.09009 8.77914 6.48012 9.28914 6.90012 9.09914Z" fill="currentColor"/><path d="M6.90007 14.9005L11.68 17.0205C11.89 17.1105 12.1301 17.1105 12.3301 17.0205L17.11 14.9005C17.53 14.7105 17.92 15.2205 17.63 15.5805L12.63 21.6905C12.29 22.1105 11.7301 22.1105 11.3901 21.6905L6.39006 15.5805C6.09006 15.2205 6.47007 14.7105 6.90007 14.9005Z" fill="currentColor"/><path d="M11.7801 9.49L7.65006 11.55C7.28006 11.73 7.28006 12.26 7.65006 12.44L11.7801 14.5C11.9201 14.57 12.09 14.57 12.23 14.5L16.36 12.44C16.73 12.26 16.73 11.73 16.36 11.55L12.23 9.49C12.08 9.42 11.9201 9.42 11.7801 9.49Z" fill="currentColor"/></g></svg>`,
  // та сама, що на кнопці «Фон» у нижній смузі — щоб гайд не показував стару
  bgTool: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M8 22.7494C4.28 22.7494 1.25 19.7194 1.25 15.9994C1.25 12.9594 3.29 10.2794 6.22 9.4894C6.59 9.3894 6.97 9.5794 7.11 9.9394C7.72 11.4694 9.02 12.6394 10.61 13.0694C11.49 13.3094 12.51 13.3094 13.37 13.0694C13.74 12.9694 14.13 13.1594 14.27 13.5194C14.58 14.3094 14.74 15.1494 14.74 16.0094C14.74 17.9294 13.92 19.7594 12.49 21.0294C11.27 22.1294 9.67 22.7494 8 22.7494ZM6.02 11.1294C4.07 11.9294 2.75 13.8494 2.75 15.9994C2.75 18.8894 5.11 21.2494 8 21.2494C9.3 21.2494 10.54 20.7694 11.5 19.8994C12.62 18.9094 13.25 17.4894 13.25 15.9994C13.25 15.5394 13.19 15.0994 13.08 14.6694C12.14 14.8194 11.12 14.7694 10.22 14.5194C8.41 14.0194 6.89 12.7794 6.02 11.1294Z" fill="currentColor"/><path d="M12 14.75C11.38 14.75 10.78 14.67 10.22 14.51C8.19 13.95 6.5 12.45 5.72 10.48C5.41 9.7 5.25 8.86 5.25 8C5.25 4.28 8.28 1.25 12 1.25C15.72 1.25 18.75 4.28 18.75 8C18.75 8.86 18.59 9.7 18.28 10.49C17.5 12.45 15.82 13.96 13.78 14.52C13.22 14.67 12.62 14.75 12 14.75ZM12 2.75C9.11 2.75 6.75 5.11 6.75 8C6.75 8.67 6.87 9.32 7.12 9.93C7.73 11.46 9.03 12.63 10.62 13.06C11.5 13.3 12.52 13.3 13.38 13.06C14.97 12.63 16.28 11.45 16.88 9.93C17.12 9.32 17.25 8.67 17.25 8C17.25 5.11 14.89 2.75 12 2.75Z" fill="currentColor"/><path d="M16 22.7497C14.33 22.7497 12.73 22.1297 11.5 21.0197C11.34 20.8797 11.25 20.6697 11.25 20.4597C11.25 20.2497 11.34 20.0397 11.5 19.8997C12.61 18.9197 13.25 17.4997 13.25 15.9997C13.25 15.3297 13.13 14.6797 12.88 14.0697C12.8 13.8697 12.81 13.6497 12.91 13.4597C13.01 13.2697 13.18 13.1297 13.38 13.0697C14.97 12.6397 16.27 11.4697 16.88 9.93973C17.02 9.57973 17.41 9.39973 17.77 9.48973C20.7 10.2897 22.74 12.9597 22.74 15.9997C22.75 19.7197 19.72 22.7497 16 22.7497ZM13.12 20.3897C13.97 20.9497 14.96 21.2497 16 21.2497C18.89 21.2497 21.25 18.8897 21.25 15.9997C21.25 13.8497 19.93 11.9297 17.98 11.1297C17.24 12.5397 16 13.6597 14.52 14.2597C14.67 14.8197 14.75 15.4097 14.75 15.9997C14.75 17.6197 14.17 19.1797 13.12 20.3897Z" fill="currentColor"/></svg>`,
  // компанія фігурок — для кнопки показу й для гайда
  figures: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path opacity="0.4" d="M17.53 7.77C17.46 7.76 17.39 7.76 17.32 7.77C15.77 7.72 14.54 6.45 14.54 4.89C14.54 3.3 15.83 2 17.43 2C19.02 2 20.32 3.29 20.32 4.89C20.31 6.45 19.08 7.72 17.53 7.77Z" fill="currentColor"/><path opacity="0.4" d="M20.79 14.7004C19.67 15.4504 18.1 15.7304 16.65 15.5404C17.03 14.7204 17.23 13.8104 17.24 12.8504C17.24 11.8504 17.02 10.9004 16.6 10.0704C18.08 9.8704 19.65 10.1504 20.78 10.9004C22.36 11.9404 22.36 13.6504 20.79 14.7004Z" fill="currentColor"/><path opacity="0.4" d="M6.44002 7.77C6.51002 7.76 6.58002 7.76 6.65002 7.77C8.20002 7.72 9.43002 6.45 9.43002 4.89C9.43002 3.3 8.14002 2 6.54002 2C4.95002 2 3.65002 3.29 3.65002 4.89C3.66002 6.45 4.89002 7.72 6.44002 7.77Z" fill="currentColor"/><path opacity="0.4" d="M6.54999 12.8496C6.54999 13.8196 6.75999 14.7396 7.13999 15.5696C5.72999 15.7196 4.26 15.4196 3.18 14.7096C1.6 13.6596 1.6 11.9496 3.18 10.8996C4.25 10.1796 5.75999 9.88962 7.18 10.0496C6.77 10.8896 6.54999 11.8396 6.54999 12.8496Z" fill="currentColor"/><path d="M12.12 15.87C12.04 15.86 11.95 15.86 11.86 15.87C10.02 15.81 8.54999 14.3 8.54999 12.44C8.54999 10.54 10.08 9 11.99 9C13.89 9 15.43 10.54 15.43 12.44C15.43 14.3 13.97 15.81 12.12 15.87Z" fill="currentColor"/><path d="M8.86999 17.9396C7.35999 18.9496 7.35999 20.6096 8.86999 21.6096C10.59 22.7596 13.41 22.7596 15.13 21.6096C16.64 20.5996 16.64 18.9396 15.13 17.9396C13.42 16.7896 10.6 16.7896 8.86999 17.9396Z" fill="currentColor"/></svg>`,
  flipY: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M9.00994 21.2497C8.81994 21.2497 8.62994 21.1797 8.47994 21.0297L3.46994 16.0197C3.17994 15.7297 3.17994 15.2497 3.46994 14.9597C3.75994 14.6697 4.23994 14.6697 4.52994 14.9597L9.53994 19.9697C9.82994 20.2597 9.82994 20.7397 9.53994 21.0297C9.38994 21.1697 9.19994 21.2497 9.00994 21.2497Z" fill="currentColor"/><path d="M9.01001 21.25C8.60001 21.25 8.26001 20.91 8.26001 20.5V3.5C8.26001 3.09 8.60001 2.75 9.01001 2.75C9.42001 2.75 9.76001 3.09 9.76001 3.5V20.5C9.76001 20.91 9.42001 21.25 9.01001 21.25Z" fill="currentColor"/><path d="M20.0099 9.26043C19.8199 9.26043 19.6299 9.19043 19.4799 9.04043L14.4699 4.03043C14.1799 3.74043 14.1799 3.26043 14.4699 2.97043C14.7599 2.68043 15.2399 2.68043 15.5299 2.97043L20.5399 7.98043C20.8299 8.27043 20.8299 8.75043 20.5399 9.04043C20.3899 9.19043 20.1999 9.26043 20.0099 9.26043Z" fill="currentColor"/><path d="M14.99 21.25C14.58 21.25 14.24 20.91 14.24 20.5V3.5C14.24 3.09 14.58 2.75 14.99 2.75C15.4 2.75 15.74 3.09 15.74 3.5V20.5C15.74 20.91 15.41 21.25 14.99 21.25Z" fill="currentColor"/></svg>`,
  flipX: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M20.5002 14.9902L15.4902 20.0102" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" /><path d="M3.5 14.9902H20.5" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" /><path d="M3.5 9.01023L8.51 3.99023" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" /><path d="M20.5 9.00977H3.5" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" /></svg>`,
  star: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M15.39 5.21L16.7999 8.02999C16.9899 8.41999 17.4999 8.78999 17.9299 8.86999L20.48 9.28999C22.11 9.55999 22.49 10.74 21.32 11.92L19.3299 13.91C18.9999 14.24 18.81 14.89 18.92 15.36L19.4899 17.82C19.9399 19.76 18.9 20.52 17.19 19.5L14.7999 18.08C14.3699 17.82 13.65 17.82 13.22 18.08L10.8299 19.5C9.11994 20.51 8.07995 19.76 8.52995 17.82L9.09996 15.36C9.20996 14.9 9.01995 14.25 8.68995 13.91L6.69996 11.92C5.52996 10.75 5.90996 9.56999 7.53996 9.28999L10.0899 8.86999C10.5199 8.79999 11.03 8.41999 11.22 8.02999L12.63 5.21C13.38 3.68 14.62 3.68 15.39 5.21Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><path d="M8 5H2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><path d="M5 19H2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><path d="M3 12H2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>`,
  settings: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 15.75C9.93 15.75 8.25 14.07 8.25 12C8.25 9.93 9.93 8.25 12 8.25C14.07 8.25 15.75 9.93 15.75 12C15.75 14.07 14.07 15.75 12 15.75ZM12 9.75C10.76 9.75 9.75 10.76 9.75 12C9.75 13.24 10.76 14.25 12 14.25C13.24 14.25 14.25 13.24 14.25 12C14.25 10.76 13.24 9.75 12 9.75Z" fill="currentColor"/><path d="M15.21 22.1903C15 22.1903 14.79 22.1603 14.58 22.1103C13.96 21.9403 13.44 21.5503 13.11 21.0003L12.99 20.8003C12.4 19.7803 11.59 19.7803 11 20.8003L10.89 20.9903C10.56 21.5503 10.04 21.9503 9.42 22.1103C8.79 22.2803 8.14 22.1903 7.59 21.8603L5.87 20.8703C5.26 20.5203 4.82 19.9503 4.63 19.2603C4.45 18.5703 4.54 17.8603 4.89 17.2503C5.18 16.7403 5.26 16.2803 5.09 15.9903C4.92 15.7003 4.49 15.5303 3.9 15.5303C2.44 15.5303 1.25 14.3403 1.25 12.8803V11.1203C1.25 9.66029 2.44 8.47029 3.9 8.47029C4.49 8.47029 4.92 8.30029 5.09 8.01029C5.26 7.72029 5.19 7.26029 4.89 6.75029C4.54 6.14029 4.45 5.42029 4.63 4.74029C4.81 4.05029 5.25 3.48029 5.87 3.13029L7.6 2.14029C8.73 1.47029 10.22 1.86029 10.9 3.01029L11.02 3.21029C11.61 4.23029 12.42 4.23029 13.01 3.21029L13.12 3.02029C13.8 1.86029 15.29 1.47029 16.43 2.15029L18.15 3.14029C18.76 3.49029 19.2 4.06029 19.39 4.75029C19.57 5.44029 19.48 6.15029 19.13 6.76029C18.84 7.27029 18.76 7.73029 18.93 8.02029C19.1 8.31029 19.53 8.48029 20.12 8.48029C21.58 8.48029 22.77 9.67029 22.77 11.1303V12.8903C22.77 14.3503 21.58 15.5403 20.12 15.5403C19.53 15.5403 19.1 15.7103 18.93 16.0003C18.76 16.2903 18.83 16.7503 19.13 17.2603C19.48 17.8703 19.58 18.5903 19.39 19.2703C19.21 19.9603 18.77 20.5303 18.15 20.8803L16.42 21.8703C16.04 22.0803 15.63 22.1903 15.21 22.1903ZM12 18.4903C12.89 18.4903 13.72 19.0503 14.29 20.0403L14.4 20.2303C14.52 20.4403 14.72 20.5903 14.96 20.6503C15.2 20.7103 15.44 20.6803 15.64 20.5603L17.37 19.5603C17.63 19.4103 17.83 19.1603 17.91 18.8603C17.99 18.5603 17.95 18.2503 17.8 17.9903C17.23 17.0103 17.16 16.0003 17.6 15.2303C18.04 14.4603 18.95 14.0203 20.09 14.0203C20.73 14.0203 21.24 13.5103 21.24 12.8703V11.1103C21.24 10.4803 20.73 9.96029 20.09 9.96029C18.95 9.96029 18.04 9.52029 17.6 8.75029C17.16 7.98029 17.23 6.97029 17.8 5.99029C17.95 5.73029 17.99 5.42029 17.91 5.12029C17.83 4.82029 17.64 4.58029 17.38 4.42029L15.65 3.43029C15.22 3.17029 14.65 3.32029 14.39 3.76029L14.28 3.95029C13.71 4.94029 12.88 5.50029 11.99 5.50029C11.1 5.50029 10.27 4.94029 9.7 3.95029L9.59 3.75029C9.34 3.33029 8.78 3.18029 8.35 3.43029L6.62 4.43029C6.36 4.58029 6.16 4.83029 6.08 5.13029C6 5.43029 6.04 5.74029 6.19 6.00029C6.76 6.98029 6.83 7.99029 6.39 8.76029C5.95 9.53029 5.04 9.97029 3.9 9.97029C3.26 9.97029 2.75 10.4803 2.75 11.1203V12.8803C2.75 13.5103 3.26 14.0303 3.9 14.0303C5.04 14.0303 5.95 14.4703 6.39 15.2403C6.83 16.0103 6.76 17.0203 6.19 18.0003C6.04 18.2603 6 18.5703 6.08 18.8703C6.16 19.1703 6.35 19.4103 6.61 19.5703L8.34 20.5603C8.55 20.6903 8.8 20.7203 9.03 20.6603C9.27 20.6003 9.47 20.4403 9.6 20.2303L9.71 20.0403C10.28 19.0603 11.11 18.4903 12 18.4903Z" fill="currentColor"/></svg>`,
  dots: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M5 14.75C3.48 14.75 2.25 13.52 2.25 12C2.25 10.48 3.48 9.25 5 9.25C6.52 9.25 7.75 10.48 7.75 12C7.75 13.52 6.52 14.75 5 14.75ZM5 10.75C4.31 10.75 3.75 11.31 3.75 12C3.75 12.69 4.31 13.25 5 13.25C5.69 13.25 6.25 12.69 6.25 12C6.25 11.31 5.69 10.75 5 10.75Z" fill="currentColor"/><path d="M19 14.75C17.48 14.75 16.25 13.52 16.25 12C16.25 10.48 17.48 9.25 19 9.25C20.52 9.25 21.75 10.48 21.75 12C21.75 13.52 20.52 14.75 19 14.75ZM19 10.75C18.31 10.75 17.75 11.31 17.75 12C17.75 12.69 18.31 13.25 19 13.25C19.69 13.25 20.25 12.69 20.25 12C20.25 11.31 19.69 10.75 19 10.75Z" fill="currentColor"/><path d="M12 14.75C10.48 14.75 9.25 13.52 9.25 12C9.25 10.48 10.48 9.25 12 9.25C13.52 9.25 14.75 10.48 14.75 12C14.75 13.52 13.52 14.75 12 14.75ZM12 10.75C11.31 10.75 10.75 11.31 10.75 12C10.75 12.69 11.31 13.25 12 13.25C12.69 13.25 13.25 12.69 13.25 12C13.25 11.31 12.69 10.75 12 10.75Z" fill="currentColor"/></svg>`,
  flag: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M5.1499 22.75C4.7399 22.75 4.3999 22.41 4.3999 22V2C4.3999 1.59 4.7399 1.25 5.1499 1.25C5.5599 1.25 5.8999 1.59 5.8999 2V22C5.8999 22.41 5.5599 22.75 5.1499 22.75Z" fill="currentColor"/><path d="M16.3499 16.75H5.1499C4.7399 16.75 4.3999 16.41 4.3999 16C4.3999 15.59 4.7399 15.25 5.1499 15.25H16.3499C17.4399 15.25 17.9499 14.96 18.0499 14.71C18.1499 14.46 17.9999 13.9 17.2199 13.13L16.0199 11.93C15.5299 11.5 15.2299 10.85 15.1999 10.13C15.1699 9.37 15.4699 8.62 16.0199 8.07L17.2199 6.87C17.9599 6.13 18.1899 5.53 18.0799 5.27C17.9699 5.01 17.3999 4.75 16.3499 4.75H5.1499C4.7299 4.75 4.3999 4.41 4.3999 4C4.3999 3.59 4.7399 3.25 5.1499 3.25H16.3499C18.5399 3.25 19.2399 4.16 19.4699 4.7C19.6899 5.24 19.8399 6.38 18.2799 7.94L17.0799 9.14C16.8299 9.39 16.6899 9.74 16.6999 10.09C16.7099 10.39 16.8299 10.66 17.0399 10.85L18.2799 12.08C19.8099 13.61 19.6599 14.75 19.4399 15.3C19.2099 15.83 18.4999 16.75 16.3499 16.75Z" fill="currentColor"/></svg>`,
  bgPanel: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M8 22.7494C4.28 22.7494 1.25 19.7194 1.25 15.9994C1.25 12.9594 3.29 10.2794 6.22 9.4894C6.59 9.3894 6.97 9.5794 7.11 9.9394C7.72 11.4694 9.02 12.6394 10.61 13.0694C11.49 13.3094 12.51 13.3094 13.37 13.0694C13.74 12.9694 14.13 13.1594 14.27 13.5194C14.58 14.3094 14.74 15.1494 14.74 16.0094C14.74 17.9294 13.92 19.7594 12.49 21.0294C11.27 22.1294 9.67 22.7494 8 22.7494ZM6.02 11.1294C4.07 11.9294 2.75 13.8494 2.75 15.9994C2.75 18.8894 5.11 21.2494 8 21.2494C9.3 21.2494 10.54 20.7694 11.5 19.8994C12.62 18.9094 13.25 17.4894 13.25 15.9994C13.25 15.5394 13.19 15.0994 13.08 14.6694C12.14 14.8194 11.12 14.7694 10.22 14.5194C8.41 14.0194 6.89 12.7794 6.02 11.1294Z" fill="currentColor"/><path d="M12 14.75C11.38 14.75 10.78 14.67 10.22 14.51C8.19 13.95 6.5 12.45 5.72 10.48C5.41 9.7 5.25 8.86 5.25 8C5.25 4.28 8.28 1.25 12 1.25C15.72 1.25 18.75 4.28 18.75 8C18.75 8.86 18.59 9.7 18.28 10.49C17.5 12.45 15.82 13.96 13.78 14.52C13.22 14.67 12.62 14.75 12 14.75ZM12 2.75C9.11 2.75 6.75 5.11 6.75 8C6.75 8.67 6.87 9.32 7.12 9.93C7.73 11.46 9.03 12.63 10.62 13.06C11.5 13.3 12.52 13.3 13.38 13.06C14.97 12.63 16.28 11.45 16.88 9.93C17.12 9.32 17.25 8.67 17.25 8C17.25 5.11 14.89 2.75 12 2.75Z" fill="currentColor"/><path d="M16 22.7497C14.33 22.7497 12.73 22.1297 11.5 21.0197C11.34 20.8797 11.25 20.6697 11.25 20.4597C11.25 20.2497 11.34 20.0397 11.5 19.8997C12.61 18.9197 13.25 17.4997 13.25 15.9997C13.25 15.3297 13.13 14.6797 12.88 14.0697C12.8 13.8697 12.81 13.6497 12.91 13.4597C13.01 13.2697 13.18 13.1297 13.38 13.0697C14.97 12.6397 16.27 11.4697 16.88 9.93973C17.02 9.57973 17.41 9.39973 17.77 9.48973C20.7 10.2897 22.74 12.9597 22.74 15.9997C22.75 19.7197 19.72 22.7497 16 22.7497ZM13.12 20.3897C13.97 20.9497 14.96 21.2497 16 21.2497C18.89 21.2497 21.25 18.8897 21.25 15.9997C21.25 13.8497 19.93 11.9297 17.98 11.1297C17.24 12.5397 16 13.6597 14.52 14.2597C14.67 14.8197 14.75 15.4097 14.75 15.9997C14.75 17.6197 14.17 19.1797 13.12 20.3897Z" fill="currentColor"/></svg>`,
  reset: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M14.55 22.42C14.22 22.42 13.91 22.2 13.82 21.86C13.71 21.46 13.95 21.05 14.36 20.94C18.42 19.87 21.25 16.19 21.25 11.99C21.25 6.89 17.1 2.74 12 2.74C7.67 2.74 4.83 5.27 3.5 6.8H6.44C6.85 6.8 7.19 7.14 7.19 7.55C7.19 7.96 6.86 8.31 6.44 8.31H2.01C1.96 8.31 1.87 8.3 1.8 8.28C1.71 8.25 1.63 8.21 1.56 8.16C1.47 8.1 1.4 8.02 1.35 7.93C1.3 7.84 1.26 7.73 1.25 7.62C1.25 7.59 1.25 7.57 1.25 7.54V3C1.25 2.59 1.59 2.25 2 2.25C2.41 2.25 2.75 2.59 2.75 3V5.39C4.38 3.64 7.45 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 16.88 19.46 21.16 14.74 22.4C14.68 22.41 14.61 22.42 14.55 22.42Z" fill="currentColor"/><path d="M11.29 22.73C11.27 22.73 11.25 22.72 11.24 22.72C10.16 22.65 9.1 22.41 8.1 22.02C7.81 21.91 7.61 21.62 7.62 21.31C7.62 21.22 7.64 21.13 7.67 21.05C7.82 20.67 8.27 20.48 8.64 20.62C9.51 20.96 10.42 21.16 11.34 21.23C11.73 21.25 12.04 21.59 12.04 21.99L12.03 22.03C12.01 22.42 11.68 22.73 11.29 22.73ZM5.78 20.58C5.61 20.58 5.45 20.52 5.31 20.42C4.47 19.74 3.73 18.95 3.13 18.07C3.04 17.94 2.99 17.8 2.99 17.65C2.99 17.4 3.11 17.17 3.32 17.03C3.65 16.8 4.13 16.89 4.36 17.21C4.36 17.22 4.36 17.22 4.36 17.22C4.37 17.23 4.38 17.25 4.39 17.26C4.91 18.01 5.54 18.68 6.25 19.24C6.42 19.38 6.53 19.59 6.53 19.82C6.53 19.99 6.48 20.16 6.37 20.3C6.22 20.48 6.01 20.58 5.78 20.58ZM2.44 15.7C2.11 15.7 1.82 15.49 1.73 15.18C1.41 14.15 1.25 13.08 1.25 12V11.99C1.26 11.58 1.59 11.25 2 11.25C2.41 11.25 2.75 11.59 2.75 12C2.75 12.94 2.89 13.86 3.16 14.73C3.18 14.81 3.19 14.88 3.19 14.96C3.19 15.28 2.98 15.57 2.66 15.67C2.59 15.69 2.52 15.7 2.44 15.7Z" fill="currentColor"/></svg>`,
  undo: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M15.13 19.0596H7.13C6.72 19.0596 6.38 18.7196 6.38 18.3096C6.38 17.8996 6.72 17.5596 7.13 17.5596H15.13C17.47 17.5596 19.38 15.6496 19.38 13.3096C19.38 10.9696 17.47 9.05957 15.13 9.05957H4.13C3.72 9.05957 3.38 8.71957 3.38 8.30957C3.38 7.89957 3.72 7.55957 4.13 7.55957H15.13C18.3 7.55957 20.88 10.1396 20.88 13.3096C20.88 16.4796 18.3 19.0596 15.13 19.0596Z" fill="currentColor"/><path d="M6.43006 11.5599C6.24006 11.5599 6.05006 11.4899 5.90006 11.3399L3.34006 8.77988C3.05006 8.48988 3.05006 8.00988 3.34006 7.71988L5.90006 5.15988C6.19006 4.86988 6.67006 4.86988 6.96006 5.15988C7.25006 5.44988 7.25006 5.92988 6.96006 6.21988L4.93006 8.24988L6.96006 10.2799C7.25006 10.5699 7.25006 11.0499 6.96006 11.3399C6.82006 11.4899 6.62006 11.5599 6.43006 11.5599Z" fill="currentColor"/></svg>`,
  redo: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M16.87 19.0596H8.87C5.7 19.0596 3.12 16.4796 3.12 13.3096C3.12 10.1396 5.7 7.55957 8.87 7.55957H19.87C20.28 7.55957 20.62 7.89957 20.62 8.30957C20.62 8.71957 20.28 9.05957 19.87 9.05957H8.87C6.53 9.05957 4.62 10.9696 4.62 13.3096C4.62 15.6496 6.53 17.5596 8.87 17.5596H16.87C17.28 17.5596 17.62 17.8996 17.62 18.3096C17.62 18.7196 17.29 19.0596 16.87 19.0596Z" fill="currentColor"/><path d="M17.57 11.5599C17.38 11.5599 17.19 11.4899 17.04 11.3399C16.75 11.0499 16.75 10.5699 17.04 10.2799L19.07 8.24988L17.04 6.21988C16.75 5.92988 16.75 5.44988 17.04 5.15988C17.33 4.86988 17.81 4.86988 18.1 5.15988L20.66 7.71988C20.95 8.00988 20.95 8.48988 20.66 8.77988L18.1 11.3399C17.95 11.4899 17.76 11.5599 17.57 11.5599Z" fill="currentColor"/></svg>`,
  alignLeft: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 5.25H3C2.59 5.25 2.25 4.91 2.25 4.5C2.25 4.09 2.59 3.75 3 3.75H12C12.41 3.75 12.75 4.09 12.75 4.5C12.75 4.91 12.41 5.25 12 5.25Z" fill="currentColor"/><path d="M12 10.25H3C2.59 10.25 2.25 9.91 2.25 9.5C2.25 9.09 2.59 8.75 3 8.75H12C12.41 8.75 12.75 9.09 12.75 9.5C12.75 9.91 12.41 10.25 12 10.25Z" fill="currentColor"/><path d="M21 15.25H3C2.59 15.25 2.25 14.91 2.25 14.5C2.25 14.09 2.59 13.75 3 13.75H21C21.41 13.75 21.75 14.09 21.75 14.5C21.75 14.91 21.41 15.25 21 15.25Z" fill="currentColor"/><path d="M21 20.25H3C2.59 20.25 2.25 19.91 2.25 19.5C2.25 19.09 2.59 18.75 3 18.75H21C21.41 18.75 21.75 19.09 21.75 19.5C21.75 19.91 21.41 20.25 21 20.25Z" fill="currentColor"/></svg>`,
  alignRight: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 4.5H21" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><path d="M12 9.5H21" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><path d="M3 14.5H21" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><path d="M3 19.5H21" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>`,
  alignCenter: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M21 5.25H3C2.59 5.25 2.25 4.91 2.25 4.5C2.25 4.09 2.59 3.75 3 3.75H21C21.41 3.75 21.75 4.09 21.75 4.5C21.75 4.91 21.41 5.25 21 5.25Z" fill="currentColor"/><path d="M16.74 10.25H7.26001C6.85001 10.25 6.51001 9.91 6.51001 9.5C6.51001 9.09 6.85001 8.75 7.26001 8.75H16.73C17.14 8.75 17.48 9.09 17.48 9.5C17.48 9.91 17.15 10.25 16.74 10.25Z" fill="currentColor"/><path d="M21 15.25H3C2.59 15.25 2.25 14.91 2.25 14.5C2.25 14.09 2.59 13.75 3 13.75H21C21.41 13.75 21.75 14.09 21.75 14.5C21.75 14.91 21.41 15.25 21 15.25Z" fill="currentColor"/><path d="M16.74 20.25H7.26001C6.85001 20.25 6.51001 19.91 6.51001 19.5C6.51001 19.09 6.85001 18.75 7.26001 18.75H16.73C17.14 18.75 17.48 19.09 17.48 19.5C17.48 19.91 17.15 20.25 16.74 20.25Z" fill="currentColor"/></svg>`,
  trimSides: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><g transform="rotate(90 12 12)"><path d="M21 22.75H3C2.59 22.75 2.25 22.41 2.25 22C2.25 21.59 2.59 21.25 3 21.25H21C21.41 21.25 21.75 21.59 21.75 22C21.75 22.41 21.41 22.75 21 22.75Z" fill="currentColor"/><path d="M21 2.75H3C2.59 2.75 2.25 2.41 2.25 2C2.25 1.59 2.59 1.25 3 1.25H21C21.41 1.25 21.75 1.59 21.75 2C21.75 2.41 21.41 2.75 21 2.75Z" fill="currentColor"/><path d="M12 18.75C11.59 18.75 11.25 18.41 11.25 18V6C11.25 5.59 11.59 5.25 12 5.25C12.41 5.25 12.75 5.59 12.75 6V18C12.75 18.41 12.41 18.75 12 18.75Z" fill="currentColor"/><path d="M14.8301 8.47039C14.6401 8.47039 14.4501 8.40039 14.3001 8.25039L12.0001 5.95039L9.70011 8.25039C9.41011 8.54039 8.93011 8.54039 8.64011 8.25039C8.35011 7.96039 8.35011 7.48039 8.64011 7.19039L11.4701 4.36039C11.7501 4.08039 12.2501 4.08039 12.5301 4.36039L15.3601 7.19039C15.6501 7.48039 15.6501 7.96039 15.3601 8.25039C15.2101 8.40039 15.0201 8.47039 14.8301 8.47039Z" fill="currentColor"/><path d="M12.0001 19.4701C11.8001 19.4701 11.6101 19.3901 11.4701 19.2501L8.64011 16.4201C8.35011 16.1301 8.35011 15.6501 8.64011 15.3601C8.93011 15.0701 9.41011 15.0701 9.70011 15.3601L12.0001 17.6601L14.3001 15.3601C14.5901 15.0701 15.0701 15.0701 15.3601 15.3601C15.6501 15.6501 15.6501 16.1301 15.3601 16.4201L12.5301 19.2501C12.3901 19.3901 12.2001 19.4701 12.0001 19.4701Z" fill="currentColor"/></g></svg>`,
  xFilled: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path opacity="0.4" d="M14.9 2H9.10001C8.42001 2 7.46 2.4 6.98 2.88L2.88 6.98001C2.4 7.46001 2 8.42001 2 9.10001V14.9C2 15.58 2.4 16.54 2.88 17.02L6.98 21.12C7.46 21.6 8.42001 22 9.10001 22H14.9C15.58 22 16.54 21.6 17.02 21.12L21.12 17.02C21.6 16.54 22 15.58 22 14.9V9.10001C22 8.42001 21.6 7.46001 21.12 6.98001L17.02 2.88C16.54 2.4 15.58 2 14.9 2Z" fill="currentColor"/><path d="M13.0599 11.9995L16.0299 9.02945C16.3199 8.73945 16.3199 8.25945 16.0299 7.96945C15.7399 7.67945 15.2599 7.67945 14.9699 7.96945L11.9999 10.9395L9.02994 7.96945C8.73994 7.67945 8.25994 7.67945 7.96994 7.96945C7.67994 8.25945 7.67994 8.73945 7.96994 9.02945L10.9399 11.9995L7.96994 14.9695C7.67994 15.2595 7.67994 15.7395 7.96994 16.0295C8.11994 16.1795 8.30994 16.2495 8.49994 16.2495C8.68994 16.2495 8.87994 16.1795 9.02994 16.0295L11.9999 13.0594L14.9699 16.0295C15.1199 16.1795 15.3099 16.2495 15.4999 16.2495C15.6899 16.2495 15.8799 16.1795 16.0299 16.0295C16.3199 15.7395 16.3199 15.2595 16.0299 14.9695L13.0599 11.9995Z" fill="currentColor"/></svg>`,
  close: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M14.9 2H9.10001C8.42001 2 7.46 2.4 6.98 2.88L2.88 6.98001C2.4 7.46001 2 8.42001 2 9.10001V14.9C2 15.58 2.4 16.54 2.88 17.02L6.98 21.12C7.46 21.6 8.42001 22 9.10001 22H14.9C15.58 22 16.54 21.6 17.02 21.12L21.12 17.02C21.6 16.54 22 15.58 22 14.9V9.10001C22 8.42001 21.6 7.46001 21.12 6.98001L17.02 2.88C16.54 2.4 15.58 2 14.9 2Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><path d="M8.5 15.5L15.5 8.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><path d="M15.5 15.5L8.5 8.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>`,
  percent: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M8.57007 15.2704L15.11 8.73047" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><path d="M8.98001 10.3701C9.65932 10.3701 10.21 9.81948 10.21 9.14017C10.21 8.46086 9.65932 7.91016 8.98001 7.91016C8.3007 7.91016 7.75 8.46086 7.75 9.14017C7.75 9.81948 8.3007 10.3701 8.98001 10.3701Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><path d="M15.52 16.0899C16.1993 16.0899 16.75 15.5392 16.75 14.8599C16.75 14.1806 16.1993 13.6299 15.52 13.6299C14.8407 13.6299 14.29 14.1806 14.29 14.8599C14.29 15.5392 14.8407 16.0899 15.52 16.0899Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>`,
  toFront: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M16.97 12.25V16.75C16.97 20.5 15.47 22 11.72 22H7.21997C3.46997 22 1.96997 20.5 1.96997 16.75V12.25C1.96997 8.5 3.46997 7 7.21997 7H11.72C15.47 7 16.97 8.5 16.97 12.25Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><path d="M21.97 5.85V9.15C21.97 11.9 20.87 13 18.12 13H16.97V12.25C16.97 8.5 15.47 7 11.72 7H10.97V5.85C10.97 3.1 12.07 2 14.82 2H18.12C20.87 2 21.97 3.1 21.97 5.85Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>`,
  toBack: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M16.9702 12.25V16.75C16.9702 20.5 15.4702 22 11.7202 22H7.22021C3.47021 22 1.97021 20.5 1.97021 16.75V12.25C1.97021 8.5 3.47021 7 7.22021 7H11.7202C15.4702 7 16.9702 8.5 16.9702 12.25Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><path opacity="0.4" d="M21.9702 5.85V9.15C21.9702 11.9 20.8702 13 18.1202 13H16.9702V12.25C16.9702 8.5 15.4702 7 11.7202 7H10.9702V5.85C10.9702 3.1 12.0702 2 14.8202 2H18.1202C20.8702 2 21.9702 3.1 21.9702 5.85Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>`,
  removeBg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M8.3902 2.16992V8.61993H1.93018V7.93994C1.93018 4.32994 4.08019 2.17993 7.69019 2.17993H8.3902V2.16992Z" fill="currentColor"/><path d="M21.7703 7.93018C21.7703 8.31018 21.4603 8.61017 21.0903 8.61017H15.3403V2.16016H16.0103C19.1903 2.17016 21.7703 4.75018 21.7703 7.93018Z" fill="currentColor"/><path d="M8.39044 15.5508V21.3108C8.39044 21.6908 8.08042 21.9908 7.71042 21.9908H7.70044C4.52044 21.9908 1.94043 19.4108 1.94043 16.2308V15.5508H8.39044Z" fill="currentColor"/><path opacity="0.4" d="M8.40042 8.60938H1.94043V15.5494H8.40042V8.60938Z" fill="currentColor"/><path d="M15.3301 8.60938V14.8694C15.3301 15.2494 15.0201 15.5494 14.6501 15.5494H8.39014V8.60938H15.3301Z" fill="currentColor"/><path opacity="0.4" d="M15.3301 2.16992H8.39014V8.61993H15.3301V2.16992Z" fill="currentColor"/><path opacity="0.4" d="M19.7998 20.7009L17.8998 22.6109C17.3798 23.1309 16.5198 23.1309 15.9798 22.6109L14.3998 21.0209C13.8798 20.4909 13.8798 19.6409 14.3998 19.1009L16.3098 17.2109L19.7998 20.7009Z" fill="currentColor"/><path d="M22.61 17.9L19.8 20.7L16.3101 17.21L19.11 14.39C19.64 13.87 20.5001 13.87 21.0301 14.39L22.61 15.98C23.13 16.51 23.13 17.38 22.61 17.9Z" fill="currentColor"/></svg>`,
  strike: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 12H20" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><path d="M16 7.2C16 5.4 14.2 4 12 4C9.8 4 8 5.2 8 7C8 8.9 9.9 9.6 12 10.2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><path d="M8 16.8C8 18.6 9.8 20 12 20C14.2 20 16 18.8 16 17C16 15.7 15.1 14.9 13.6 14.4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>`,
  alignTop: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><g transform="rotate(90 12 12)"><path d="M12 5.25H3C2.59 5.25 2.25 4.91 2.25 4.5C2.25 4.09 2.59 3.75 3 3.75H12C12.41 3.75 12.75 4.09 12.75 4.5C12.75 4.91 12.41 5.25 12 5.25Z" fill="currentColor"/><path d="M12 10.25H3C2.59 10.25 2.25 9.91 2.25 9.5C2.25 9.09 2.59 8.75 3 8.75H12C12.41 8.75 12.75 9.09 12.75 9.5C12.75 9.91 12.41 10.25 12 10.25Z" fill="currentColor"/><path d="M21 15.25H3C2.59 15.25 2.25 14.91 2.25 14.5C2.25 14.09 2.59 13.75 3 13.75H21C21.41 13.75 21.75 14.09 21.75 14.5C21.75 14.91 21.41 15.25 21 15.25Z" fill="currentColor"/><path d="M21 20.25H3C2.59 20.25 2.25 19.91 2.25 19.5C2.25 19.09 2.59 18.75 3 18.75H21C21.41 18.75 21.75 19.09 21.75 19.5C21.75 19.91 21.41 20.25 21 20.25Z" fill="currentColor"/></g></svg>`,
  alignMiddle: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><g transform="rotate(90 12 12)"><path d="M21 5.25H3C2.59 5.25 2.25 4.91 2.25 4.5C2.25 4.09 2.59 3.75 3 3.75H21C21.41 3.75 21.75 4.09 21.75 4.5C21.75 4.91 21.41 5.25 21 5.25Z" fill="currentColor"/><path d="M16.74 10.25H7.26001C6.85001 10.25 6.51001 9.91 6.51001 9.5C6.51001 9.09 6.85001 8.75 7.26001 8.75H16.73C17.14 8.75 17.48 9.09 17.48 9.5C17.48 9.91 17.15 10.25 16.74 10.25Z" fill="currentColor"/><path d="M21 15.25H3C2.59 15.25 2.25 14.91 2.25 14.5C2.25 14.09 2.59 13.75 3 13.75H21C21.41 13.75 21.75 14.09 21.75 14.5C21.75 14.91 21.41 15.25 21 15.25Z" fill="currentColor"/><path d="M16.74 20.25H7.26001C6.85001 20.25 6.51001 19.91 6.51001 19.5C6.51001 19.09 6.85001 18.75 7.26001 18.75H16.73C17.14 18.75 17.48 19.09 17.48 19.5C17.48 19.91 17.15 20.25 16.74 20.25Z" fill="currentColor"/></g></svg>`,
  alignBottom: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" aria-hidden="true"><g transform="rotate(90 12 12)"><path d="M12 4.5H21" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><path d="M12 9.5H21" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><path d="M3 14.5H21" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><path d="M3 19.5H21" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></g></svg>`,
  arrowUp: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M18.0701 10.3204C17.8801 10.3204 17.6901 10.2504 17.5401 10.1004L12.0001 4.56043L6.46012 10.1004C6.17012 10.3904 5.69012 10.3904 5.40012 10.1004C5.11012 9.81043 5.11012 9.33043 5.40012 9.04043L11.4701 2.97043C11.7601 2.68043 12.2401 2.68043 12.5301 2.97043L18.6001 9.04043C18.8901 9.33043 18.8901 9.81043 18.6001 10.1004C18.4601 10.2504 18.2601 10.3204 18.0701 10.3204Z" fill="currentColor"/><path d="M12 21.2499C11.59 21.2499 11.25 20.9099 11.25 20.4999V3.66992C11.25 3.25992 11.59 2.91992 12 2.91992C12.41 2.91992 12.75 3.25992 12.75 3.66992V20.4999C12.75 20.9099 12.41 21.2499 12 21.2499Z" fill="currentColor"/></svg>`,
  plus: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 12H18" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><path d="M12 18V6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>`,
  userAdd: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><path d="M3.41016 22C3.41016 18.13 7.26015 15 12.0002 15C12.9602 15 13.8902 15.13 14.7602 15.37" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><path d="M22 18C22 18.32 21.96 18.63 21.88 18.93C21.79 19.33 21.63 19.72 21.42 20.06C20.73 21.22 19.46 22 18 22C16.97 22 16.04 21.61 15.34 20.97C15.04 20.71 14.78 20.4 14.58 20.06C14.21 19.46 14 18.75 14 18C14 16.92 14.43 15.93 15.13 15.21C15.86 14.46 16.88 14 18 14C19.18 14 20.25 14.51 20.97 15.33C21.61 16.04 22 16.98 22 18Z" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" /><path d="M19.4897 17.9795H16.5098" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" /><path d="M18 16.5195V19.5095" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" /></svg>`,
  cart: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M2 2H3.74001C4.82001 2 5.67 2.93 5.58 4L4.75 13.96C4.61 15.59 5.89999 16.99 7.53999 16.99H18.19C19.63 16.99 20.89 15.81 21 14.38L21.54 6.88C21.66 5.22 20.4 3.87 18.73 3.87H5.82001" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" /><path d="M16.25 22C16.9404 22 17.5 21.4404 17.5 20.75C17.5 20.0596 16.9404 19.5 16.25 19.5C15.5596 19.5 15 20.0596 15 20.75C15 21.4404 15.5596 22 16.25 22Z" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" /><path d="M8.25 22C8.94036 22 9.5 21.4404 9.5 20.75C9.5 20.0596 8.94036 19.5 8.25 19.5C7.55964 19.5 7 20.0596 7 20.75C7 21.4404 7.55964 22 8.25 22Z" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" /><path d="M9 8H21" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" /></svg>`,
  warning: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 9V14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><path d="M12.0001 21.4093H5.94005C2.47005 21.4093 1.02005 18.9293 2.70005 15.8993L5.82006 10.2793L8.76006 4.9993C10.5401 1.7893 13.4601 1.7893 15.2401 4.9993L18.1801 10.2893L21.3001 15.9093C22.9801 18.9393 21.5201 21.4193 18.0601 21.4193H12.0001V21.4093Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><path d="M11.9945 17H12.0035" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" /></svg>`,
  circleX: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><path d="M9.17004 14.8299L14.83 9.16992" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><path d="M14.83 14.8299L9.17004 9.16992" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>`,
  arrowDown: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><g transform="rotate(180 12 12)"><path d="M18.0701 10.3204C17.8801 10.3204 17.6901 10.2504 17.5401 10.1004L12.0001 4.56043L6.46012 10.1004C6.17012 10.3904 5.69012 10.3904 5.40012 10.1004C5.11012 9.81043 5.11012 9.33043 5.40012 9.04043L11.4701 2.97043C11.7601 2.68043 12.2401 2.68043 12.5301 2.97043L18.6001 9.04043C18.8901 9.33043 18.8901 9.81043 18.6001 10.1004C18.4601 10.2504 18.2601 10.3204 18.0701 10.3204Z" fill="currentColor"/><path d="M12 21.2499C11.59 21.2499 11.25 20.9099 11.25 20.4999V3.66992C11.25 3.25992 11.59 2.91992 12 2.91992C12.41 2.91992 12.75 3.25992 12.75 3.66992V20.4999C12.75 20.9099 12.41 21.2499 12 21.2499Z" fill="currentColor"/></g></svg>`,
  arrowLeft: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><g transform="rotate(-90 12 12)"><path d="M18.0701 10.3204C17.8801 10.3204 17.6901 10.2504 17.5401 10.1004L12.0001 4.56043L6.46012 10.1004C6.17012 10.3904 5.69012 10.3904 5.40012 10.1004C5.11012 9.81043 5.11012 9.33043 5.40012 9.04043L11.4701 2.97043C11.7601 2.68043 12.2401 2.68043 12.5301 2.97043L18.6001 9.04043C18.8901 9.33043 18.8901 9.81043 18.6001 10.1004C18.4601 10.2504 18.2601 10.3204 18.0701 10.3204Z" fill="currentColor"/><path d="M12 21.2499C11.59 21.2499 11.25 20.9099 11.25 20.4999V3.66992C11.25 3.25992 11.59 2.91992 12 2.91992C12.41 2.91992 12.75 3.25992 12.75 3.66992V20.4999C12.75 20.9099 12.41 21.2499 12 21.2499Z" fill="currentColor"/></g></svg>`,
  arrowRight: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><g transform="rotate(90 12 12)"><path d="M18.0701 10.3204C17.8801 10.3204 17.6901 10.2504 17.5401 10.1004L12.0001 4.56043L6.46012 10.1004C6.17012 10.3904 5.69012 10.3904 5.40012 10.1004C5.11012 9.81043 5.11012 9.33043 5.40012 9.04043L11.4701 2.97043C11.7601 2.68043 12.2401 2.68043 12.5301 2.97043L18.6001 9.04043C18.8901 9.33043 18.8901 9.81043 18.6001 10.1004C18.4601 10.2504 18.2601 10.3204 18.0701 10.3204Z" fill="currentColor"/><path d="M12 21.2499C11.59 21.2499 11.25 20.9099 11.25 20.4999V3.66992C11.25 3.25992 11.59 2.91992 12 2.91992C12.41 2.91992 12.75 3.25992 12.75 3.66992V20.4999C12.75 20.9099 12.41 21.2499 12 21.2499Z" fill="currentColor"/></g></svg>`,
};
function feIco(name, cls) {
  const s = FE_ICO[name];
  if (!s) return '';
  return '<i class="fe-i' + (cls ? ' ' + cls : '') + '">' + s + '</i>';
}

// ============================================================
// ХЕЛПЕРИ UI
// ============================================================
function fePagedGrid(items, page, per, setterFn, renderItem, cols) {
  const totalPages = Math.max(1, Math.ceil(items.length / per));
  const p = Math.min(page, totalPages - 1);
  let h = `<div class="fe-grid ${cols === 3 ? 'g3' : cols === 2 ? 'g2' : cols === 5 ? 'g5' : ''}">`;
  items.slice(p * per, p * per + per).forEach(it => h += renderItem(it));
  h += '</div>';
  if (totalPages > 1) {
    h += `<div class="fe-pager">
      <button ${p === 0 ? 'disabled' : ''} onclick="${setterFn}(${p - 1})">←</button>
      <span>${p + 1} / ${totalPages}</span>
      <button ${p === totalPages - 1 ? 'disabled' : ''} onclick="${setterFn}(${p + 1})">→</button></div>`;
  }
  return h;
}
// Плитка аксесуара: показуємо обрізане превʼю, домальовуючи його після
// вставки розмітки. На спільному полотні 2500×3084 сам предмет займає
// третину, тому без обрізки в плитці він виглядав крихітним.
const FE_ACC_THUMBS = {};
function feAccTile(url, id) {
  const ready = FE_ACC_THUMBS[id];
  setTimeout(() => feFillAccThumb(url, id), 0);
  return '<div class="fe-tile-img fe-item-img" id="fe-ath-' + id + '">'
       + (ready ? '<img src="' + ready + '" alt="">' : '') + '</div>';
}
async function feFillAccThumb(url, id) {
  if (!url || FE_ACC_THUMBS[id]) return;
  const box = document.getElementById('fe-ath-' + id);
  if (!box) return;                       // плитки вже немає на екрані
  try {
    const r = await feTrimUrl(url, FE_THUMB_PX);
    FE_ACC_THUMBS[id] = r.url;
    const still = document.getElementById('fe-ath-' + id);
    if (still) still.innerHTML = '<img src="' + r.url + '" alt="">';
  } catch (e) {}
}
function feZoomTile(url, z) {
  z = z || {};
  return `<div class="fe-tile-img"><img src="${feSpx(url, FE_SPRITE_PX)}" style="top:${z.top != null ? z.top : -30}%;
    transform:scale(${z.scale || 3.2});transform-origin:${z.origin || '50% 38%'}"></div>`;
}
// рядок-слайдер
// Значення поруч із повзунком — не просто підпис, а поле: число можна
// вписати вручну, коли треба точно, а не «на око».
function feSlider(label, id, min, max, step, val, fn, unit, opts) {
  opts = opts || {};
  const ev = opts.onRelease ? 'onchange' : 'oninput';
  const sync = `feSyncNum('${id}',this.value)`;
  const live = opts.onRelease ? `oninput="${sync}"` : '';
  return `<div class="fe-row">
    <div class="fe-row-head"><span>${label}</span>
      <span class="fe-row-val">
        <input class="fe-num" type="number" id="${id}-v" value="${val}"
          min="${min}" max="${max}" step="${step}" ${opts.dis ? 'disabled' : ''}
          onchange="feNumApply('${id}','${fn}',this.value)"
          onkeydown="if(event.key==='Enter'){this.blur();}">${unit === '%' ? feIco('percent', 'pct') : unit ? `<i>${unit}</i>` : ''}
      </span></div>
    <input type="range" class="fe-range${opts.dis ? ' off' : ''}" ${opts.dis ? 'disabled' : ''}
      id="${id}" min="${min}" max="${max}" step="${step}" value="${val}"
      ${live} ${ev}="${fn}(this.value); ${sync}">
  </div>`;
}
// Полотно → панель: поки тягнеш обʼєкт мишею чи пальцем, числа не мають
// відставати. Оновлюємо тільки значення, панель не перемальовуємо.
function feSyncPanelNums(o) {
  if (!o || feActiveTool !== 'props') return;
  const set = (id, v) => {
    const r = document.getElementById(id);
    if (r) r.value = v;
    feSyncNum(id, v);
  };
  const ang = document.getElementById('fe-p-ang');
  if (ang && document.activeElement !== ang) ang.value = Math.round(o.angle || 0);
  if (feIsLineLike(o)) {
    set('fe-p-len', Math.round((o.width || 1) * Math.abs(o.scaleX || 1)));
    set('fe-p-th', Math.round(feLineVisThick(o) * 2) / 2);
  }
  if (o._feKind === 'photoframe' && o.type === 'image') {
    set('fe-fr-z', Math.round((o._feZoom || 1) * 100));
  }
}
// повзунок → поле
function feSyncNum(id, v) {
  const e = document.getElementById(id + '-v');
  if (e && document.activeElement !== e) e.value = v;
}
// поле → повзунок і сам обʼєкт
function feNumApply(id, fnName, v) {
  const r = document.getElementById(id);
  let val = parseFloat(String(v).replace(',', '.'));
  if (!isFinite(val)) { if (r) feSyncNum(id, r.value); return; }
  if (r) {
    const lo = parseFloat(r.min), hi = parseFloat(r.max);
    if (isFinite(lo)) val = Math.max(lo, val);
    if (isFinite(hi)) val = Math.min(hi, val);
    r.value = val;
  }
  feSyncNum(id, val);
  const fn = window[fnName];
  if (typeof fn === 'function') fn(val);
}
// Поки тягнемо повзунок — жодних перемальовувань панелі й записів в історію
['pointerdown','touchstart','mousedown'].forEach(ev => document.addEventListener(ev, e => {
  const el = e.target;
  if (!el || !el.classList || !el.classList.contains('fe-range')) return;
  FE._sliding = true;
  // Повзунок вигину: одразу переводимо рівний напис у вигнутий вигляд, щоб
  // живий режим працював уже з першого руху, а не з другого заходу.
  if (el.id === 'fe-p-cv' && typeof feCurvePrepare === 'function') feCurvePrepare(el.value);
}, true));
['pointerup','pointercancel','touchend','mouseup'].forEach(ev => document.addEventListener(ev, () => {
  if (!FE._sliding) return;
  FE._sliding = false;
  // ВАЖЛИВО: подія change у повзунка спрацьовує вже ПІСЛЯ pointerup.
  // Якщо перемалювати панель одразу, поле зникне з DOM разом із подією,
  // і зміна просто загубиться — саме через це вигин застосовувався з другого разу.
  FE._curveCenter = null;      // наступне перетягування рахує центр заново
  FE._curveConverted = false;
  setTimeout(() => {
    if (typeof feCommitPendingText === 'function') feCommitPendingText();
    feSnapshot();
    feRefreshPanel();
  }, 0);
}, true));

// ============================================================
// КРОК 1 — НАЛАШТУВАННЯ
// ============================================================
function feInitSetup() {
  // Чернетка лежить у великому сховищі, читається асинхронно — тому першим
  // ділом дочікуємось її і лише потім будуємо екран.
  if (FE._draft === undefined) {
    if (!FE._draftLoading) {
      FE._draftLoading = true;
      feDraftLoad().then(() => feInitSetup()).catch(() => { FE._draft = null; feInitSetup(); });
    }
    return;
  }
  // одноразово підтягуємо збережений стан (макети, фото, свої фони)
  if (!FE._loaded) {
    FE._loaded = true;
    const s = feLoadState();
    if (s) {
      FE.layouts = s.layouts || {};
      FE.bgSaved = s.bgSaved || {};
      FE.myTpl   = s.myTpl || [];
      // старі збережені фони не знали, під яку рамку вони зроблені
      FE.myTpl.forEach(t => {
        if (!t.size) { t.size = s.size || FE.size; t.orient = s.orient || FE.orient; }
      });
      FE.uploads = s.uploads || [];
      if (s.size)   FE.size = s.size;
      if (s.orient) FE.orient = s.orient;
      if (s.color)  FE.color = s.color;
      if (Array.isArray(s.figures) && s.figures.length) FE.figures = s.figures;
      feApplyLayoutMeta();
      // Наявність макета більше нічого не означає: чернетка зберігається
      // і без «Зберегти». Дивимось лише на власну позначку.
      FE._visitedEditor = feBgDone();
      // Повертаємо й пройдений шлях етапами — інакше після перезавантаження
      // людина з готовою роботою мусила б клацати кроки заново.
      if (FE.figures.length) { FE._frameOk = true; FE._maxStep = Math.max(FE._maxStep || 0, 2); }
      if (FE.figures.length && feBgDone()) FE._maxStep = FE_STEPS.length - 1;
    }
    // Питаємо один раз за сеанс. Незавершену фігурку теж рахуємо роботою:
    // раніше рамка про неї не знала, і після перезавантаження людина
    // бачила «фігурок немає», а в конструкторі вони раптом були на місці.
    const hasWork = (FE.figures.length > 0) ||
      Object.keys(FE.layouts || {}).length > 0 ||
      feWipFigs().length > 0;
    if (hasWork) setTimeout(feAskStart, 60);
  }
  document.getElementById('fe-colors-opts').innerHTML = FE_FRAME_COLORS.map(c => `
    <div class="fe-opt ${FE.color === c.id ? 'sel' : ''}" onclick="feSetColor('${c.id}')">
      <div class="fe-swatch" style="background:${c.hex}"></div>
      <div class="fe-opt-name">${c.name}</div></div>`).join('');

  document.getElementById('fe-sizes-opts').innerHTML = FE_SIZES.map(s => {
    const land = s.wMm !== s.hMm && FE.orient === 'landscape';
    const w = land ? s.hMm : s.wMm, hh = land ? s.wMm : s.hMm;
    const k = 50 / Math.max(w, hh);
    return `<div class="fe-opt ${FE.size === s.id ? 'sel' : ''}" onclick="feSetSize('${s.id}')">
      <div class="fe-sizebox" style="width:${(w*k).toFixed(0)}px;height:${(hh*k).toFixed(0)}px"></div>
      <div class="fe-opt-name">${s.name}</div>
      <div class="fe-opt-note">${w}×${hh} мм · до ${land ? (s.maxFigsLand || s.maxFigs) : s.maxFigs} фіг.</div></div>`;
  }).join('');

  feRenderOrient();
  feRenderFigsSetup(); feRenderPreview(); feUpdatePrice();
  feSetupTab(FE._setupTab || 'frame');
  feScrollTip();
}
// Перший крок на телефоні: панель займає третину екрана, і згори видно
// лише «Колір рамки» — здається, що вибір цим і вичерпується, а нижче
// ще розмір і орієнтація. Кажемо це прямо, один раз за сеанс, і прибираємо,
// щойно людина сама гортнула.
function feScrollTip(tries) {
  if (!feIsMobile() || FE._scrollTipDone) return;
  if ((FE._setupTab || 'frame') !== 'frame') return;   // тільки на кроці «Рамка»
  const card = document.querySelector('.fe-setup-card');
  if (!card || document.getElementById('fe-scroll-tip')) return;
  // Поки відкрите вікно («Продовжити / Почати спочатку») — мовчимо: підказка
  // лягала поверх нього і пояснювала прокрутку панелі, якої ще не видно.
  // Чекаємо, доки закриють, але не вічно: дві хвилини — і забуваємо.
  if (!FE._scrollTipT0) FE._scrollTipT0 = Date.now();
  if (Date.now() - FE._scrollTipT0 > 120000) return;
  if (document.querySelector('.fe-modal-bg.open')) {
    setTimeout(() => feScrollTip(0), 400);
    return;
  }
  // Панель могла ще не отримати висоту: заставка, шрифти, розкладка. Поки
  // вона нульова — міряти немає сенсу, пробуємо ще кілька разів.
  const n = tries || 0;
  if (!card.clientHeight || card.scrollHeight <= card.clientHeight + 8) {
    if (n < 12) setTimeout(() => feScrollTip(n + 1), 250);
    return;
  }
  FE._scrollTipDone = true;

  const tip = document.createElement('div');
  tip.id = 'fe-scroll-tip';
  tip.className = 'fe-swipe-tip vert';
  tip.innerHTML = `<span>⌃</span><b>🖐</b><span>⌄</span>
    <i>Гортайте вниз — там розмір і орієнтація</i>`;
  // панель прокручується, тож підказку тримаємо нерухомо поверх неї
  tip.style.position = 'fixed';
  const put = () => {
    const r = card.getBoundingClientRect();
    tip.style.left = r.left + 'px';  tip.style.top = r.top + 'px';
    tip.style.width = r.width + 'px'; tip.style.height = r.height + 'px';
  };
  put();
  document.body.appendChild(tip);
  window.addEventListener('resize', put);

  let done = false;
  const kill = () => {
    if (done) return; done = true;
    clearTimeout(t);
    card.removeEventListener('scroll', kill);
    window.removeEventListener('resize', put);
    tip.classList.add('gone');
    setTimeout(() => tip.remove(), 250);
  };
  const t = setTimeout(kill, 6000);
  card.addEventListener('scroll', kill, { passive:true });
  tip.addEventListener('click', kill);
}
function feRenderOrient() {
  const el = document.getElementById('fe-orient-opts');
  if (!el) return;
  const sq = feDims().square;
  el.innerHTML = [
    { id:'portrait',  n:'Вертикально', w:34, h:48 },
    { id:'landscape', n:'Горизонтально', w:48, h:34 },
  ].map(o => `<div class="fe-opt ${FE.orient === o.id ? 'sel' : ''} ${sq ? 'dim' : ''}"
      onclick="${sq ? '' : `feSetOrient('${o.id}')`}">
      <div class="fe-sizebox" style="width:${o.w}px;height:${o.h}px"></div>
      <div class="fe-opt-name">${o.n}</div></div>`).join('') +
    (sq ? `<p style="grid-column:1/-1;font-size:11.5px;color:var(--fe-dim);margin:2px 0 0">
      Квадратна рамка — орієнтація не впливає.</p>` : '');
}
// ---- Зберігається РІВНО ОДИН макет — останній, над яким працювали ----
function feLayoutKey(size, orient) { return (size || FE.size) + '_' + (orient || FE.orient); }
// Чи збережено фон САМЕ для цієї рамки. Раніше дивились на позначку «людина
// заходила в редактор», і вона лишалась піднятою з минулих сеансів — тому
// фінал відкривався тому, хто фон навіть не відкривав.
// Позначка стоїть на конкретній рамці: змінили розмір чи орієнтацію —
// фон для неї ще не зроблено, і крок треба пройти заново.
function feBgDone() { return !!(FE.bgSaved || {})[feLayoutKey()]; }
// Записує поточний макет
function feStashLayout() {
  if (!FE.canvas) return;
  FE.layouts = FE.layouts || {};
  FE.layouts[feLayoutKey()] = {
    canvas: FE.canvas.toJSON(FE_KEEP),
    captions: FE.captions,
    template: FE.template,
    bgPreview: FE._bgPreview || null,
    bgAcc: FE.canvas.getObjects().filter(o => o._feKind === 'accessory').length,
    bgItems: FE.canvas.getObjects().filter(o => o._feKind === 'item').map(o => o._feItem),
    figPos: FE.figures.map(f => ({ px:f._px, py:f._py })),
  };
}
// Підтягує метадані макета для поточної рамки (позиції фігурок і превʼю)
function feApplyLayoutMeta() {
  const L = (FE.layouts || {})[feLayoutKey()];
  FE.canvas = null;
  if (!L) {
    // шлях етапами теж починається з нуля, інакше лишався б відкритим до фіналу
  FE._maxStep = 0; FE._frameOk = false; FE._setupTab = 'frame';
  FE._bgPreview = null; FE.template = null; FE._bgAcc = 0; FE._bgItems = [];
    FE.figures.forEach(f => { f._px = null; f._py = null; f._placed = null; });
    return;
  }
  FE._bgPreview = L.bgPreview || null;
  FE.template   = L.template || null;
  FE._bgAcc     = L.bgAcc || 0;
  FE._bgItems   = L.bgItems || [];
  FE.captions   = L.captions || { names:{}, s:null };
  (L.figPos || []).forEach((p, i) => {
    if (!FE.figures[i]) return;
    FE.figures[i]._px = p.px; FE.figures[i]._py = p.py; FE.figures[i]._placed = null;
  });
}
function feSwitchLayout(fn) {
  // просто перемикаємо рамку — нічого не видаляємо.
  // Старий макет зникне лише коли збережеш новий кнопкою «Готово».
  feStashLayout();
  if (FE.canvas) { FE.canvas.dispose(); FE.canvas = null; }
  fn();
  feApplyLayoutMeta();
  feSaveSetup(true);
  feInitSetup();
}
// Повне очищення — «почати спочатку»
function feResetAll() {
  if (FE.canvas) { FE.canvas.dispose(); FE.canvas = null; }
  FE.layouts = {}; FE.figures = []; FE.bgSaved = {};
  // «почати спочатку» — показуємо підказки знову.
  // Позначку «більше не нагадувати» не чіпаємо: це свідоме рішення людини.
  // Скидаємо і «більше не нагадувати»: тексти підказок із часом міняються,
  // і людина, що колись їх вимкнула, має побачити нове.
  try {
    localStorage.removeItem('fe_hints_seen');
    localStorage.removeItem('fe_safe_never');
    localStorage.removeItem('fe_tour_seen');
    // і незавершену фігурку з конструктора: без цього після «Почати
    // спочатку» вона поверталась, щойно людина відкривала збирання
    localStorage.removeItem(FE_WIP_KEY);
  } catch (e) {}
  // Шлях етапами теж починається з нуля. Без цього після «Почати спочатку»
  // лишались відкритими ті кроки, куди людина доходила в минулій роботі.
  FE._maxStep = 0; FE._frameOk = false; FE._setupTab = 'frame';
  FE._bgPreview = null; FE.template = null; FE._bgAcc = 0; FE._bgItems = [];
  FE.captions = { names:{}, s:null };
  // Знімки старого проєкту в новому лише заважають
  FE.uploads = []; FE.uploadPage = 0; FE.uploadSel = null;
  FE.orderCode = null; FE._dirty = false;
  FE._quotaWarned = false;
  feClearState();              // звільняємо сховище від старої чернетки
  feSaveSetup(true);
  feInitSetup();
  feToast('Почали з чистого аркуша');
}
function feSetOrient(id) { FE._frameOk = true; if (FE.orient !== id) feSwitchLayout(() => { FE.orient = id; }); }
function feSetColor(id)  { FE._frameOk = true; FE.color = id; feInitSetup(); feSaveState(); }
function feSetSize(id) {
  FE._frameOk = true;
  if (FE.size === id) return;
  feSwitchLayout(() => {
    FE.size = id;
    const max = feMaxFigs();
    if (FE.figures.length > max) FE.figures = FE.figures.slice(0, max);
  });
}
// Фігурки, які людина зібрала в конструкторі, але не встигла підтвердити
// кнопкою «Готово — у рамку»: сторінку перезавантажили посеред роботи.
// Конструктор тримає їх окремою чернеткою — щоб рамка про них знала.
const FE_WIP_KEY = 'mb_frame_wip';
function feWipFigs() {
  try {
    const w = JSON.parse(feLGet(FE_WIP_KEY) || 'null');
    if (!w || !Array.isArray(w.figures) || !w.figures.length) return [];
    if (Date.now() - (w.at || 0) > 12 * 3600 * 1000) return [];
    // порожня заготовка, якої навіть не торкались, роботою не рахується
    if (w.baseSig && typeof window.frameSig === 'function' &&
        window.frameSig(w.figures) === w.baseSig) return [];
    return w.figures.filter(f => f && f.type);
  } catch (e) { return []; }
}
function feSavedFigures() {
  try { const s = JSON.parse(localStorage.getItem('brickstudio_state') || '{}');
    return (s.figures || []).filter(f => f && f.type); } catch (e) { return []; }
}
function feRenderFigsSetup() {
  const max = feMaxFigs(), saved = feSavedFigures();
  let h = `<p style="font-size:12.5px;color:var(--fe-dim);margin-bottom:10px">Додано ${FE.figures.length} з ${max}</p>`;
  if (FE.figures.length) {
    h += '<div class="fe-opts" style="margin-bottom:12px">';
    FE.figures.forEach((f, i) => {
      h += `<div class="fe-opt fe-figcard" onclick="feOpenBuilder(${i})">
        <button class="fe-figcard-del" title="Прибрати"
          onclick="event.stopPropagation();feRemoveSetupFig(${i})">${feIco('circleX')}</button>
        <div class="fe-figthumb" id="fe-ft-${i}">${feFigIco(f)}</div>
        <div class="fe-opt-name">${feFigName(f)} ${i+1}</div>
        <div class="fe-figcard-edit">✎ Редагувати</div></div>`;
    });
    h += '</div>';
  }
  h += `<button class="fe-btn-full" onclick="feOpenBuilder()">${feIco('plus')} Зібрати фігурку</button>`;
  if (saved.length) {
    const used = i => FE.figures.some(f => f._imp === i);
    const free = saved.filter((f, i) => !used(i)).length;
    h += `<div class="fe-lbl" style="margin-top:14px">З конструктора — кожну можна додати один раз</div>
      <div class="fe-opts" style="margin-top:6px">`;
    saved.forEach((f, i) => {
      const on = used(i);
      h += `<div class="fe-opt ${on ? 'dim' : ''}" ${on ? '' : `onclick="feImportOne(${i})"`}>
        <div class="fe-figthumb" id="fe-sv-${i}">${feFigIco(f)}</div>
        <div class="fe-opt-name">${feFigName(f)} ${i + 1}</div>
        <div class="fe-opt-note" style="color:${on ? 'var(--fe-green)' : 'var(--fe-gold)'}">
          ${on ? '✓ вже додано' : feIco('plus') + ' додати'}</div></div>`;
    });
    h += `</div>`;
    if (free) h += `<button class="fe-btn-full soft" onclick="feImportSaved()">${feIco('userAdd')} Додати решту (${free})</button>`;
  }
  document.getElementById('fe-figs-setup').innerHTML = h;
  feFillFigThumbs(FE.figures, 'fe-ft-');
  feFillFigThumbs(saved, 'fe-sv-');
  feUpdateRail();
}

// ===== ЕТАПИ: РАМКА → ФІГУРКИ → ФОН → ФІНАЛ =====
const FE_STEPS = [
  { id:'frame', ico:feIco('templates'), name:'Рамка' },
  { id:'figs',  ico:feIco('figures'), name:'Фігурки' },
  { id:'bg',    ico:feIco('bgPanel'), name:'Фон' },
  { id:'final', ico:feIco('flag'), name:'Фінал' },
];
// Етапи проходять по черзі: спершу рамка, потім фігурки, потім фон, і лише
// тоді фінал. Раніше на компʼютері смуга збоку пускала будь-куди — людина
// потрапляла у «Фон» без жодної фігурки й не розуміла, чому нічого не виходить.
// Повертає причину, чому етап недоступний, або null.
function feStepBlock(id) {
  const i = FE_STEPS.findIndex(x => x.id === id);
  if (i > feMaxStep()) return 'Пройдіть попередні кроки';
  if (id !== 'frame' && !FE._frameOk) return 'Спершу оберіть рамку';
  if ((id === 'bg' || id === 'final') && !FE.figures.length)
    return 'Спершу додайте хоча б одну фігурку';
  if (id === 'final' && !feBgDone()) return 'Спершу оформіть і збережіть фон';
  return null;
}
// Куди людина вже доходила. Уперед пускає лише кнопка «Далі» — так само,
// як на телефоні. Інакше на компʼютері смуга збоку відкривала наступні етапи
// одразу, щойно вибір ставав технічно можливим, і шлях розсипався.
function feMaxStep() {
  if (FE._maxStep == null) FE._maxStep = 0;
  return FE._maxStep;
}
function feStepIdx() {
  const i = FE_STEPS.findIndex(s => s.id === (FE._setupTab || 'frame'));
  return i < 0 ? 0 : i;
}
function feSetupTab(tab) {
  const why = feStepBlock(tab);
  if (why) { feToast(why); return; }
  const changed = FE._setupTab !== tab;
  FE._setupTab = tab;
  FE_STEPS.forEach(s => {
    const pane = document.getElementById('fe-pane-' + s.id);
    if (pane) pane.classList.toggle('on', s.id === tab);
  });
  feRenderSteps(changed);
  // прокрутку скидаємо тільки коли етап справді змінився,
  // інакше будь-яка дія (вибір кольору/розміру) кидала б екран угору
  if (!changed) return;
  const card = document.querySelector('.fe-setup-card');
  if (card) card.scrollTop = 0;
  const setup = document.getElementById('fe-setup');
  if (setup) setup.scrollTop = 0;
}
function feStepNext() {
  const i = feStepIdx();
  if (i >= FE_STEPS.length - 1) return;
  // натиснули «Далі» на першому екрані — отже, з рамкою визначились
  if (FE_STEPS[i].id === 'frame') FE._frameOk = true;
  const nx = FE_STEPS[i + 1].id;
  // спершу питаємо, чи можна туди взагалі: кнопка може бути пригашеною,
  // а натиснути її все одно вдавалось
  FE._maxStep = Math.max(feMaxStep(), i);
  const why = feStepBlockRule(nx);
  if (why) { feToast(why); return; }
  FE._maxStep = Math.max(FE._maxStep, i + 1);
  feSetupTab(nx);
}
// Ті самі правила, але без урахування пройденого шляху — саме їх перевіряє
// кнопка «Далі», бо вона цей шлях і подовжує.
function feStepBlockRule(id) {
  if (id !== 'frame' && !FE._frameOk) return 'Спершу оберіть рамку';
  if ((id === 'bg' || id === 'final') && !FE.figures.length)
    return 'Спершу додайте хоча б одну фігурку';
  if (id === 'final' && !feBgDone()) return 'Спершу оформіть і збережіть фон';
  return null;
}
function feStepPrev() {
  const i = feStepIdx();
  if (i > 0) feSetupTab(FE_STEPS[i - 1].id);
}
// Смуга етапів (компʼютер — збоку, телефон — шкала прогресу)
function feRenderSteps(scrollToCur) {
  const cur = feStepIdx();
  const rail = document.getElementById('fe-rail');
  if (rail) {
    rail.innerHTML = FE_STEPS.map((s, i) => `
      <div class="fe-rail-item ${i === cur ? 'on' : ''} ${feStepBlock(s.id) ? 'lock' : ''}"
        title="${feStepBlock(s.id) || s.name}" onclick="feSetupTab('${s.id}')">
        <div class="fe-rail-ico" ${s.id === 'figs' ? 'id="fe-rail-figico"' : ''}>${s.ico}</div>
        <span>${s.name}</span>
        ${s.id === 'figs' ? '<b class="fe-rail-badge" id="fe-rail-count">0</b>' : ''}
      </div>`).join('');
  }
  const ms = document.getElementById('fe-msteps');
  if (ms) {
    ms.innerHTML = FE_STEPS.map((s, i) => {
      // «пройдений» рахуємо не за поточним кроком, а за тим, куди людина вже
      // доходила — тоді можна вільно вертатись і йти вперед по своїх слідах
      const open = !feStepBlock(s.id);
      const cls = i === cur ? 'cur' : (open ? 'done' : 'future');
      return `<div class="fe-mstep ${cls}" onclick="feSetupTab('${s.id}')">
        <span class="fe-mstep-num">${i + 1}</span><span>${s.name}</span>
      </div>${i < FE_STEPS.length - 1 ? '<i class="fe-mstep-line"></i>' : ''}`;
    }).join('');
    if (scrollToCur) {
      const el = ms.querySelector('.fe-mstep.cur');
      if (el) el.scrollIntoView({ inline:'center', block:'nearest', behavior:'smooth' });
    }
  }
  // нижній бар
  const isFinal = cur === FE_STEPS.length - 1;
  const nextId = FE_STEPS[cur + 1] && FE_STEPS[cur + 1].id;
  // «Далі» веде на наступний етап, тому перевіряємо саме його. Але з рамки
  // піти можна завжди: сам перехід і означає, що рамку обрано.
  const why = (nextId && nextId !== 'figs') ? feStepBlockRule(nextId) : null;
  // Кнопок дві пари: знизу на телефоні й під превʼю на компʼютері
  [['fe-mnav-back', 'fe-mnav-next', 'fe-mnav-cart'],
   ['fe-dnav-back', 'fe-dnav-next', 'fe-dnav-cart']].forEach(([bId, nId, cId]) => {
    const back = document.getElementById(bId);
    const next = document.getElementById(nId);
    const cart = document.getElementById(cId);
    if (back) back.disabled = cur === 0;
    if (next) {
      next.style.display = isFinal ? 'none' : '';
      next.classList.toggle('off', !!why);
      next.title = why || '';
    }
    if (cart) cart.style.display = isFinal ? '' : 'none';
  });
  const hint = document.getElementById('fe-step-hint');
  if (hint) hint.textContent = why || '';
  feUpdateRail();
  feUpdateCartBtn();
  feRenderFinalSummary();
}
// Правильне закінчення: 1 фігурка, 2 фігурки, 5 фігурок. «1 фігурок»
// одразу впадає в око й виглядає неохайно саме там, де людина перевіряє
// замовлення перед оплатою.
function feWordN(n, one, few, many) {
  const a = Math.abs(n) % 100, b = a % 10;
  if (a > 10 && a < 20) return many;
  if (b === 1) return one;
  if (b >= 2 && b <= 4) return few;
  return many;
}
function feRenderFinalSummary() {
  const el = document.getElementById('fe-final-summary');
  if (!el) return;
  const s = feSize();
  const humans = FE.figures.filter(f => f.type !== 'animal').length;
  const animals = FE.figures.filter(f => f.type === 'animal').length;
  const rows = [
    ['Рамка', `${s.name} · ${FE.orient === 'landscape' ? 'горизонтальна' : 'вертикальна'}`],
    ['Колір', feColor().name],
    ['Фігурки', FE.figures.length ? [
      humans  ? humans  + ' ' + feWordN(humans,  'фігурка',  'фігурки',  'фігурок')  : '',
      animals ? animals + ' ' + feWordN(animals, 'тваринка', 'тваринки', 'тваринок') : '',
    ].filter(Boolean).join(' + ') : '—'],
    ['Фон', feBgDone() ? 'оформлено' : 'не оформлено'],
  ];
  el.innerHTML = rows.map(([k, v]) =>
    `<div class="fe-sum-row"><i>${k}</i><b>${v}</b></div>`).join('');
  const note = document.getElementById('fe-bg-note');
  if (note) note.textContent = feBgDone()
    ? 'Фон уже оформлено — можна зайти й змінити будь-коли.'
    : 'Ще не оформлено. Оберіть шаблон або зробіть свій дизайн.';
}
// ===== КНОПКА «В КОШИК» =====
// Доступна лише коли людина і фон зробила, і фігурки зібрала.
function feCartBlockers() {
  const miss = [];
  if (!feBgDone()) miss.push('оформіть і збережіть фон');
  if (!FE.figures.length)  miss.push('додайте фігурки');
  return miss;
}
function feUpdateCartBtn() {
  const miss = feCartBlockers();
  ['fe-to-cart', 'fe-mnav-cart', 'fe-dnav-cart'].forEach(id => {
    const b = document.getElementById(id);
    if (b) b.classList.toggle('off', miss.length > 0);
  });
  const hint = document.getElementById('fe-cart-hint');
  if (hint) hint.textContent = miss.length ? `Щоб продовжити — ${miss.join(' та ')}` : '';
}
function feToCart() {
  const miss = feCartBlockers();
  if (miss.length) { alert('Щоб продовжити — ' + miss.join(' та ') + '.'); return; }
  feFinalize();
}

function feUpdateRail() {
  const badge = document.getElementById('fe-rail-count');
  if (badge) {
    badge.textContent = FE.figures.length;
    badge.classList.toggle('empty', FE.figures.length === 0);
  }
  // іконка розділу — перша зібрана фігурка замість емодзі
  const ico = document.getElementById('fe-rail-figico');
  if (ico && FE.figures.length) {
    feComposeFigure(FE.figures[0]).then(r => {
      const el = document.getElementById('fe-rail-figico');
      if (r && el) el.innerHTML = `<img src="${r.url}">`;
    });
  } else if (ico) {
    ico.innerHTML = feIco('figures');
  }
}
// підставляє справжні зображення фігурок у картки
async function feFillFigThumbs(list, prefix) {
  for (let i = 0; i < list.length; i++) {
    const el = document.getElementById(prefix + i);
    if (!el) continue;
    const r = await feComposeFigure(list[i]);
    if (r && document.getElementById(prefix + i)) {
      document.getElementById(prefix + i).innerHTML = `<img src="${r.url}">`;
    }
  }
}
function feImportOne(i) {
  const saved = feSavedFigures();
  if (!saved[i]) return;
  if (FE.figures.some(f => f._imp === i)) return;
  if (FE.figures.length >= feMaxFigs()) { alert('Ліміт фігурок для цього розміру вичерпано'); return; }
  const copy = JSON.parse(JSON.stringify(saved[i]));
  copy._imp = i;
  FE.figures.push(copy);
  feSetupChanged();
}
function feRemoveSetupFig(i) { FE.figures.splice(i, 1); feSetupChanged(); }
function feImportSaved() {
  const max = feMaxFigs(); let added = 0;
  feSavedFigures().forEach((f, i) => {
    if (FE.figures.some(x => x._imp === i)) return;
    if (FE.figures.length >= max) return;
    const copy = JSON.parse(JSON.stringify(f)); copy._imp = i;
    FE.figures.push(copy); added++;
  });
  if (!added) alert('Усі фігурки з конструктора вже додані або досягнуто ліміт');
  feSetupChanged();
}
// Скільки аксесуарів у фігурки. Боксерські рукавички займають обидві
// руки, але коштують як один аксесуар — це один предмет у наборі.
// Значок і назва типу фігурки — щоб готова не підписувалась «Тваринкою»
function feFigIco(f)  { return (window.FIG_ICONS||{})[f&&f.type] || '🐾'; }
function feFigName(f) { return f && f.type === 'human' ? 'Фігурка'
                           : (window.FIG_NAMES||{})[f&&f.type] || 'Тваринка'; }
function feFigAccCount(f) {
  if (!f || (f.type !== 'human' && f.type !== 'ready')) return 0;
  if (f.accLeft === 'boxing' || f.accRight === 'boxing') return 1;
  return (f.accLeft ? 1 : 0) + (f.accRight ? 1 : 0);
}
// Аксесуари, покладені просто на фон
function feBgAccCount() {
  const ed = document.getElementById('fe-editor');
  // поза редактором рахуємо лише збережене (після «Готово»)
  if (!FE.canvas || !ed || !ed.classList.contains('active')) return FE._bgAcc || 0;
  return FE.canvas.getObjects().filter(o => o._feKind === 'accessory').length;
}
function fePriceParts() {
  const s = feSize();
  const parts = [{ n:`Рамка ${s.name} (з 1 фігуркою)`, v:s.price }];
  let extraH = 0, animals = 0, prints = 0, accs = 0, paints = 0;
  let itemFigs = 0;
  FE.figures.forEach((f, i) => {
    if (f.type === 'item') { itemFigs++; return; }   // рахуємо окремо, нижче
    // Перша фігурка входить у ціну рамки — байдуже, готова вона чи зібрана
    if (i > 0) {
      if (f.type === 'animal') animals++;
      else extraH++;   // готова фігурка коштує як звичайна додаткова
    }
    if (f.print) prints++;
    if (f.customPaint) paints++;   // покраска тваринки за фото
    accs += feFigAccCount(f);
  });
  const bgAcc = feBgAccCount();
  if (extraH)  parts.push({ n:`Додаткові фігурки × ${extraH}`, v:extraH * FE_PRICE.figure });
  if (animals) parts.push({ n:`Тваринки × ${animals}`,        v:animals * FE_PRICE.animal });
  if (prints)  parts.push({ n:`Принти × ${prints}`,            v:prints * FE_PRICE.print });
  if (paints)  parts.push({ n:`Покраска за фото × ${paints}`,  v:paints * FE_PRICE.customPaint });
  if (accs)    parts.push({ n:`Аксесуари фігурок × ${accs}`,   v:accs * FE_PRICE.accessory });
  if (bgAcc)   parts.push({ n:`Аксесуари на фоні × ${bgAcc}`,  v:bgAcc * FE_PRICE.accessory });
  // предмети з бібліотеки — кожен зі своєю ціною, тому групуємо за назвою
  // Предмети йдуть за ціною аксесуара, тому показуємо їх одним рядком —
  // окремий цінник у підсумку тільки заплутував би.
  const itemCount = feBgItemIds().length + itemFigs;
  if (itemCount) parts.push({ n:`Предмети × ${itemCount}`, v:itemCount * FE_PRICE.accessory });
  const total = parts.reduce((a, p) => a + p.v, 0);
  return { parts, total };
}
function feUpdatePrice() {
  const { parts, total } = fePriceParts();
  const txt = total.toLocaleString('uk-UA') + ' ₴';
  ['fe-total-price', 'fe-total-price-m'].forEach(id => {
    const el = document.getElementById(id); if (el) el.textContent = txt;
  });
  const html = parts.map(p => `<div class="fe-pd"><i>${p.n}</i><b>${p.v} ₴</b></div>`).join('') +
    `<div class="fe-pd total"><i>Разом</i><b>${txt}</b></div>`;
  ['fe-price-details', 'fe-price-details-m'].forEach(id => {
    const d = document.getElementById(id); if (d) d.innerHTML = html;
  });
  feUpdateCartBtn();
}
// Частка відступу безпечної лінії від краю (по кожній осі)
function feInsetFrac() {
  const d = feDims();
  return { x: SAFE_INSET_MM / d.wMm, y: SAFE_INSET_MM / d.hMm };
}
// координати полотна ⇄ координати видимої зони
function feToVisible(px, py) {
  const f = feInsetFrac();
  return { x: (px - f.x) / (1 - 2*f.x), y: (py - f.y) / (1 - 2*f.y) };
}
function feFromVisible(ux, uy) {
  const f = feInsetFrac();
  return { x: f.x + ux * (1 - 2*f.x), y: f.y + uy * (1 - 2*f.y) };
}

// Превʼю рахує свій розмір із висоти картки. Якщо намалювати його раніше,
// ніж браузер розклав сторінку (перший показ, поворот екрана, зникла
// адресна смуга), картка ще не має правильної висоти — і рамка виходить
// завеликою, нижній край ховається за смугою етапів. Тому стежимо за
// карткою і перемальовуємо, щойно її висота справді змінилась.
function feWatchPreviewBox() {
  const card = document.querySelector('.fe-preview-card');
  if (!card || FE._pvRO || typeof ResizeObserver === 'undefined') return;
  FE._pvRO = new ResizeObserver(() => {
    const h = card.clientHeight;
    if (!h || Math.abs(h - (FE._pvH || 0)) < 12) return;   // дрібні коливання ігноруємо
    FE._pvH = h;
    if (FE._pvBusy) return;
    // страховка від нескінченного кола, якщо колись зʼявиться верстка,
    // де малюнок сам впливає на висоту картки
    const now = Date.now();
    if (now - (FE._pvAt || 0) < 300) return;
    FE._pvAt = now;
    feRenderPreview();
  });
  FE._pvRO.observe(card);
}
async function feRenderPreview() {
  FE._pvBusy = true;
  try { await feRenderPreviewInner(); } finally { FE._pvBusy = false; }
  feWatchPreviewBox();
}
async function feRenderPreviewInner() {
  const d = feDims(), c = feColor();
  // на телефоні превʼю має вміститись у верхню половину екрана
  // розмір беремо з реальної висоти контейнера, а не з припущень про бари
  let box = 330;
  if (window.innerWidth <= 860) {
    const card = document.querySelector('.fe-preview-card');
    const availH = (card && card.clientHeight) ? card.clientHeight - 16 : window.innerHeight * 0.42;
    // рамка з бортиком займає ~110% від box, тому ділимо
    box = Math.max(140, Math.min(340, window.innerWidth * 0.82 / 1.1, availH / 1.1));
  }
  const f = feInsetFrac();
  // превʼю показує тільки видиму зону (те, що не сховає бортик)
  const vwMm = d.wMm * (1 - 2*f.x), vhMm = d.hMm * (1 - 2*f.y);
  const k = box / Math.max(vwMm, vhMm), w = vwMm * k, h = vhMm * k;
  const b = Math.round(box * 0.05);
  // Знімок фону робиться на ВСЮ рамку, а превʼю показує лише видиму зону.
  // Якщо розтягнути знімок на 100% — усе, що зайшло за пунктир, підтягується
  // назад усередину, і людина не бачить, що бортик зʼїсть край напису.
  // Тому кладемо знімок у натуральний масштаб і зсуваємо на бортик: те, що
  // за межами, обрізається (mat має overflow:hidden) — як буде насправді.
  const fullW = w / (1 - 2*f.x), fullH = h / (1 - 2*f.y);
  const bg = FE._bgPreview
    ? `background-image:url(${FE._bgPreview});background-repeat:no-repeat;
       background-size:${fullW}px ${fullH}px;
       background-position:${-f.x * fullW}px ${-f.y * fullH}px;`
    : 'background:#FFFFFF;';
  const figH = (FIG_HEIGHT_MM / vhMm) * h;

  // біла рамка на світлому фоні зливається — робимо чіткий контур і тінь усередині
  const white = c.id === 'white';
  const edge = white
    ? 'border:1px solid rgba(0,0,0,.45);box-shadow:0 12px 30px rgba(0,0,0,.55), inset 0 0 0 1px rgba(0,0,0,.12);'
    : 'border:1px solid rgba(255,255,255,.22);box-shadow:0 12px 30px rgba(0,0,0,.55);';
  const matEdge = white ? 'box-shadow:inset 0 0 0 1px rgba(0,0,0,.28);' : 'box-shadow:inset 0 0 0 1px rgba(0,0,0,.35);';

  const wrap = document.getElementById('fe-preview-frame');
  wrap.innerHTML = `
    <div style="display:flex;flex-direction:column;align-items:center;gap:16px">
      <div style="width:${w+b*2}px;height:${h+b*2}px;background:${c.hex};${edge}
                  padding:${b}px;box-sizing:border-box">
        <div id="fe-pv-mat" style="position:relative;width:100%;height:100%;${bg}${matEdge}overflow:hidden"></div>
      </div>
    </div>`;

  const mat = document.getElementById('fe-pv-mat');
  const cs = feCapS();
  for (let i = 0; i < FE.figures.length; i++) {
    const fg = FE.figures[i];
    if (fg._px == null) fg._px = (i + 1) / (FE.figures.length + 1);
    if (fg._py == null) fg._py = 0.62;
    const r = await feComposeFigure(fg);
    if (!r) continue;
    const url = r.url;

    const v = feToVisible(fg._px, fg._py);
    const box = document.createElement('div');
    box.className = 'fe-pv-fig';
    box.style.left = (Math.min(1, Math.max(0, v.x)) * 100) + '%';
    box.style.top  = (Math.min(1, Math.max(0, v.y)) * 100) + '%';
    box.dataset.i = i;

    const im = document.createElement('img');
    // спершу приховуємо — інакше на мить видно картинку в натуральну величину
    im.style.visibility = 'hidden';
    const pvPxPerMm = h / vhMm;
    im.onload = () => {
      im.style.height = (im.naturalHeight * MM_PER_SPRITE_PX * pvPxPerMm) + 'px';
      im.style.visibility = '';
    };
    im.src = url;
    box.appendChild(im);

    const capText = feCapText(FE.captions.names[fg._placed]);
    if (capText) {
      const cap = document.createElement('div');
      cap.className = 'fe-pv-cap';
      cap.textContent = cs.upper ? capText.toUpperCase() : capText;
      cap.style.cssText = `font-family:'${cs.font}',sans-serif;font-weight:${cs.weight};
        font-style:${cs.italic ? 'italic' : 'normal'};${cs.underline ? 'text-decoration:underline;' : ''}
        color:${cs.color};text-align:${cs.align};
        white-space:pre-line;line-height:1.16;
        font-size:${Math.max(6, (cs.size / 100) * w)}px;
        letter-spacing:${(cs.spacing / 1000).toFixed(2)}em;
        margin-top:${(cs.offset / 100) * figH}px;
        transform:translateX(${((r.cx != null ? r.cx : 0.5) - 0.5) * 100}%);`;
      box.appendChild(cap);
    }
    mat.appendChild(box);
  }
  feBindPreviewDrag(mat);
}
// перетягування фігурок у превʼю
function feBindPreviewDrag(mat) {
  let cur = null, box = null;
  mat.addEventListener('pointerdown', e => {
    const t = e.target.closest && e.target.closest('.fe-pv-fig');
    if (!t) return;
    cur = t; box = mat.getBoundingClientRect();
    cur.setPointerCapture(e.pointerId);
    cur.style.cursor = 'grabbing';
    e.preventDefault();
  });
  mat.addEventListener('pointermove', e => {
    if (!cur) return;
    const x = Math.min(1, Math.max(0, (e.clientX - box.left) / box.width));
    const y = Math.min(1, Math.max(0, (e.clientY - box.top) / box.height));
    cur.style.left = (x * 100) + '%';
    cur.style.top  = (y * 100) + '%';
    const f = FE.figures[+cur.dataset.i];
    if (f) { const p = feFromVisible(x, y); f._px = p.x; f._py = p.y; }
  });
  mat.addEventListener('pointerup', () => {
    if (cur) { cur.style.cursor = ''; cur = null; feSaveSetup(); }
  });
}
function feSaveSetup() {
  // Стан у пам'яті оновлюємо одразу, а важкий запис у сховище відкладаємо:
  // чернетка важить мегабайти (макети + свої фони), і запис на кожен рух
  // повзунка підвішував перший екран на кілька секунд.
  try {
    const d = feLoadState() || {};
    d.v = 2;
    d.figures = FE.figures; d.size = FE.size; d.orient = FE.orient; d.color = FE.color;
    d.layouts = FE.layouts || d.layouts || {};
    d.myTpl = FE.myTpl || d.myTpl || [];
    d.uploads = feUploadsToSave();
    FE._draft = d;
    clearTimeout(FE._setupSaveT);
    FE._setupSaveT = setTimeout(() => {
      feIdbSet(FE_SAVE_KEY, FE._draft)
        .catch(() => { try { localStorage.setItem(FE_SAVE_KEY, JSON.stringify(FE._draft)); } catch (e) {} });
    }, 800);
  } catch (e) {}
}
// оновити все, що залежить від набору фігурок
function feSetupChanged() {
  feRenderFigsSetup(); feRenderPreview(); feUpdatePrice(); feSaveSetup();
  // Кнопка «Далі» показує, чи можна йти далі. Без цього виклику вона лишалась
  // пригашеною після додавання першої фігурки — хоч працювала.
  feRenderSteps();
}

// ============================================================
// ЗБІРНИК ФІГУРОК
// ============================================================
const FEB = { fig: null, tab: 'type', page: {}, editIndex: null };
function feNewFigure(type) {
  return { type, skin:'flesh', face:0, hairType:'bald', hairColor:'#B5A585', hairStyle:11, hatStyle:1,
    torsoColor:'flesh', sleeveColor:'flesh', printCat:null, print:null,
    legsType:'normal', legsColor:'flesh', accLeft:null, accRight:null, animalType:1, readyId:1, facing:'front' };
}
function feOpenBuilder(editIndex) {
  if (editIndex == null && FE.figures.length >= feMaxFigs()) { alert('Досягнуто ліміт фігурок для цього розміру рамки'); return; }

  // Основний шлях — повноцінний поетапний конструктор (той самий, що для брелків)
  if (typeof window.openFrameBuilder === 'function') {
    const list = FE.figures.map(f => JSON.parse(JSON.stringify(f)));
    // Коли фігурки вже є, порожню наперед не створюємо: інакше людина одразу
    // потрапляла в збирання людини й не бачила, що можна взяти тваринку чи
    // предмет. Замість цього відкриваємо набір і показуємо вибір типу.
    // Питаємо тип завжди, коли додають нову: навіть на першій фігурці людина
    // має одразу бачити, що є не тільки людина, а й тваринка, готова фігурка
    // та предмет. Раніше її мовчки кидало в збирання людини.
    let startIdx = editIndex;
    let askType = false;
    if (editIndex == null) {
      if (list.length) { startIdx = list.length - 1; askType = true; }
      // 'first' — набір порожній: вибір типу не додає ще одну фігурку,
      // а замінює ту порожню, що конструктор створює за замовчуванням
      else { list.push(feNewFigure('human')); startIdx = 0; askType = 'first'; }
    }
    window.openFrameBuilder(list, feMaxFigs(), startIdx, figs => {
      // зберігаємо звʼязок з імпортованими з конструктора
      figs.forEach((f, i) => { if (FE.figures[i] && FE.figures[i]._imp != null) f._imp = FE.figures[i]._imp; });
      FE.figures = figs.slice(0, feMaxFigs());
      FE._visitedFigs = true;
      feSetupChanged();
      // Лишаємось на «Фігурках»: далі веде кнопка «Далі», а не сам конструктор.
      // Інакше людину викидало на «Фон», хоча вона, може, хотіла додати ще одну.
      feSetupTab('figs');
    }, askType);
    return;
  }

  // Запасний варіант — вбудований спрощений білдер
  FEB.fig = editIndex != null ? JSON.parse(JSON.stringify(FE.figures[editIndex])) : feNewFigure('human');
  FEB.editIndex = editIndex != null ? editIndex : null;
  FEB.tab = 'type'; FEB.page = {};
  feModal('fe-m-builder'); feBuilderRender();
}
const FEB_TABS_HUMAN = [
  {id:'type',ico:'🧩',name:'Тип'},{id:'skin',ico:'😊',name:'Обличчя'},{id:'hair',ico:'💇',name:'Зачіска'},
  {id:'torso',ico:'👕',name:'Торс'},{id:'print',ico:'🖨',name:'Принт'},{id:'legs',ico:'👖',name:'Ноги'},
  {id:'acc',ico:'⚔️',name:'Аксесуари'},
];
const FEB_TABS_ANIMAL = [{id:'type',ico:'🧩',name:'Тип'},{id:'animal',ico:'🐾',name:'Тваринка'}];

function feBuilderRender() {
  const f = FEB.fig;
  const tabs = f.type === 'human' ? FEB_TABS_HUMAN : FEB_TABS_ANIMAL;
  if (!tabs.some(t => t.id === FEB.tab)) FEB.tab = 'type';
  document.getElementById('fe-b-tabs').innerHTML = tabs.map(t =>
    `<div class="fe-b-tab ${FEB.tab === t.id ? 'on' : ''}" onclick="feBuilderTab('${t.id}')"><span>${t.ico}</span>${t.name}</div>`).join('');
  document.getElementById('fe-b-section').innerHTML = feBuilderSection();
  feBuilderPreview();
}
function feBuilderTab(id) { FEB.tab = id; feBuilderRender(); }
function feBuilderSet(k, v) { FEB.fig[k] = v; feBuilderRender(); }
function feBuilderPage(k, p) { FEB.page[k] = p; feBuilderRender(); }

function feBuilderSection() {
  const f = FEB.fig, SM = feSM();
  if (FEB.tab === 'type') {
    return `<div class="fe-b-sec"><div class="fe-b-sec-t">Хто це буде</div><div class="fe-chips">
      <div class="fe-chip ${f.type==='human'?'sel':''}" onclick="feBuilderSet('type','human')">🧍 Людина</div>
      <div class="fe-chip ${f.type==='animal'?'sel':''}" onclick="feBuilderSet('type','animal')">🐾 Тваринка</div>
      </div></div><div class="fe-b-sec"><div class="fe-b-sec-t">Розворот</div><div class="fe-chips">
      <div class="fe-chip ${f.facing==='front'?'sel':''}" onclick="feBuilderSet('facing','front')">Спереду</div>
      <div class="fe-chip ${f.facing==='back'?'sel':''}" onclick="feBuilderSet('facing','back')">Ззаду</div></div></div>`;
  }
  if (FEB.tab === 'animal') {
    const oos = window.ANIMALS_OOS || [];
    return `<div class="fe-b-sec"><div class="fe-b-sec-t">Оберіть тваринку</div>` +
      fePagedGrid(window.ANIMALS || [], FEB.page.animal || 0, 12, 'fePageAnimal', a => {
        const url = (SM.animals||{})[a.id], off = oos.includes(a.id);
        return `<div class="fe-tile ${f.animalType===a.id?'sel':''} ${off?'oos':''}"
          onclick="${off?'':`feBuilderSet('animalType',${a.id})`}">${url?feAccTile(url, 'an_'+a.id):a.label}</div>`;
      }, 4) + '</div>';
  }
  if (FEB.tab === 'skin') {
    let h = `<div class="fe-b-sec"><div class="fe-b-sec-t">Колір шкіри</div><div class="fe-chips">`;
    (window.SKIN_COLORS || []).forEach(s => {
      const off = (window.SKIN_OOS||[]).includes(s.id);
      h += `<div class="fe-chip ${f.skin===s.id?'sel':''}" style="${off?'opacity:.4':''}"
        onclick="${off?'':`feBuilderSet('skin','${s.id}')`}">${s.label}</div>`;
    });
    h += `</div></div><div class="fe-b-sec"><div class="fe-b-sec-t">Обличчя</div>`;
    return h + fePagedGrid(window.FACES || [], FEB.page.face || 0, 12, 'fePageFace', fc => {
      const url = (SM.faces||{})[fc.id], off = (window.FACES_OOS||[]).includes(fc.id);
      return `<div class="fe-tile ${f.face===fc.id?'sel':''} ${off?'oos':''}"
        onclick="${off?'':`feBuilderSet('face',${fc.id})`}" title="${fc.label}">
        ${url?feZoomTile(url,{top:-28,scale:3.2,origin:'50% 38%'}):fc.label}
        <div class="fe-tile-lbl">${fc.label}</div></div>`;
    }, 4) + '</div>';
  }
  if (FEB.tab === 'hair') {
    let h = `<div class="fe-b-sec"><div class="fe-b-sec-t">Тип</div><div class="fe-chips">`;
    (window.HAIR_TYPES || []).forEach(t =>
      h += `<div class="fe-chip ${f.hairType===t.id?'sel':''}" onclick="feBuilderSet('hairType','${t.id}')">${t.label}</div>`);
    h += `</div></div>`;
    if (f.hairType === 'hat') {
      h += `<div class="fe-b-sec"><div class="fe-b-sec-t">Головний убір</div>`;
      h += fePagedGrid(window.HATS || [], FEB.page.hat || 0, 12, 'fePageHat', ht => {
        const o = (SM.hats||{})[ht.id] || {}, url = o.back || o.front, off = (window.HATS_OOS||[]).includes(ht.id);
        return `<div class="fe-tile ${f.hatStyle===ht.id?'sel':''} ${off?'oos':''}"
          onclick="${off?'':`feBuilderSet('hatStyle',${ht.id})`}">
          ${url?feZoomTile(url,{top:5,scale:2,origin:'50% 25%'}):ht.id}</div>`;
      }, 4) + '</div>';
    } else if (f.hairType === 'hair') {
      const colors = (window.HAIR_COLORS||[]).filter(c => (window.HAIR_STYLES||[]).some(s => ((SM.hair||{})[`${s.id}_${c}`]||{}).front));
      h += `<div class="fe-b-sec"><div class="fe-b-sec-t">Колір</div><div class="fe-colors">`;
      colors.forEach(c => h += `<div class="fe-color ${f.hairColor===c?'sel':''}" style="background:${c}" onclick="feBuilderHairColor('${c}')"></div>`);
      h += `</div></div>`;
      const styles = (window.HAIR_STYLES||[]).filter(s => ((SM.hair||{})[`${s.id}_${f.hairColor}`]||{}).front);
      h += `<div class="fe-b-sec"><div class="fe-b-sec-t">Стиль</div>`;
      h += fePagedGrid(styles, FEB.page.hair || 0, 12, 'fePageHair', s => {
        const o = (SM.hair||{})[`${s.id}_${f.hairColor}`] || {}, url = o.back || o.front;
        return `<div class="fe-tile ${f.hairStyle===s.id?'sel':''}" onclick="feBuilderSet('hairStyle',${s.id})">
          ${url?feZoomTile(url,{top:5,scale:1.7,origin:'50% 28%'}):s.id}</div>`;
      }, 4) + '</div>';
    }
    return h;
  }
  if (FEB.tab === 'torso') {
    const cs = k => k === 'flesh' ? 'background:#F5CC7F' : `background:${k}`;
    let h = `<div class="fe-b-sec"><div class="fe-b-sec-t">Колір торсу</div><div class="fe-colors">`;
    Object.keys(SM.torso||{}).filter(k => SM.torso[k]).forEach(k =>
      h += `<div class="fe-color ${f.torsoColor===k?'sel':''}" style="${cs(k)}" onclick="feBuilderSet('torsoColor','${k}')"></div>`);
    h += `</div></div><div class="fe-b-sec"><div class="fe-b-sec-t">Колір рукавів</div><div class="fe-colors">`;
    Object.keys(SM.arms||{}).filter(k => SM.arms[k]).forEach(k =>
      h += `<div class="fe-color ${f.sleeveColor===k?'sel':''}" style="${cs(k)}" onclick="feBuilderSet('sleeveColor','${k}')"></div>`);
    return h + '</div></div>';
  }
  if (FEB.tab === 'print') {
    let h = `<div class="fe-b-sec"><div class="fe-b-sec-t">Категорія</div><div class="fe-chips">`;
    (window.PRINT_CATS||[]).forEach(c => h += `<div class="fe-chip ${f.printCat===c?'sel':''}" onclick="feBuilderPrintCat('${c}')">${c}</div>`);
    h += `</div></div>`;
    if (f.printCat && (window.PRINTS||{})[f.printCat]) {
      h += `<div class="fe-b-sec"><div class="fe-b-sec-t">Принт</div>`;
      h += fePagedGrid(PRINTS[f.printCat], FEB.page.print || 0, 12, 'fePagePrint', p => {
        const url = (SM.prints||{})[p.id];
        return `<div class="fe-tile ${f.print===p.id?'sel':''}" onclick="feBuilderSet('print','${p.id}')" title="${p.label}">
          ${url?`<div class="fe-tile-img" style="background:${p.darkBg?'#0E1422':'#fff'}">
            <img src="${feSpx(url, FE_SPRITE_PX)}" style="top:-45%;transform:scale(2.6);transform-origin:50% 50%"></div>`:p.label}</div>`;
      }, 4) + '</div>';
    }
    if (f.print) h += `<button class="fe-btn-full soft" onclick="feBuilderSet('print',null)">${feIco('close')} Прибрати принт</button>`;
    return h;
  }
  if (FEB.tab === 'legs') {
    let h = `<div class="fe-b-sec"><div class="fe-b-sec-t">Тип ніг</div><div class="fe-chips">`;
    (window.LEG_TYPES||[]).forEach(t => h += `<div class="fe-chip ${f.legsType===t.id?'sel':''}" onclick="feBuilderSet('legsType','${t.id}')">${t.label}</div>`);
    h += `</div></div><div class="fe-b-sec"><div class="fe-b-sec-t">Колір</div><div class="fe-colors">`;
    const pref = f.legsType + '_';
    Object.keys(SM.legs||{}).filter(k => k.startsWith(pref) && SM.legs[k]).forEach(k => {
      const col = k.replace(pref, '');
      h += `<div class="fe-color ${f.legsColor===col?'sel':''}" style="background:${col==='flesh'?'#F5CC7F':col}"
        onclick="feBuilderSet('legsColor','${col}')"></div>`;
    });
    return h + '</div></div>';
  }
  if (FEB.tab === 'acc') {
    const accs = SM.accessories || {}, oos = window.ACC_OOS || [];
    // скільки їх насправді — щоб додані пізніше не лишались невидимими
    const total = Object.keys(accs).filter(k => /^L_\d+$/.test(k) && accs[k]).length || 50;
    const nums = []; for (let i = 1; i <= total; i++) nums.push(i);
    let h = '';
    ['left','right'].forEach(side => {
      const key = side === 'left' ? 'accLeft' : 'accRight', pre = side === 'left' ? 'L_' : 'R_';
      h += `<div class="fe-b-sec"><div class="fe-b-sec-t">${side==='left'?'Ліва рука':'Права рука'}</div>
        <div class="fe-chips" style="margin-bottom:8px">
          <div class="fe-chip ${!f[key]?'sel':''}" onclick="feBuilderSet('${key}',null)">Без</div></div>`;
      h += fePagedGrid(nums, FEB.page['acc'+side] || 0, 12, side === 'left' ? 'fePageAccL' : 'fePageAccR', i => {
        const id = pre + i, url = accs[id], off = oos.includes(i);
        return `<div class="fe-tile ${f[key]===id?'sel':''} ${off?'oos':''}"
          onclick="${off?'':`feBuilderSet('${key}','${id}')`}">${url?feAccTile(url, id):i}
          <div class="fe-tile-lbl">${i}</div></div>`;
      }, 4) + '</div>';
    });
    return h;
  }
  return '';
}
function feBuilderHairColor(c) {
  FEB.fig.hairColor = c;
  const SM = feSM();
  if (!((SM.hair||{})[`${FEB.fig.hairStyle}_${c}`]||{}).front) {
    const first = (window.HAIR_STYLES||[]).find(s => ((SM.hair||{})[`${s.id}_${c}`]||{}).front);
    if (first) FEB.fig.hairStyle = first.id;
  }
  FEB.page.hair = 0; feBuilderRender();
}
function feBuilderPrintCat(c) { FEB.fig.printCat = c; FEB.page.print = 0; feBuilderRender(); }
function fePageAnimal(p){feBuilderPage('animal',p)} function fePageFace(p){feBuilderPage('face',p)}
function fePageHat(p){feBuilderPage('hat',p)}       function fePageHair(p){feBuilderPage('hair',p)}
function fePagePrint(p){feBuilderPage('print',p)}   function fePageAccL(p){feBuilderPage('accleft',p)}
function fePageAccR(p){feBuilderPage('accright',p)}

function feBuilderPreview() {
  document.getElementById('fe-b-stage').innerHTML =
    feFigureLayerUrls(FEB.fig).filter(Boolean).map(u => `<img src="${feSpx(u, FE_SPRITE_PX)}">`).join('');
}
function feBuilderSave() {
  if (FEB.editIndex != null) FE.figures[FEB.editIndex] = FEB.fig;
  else FE.figures.push(FEB.fig);
  feModalClose(); feSetupChanged();
  if (feActiveTool === 'figures') feRefreshPanel();
}

// ============================================================
// ФІГУРКА → КАРТИНКА
// ============================================================
// Знімок тваринки для фону: свій файл і свій справжній розмір у міліметрах
function feAnimalFrame(fig) {
  if (!fig || fig.type !== 'animal') return null;
  const a = (window.ANIMAL_FRAME || {})[fig.animalType];
  return (a && a.url && a.wMm) ? a : null;
}
function feFigureLayerUrls(fig) {
  // «Інше» з набору — не збірна фігурка, а готовий малюнок предмета
  if (fig && fig.type === 'item') {
    const it = (window.FE_ITEM_LIB || []).find(x => x.id === fig.itemId);
    return it && it.url ? [it.url] : [];
  }
  const SM = feSM(), out = [], add = u => u && out.push(u);
  if (fig.type === 'animal') {
    // На фон іде окремий знімок тваринки — у справжньому розмірі поруч із
    // фігуркою. У конструкторі вона навмисно більша, щоб її було видно.
    const af = feAnimalFrame(fig);
    add(af ? af.url : (SM.animals||{})[fig.animalType]);
    return out;
  }
  // Готова фігурка — тіло однією деталлю: голова тілесна, торс/руки/ноги не збираються
  const isReady = fig.type === 'ready';
  const skin = isReady ? 'flesh' : (fig.skin || 'flesh'), isBack = fig.facing === 'back';
  const T = SM.torso||{}, AF = SM.arms||{}, AB = SM.armsBack||{};
  const L = isBack ? (SM.legsBack||{}) : (SM.legs||{});
  let hw = null;
  if (fig.hairType === 'hat')  hw = (SM.hats||{})[fig.hatStyle];
  if (fig.hairType === 'hair') hw = (SM.hair||{})[`${fig.hairStyle}_${fig.hairColor}`];
  hw = hw || {};
  if (!isBack) add(hw.back);
  if (isReady) {
    const rb = (window.READY_FIGS||[]).find(r => r.id === fig.readyId) || (window.READY_FIGS||[])[0];
    add(rb && (isBack ? rb.back : rb.front));
  } else {
    add(L[`${fig.legsType}_${fig.legsColor}`]);
    if (isBack) { add(SM.handsBack); add(AB[fig.sleeveColor]||AB[fig.torsoColor]||AB[skin]); }
    else        { add(AF[fig.sleeveColor]||AF[fig.torsoColor]||AF[skin]); }
    add(T[fig.torsoColor]||T[skin]);
    if (!isBack && fig.print) add((SM.prints||{})[fig.print]);
  }
  const accs = SM.accessories || {};
  if (!isBack) {
    // у готового тіла долоні вже намальовані, а сумка має лягти поверх
    if (!isReady) {
      if (fig.accLeft === 'L_32')  add(accs['L_32']);
      if (fig.accRight === 'R_32') add(accs['R_32']);
      add((SM.hands||{})[skin]);
    }
    if (fig.accLeft === 'boxing') add(accs.boxing);
    else { if (fig.accLeft && (isReady || fig.accLeft !== 'L_32')) add(accs[fig.accLeft]);
           if (fig.accRight && (isReady || fig.accRight !== 'R_32')) add(accs[fig.accRight]); }
  }
  add((SM.head||{})[skin]);
  if (!isBack) add((SM.faces||{})[fig.face ?? 0]);
  add(isBack ? hw.rear : hw.front);
  return out;
}
// Збирає шари фігурки й обрізає порожні поля — щоб рамка виділення і масштаб були точні
const FE_FIG_CACHE = {};
function feComposeFigure(fig) {
  const key = JSON.stringify(feFigureLayerUrls(fig));
  if (FE_FIG_CACHE[key]) return Promise.resolve(FE_FIG_CACHE[key]);
  return new Promise(resolve => {
    const urls = feFigureLayerUrls(fig).filter(Boolean);
    if (!urls.length) return resolve(null);
    const done = r => { if (r) FE_FIG_CACHE[key] = r; resolve(r); };
    const cv = document.createElement('canvas');
    cv.width = FIG_SPRITE_W; cv.height = FIG_SPRITE_H;
    const ctx = cv.getContext('2d', { willReadFrequently: true });
    let loaded = 0; const imgs = urls.map(() => null);
    urls.forEach((u, i) => {
      const im = new Image(); im.crossOrigin = 'anonymous';
      im.onload = im.onerror = () => {
        imgs[i] = (im.complete && im.naturalWidth) ? im : null;
        if (++loaded !== urls.length) return;
        // Шари фігурки намальовані на спільному полотні 480×590 — їх просто
        // накладаємо. Предмет же намальований «в обріз», зі своїми пропорціями:
        // якщо втиснути його в те саме полотно, він сплющиться — саме це й було
        // видно на превʼю. Тому під предмет підганяємо полотно, зберігаючи його
        // співвідношення сторін. Висота лишається 590 — так само, як на фоні.
        const isItem = fig && fig.type === 'item';
        const first = imgs.find(Boolean);
        // Тваринка на фон намальована «в обріз» і має власний справжній розмір
        // у міліметрах. Переводимо його в пікселі спрайта — далі все рахується
        // тією ж міркою, що й для фігурок, і на фоні, і в превʼю.
        const af = feAnimalFrame(fig);
        if (af && first && first.naturalWidth) {
          const k = (af.wMm / MM_PER_SPRITE_PX) / first.naturalWidth;
          cv.width  = Math.max(1, Math.round(first.naturalWidth * k));
          cv.height = Math.max(1, Math.round(first.naturalHeight * k));
        } else if (isItem && first && first.naturalHeight) {
          const itm = (window.FE_ITEM_LIB || []).find(x => x.id === fig.itemId) || {};
          // Той самий рахунок, що й на фоні. spritePx — пікселі файлу вже є
          // пікселями спрайта, тож нічого не чіпаємо: ні пропорцій, ні розміру.
          // Решта предметів намальовані на повному полотні, їх зводимо до 480×590.
          const k = itm.spritePx ? (itm.scale || 1) : FIG_SPRITE_H / first.naturalHeight;
          cv.width  = Math.max(1, Math.round(first.naturalWidth * k));
          cv.height = Math.max(1, Math.round(first.naturalHeight * k));
        }
        imgs.forEach(x => { if (x) ctx.drawImage(x, 0, 0, cv.width, cv.height); });
        try { done(feTrimCanvas(cv)); } catch (e) {
          try { done({ url:cv.toDataURL('image/png'), cx:0.5 }); } catch (e2) { resolve(null); }
        }
      };
      im.src = feSpx(u, FE_SPRITE_PX);
    });
  });
}
// Обрізає прозорі поля навколо намальованого
function feTrimCanvas(cv) {
  const ctx = cv.getContext('2d', { willReadFrequently: true });
  const d = ctx.getImageData(0, 0, cv.width, cv.height).data;
  let minX = cv.width, minY = cv.height, maxX = -1, maxY = -1;
  for (let y = 0; y < cv.height; y++) {
    for (let x = 0; x < cv.width; x++) {
      if (d[(y * cv.width + x) * 4 + 3] > 8) {
        if (x < minX) minX = x; if (x > maxX) maxX = x;
        if (y < minY) minY = y; if (y > maxY) maxY = y;
      }
    }
  }
  if (maxX < 0) return { url: cv.toDataURL('image/png'), cx: 0.5 };
  const w = maxX - minX + 1, h = maxY - minY + 1;
  const out = document.createElement('canvas');
  out.width = w; out.height = h;
  out.getContext('2d').drawImage(cv, minX, minY, w, h, 0, 0, w, h);
  // cx — де у обрізаному зображенні опинився центр спрайта (там, де тіло фігурки)
  // ширину беремо з самого полотна: під предмет воно ширше за спрайт фігурки
  return { url: out.toDataURL('image/png'), cx: (cv.width / 2 - minX) / w };
}
// Відбиток фігурки: якщо людина її перезібрала або замінила іншою,
// відбиток зміниться — і збережений на полотні знімок треба перемалювати.
function feFigSig(fig) {
  try { return JSON.stringify(feFigureLayerUrls(fig)); } catch (e) { return ''; }
}
async function feAddFigureToCanvas(fig, index, total) {
  // Предмет із набору кладемо за правилами предметів: справжній розмір,
  // без розтягування. Підпис він отримує так само, як фігурка.
  if (fig && fig.type === 'item') return feAddItemFigure(fig, index, total);
  const r = await feComposeFigure(fig);
  if (!r) return;
  const dataUrl = r.url;
  const d = feDims();
  const pxPerMm = FE.baseH / d.hMm;
  const n = Math.max(total || 1, 1);
  const px = fig._px != null ? fig._px * FE.baseW : (FE.baseW/(n+1))*((index??0)+1);
  const py = fig._py != null ? fig._py * FE.baseH : FE.baseH*0.62;
  return new Promise(resolve => {
    fabric.Image.fromURL(dataUrl, img => {
      // єдиний масштаб для всіх спрайтів — тваринки лишаються природного розміру
      const scale = MM_PER_SPRITE_PX * pxPerMm;
      img.set({ left:px, top:py,
        originX:'center', originY:'center', scaleX:scale, scaleY:scale,
        // фігурка — тільки перетягування, без рамки й маркерів
        lockScalingX:true, lockScalingY:true, lockRotation:true,
        hasControls:false, hasBorders:false, lockUniScaling:true,
        _feKind:'figure', _feId:'f' + (++FE._idc), _feCx:r.cx, _feSig:feFigSig(fig),
        _feName:feFigName(fig)+' '+((index??0)+1) });
      feC().add(img); feSafeToFront(); feC().requestRenderAll(); resolve();
    });
  });
}

// ---- Перевірка виходу за безпечну зону ----
function feSafeRect() {
  const i = feInsetPx();
  return { left:i.x, top:i.y, right:FE.baseW - i.x, bottom:FE.baseH - i.y };
}
function feIsOutside(o) {
  if (!o || o._feSafe) return false;
  const s = feSafeRect(), b = o.getBoundingRect(true);
  const t = 1.5; // допуск
  return b.left < s.left - t || b.top < s.top - t ||
         b.left + b.width > s.right + t || b.top + b.height > s.bottom + t;
}
function feCheckOutside(o) {
  if (feLGet('fe_outside_hidden') === '1') return;
  if (!feIsOutside(o)) return;
  feModal('fe-m-outside');
}
function feOutsideNeverShow() { feLSet('fe_outside_hidden', '1'); feModalClose(); }

// ============================================================
// КРОК 2 — РЕДАКТОР
// ============================================================
// Чи є незбережені зміни (після останнього «Готово»)
function feDirty() { return !!FE._dirty; }
// saved = true тільки з кнопки «Зберегти». Стрілка «назад» веде на той самий
// етап «Фон», а не на фінал: людина фон не зберегла, отже й крок не пройдено.
function feBackToSetup(ask, saved) {
  if (ask && feDirty()) {
    if (!confirm('Вийти без збереження?\n\nЗміни фону не збережуться.\nЩоб зберегти — натисніть «Зберегти» вгорі праворуч.')) return;
    // відкидаємо все, що зробили після останнього «Готово»
    if (FE.canvas) { FE.canvas.dispose(); FE.canvas = null; }
    feApplyLayoutMeta();
  }
  // Превʼю рамки на першому екрані раніше оновлювалось лише через «Готово».
  // Через це здавалось, що чернетка не зберігається, хоча вона зберігалась.
  if (FE.canvas) {
    try { FE._bgPreview = feCapture(true, { format:'jpeg', quality:0.7, mult:0.5 }); } catch (e) {}
    feStashLayout();
  }
  FE._dirty = false;
  feLockPageScroll(false);
  document.getElementById('fe-editor').classList.remove('active');
  document.getElementById('fe-setup').style.display = 'flex';
  // після роботи з фоном ведемо людину далі — на фінал
  if (feBgDone() || FE.figures.length) FE._frameOk = true;
  // На фінал ведемо лише після свідомого збереження фону
  if (saved && feBgDone() && FE.figures.length) {
    FE._maxStep = FE_STEPS.length - 1;
    FE._setupTab = 'final';
  } else {
    FE._setupTab = 'bg';
    FE._maxStep = Math.max(feMaxStep(), 2);
  }
  feClosePanel(); feInitSetup();
}
// ============================================================
// ЕКСКУРСІЯ ІНТЕРФЕЙСОМ
// Коротке знайомство з кнопками для тих, хто тут уперше. Показуємо один
// раз, далі — лише за бажанням, кнопкою «?» у верхній смузі.
// Кожен крок: іконка тієї самої кнопки, назва і одне речення по суті.
// ============================================================
const FE_TOUR = [
  { ico:'templates', t:'Шаблони',
    d:'Готові фони. Обираєш — і далі міняєш під себе: колір, написи, картинки. Фігурки й підписи при цьому лишаються на місці.' },
  { ico:'bgTool', t:'Фон',
    d:'Суцільний колір або перехід кольорів. Звідси ж вантажать власне фото на весь аркуш.' },
  { ico:'text', t:'Текст',
    d:'Написи: імена, дата, побажання. Виділив слово в полі «Текст напису» — і шрифт, розмір чи колір підуть тільки на нього.' },
  { ico:'files', t:'Файли',
    d:'Свої фото й картинки. Фото можна обрізати ножицями по боках, закруглити кути й додати рамку.' },
  { ico:'shapes', t:'Фігури',
    d:'Серця, зірки, лінії, стрілки й мʼякі кольорові плями для підкладки під написи.' },
  { ico:'stickers', t:'Стікери',
    d:'Дрібний декор і емодзі — швидко оживити порожнє місце.' },
  { ico:'layers', t:'Шари',
    d:'Список усього, що на фоні. Звідси зручно замикати те, що більше не чіпаєш, і міняти порядок.' },
  { pill:true, t:'Фігурки — показати / сховати',
    d:'Кнопка вгорі. Фігурки на друк не йдуть, їх наклеюють вручну — але видно, скільки місця вони займуть.' },
  { dash:true, t:'Пунктирна лінія',
    d:'Усе за нею накриє рамка. Тримайте всередині обличчя, написи й дати — решта може обрізатись.' },
  { save:true, t:'Зберегти',
    d:'Кнопка вгорі праворуч. Доки не натиснете — фон вважається неоформленим. Робота тим часом сама лягає в чернетку.' },
];
let feTourI = 0;
function feTourStart(fromButton) {
  feTourI = 0;
  feModalClose();
  feTourRender();
  feModal('fe-m-tour');
  if (!fromButton) feLSet('fe_tour_seen', '1');
}
function feTourNext(d) {
  feTourI += d;
  if (feTourI < 0) feTourI = 0;
  if (feTourI >= FE_TOUR.length) { feTourEnd(); return; }
  feTourRender();
}
function feTourEnd() {
  feLSet('fe_tour_seen', '1');
  feModalClose();
  // тепер можна показати пульсацію на кнопках — людина вже дивиться на екран
  setTimeout(feFirstRunHints, 150);
}
function feTourRender() {
  const s = FE_TOUR[feTourI];
  const box = document.getElementById('fe-tour-body');
  if (!s || !box) return;
  const ico = s.ico ? feIco(s.ico)
    : s.pill ? feIco('figures')
    : s.dash ? '<svg viewBox="0 0 40 30" aria-hidden="true"><rect x="2" y="2" width="36" height="26" rx="3" fill="none" stroke="currentColor" stroke-width="2" stroke-dasharray="5 4"/></svg>'
    : '✓';
  box.innerHTML =
    '<div class="fe-tour-ico">' + ico + '</div>' +
    '<div class="fe-tour-t">' + s.t + '</div>' +
    '<div class="fe-tour-d">' + s.d + '</div>';
  const dots = document.getElementById('fe-tour-dots');
  if (dots) dots.innerHTML = FE_TOUR.map((x, i) =>
    '<i class="' + (i === feTourI ? 'on' : '') + '"></i>').join('');
  const back = document.getElementById('fe-tour-back');
  if (back) back.disabled = feTourI === 0;
  const next = document.getElementById('fe-tour-next');
  if (next) next.textContent = feTourI === FE_TOUR.length - 1 ? 'Готово' : 'Далі →';
  const cnt = document.getElementById('fe-tour-count');
  if (cnt) cnt.textContent = (feTourI + 1) + ' / ' + FE_TOUR.length;
}
// ===== ПІДКАЗКИ В РЕДАКТОРІ (телефон) =====
// Фігурки одразу видно; підсвічуємо лише перемикач, щоб його помітили.
function feFirstRunHints() {
  if (feLGet('fe_hints_seen')) return;
  feLSet('fe_hints_seen', '1');

  // 1. Підсвічуємо кнопку на 10 секунд
  setTimeout(() => {
    const b = document.getElementById('fe-btn-figs');
    if (!b) return;
    b.classList.add('pulse');
    const tip = document.createElement('div');
    tip.className = 'fe-tip-figs';
    tip.textContent = 'Клацни — показати / сховати фігурки';
    b.appendChild(tip);
    const kill = () => { b.classList.remove('pulse'); tip.remove(); b.removeEventListener('click', kill); };
    b.addEventListener('click', kill);
    setTimeout(kill, 10000);
  }, 150);

  // 2. Підказка, що панель інструментів гортається пальцем
  if (window.innerWidth <= 860) setTimeout(() => feSwipeTip(), 600);
}
function feSwipeTip() {
  const tools = document.getElementById('fe-tools');
  if (!tools || document.getElementById('fe-swipe-tip')) return;
  const tip = document.createElement('div');
  tip.id = 'fe-swipe-tip';
  tip.className = 'fe-swipe-tip';
  tip.innerHTML = `<span>‹‹</span><b>🖐</b><span>››</span>`;
  // ВАЖЛИВО: не чіпаємо position самої панелі — вона вже absolute,
  // інакше bottom:8px починає рахуватись від верху й панель летить угору
  tools.appendChild(tip);
  let done = false;
  const kill = () => {
    if (done) return; done = true;
    clearTimeout(t); tools.removeEventListener('scroll', kill);
    tip.classList.add('gone'); setTimeout(() => tip.remove(), 250);
  };
  const t = setTimeout(kill, 5000);
  tools.addEventListener('scroll', kill, { passive:true });
  tip.addEventListener('click', kill);
}

// iOS зсуває фіксовані елементи, коли сторінка прокрутилась через фокус у полі.
// Тримаємо вікно на нулі, поки відкритий редактор.
function feLockPageScroll(on) {
  document.documentElement.classList.toggle('fe-noscroll', !!on);
  document.body.classList.toggle('fe-noscroll', !!on);
  if (on) {
    if (!FE._scrollFix) {
      FE._scrollFix = () => { if (window.scrollY || window.scrollX) window.scrollTo(0, 0); };
      window.addEventListener('scroll', FE._scrollFix, { passive:true });
      document.addEventListener('focusout', () => setTimeout(FE._scrollFix, 50));
    }
    window.scrollTo(0, 0);
  }
}

async function feOpenEditor() {
  feLockPageScroll(true);
  document.getElementById('fe-setup').style.display = 'none';
  // ---
  document.getElementById('fe-editor').classList.add('active');
  feSyncSnapBtn();     // магніт має одразу показувати, увімкнене прилипання чи ні

  const d = feDims(), ratio = d.wMm / d.hMm;
  FE.baseW = ratio >= 1 ? CANVAS_LONG_PX : Math.round(CANVAS_LONG_PX * ratio);
  FE.baseH = ratio >= 1 ? Math.round(CANVAS_LONG_PX / ratio) : CANVAS_LONG_PX;

  if (FE.canvas) { FE.canvas.dispose(); FE.canvas = null; }
  const el = document.getElementById('fe-canvas');
  el.width = FE.baseW; el.height = FE.baseH;

  feSetupControls();
  // Фільтри рахуємо на Canvas2D, а не на WebGL: у WebGL є межа текстури
  // (типово 2048 px), через яку великі фото після «чорно-білого» обрізалися.
  fabric.enableGLFiltering = false;
  fabric.textureSize = 4096;
  FE.canvas = new fabric.Canvas('fe-canvas', {
    backgroundColor:'#FFFFFF', preserveObjectStacking:true, selection:true,
    selectionColor:'rgba(237,208,92,.12)', selectionBorderColor:'#EDD05C', selectionLineWidth:1.5 });
  FE.canvas.setWidth(FE.baseW); FE.canvas.setHeight(FE.baseH);

  feDrawSafeZone(); feBindCanvas(); feBindContextMenu(); feZoomStart(); feRenderCtx(); feSyncFigsBtn(); fePreloadFonts();
  FE.figsHidden = false;

  // ---- спроба відновити чернетку ----
  const saved = feLoadState();
  if (saved) {
    FE.myTpl   = FE.myTpl   || saved.myTpl   || [];
    FE.uploads = FE.uploads.length ? FE.uploads : (saved.uploads || []);
    FE.layouts = FE.layouts || saved.layouts || {};
  }
  // макет цієї конкретної рамки (розмір + орієнтація)
  const L = (FE.layouts || {})[feLayoutKey()];
  if (L && L.canvas && await feAskRestore()) {
    FE.captions = L.captions || { names:{}, s:null };
    FE.template = L.template || null;
    FE.hLock = true;
    await new Promise(res => FE.canvas.loadFromJSON(L.canvas, () => {
      FE.canvas.getObjects().forEach(feRehydrate);
      // без пунктиру у збереженні — домалюємо
      if (!FE.canvas.getObjects().some(o => o._feSafe)) feDrawSafeZone();
      feFixFigures(); feEnsureFonts();
      feSafeToFront(); FE.canvas.requestRenderAll(); res();
    }));
    FE.hLock = false;
    // прибираємо зайві фігурки, якщо їх більше ніж у наборі
    const figs = feFiguresOnCanvas();
    figs.slice(FE.figures.length).forEach(o => {
      delete FE.captions.names[o._feId];
      FE.canvas.getObjects().filter(x => x._feKind === 'caption' && x._feFigId === o._feId)
        .forEach(x => FE.canvas.remove(x));
      FE.canvas.remove(o);
    });
    // Зводимо набір фігурок із тим, що лежить на полотні.
    // Раніше тут лише прибирались зайві. Якщо ж людина повернулась на крок
    // назад і замінила фігурку, на полотні лишався старий знімок, а коли
    // макет зберігся без фігурок — вони зникали назовсім і не поверталися.
    const onCanvas = feFiguresOnCanvas();
    for (let i = 0; i < FE.figures.length; i++) {
      const src = FE.figures[i];
      const cur = onCanvas[i];
      const sig = feFigSig(src);
      if (cur && cur._feSig && cur._feSig === sig) {
        src._placed = cur._feId; cur._feSrc = i;    // та сама фігурка — лишаємо
        continue;
      }
      if (cur) {                                    // застаріла — прибираємо разом із підписом
        delete FE.captions.names[cur._feId];
        FE.canvas.getObjects()
          .filter(x => x._feKind === 'caption' && x._feFigId === cur._feId)
          .forEach(x => FE.canvas.remove(x));
        // позицію лишаємо ту саму, щоб нова стала на місце старої
        if (src._px == null) { src._px = cur.left / FE.baseW; src._py = cur.top / FE.baseH; }
        FE.canvas.remove(cur);
      }
      src._placed = null;
      await feAddFigureToCanvas(src, i, FE.figures.length);
      const added = feFiguresOnCanvas().slice(-1)[0];
      if (added) { src._placed = added._feId; added._feSrc = i; }
    }
    feClampFigures(); feSyncCaptions(true); feApplyFigsVis();
    FE.history = []; FE.hIndex = -1; feSnapshot();
    feToast('Чернетку відновлено');
    // на телефоні панель не відкриваємо самі — вона займає весь екран
    if (window.innerWidth > 860) feTool('templates');
    feFirstRunHints();      // продовжуємо роботу — нагадувати нема про що
    return;
  }

  FE.captions.names = {};
  for (let i = 0; i < FE.figures.length; i++) {
    FE.figures[i]._placed = null;
    await feAddFigureToCanvas(FE.figures[i], i, FE.figures.length);
    const added = feFiguresOnCanvas().slice(-1)[0];
    if (added) { FE.figures[i]._placed = added._feId; added._feSrc = i; }
  }
  feClampFigures();

  FE.history = []; FE.hIndex = -1; feSnapshot();
  if (window.innerWidth > 860) feTool('templates');
  // Уперше — знайомство з кнопками. Далі нічого не показуємо: про пунктир
  // попереджає окреме вікно в момент, коли щось справді за нього вилізло,
  // а стара підказка лише дублювала екскурсію й збивала з пантелику.
  // Підказки-пульсації запускаємо ПІСЛЯ екскурсії: інакше вони встигали
  // згаснути, поки людина читала, і вона їх просто не бачила.
  if (!feLGet('fe_tour_seen')) feTourStart();
  else feFirstRunHints();
}
// ============================================================
// ПОПЕРЕДЖЕННЯ ПРО ВИХІД ЗА ПУНКТИР
// Усе, що перетинає пунктирну лінію, накриється рамкою й не буде видно.
// Раніше про це писало лише вікно-підказка на початку — і людина про це
// забувала. Тепер смуга зʼявляється просто в момент, коли щось вилізло.
// ============================================================
function feKeepOnCanvas(o) {
  if (!o || o._feSafe) return false;
  const i = feInsetPx();
  const L = i.x, T = i.y, R = FE.baseW - i.x, B = FE.baseH - i.y;
  o.setCoords();
  const r = o.getBoundingRect(true, true);
  // лишився хоч клаптик у межах пунктиру — не чіпаємо
  const overlaps = r.left < R && r.left + r.width > L && r.top < B && r.top + r.height > T;
  if (overlaps) return false;
  let dx = 0, dy = 0;
  if (r.left + r.width <= L) dx = L - (r.left + r.width) + Math.min(r.width, 40);
  else if (r.left >= R)      dx = R - r.left - Math.min(r.width, 40);
  if (r.top + r.height <= T) dy = T - (r.top + r.height) + Math.min(r.height, 40);
  else if (r.top >= B)       dy = B - r.top - Math.min(r.height, 40);
  if (!dx && !dy) return false;
  o.set({ left:o.left + dx, top:o.top + dy });
  o.setCoords();
  return true;
}
function feOutsideSafe() {
  const c = FE.canvas; if (!c) return [];
  const i = feInsetPx();
  const L = i.x, T = i.y, R = FE.baseW - i.x, B = FE.baseH - i.y;
  return c.getObjects().filter(o => {
    if (o._feSafe || o.visible === false) return false;
    const r = o.getBoundingRect(true, true);
    return r.left < L - 1 || r.top < T - 1
        || r.left + r.width > R + 1 || r.top + r.height > B + 1;
  });
}
// Чи виходить конкретний обʼєкт за пунктир
function feIsOutsideSafe(o) {
  if (!o || o._feSafe || o.visible === false || !FE.canvas) return false;
  const i = feInsetPx();
  const r = o.getBoundingRect(true, true);
  return r.left < i.x - 1 || r.top < i.y - 1
      || r.left + r.width > FE.baseW - i.x + 1
      || r.top + r.height > FE.baseH - i.y + 1;
}
// Попереджаємо про ТОЙ обʼєкт, який щойно рухали, і тільки в мить, коли він
// перетнув пунктир. Раніше перевірялося все полотно однією позначкою: фонове
// фото, яке лежить за пунктиром навмисне, вмикало попередження на першому ж
// русі будь-чого — а потім позначка так і лишалась піднятою, і про справжній
// вихід за межі вже ніхто не казав.
function feSafeWarn(target) {
  const ed = document.getElementById('fe-editor');
  if (!ed || !ed.classList.contains('active')) return;

  const list = target ? [target] : feOutsideSafe();
  list.forEach(o => {
    const out = feIsOutsideSafe(o);
    if (!out) { o._feWasOut = false; return; }   // повернувся — скажемо наступного разу
    if (o._feWasOut) return;                     // уже був за межами, не бубнимо
    o._feWasOut = true;
    if (feLGet('fe_safe_never')) return;         // людина попросила не нагадувати
    feModal('fe-m-safe');
  });
}
// «Більше не нагадувати» у вікні про пунктир.
// Позначка скидається при «Почати спочатку» — щоб нове попередження
// побачив навіть той, хто колись її поставив.
function feSafeNever() {
  feLSet('fe_safe_never', '1');
  feModalClose();
  feToast('Більше не нагадуватимемо про пунктир');
}



// Відступ безпечної зони в пікселях канви (рівно 5 мм від краю фону)
function feInsetPx() {
  const d = feDims();
  return { x: FE.baseW * (SAFE_INSET_MM / d.wMm), y: FE.baseH * (SAFE_INSET_MM / d.hMm) };
}
// Вигляд маркерів виділення — круглі білі з помаранчевим контуром
function feSetupControls() {
  if (FE._ctrlsDone) return;
  FE._ctrlsDone = true;

  // iOS зумить сторінку, коли фокус потрапляє в поле зі шрифтом менше 16px.
  // Fabric створює для редагування тексту приховане поле з розміром 1px і
  // одразу ставить у нього фокус — тож правити його треба саме при створенні,
  // а не після enterEditing: там уже пізно, зум устиг спрацювати.
  if (fabric.IText && fabric.IText.prototype.initHiddenTextarea) {
    const origInit = fabric.IText.prototype.initHiddenTextarea;
    fabric.IText.prototype.initHiddenTextarea = function () {
      origInit.call(this);
      if (this.hiddenTextarea) this.hiddenTextarea.style.fontSize = '16px';
    };
  }
  const P = fabric.Object.prototype;
  P.transparentCorners = false;
  P.cornerStyle   = 'circle';
  P.cornerColor   = '#FFFFFF';
  P.cornerStrokeColor = '#EDD05C';
  P.cornerSize    = 11;
  // на сенсорних екранах fabric малює маркери розміром touchCornerSize (типово 24) —
  // це завелико, перекриває дрібні аксесуари
  P.touchCornerSize = 13;
  P.borderColor   = '#EDD05C';
  P.borderScaleFactor = 1.6;
  P.padding       = 2;
  P.rotatingPointOffset = 30;
  if (fabric.Textbox) {
    fabric.Textbox.prototype.cornerColor = '#FFFFFF';
    fabric.Textbox.prototype.cornerStrokeColor = '#EDD05C';
  }
  // круглий маркер повороту зі стрілкою
  const rotIcon = new Image();
  rotIcon.src = 'data:image/svg+xml;utf8,' + encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30">
      <circle cx="15" cy="15" r="12" fill="#fff" stroke="#EDD05C" stroke-width="2"/>
      <path d="M10 15a5 5 0 1 1 1.6 3.6" fill="none" stroke="#EDD05C" stroke-width="2" stroke-linecap="round"/>
      <path d="M9 12.5l1.2 3 3-1.2z" fill="#EDD05C"/></svg>`);
  if (fabric.Object.prototype.controls && fabric.Object.prototype.controls.mtr) {
    fabric.Object.prototype.controls.mtr.render = function (ctx, left, top) {
      const s = 26;
      ctx.save(); ctx.translate(left, top);
      if (rotIcon.complete) ctx.drawImage(rotIcon, -s/2, -s/2, s, s);
      ctx.restore();
    };
    fabric.Object.prototype.controls.mtr.sizeX = 26;
    fabric.Object.prototype.controls.mtr.sizeY = 26;
  }
}
function feDrawSafeZone() {
  const i = feInsetPx();
  const r = new fabric.Rect({ left:i.x, top:i.y,
    width:FE.baseW - i.x*2, height:FE.baseH - i.y*2, fill:'transparent',
    stroke:'rgba(120,130,150,.65)', strokeWidth:2, strokeDashArray:[9,7],
    selectable:false, evented:false, excludeFromExport:true, _feSafe:true });
  feC().add(r); r.moveTo(9999);
}
function feSafeToFront() {
  if (!FE.canvas) return;
  // фігурки, підписи та аксесуари — завжди поверх фонових елементів
  FE.canvas.getObjects()
    .filter(o => o._feKind === 'figure' || o._feKind === 'caption'
              || o._feKind === 'accessory' || o._feKind === 'item')
    .forEach(o => o.moveTo(9998));
  const s = FE.canvas.getObjects().find(o => o._feSafe);
  if (s) s.moveTo(9999);
}

// ============================================================
// ГЕОМЕТРІЯ: фігури, стрілки, фоторамки  (viewBox 100×100)
// ============================================================
const FE_PATH = {
  heart:   'M50 90C16 64 6 47 6 31 6 16 17 6 30 6c9 0 16 4 20 11 4-7 11-11 20-11 13 0 24 10 24 25 0 16-10 33-44 59z',
  star:    'M50 4l13 30 33 3-25 22 8 33-29-18-29 18 8-33L4 37l33-3z',
  diamond: 'M50 2l48 48-48 48L2 50z',
  hexagon: 'M27 6h46l25 44-25 44H27L2 50z',
  pentagon:'M50 3l47 34-18 55H21L3 37z',
  arch:    'M6 96V44a44 44 0 0 1 88 0v52z',
  blob:    'M78 14c14 12 20 34 12 51S58 96 40 92 6 70 6 50 18 14 34 8s30-6 44 6z',
  burst:   'M50 2l9 16 17-8-3 19 19 3-11 15 14 13-19 7 5 19-19-5-8 18-12-15-16 11-1-20-19 2 8-18-16-9 15-12-9-17 19 3z',
  film:    'M4 22h92v56H4z',
  tri:     'M50 6l46 88H4z',
  arrowR:  'M4 38h56V16l36 34-36 34V62H4z',
  arrowL:  'M96 38H40V16L4 50l36 34V62h56z',
  arrowU:  'M38 96V40H16L50 4l34 36H62v56z',
  arrowD:  'M38 4v56H16l34 36 34-36H62V4z',
  arrowLR: 'M4 50l22-20v12h48V30l22 20-22 20V58H26v12z',
  arrowUD: 'M50 4l20 22H58v48h12L50 96 30 74h12V26H30z',
  arrowThin:'M4 50h80M68 34l18 16-18 16',
  arrowCurve:'M8 84C8 40 40 20 82 20M66 8l18 12-18 14',
  chevron: 'M30 12l34 38-34 38',
  dblChev: 'M20 12l30 38-30 38M52 12l30 38-30 38',
  caret:   'M12 32l38 36 38-36',
  zigzag:  'M4 62l22-24 20 20 22-30 26 26',
  spiral:  'M56 50a10 10 0 1 1-12-10 22 22 0 1 1 24 24',
  dashed:  'M6 50h12M28 50h12M50 50h12M72 50h8M78 38l14 12-14 12',
  dotted:  'M8 50h4M22 50h4M36 50h4M50 50h4M64 50h4M76 38l14 12-14 12',
  corner:  'M10 14h50v50M46 50l14 14 14-14',
  lineV:    'M50 6v88',
  lineDash: 'M6 50h14M30 50h14M56 50h14M80 50h14',
};
// Створює обʼєкт фігури розміром w×h з центром у (0,0)
function feMakeShape(id, w, h, opts) {
  opts = opts || {};
  const base = { originX:'center', originY:'center', fill:opts.fill || '#E53935',
                 stroke:opts.stroke || null, strokeWidth:opts.strokeWidth || 0,
                 strokeUniform:true };
  if (id === 'rect')   return new fabric.Rect({ ...base, width:w, height:h, rx:opts.rx||0, ry:opts.rx||0 });
  // заокруглений прямокутник — справжній Rect, а не розтягнутий контур,
  // тому кути лишаються рівними колами за будь-яких пропорцій
  if (id === 'rect-r') {
    const r = opts.rx != null ? opts.rx : Math.min(w, h) * 0.18;
    return new fabric.Rect({ ...base, width:w, height:h, rx:r, ry:r });
  }
  if (id === 'circle') return new fabric.Circle({ ...base, radius:Math.min(w,h)/2 });
  if (id === 'ellipse')return new fabric.Ellipse({ ...base, rx:w/2, ry:h/2 });
  if (id === 'line')   return new fabric.Line([-w/2,0,w/2,0], { originX:'center', originY:'center',
                              stroke:opts.fill || '#1B2433', strokeWidth:opts.strokeWidth || 4 });
  const d = FE_PATH[id];
  if (!d) return null;
  const stroked = ['arrowThin','arrowCurve','chevron','dblChev','caret','zigzag','spiral','dashed','dotted','corner','lineV','lineDash'].includes(id);
  const p = new fabric.Path(d, {
    ...base,
    fill: stroked ? 'transparent' : base.fill,
    stroke: stroked ? (opts.fill || '#1B2433') : base.stroke,
    strokeWidth: stroked ? 7 : base.strokeWidth,
    strokeLineCap:'round', strokeLineJoin:'round',
  });
  p.set({ scaleX: w / 100, scaleY: h / 100 });
  return p;
}
const FE_SHAPES = [
  {id:'rect',n:'Прямокутник'},{id:'circle',n:'Коло'},{id:'ellipse',n:'Овал'},{id:'tri',n:'Трикутник'},
  {id:'diamond',n:'Ромб'},{id:'star',n:'Зірка'},{id:'heart',n:'Серце'},{id:'hexagon',n:'Шестикутник'},
  {id:'pentagon',n:'Пʼятикутник'},{id:'burst',n:'Спалах'},{id:'blob',n:'Пляма'},{id:'line',n:'Лінія'},
];
const FE_ARROWS = ['line','lineV','lineDash','arrowR','arrowL','arrowU','arrowD','arrowLR','arrowUD',
                   'arrowThin','arrowCurve','chevron','dblChev','caret','zigzag','spiral',
                   'dashed','dotted','corner'];
// Кожна форма — один path (може містити кілька підконтурів) у системі 100×100
const FE_FRAME_D = {
  'square':  'M0 0h100v100H0z',            // рівний квадрат
  'pano':    'M0 0h236v104H0z',            // панорама 59 × 26
  'rect':    'M2 12h96v76H2z',
  'rect-r':  'M16 12h64a14 14 0 0 1 14 14v48a14 14 0 0 1-14 14H16A14 14 0 0 1 2 74V26A14 14 0 0 1 16 12z',
  'circle':  'M50 4a46 46 0 1 1-.1 0z',
  'ellipse': 'M50 14c26 0 46 16 46 36S76 86 50 86 4 70 4 50s20-36 46-36z',
  'arch':    'M4 96V46a46 46 0 0 1 92 0v50z',
  'tri':     'M50 6l46 88H4z',
  'diamond': 'M50 2l48 48-48 48L2 50z',
  'hexagon': 'M27 8h46l25 42-25 42H27L2 50z',
  'pentagon':'M50 4l47 34-18 55H21L3 38z',
  'blob':    'M78 14c14 12 20 34 12 51S58 96 40 92 6 70 6 50 18 14 34 8s30-6 44 6z',
  'heart':   'M50 92C16 66 4 48 4 31 4 16 15 5 29 5c9 0 16 4 21 11 5-7 12-11 21-11 14 0 25 11 25 26 0 17-12 35-46 61z',
  'star':    'M50 4l13 30 33 3-25 22 8 33-29-18-29 18 8-33L4 37l33-3z',
  'burst':   'M50 2l9 16 17-8-3 19 19 3-11 15 14 13-19 7 5 19-19-5-8 18-12-15-16 11-1-20-19 2 8-18-16-9 15-12-9-17 19 3z',
  // Плівка й розрізи
  'split2v': 'M2 12h45v76H2z M53 12h45v76H53z',
  'split2h': 'M2 10h96v36H2z M2 54h96v36H2z',
  'split3v': 'M2 12h29v76H2z M35.5 12h29v76h-29z M69 12h29v76H69z',
  'split4':  'M2 10h45v36H2z M53 10h45v36H53z M2 54h45v36H2z M53 54h45v36H53z',
  'film3':   'M14 8h72v24H14z M14 38h72v24H14z M14 68h72v24H14z',
  'wide':    'M2 26h96v48H2z',
  'tall':    'M20 4h60v92H20z',
  'circsq':  'M50 8a42 42 0 1 1-.1 0z M2 78h96v14H2z',
};
const FE_FRAME_GROUPS = {
  'Базові': ['square','pano','rect-r','circle','ellipse','arch','tri','diamond','hexagon','pentagon','blob'],
  'Плівка й розрізи': ['split2v','split2h','split3v','split4','film3','wide','tall','circsq'],
  'Декор':  ['heart','star','burst'],
};
const FE_FRAMES = [].concat(FE_FRAME_GROUPS['Базові'], FE_FRAME_GROUPS['Плівка й розрізи'], FE_FRAME_GROUPS['Декор']);
function feFrameD(id) { return FE_FRAME_D[id] || FE_FRAME_D.rect; }
// Прямокутні форми малюємо звичайним прямокутником — так працює заокруглення
// «wide» і «tall» — теж звичайні прямокутники, лише інших пропорцій,
// тому заокруглення кутів має працювати і для них.
function feIsRectShape(id) {
  return id === 'rect' || id === 'square' || id === 'pano'
      || id === 'wide' || id === 'tall';
}

// Кутасті форми описуємо вершинами — тоді кути можна заокруглювати
const FE_FRAME_POLY = {
  tri:      [[50,6],[96,94],[4,94]],
  diamond:  [[50,2],[98,50],[50,98],[2,50]],
  hexagon:  [[27,8],[73,8],[98,50],[73,92],[27,92],[2,50]],
  pentagon: [[50,4],[97,38],[79,93],[21,93],[3,38]],
  star:     [[50,4],[63,34],[96,37],[71,59],[79,92],[50,74],[21,92],[29,59],[4,37],[37,34]],
};
function feIsPolyShape(id) { return !!FE_FRAME_POLY[id]; }
function feHasCorners(id) { return feIsRectShape(id) || feIsPolyShape(id); }

// Малює багатокутник із заокругленими кутами. Точки — вже у фінальному
// масштабі, тому радіус однаковий по всіх кутах.
function fePolyPath(pts, r) {
  const n = pts.length;
  const V = (a, b) => [b[0]-a[0], b[1]-a[1]];
  const len = v => Math.hypot(v[0], v[1]) || 1;
  let d = '';
  for (let i = 0; i < n; i++) {
    const prev = pts[(i - 1 + n) % n], cur = pts[i], next = pts[(i + 1) % n];
    const vIn = V(cur, prev), vOut = V(cur, next);
    const lIn = len(vIn), lOut = len(vOut);
    // радіус не може зʼїсти більше половини сторони
    const rr = Math.max(0, Math.min(r, lIn / 2, lOut / 2));
    const a = [cur[0] + vIn[0] / lIn * rr,  cur[1] + vIn[1] / lIn * rr];
    const b = [cur[0] + vOut[0] / lOut * rr, cur[1] + vOut[1] / lOut * rr];
    d += (i === 0 ? `M${a[0].toFixed(2)} ${a[1].toFixed(2)}`
                  : `L${a[0].toFixed(2)} ${a[1].toFixed(2)}`);
    if (rr > 0.01) d += `Q${cur[0].toFixed(2)} ${cur[1].toFixed(2)} ${b[0].toFixed(2)} ${b[1].toFixed(2)}`;
    else d += `L${b[0].toFixed(2)} ${b[1].toFixed(2)}`;
  }
  return d + 'Z';
}
// Обʼєкт форми потрібного розміру із заданим заокругленням кутів
function feFrameShapeObj(id, FW, FH, rPx) {
  const r = Math.max(0, rPx || 0);
  if (feIsRectShape(id)) {
    const rr = Math.min(r, FW / 2, FH / 2);
    return new fabric.Rect({ width:FW, height:FH, rx:rr, ry:rr,
      originX:'center', originY:'center', left:0, top:0 });
  }
  if (feIsPolyShape(id) && r > 0) {
    const P = FE_FRAME_POLY[id];
    const xs = P.map(p => p[0]), ys = P.map(p => p[1]);
    const x0 = Math.min(...xs), y0 = Math.min(...ys);
    const kx = FW / (Math.max(...xs) - x0), ky = FH / (Math.max(...ys) - y0);
    const pts = P.map(p => [(p[0] - x0) * kx, (p[1] - y0) * ky]);
    const p = new fabric.Path(fePolyPath(pts, r), {
      originX:'center', originY:'center', fill:'#000', left:0, top:0 });
    return p;
  }
  const c = feFrameClip(id, FW, FH);
  c.set({ left:0, top:0 });
  return c;
}
// Співвідношення сторін контуру (ширина/висота) — рахуємо з самого шляху
const _feArCache = {};
function feFrameAspect(id) {
  if (_feArCache[id]) return _feArCache[id];
  let ar = 1;
  try {
    const p = new fabric.Path(feFrameD(id));
    if (p.width && p.height) ar = p.width / p.height;
  } catch (e) {}
  return (_feArCache[id] = ar);
}
// Обʼєкт-маска потрібного розміру, центрований
function feFrameClip(id, W, H) {
  const p = new fabric.Path(feFrameD(id), {
    originX:'center', originY:'center', fill:'#000', fillRule:'nonzero',
  });
  // Контури намальовані по-різному в межах поля 100×100 (наприклад, «rect»
  // займає лише 96×76). Тому масштабуємо не від 100, а від реальних габаритів
  // самого контуру — інакше маска й пунктир виходять меншими за рамку.
  const bw = p.width || 100, bh = p.height || 100;
  p.set({ scaleX: W / bw, scaleY: H / bh, left:0, top:0 });
  return p;
}
// SVG-превʼю у стилі «небо + пагорби + сонце»
function feFramePreviewSvg(id) {
  const cid = 'fc' + id.replace(/[^a-z0-9]/gi, '');
  // Контури намальовані в різних масштабах (панорама — 236×104), тому
  // вписуємо кожен у поле 100×100 з його власними пропорціями. Інакше всі
  // прямокутні форми в списку виглядали однаковими квадратами.
  let sc = 1, dx = 0, dy = 0, bw = 100, bh = 100;
  try {
    const p = new fabric.Path(feFrameD(id));
    bw = p.width || 100; bh = p.height || 100;
    sc = Math.min(100 / bw, 100 / bh);
    dx = (100 - bw * sc) / 2 - (p.pathOffset ? (p.pathOffset.x - bw / 2) * sc : 0);
    dy = (100 - bh * sc) / 2 - (p.pathOffset ? (p.pathOffset.y - bh / 2) * sc : 0);
  } catch (e) {}
  // transform ставимо на сам <path>: <g> усередині <clipPath> браузер ігнорує,
  // і через це всі превʼю зникали
  return `<defs><clipPath id="${cid}">
      <path d="${feFrameD(id)}" transform="translate(${dx} ${dy}) scale(${sc})"/>
    </clipPath></defs>
    <g clip-path="url(#${cid})">
      <rect x="0" y="0" width="100" height="100" fill="#CFE3F5"/>
      <circle cx="72" cy="28" r="9" fill="#FFFFFF"/>
      <path d="M0 66l24-18 20 14 22-20 34 26v34H0z" fill="#8FC98A"/>
      <path d="M0 82l30-16 26 12 44-18v42H0z" fill="#6FB86C"/>
    </g>`;
}

// SVG-превʼю для плитки
function feShapeSvg(id, color, stroked) {
  if (id === 'rect')    return `<rect x="8" y="20" width="84" height="60" fill="${color}"/>`;
  if (id === 'rect-r')  return `<rect x="8" y="20" width="84" height="60" rx="14" fill="${color}"/>`;
  if (id === 'circle')  return `<circle cx="50" cy="50" r="44" fill="${color}"/>`;
  if (id === 'ellipse') return `<ellipse cx="50" cy="50" rx="46" ry="32" fill="${color}"/>`;
  if (id === 'line')    return `<path d="M6 50h88" stroke="${color}" stroke-width="8" stroke-linecap="round"/>`;
  const d = FE_PATH[id]; if (!d) return '';
  const st = ['arrowThin','arrowCurve','chevron','dblChev','caret','zigzag','spiral','dashed','dotted','corner','lineV','lineDash'].includes(id);
  return st ? `<path d="${d}" fill="none" stroke="${color}" stroke-width="8" stroke-linecap="round" stroke-linejoin="round"/>`
            : `<path d="${d}" fill="${color}"/>`;
}

// ============================================================
// ІНСТРУМЕНТИ (ліва панель)
// ============================================================
let feActiveTool = null;

// Поки відкрита шторка на телефоні — підіймаємо полотно, щоб робоча зона
// лишалась над нею. Але не вище, ніж дозволяє верхній бар: якщо рамка вже
// впритул до нього, зсуву не буде — інакше фон тікає під кнопки.
function feShiftStage(on) {
  if (!feIsMobile() || !FE.canvas) return;
  const stage = document.getElementById('fe-stage');
  if (!stage || !stage.clientHeight) return;

  if (on) {
    if (FE._bandPrev) return;
    const panel = document.getElementById('fe-panel');
    const h = panel ? panel.getBoundingClientRect().height : 0;
    if (!h) return;

    const TOP_BAR = 62, GAP = 8;
    const bandTop = TOP_BAR, bandBottom = window.innerHeight - h - GAP;
    const bandH = bandBottom - bandTop;
    if (bandH < 140) return;

    // Вписуємо полотно у вільну смугу. Ніколи не збільшуємо — лише зменшуємо,
    // рівно настільки, щоб рамка повністю помістилась над шторкою.
    const fit = Math.min(bandH / FE.baseH, (stage.clientWidth - 24) / FE.baseW);
    const z = Math.min(FE.zoom, fit);

    FE._bandPrev = { zoom:FE.zoom, panX:FE.panX || 0, panY:FE.panY || 0 };
    // Горизонтальна рамка низька — вона у смугу вписується й без зменшення.
    // Але піднімати її все одно треба: інакше вона лишається по центру екрана,
    // тобто наполовину за шторкою. Тому масштаб міняємо лише за потреби,
    // а зсув робимо завжди.
    if (z < FE.zoom - 0.001) { FE.zoom = z; feApplyZoom(); }
    // ставимо по центру вільної смуги
    const stageMid = stage.getBoundingClientRect().top + stage.clientHeight / 2;
    FE.panX = 0;
    FE.panY = Math.round((bandTop + bandBottom) / 2 - stageMid);
  } else {
    if (!FE._bandPrev) return;
    FE.zoom = FE._bandPrev.zoom;
    FE.panX = FE._bandPrev.panX;
    FE.panY = FE._bandPrev.panY;
    FE._bandPrev = null;
    feApplyZoom();
  }
  fePanApply();
}

// Коли відкрита клавіатура — вписуємо полотно у смугу, що лишилась над нею,
// щоб було видно напис, який набираєш.
// Панель-шухляда на телефоні лежить унизу, і клавіатура накриває її разом
// із полем тексту. Піднімаємо шухляду рівно на висоту клавіатури й трохи
// збільшуємо, щоб було видно, що саме друкуєш.
function fePanelKb(on, field) {
  const panel = document.getElementById('fe-panel');
  if (!panel || !feIsMobile()) return;
  const vv = window.visualViewport;
  const update = () => {
    // Над самою клавіатурою є ще смуга з підказками й адресою сайту.
    // Ховаємо шухляду за неї: так видно більше полотна.
    const kb = vv ? Math.max(0, window.innerHeight - vv.height - vv.offsetTop) : 0;
    // Шухляда доходить до самого низу екрана й ховається за клавіатурою —
    // так видно, що список продовжується і його можна гортати.
    // Вміст при цьому лишається над клавіатурою: за це відповідає відступ знизу.
    panel.style.setProperty('--fe-kb', kb + 'px');
    if (field) try { field.scrollIntoView({ block:'center' }); } catch (e) {}
    // Наводимо полотно щоразу, коли змінилась висота клавіатури: інакше
    // одноразової підгонки не видно — клавіатура виїжджає в кілька кроків.
    feFitAbovePanel();
  };
  if (on) {
    // Запамʼятовуємо, що саме редагують: поки друкуєш, виділення може
    // злетіти, а камера має лишатись на тому ж написі.
    FE._panelKb = true;
    FE._kbObj = feAct() || FE._lockedSel || FE._kbObj;
    panel.classList.add('kb');
    update();
    if (vv && FE._kbUpd) {   // панель могла перебудуватись — не множимо стеження
      vv.removeEventListener('resize', FE._kbUpd);
      vv.removeEventListener('scroll', FE._kbUpd);
    }
    FE._kbUpd = update;
    if (vv) { vv.addEventListener('resize', update); vv.addEventListener('scroll', update); }
    setTimeout(update, 250);   // клавіатура виїжджає не миттєво
    setTimeout(update, 450);
  } else {
    FE._panelKb = false;
    FE._kbObj = null;
    panel.classList.remove('kb');
    panel.style.removeProperty('--fe-kb');
    feKeyboardFit(false);        // повертаємо полотно як було
    if (vv && FE._kbUpd) {
      vv.removeEventListener('resize', FE._kbUpd);
      vv.removeEventListener('scroll', FE._kbUpd);
    }
    FE._kbUpd = null;
  }
}
// Полотно стискаємо так, щоб воно вміщалось між верхнім баром і шухлядою.
// Раніше при друкуванні в панелі фон лишався за нею — не було видно,
// що саме змінюється.
function feFitAbovePanel() {
  const panel = document.getElementById('fe-panel');
  const stage = document.getElementById('fe-stage');
  if (!panel || !stage || !FE.canvas || !feIsMobile()) return;
  const TOP_BAR = 62;
  const bottom = panel.getBoundingClientRect().top - 8;
  const bandH = bottom - TOP_BAR;
  if (bandH < 100) return;
  if (!FE._kbPrev) FE._kbPrev = { zoom:FE.zoom, panX:FE.panX || 0, panY:FE.panY || 0 };

  const c = FE.canvas;
  const stageW = stage.clientWidth - 24;
  const fit = Math.min(bandH / FE.baseH, stageW / FE.baseW);   // вписати весь фон
  const o = feAct() || FE._kbObj || FE._lockedSel;

  // Наводимося на те, що редагують: інакше у вузькій смузі згори видно
  // випадковий шматок фону й незрозуміло, що саме змінюється.
  if (o && !o._feSafe) {
    o.setCoords();
    const r = o.getBoundingRect(true, true);
    const need = Math.min(bandH / (r.height * 1.7 || 1), stageW / (r.width * 1.25 || 1));
    FE.zoom = Math.max(fit, Math.min(need, fit * 3));
    feApplyZoom();
    // Рахуємо від справжнього положення полотна на екрані — воно вже враховує
    // і поточний зсув, і новий масштаб.
    const box = c.lowerCanvasEl.getBoundingClientRect();
    const objX = box.left + (r.left + r.width / 2) * FE.zoom;
    const objY = box.top + (r.top + r.height / 2) * FE.zoom;
    const stageBox = stage.getBoundingClientRect();
    FE.panX = Math.round((FE.panX || 0) + (stageBox.left + stage.clientWidth / 2 - objX));
    FE.panY = Math.round((FE.panY || 0) + ((TOP_BAR + bottom) / 2 - objY));
    fePanApply();
    return;
  }

  if (fit < FE.zoom) { FE.zoom = fit; feApplyZoom(); }
  const stageMid = stage.getBoundingClientRect().top + stage.clientHeight / 2;
  FE.panX = 0;
  FE.panY = Math.round((TOP_BAR + bottom) / 2 - stageMid);
  fePanApply();
}
function feKeyboardFit(on) {
  if (!feIsMobile() || !FE.canvas) return;
  const stage = document.getElementById('fe-stage');
  if (!stage || !stage.clientHeight) return;

  if (on) {
    const apply = () => {
      // Коли друкують у шухляді налаштувань, наведенням керує feFitAbovePanel:
      // ця підгонка центрує весь фон і затирала б його.
      if (FE._panelKb) return;
      const vv = window.visualViewport;
      const bottom = (vv ? vv.height + vv.offsetTop : window.innerHeight) - 8;
      const TOP_BAR = 62;
      const bandH = bottom - TOP_BAR;
      if (bandH < 120) return;

      if (!FE._kbPrev) FE._kbPrev = { zoom:FE.zoom, panX:FE.panX || 0, panY:FE.panY || 0 };
      const fit = Math.min(bandH / FE.baseH, (stage.clientWidth - 24) / FE.baseW);
      if (fit < FE.zoom) { FE.zoom = fit; feApplyZoom(); }
      const stageMid = stage.getBoundingClientRect().top + stage.clientHeight / 2;
      FE.panX = 0;
      FE.panY = Math.round((TOP_BAR + bottom) / 2 - stageMid);
      fePanApply();
    };
    // клавіатура виїжджає не миттєво — міряємо, коли вона вже на місці
    setTimeout(apply, 320);
    if (window.visualViewport && !FE._kbListener) {
      FE._kbListener = () => {
        const vv = window.visualViewport;
        // клавіатуру сховали (кнопкою на самій клавіатурі чи жестом) —
        // fabric про це не повідомляє, тому стежимо за висотою вікна
        const closed = vv.height >= window.innerHeight - 100;
        if (closed && FE._kbPrev) feKeyboardFit(false);
        else if (!closed) apply();
      };
      window.visualViewport.addEventListener('resize', FE._kbListener);
    }
  } else {
    if (window.visualViewport && FE._kbListener) {
      window.visualViewport.removeEventListener('resize', FE._kbListener);
      FE._kbListener = null;
    }
    if (!FE._kbPrev) return;
    FE.zoom = FE._kbPrev.zoom;
    FE.panX = FE._kbPrev.panX;
    FE.panY = FE._kbPrev.panY;
    FE._kbPrev = null;
    feApplyZoom(); fePanApply();
  }
}

function feClosePanel() {
  const p = document.getElementById('fe-panel');
  feShiftStage(false);
  if (p) p.classList.remove('open', 'props');
  FE.uploadSel = null;   // вибір фото не має лишатись до наступного заходу
  if (FE._panFrame) feFramePan(false);
  document.querySelectorAll('.fe-tool').forEach(b => b.classList.remove('on'));
  feSyncFigsBtn();
  feActiveTool = null;
}
const FE_TOOL_TITLES = { figures:'Фігурки', templates:'Шаблони', bg:'Фон', text:'Текст',
  captions:'Підписи', files:'Файли', shapes:'Фігури', stickers:'Стікери', layers:'Шари',
  props:'Налаштування', accessories:'Аксесуари', items:'Предмети' };
function feTool(name) {
  if (feActiveTool === name) { feClosePanel(); return; }
  if (name !== 'files') FE.uploadSel = null;
  feActiveTool = name;
  document.querySelectorAll('.fe-tool').forEach(b => b.classList.toggle('on', b.dataset.tool === name));
  feSyncFigsBtn();   // підсвітка цієї кнопки означає видимість фігурок, а не вкладку
  const panel = document.getElementById('fe-panel');
  panel.classList.add('open');
  panel.classList.toggle('props', name === 'props');   // шторка знизу
  document.getElementById('fe-panel-title').textContent = FE_TOOL_TITLES[name] || 'Панель';
  const body = document.getElementById('fe-panel-body');
  body.innerHTML = fePanelHtml(name);
  body.scrollTop = 0;            // нова вкладка завжди відкривається згори
  // Висоту шторки міряємо лише після того, як браузер її розклав. Інакше при
  // першому відкритті вкладки розмір ще нульовий — і полотно не вписувалось.
  requestAnimationFrame(() => requestAnimationFrame(() => feShiftStage(true)));
}
function feRefreshPanel() {
  // поки друкують у полі — панель не перемальовуємо, інакше курсор вилітає
  // після кожної літери (вигнутий текст перебудовує обʼєкт на кожну зміну)
  if (!feActiveTool || FE._sliding || FE._typing) return;
  document.getElementById('fe-panel-title').textContent = FE_TOOL_TITLES[feActiveTool] || 'Панель';
  document.getElementById('fe-panel-body').innerHTML = fePanelHtml(feActiveTool);
  if (feActiveTool === 'bg') feGradPreview();
}
// ============================================================
// КОНТЕКСТНА СМУГА ДІЙ (над панеллю інструментів)
// ============================================================
const feIsMobile = () => window.innerWidth <= 860;
const FE_CTX_KIND = { figure:'Фігурка', text:'Текст', shape:'Фігура',
  sticker:'Стікер', image:'Картинка', photoframe:'Фоторамка', accessory:'Аксесуар',
  caption:'Підпис' };
function feRenderCtx() {
  const bar = document.getElementById('fe-ctx');
  if (!bar) return;
  if (!feIsMobile()) { bar.innerHTML = ''; bar.className = ''; return; }   // лише для телефона
  feCtxMenuClose();
  const o = feAct() || FE._lockedSel;
  const kind = o && (o._feKind || (o.type === 'activeSelection' ? 'group' : 'shape'));
  // фігурки лише перетягуються — жодних дій, замків і налаштувань
  if (!o || kind === 'figure') {
    bar.className = 'active';
    bar.innerHTML = `${feSnapBtn()}
      ${o ? `<button class="fe-ctx-btn" title="Поставити на одну лінію з сусідом"
        onclick="feAlignBottom()">${feIco('alignBottom')}</button>` : ''}
      <span class="fe-ctx-hint left">${o ? 'Пересувайте, або поставте на одну лінію' : 'Торкніться обʼєкта, щоб редагувати'}</span>`;
    return;
  }
  // Заблокований — показуємо тільки замок і пояснення
  if (o._feLocked) {
    bar.className = 'active locked';
    bar.innerHTML = `
      <span class="fe-ctx-lockico">${feIco('locked')}</span>
      <span class="fe-ctx-hint left">Зафіксовано — зніміть замок, щоб редагувати</span>
      <button class="fe-ctx-settings" onclick="feToggleLock()">${feIco('unlocked')} Зняти замок</button>`;
    return;
  }
  bar.className = 'active';
  // Головна дія залежить від типу: текст — олівець, решта — колір
  let primary;
  const NO_COLOR = ['image', 'photoframe', 'sticker', 'accessory', 'item', 'group'];
  if (kind === 'text' || kind === 'caption') {
    primary = `<button class="fe-ctx-btn main" title="Змінити текст" onclick="feCtxEditText()">✎</button>
      <button class="fe-ctx-btn" title="Прибрати порожнє навколо" onclick="feTextTrim()">${feIco('trimSides')}</button>`;
  } else if (kind === 'photoframe') {
    if (o.type === 'image') {
      const on = FE._panFrame === o;
      primary = `<button class="fe-ctx-btn ${on ? 'main' : ''}" title="Рухати фото всередині"
          onclick="feFramePan()">✋</button>
        <button class="fe-ctx-btn" title="Замінити фото" onclick="feFramePickPhoto()">${feIco('files')}</button>`;
    } else {
      primary = `<button class="fe-ctx-btn main" title="Завантажити фото"
        onclick="feFramePickPhoto()">${feIco('files')}</button>`;
    }
  } else if (feIsVector(o)) {
    // векторний малюнок можна перефарбувати одним кольором
    const cur = feSvgCurrentColor(o);
    primary = `<label class="fe-ctx-swatch" title="Колір малюнка" style="background:${cur}">
      <input type="color" value="${cur}" oninput="feSvgColor(this.value)"></label>`;
  } else if (kind === 'image' && o.type === 'image') {
    // завантажене фото: заливки в нього немає, тож ліворуч ставимо замок —
    // фон зазвичай саме його й фіксують, щоб не зрушити випадково
    primary = `<button class="fe-ctx-btn" title="Зафіксувати" onclick="feToggleLock()">${feIco('unlocked')}</button>`;
  } else if (NO_COLOR.includes(kind)) {
    primary = '';   // у решти растрових обʼєктів заливки немає
  } else {
    const cur = (o._feSoft && o._feSoft.color) || feHex(o.fill) || '#22C55E';
    primary = `<label class="fe-ctx-swatch" title="Колір" style="background:${cur}">
      <input type="color" value="${cur}" oninput="feCtxColor(this.value)"></label>`;
  }
  bar.innerHTML = `
    ${primary}
    <span class="fe-ctx-name">${FE_CTX_KIND[kind] || 'Обʼєкт'}</span>
    <i class="fe-ctx-sep"></i>
    ${feSnapBtn()}
    <button class="fe-ctx-btn" title="Ще" onclick="feCtxMenu(event)">${feIco('dots')}</button>
    <button class="fe-ctx-btn danger" title="Видалити" onclick="feDeleteActive()">${feIco('trash')}</button>
    <button class="fe-ctx-settings" onclick="feOpenProps()">${feIco('settings')} Налаштування</button>`;
}
// Колір міняємо «наживо» — смугу не перемальовуємо,
// інакше системний вибір кольору закривався б на першому ж дотику
function feCtxColor(v) {
  const o = feAct(); if (!o) return;
  const sw = document.querySelector('#fe-ctx .fe-ctx-swatch');
  if (sw) sw.style.background = v;
  // аура — це картинка, її треба перемалювати, а не міняти заливку
  if (o._feSoft) {
    o._feSoft.color = v;
    clearTimeout(FE._ctxColorT);
    FE._ctxColorT = setTimeout(() => {
      const s = o._feSoft;
      o.setSrc(feSoftDataUrl(s.shape, s.color, s.blur), () => {
        feC().requestRenderAll(); feSnapshot(); feRefreshPanel();
      });
    }, 250);
    return;
  }
  o.set('fill', v);
  feC().requestRenderAll();
  clearTimeout(FE._ctxColorT);
  FE._ctxColorT = setTimeout(() => { feSnapshot(); feRefreshPanel(); }, 400);
}
// Додали обʼєкт: панель інструментів закриваємо, налаштування не відкриваємо
function feAfterAdd() {
  // на компʼютері поводимось як раніше — одразу показуємо налаштування
  if (!feIsMobile()) { feOpenProps(); return; }
  feClosePanel();
  feRenderCtx();
}
// Прибрати порожнє місце по боках тексту — звужуємо блок під сам текст
function feTextTrim() {
  const o = feAct();
  if (!o || !/text/i.test(o.type || '')) { feToast('Оберіть текст'); return; }
  if (o.type === 'textbox') {
    let w = 0;
    for (let i = 0; i < (o.textLines || []).length; i++) w = Math.max(w, o.getLineWidth(i));
    if (!w) { feToast('Нема що прибирати'); return; }
    o.set('width', Math.max(10, Math.ceil(w) + 2));
    o.setCoords();
  }
  feAfter(); feRefreshPanel(); feRenderCtx();
  feToast('Порожнє місце прибрано');
}
function feCtxEditText() {
  const o = feAct(); if (!o) return;
  // Вигнутий напис — це група окремих літер, редагувати його прямо на полотні
  // неможливо. Тому відкриваємо налаштування й одразу ставимо курсор у поле тексту.
  if (feIsCurved(o) || typeof o.enterEditing !== 'function') {
    feOpenProps();
    setTimeout(() => {
      const ta = document.getElementById('fe-p-text');
      if (!ta) return;
      ta.scrollIntoView({ block:'nearest' });
      ta.focus(); if (ta.select) ta.select();
      ta.classList.add('flash');
      setTimeout(() => ta.classList.remove('flash'), 1400);
    }, 150);
    return;
  }
  if (typeof o.enterEditing === 'function') {
    o.enterEditing(); o.selectAll && o.selectAll();
    // fabric створює власне приховане поле — iOS зумить сторінку,
    // якщо шрифт у ньому менший за 16px
    if (o.hiddenTextarea) o.hiddenTextarea.style.fontSize = '16px';
    feC().requestRenderAll();
  } else feOpenProps();
}
// «•••» — швидке меню
function feCtxMenu(e) {
  if (e) e.stopPropagation();
  const m = document.getElementById('fe-ctx-menu');
  const o = feAct(); if (!m || !o) return;
  if (m.classList.contains('open')) { feCtxMenuClose(); return; }
  m.innerHTML = `
    <div class="fe-ctxm-lbl">Вирівняти на полотні</div>
    <div class="fe-ctxm-grid">
      <button onclick="feAlign('l');feCtxMenuClose()" title="Ліворуч">${feIco('arrowLeft')}</button>
      <button onclick="feAlign('cx');feCtxMenuClose()" title="По центру">${feIco('flipX')}</button>
      <button onclick="feAlign('r');feCtxMenuClose()" title="Праворуч">${feIco('arrowRight')}</button>
      <button onclick="feAlign('t');feCtxMenuClose()" title="Догори">${feIco('arrowUp')}</button>
      <button onclick="feAlign('cy');feCtxMenuClose()" title="По центру">${feIco('flipY')}</button>
      <button onclick="feAlign('b');feCtxMenuClose()" title="Донизу">${feIco('arrowDown')}</button>
    </div>
    <div class="fe-ctxm-lbl">Порядок</div>
    <div class="fe-ctxm-row">
      <button onclick="feCtxOrder(1)">${feIco('toFront')} Наперед</button>
      <button onclick="feCtxOrder(-1)">${feIco('toBack')} Назад</button>
    </div>
    <div class="fe-ctxm-lbl">Дії</div>
    <div class="fe-ctxm-row">
      <button onclick="feDuplicate();feCtxMenuClose()">${feIco('toFront')} Дублювати</button>
      <button onclick="feToggleLock();feCtxMenuClose()">${o._feLocked ? feIco('unlocked') + ' Зняти замок' : feIco('locked') + ' Зафікс.'}</button>
    </div>`;
  m.classList.add('open');
}
function feCtxMenuClose() {
  const m = document.getElementById('fe-ctx-menu');
  if (m) m.classList.remove('open');
}
function feCtxOrder(d) {
  const o = feAct(); if (!o) return;
  d > 0 ? o.bringForward() : o.sendBackwards();
  feSafeToFront(); feAfter(); feCtxMenuClose(); feRefreshPanel();
}

// ============================================================
// КОНТЕКСТНЕ МЕНЮ ПРАВОЮ КНОПКОЮ (компʼютер)
// ============================================================
function feMenuClose() {
  const m = document.getElementById('fe-menu');
  if (m) m.remove();
  document.removeEventListener('mousedown', feMenuOutside, true);
  window.removeEventListener('blur', feMenuClose);
}
// Клік усередині меню не має його закривати — інакше пункт зникає
// раніше, ніж встигне спрацювати, і жодна дія не виконується.
function feMenuOutside(e) {
  const m = document.getElementById('fe-menu');
  if (m && e.target && m.contains(e.target)) return;
  feMenuClose();
}
function feMenuItems(o) {
  const I = [];
  const kind = o && (o._feKind || (o.type === 'activeSelection' ? 'group' : 'shape'));

  I.push({ ico:'≡',  n:'Центр по ширині', fn:"feAlign('cx')" });
  I.push({ ico:'≡',  n:'Центр по висоті', fn:"feAlign('cy')" });
  I.push({ ico:'⊞',  n:'У центр полотна', fn:"feAlign('cx');feAlign('cy')" });

  if (kind === 'figure') return I;   // фігурки лише пересуваються

  I.push({ sep:true });
  I.push({ ico:feIco('toFront'), n:'Наперед', fn:'feCtxOrder(1)' });
  I.push({ ico:feIco('toBack'), n:'Назад',   fn:'feCtxOrder(-1)' });

  I.push({ sep:true });
  I.push({ ico:feIco('toFront'), n:'Дублювати', fn:'feDuplicate()' });
  I.push({ ico:o._feLocked ? feIco('unlocked') : feIco('locked'),
           n:o._feLocked ? 'Зняти замок' : 'Зафіксувати', fn:'feToggleLock()' });

  if (/text/i.test(o.type || '')) {
    I.push({ ico:'✎',   n:'Редагувати текст',        fn:'feCtxEditText()' });
    I.push({ ico:feIco('trimSides'), n:'Прибрати порожнє навколо', fn:'feTextTrim()' });
  }
  if (kind === 'photoframe' && o.type === 'image') {
    I.push({ ico:'✋', n:'Рухати фото всередині', fn:'feFramePan()' });
    I.push({ ico:feIco('files'), n:'Замінити фото',        fn:'feFramePickPhoto()' });
  }
  if (o._feSoft || feHex(o.fill)) {
    I.push({ ico:feIco('settings'), n:'Налаштування…', fn:'feOpenProps()' });
  }
  I.push({ sep:true });
  I.push({ ico:feIco('trash'), n:'Видалити', fn:'feDeleteActive()', danger:true });
  return I;
}
function feShowMenu(x, y) {
  feMenuClose();
  const o = feAct();
  if (!o) return;
  const m = document.createElement('div');
  m.id = 'fe-menu';
  m.innerHTML = feMenuItems(o).map(it => it.sep
    ? '<i class="fe-menu-sep"></i>'
    : `<button class="fe-menu-it ${it.danger ? 'danger' : ''}"
         onclick="feMenuClose();${it.fn}"><span>${it.ico}</span>${it.n}</button>`).join('');
  document.body.appendChild(m);
  // не вилазимо за край екрана
  const r = m.getBoundingClientRect();
  m.style.left = Math.min(x, window.innerWidth  - r.width  - 8) + 'px';
  m.style.top  = Math.min(y, window.innerHeight - r.height - 8) + 'px';
  setTimeout(() => {
    document.addEventListener('mousedown', feMenuOutside, true);
    window.addEventListener('blur', feMenuClose);
  }, 0);
}
// Який обʼєкт під курсором (свій пошук — надійніший за findTarget з чужою подією)
function feHitTest(e, includeLocked) {
  const c = FE.canvas; if (!c) return null;
  let p;
  try { p = c.getPointer(e); } catch (err) { return null; }
  const pt = new fabric.Point(p.x, p.y);
  const objs = c.getObjects();
  for (let i = objs.length - 1; i >= 0; i--) {
    const o = objs[i];
    if (o._feSafe || o.visible === false) continue;
    if (o.selectable === false && !(includeLocked && o._feLocked)) continue;
    try { if (o.containsPoint(pt)) return o; } catch (err) {}
  }
  return null;
}
function feBindContextMenu() {
  if (window._feMenuBound) return;
  window._feMenuBound = true;
  // вішаємо на документ у фазі перехоплення — так не залежимо ні від того,
  // коли створено редактор, ні від власних обробників fabric
  document.addEventListener('contextmenu', e => {
    const ed = document.getElementById('fe-editor');
    if (!ed || !ed.classList.contains('active') || !ed.contains(e.target)) return;
    e.preventDefault();                 // жодних «зберегти картинку» й «переглянути код»
    e.stopPropagation();
    if (feIsMobile() || !FE.canvas) return;
    const c = FE.canvas;
    const t = feHitTest(e, true);
    if (t && t !== c.getActiveObject()) { c.setActiveObject(t); c.requestRenderAll(); feRenderCtx(); }
    if (!c.getActiveObject()) { feMenuClose(); return; }
    feShowMenu(e.clientX, e.clientY);
  }, true);
}

// Панель налаштувань відкривається поверх, запамʼятовуючи попередній інструмент
function feOpenProps() {
  // фігурки й тваринки просто перетягуються — без панелі налаштувань
  const a = FE.canvas && FE.canvas.getActiveObject();
  if (a && a._feKind === 'figure') { feCloseProps(); return; }
  // на телефоні для замкненого показуємо лише пояснення у смузі дій,
  // на компʼютері — звичайні налаштування з кнопкою «Зняти замок»
  if (a && a._feLocked && feIsMobile()) { feLockedNotice(a); feCloseProps(); return; }
  if (feActiveTool === 'props') { feRefreshPanel(); return; }   // без перемикання-вимкнення
  FE._prevTool = feActiveTool;
  feActiveTool = null;
  feTool('props');
}
function feCloseProps() {
  if (feActiveTool !== 'props') return;
  // На компʼютері повертаємо ту вкладку, з якої зайшли: клік по порожньому
  // місцю не має закривати панель, з якою людина працює.
  const back = FE._prevTool;
  if (!feIsMobile() && back && back !== 'props') {
    feActiveTool = null;
    FE._prevTool = null;
    feTool(back);
    return;
  }
  // на телефоні налаштування — шторка, її просто закриваємо
  feClosePanel();
}
function fePanelHtml(name) {
  switch (name) {
    case 'figures':   return fePanelFigures();
    case 'templates': return fePanelTemplates();
    case 'bg':        return fePanelBg();
    case 'text':      return fePanelText();
    case 'captions':  return fePanelCaptions();
    case 'files':     return fePanelFiles();
    case 'shapes':    return fePanelShapes();
    case 'stickers':  return fePanelStickers();
    case 'layers':    return fePanelLayers();
    case 'props':     return fePanelProps();
    case 'accessories': return fePanelAccessories();
    case 'items':     return fePanelItems();
    default: return '';
  }
}

// --- Фігурки ---
function fePanelFigures() {
  if (!FE.figures.length) {
    return `<p style="font-size:12.5px;line-height:1.6">
      Фігурки додаються на першому екрані. Натисніть «←» вгорі ліворуч, щоб повернутись.</p>`;
  }
  let h = `<div class="fe-grid g3">`;
  FE.figures.forEach((f, i) => h += `<div class="fe-tile" style="flex-direction:column;font-size:10px">
    <div style="font-size:20px">${feFigIco(f)}</div>${i+1}</div>`);
  h += `</div>
    <button class="fe-btn-full" onclick="feToggleFigures()">
      ${FE.figsHidden ? feIco('eye') + ' Показати фігурки' : feIco('eyeOff') + ' Сховати фігурки'}</button>
    <p style="font-size:11.5px;margin-top:12px;line-height:1.5">
      На полотні фігурки можна лише перетягувати. Додати, змінити чи прибрати їх —
      на першому екрані.</p>`;
  return h;
}
async function feAddSetupFigureToCanvas(i) {
  const fig = FE.figures[i];
  if (!fig || fig._placed) return;
  const count = feFiguresOnCanvas().length;
  await feAddFigureToCanvas(fig, count, count + 1);
  const added = feFiguresOnCanvas().slice(-1)[0];
  if (added) { fig._placed = added._feId; added._feSrc = i; }
  feSnapshot(); feRefreshPanel();
}
function feRemoveFigureFromCanvas(i) {
  const fig = FE.figures[i]; if (!fig || !fig._placed) return;
  const c = feC();
  c.getObjects().filter(o => o._feKind === 'figure' && o._feId === fig._placed).forEach(o => c.remove(o));
  delete FE.captions.names[fig._placed];
  fig._placed = null;
  feSyncCaptions(true);
  c.requestRenderAll(); feSnapshot(); feRefreshPanel();
}
function feSyncFigsBtn() {
  const b = document.getElementById('fe-btn-figs');
  if (b) b.classList.toggle('on', !FE.figsHidden);
}
// Видимість фігурок на полотні мусить збігатися з FE.figsHidden.
// Після відновлення чернетки чи застосування фону в JSON можуть лишитись
// об'єкти з visible:false — тоді перше натискання кнопки лише «доганяло» стан.
function feApplyFigsVis() {
  const c = FE.canvas; if (!c) return;
  let changed = false;
  c.getObjects().filter(o => o._feKind === 'figure' || (o._feKind === 'caption' && !o._feForItem))
    .forEach(o => { if (o.visible === FE.figsHidden) { o.set('visible', !FE.figsHidden); changed = true; } });
  if (changed) c.requestRenderAll();
  feSyncFigsBtn();
}
function feToggleFigures() {
  const c = FE.canvas; if (!c) return;
  FE.figsHidden = !FE.figsHidden;
  c.getObjects().filter(o => o._feKind === 'figure' || (o._feKind === 'caption' && !o._feForItem))
    .forEach(o => o.set('visible', !FE.figsHidden));
  c.discardActiveObject(); c.requestRenderAll(); feSnapshot();
  // кнопка світиться, коли фігурки НА фоні, і гасне, коли їх сховано
  feSyncFigsBtn();
  feToast(FE.figsHidden ? 'Фігурки сховано' : 'Фігурки показано');
  if (feActiveTool === 'figures') feRefreshPanel();
}

// --- Аксесуари на фон (кожен +50 грн) ---
const FE_ACC_PER_PAGE = 12;
let _feAccPage = 0;
function feAccPage(p) { _feAccPage = p; feRefreshPanel(); }
function fePanelAccessories() {
  const accs = feSM().accessories || {};
  const oos = window.ACC_OOS || [];
  // скільки їх насправді — щоб додані пізніше не лишались невидимими
  const total = Object.keys(accs).filter(k => /^L_\d+$/.test(k) && accs[k]).length || 50;
  const nums = []; for (let i = 1; i <= total; i++) nums.push(i);
  const cnt = feBgAccCount();
  let h = `<p style="font-size:12px;line-height:1.55;margin-bottom:10px">
    Аксесуари можна класти просто на фон. Кожен додає <b style="color:var(--fe-gold)">+${FE_PRICE.accessory} ₴</b>.
    ${cnt ? `<br>Зараз на фоні: <b>${cnt}</b> шт.` : ''}</p>`;
  h += fePagedGrid(nums, _feAccPage, FE_ACC_PER_PAGE, 'feAccPage', i => {
    const url = accs['L_' + i];
    const off = oos.includes(i);
    const id = 'L_' + i;
    return `<div class="fe-tile ${off ? 'oos' : ''}" onclick="${off ? '' : `feAddAccessory('${id}')`}">
      ${url ? feAccTile(url, id) : i}
      <div class="fe-tile-lbl">${i}</div></div>`;
  }, 4);
  return h;
}

// Предмет, обраний замість фігурки на першому екрані.
// Лягає у справжньому розмірі й лишається у списку фігурок — тому має
// і рядок у «Підписах», і своє місце в розрахунку ціни.
async function feAddItemFigure(fig, index, total) {
  const it = (window.FE_ITEM_LIB || []).find(x => x.id === fig.itemId);
  if (!it || !it.url) return;
  const r = await feTrimUrl(it.url);
  const d = feDims();
  const n = Math.max(total || 1, 1);
  const px = fig._px != null ? fig._px * FE.baseW : (FE.baseW / (n + 1)) * ((index ?? 0) + 1);
  const py = fig._py != null ? fig._py * FE.baseH : FE.baseH * 0.62;
  return new Promise(resolve => {
    fabric.Image.fromURL(r.url, img => {
      const norm = it.spritePx ? 1 : FIG_SPRITE_H / (r.origH || FIG_SPRITE_H);
      const scale = MM_PER_SPRITE_PX * (FE.baseH / d.hMm) * norm * (it.scale || 1);
      img.set({ left:px, top:py, originX:'center', originY:'center',
        scaleX:scale, scaleY:scale,
        lockScalingX:true, lockScalingY:true, lockUniScaling:true,
        _feKind:'figure', _feId:'f' + (++FE._idc), _feCx:0.5,
        _feSig:feFigSig(fig), _feItem:it.id,
        _feName:it.name ? 'Предмет ' + it.name : 'Предмет' });
      feC().add(img); feSafeToFront(); feC().requestRenderAll(); resolve();
    }, { crossOrigin:'anonymous' });
  });
}
// Обрізає одиночний спрайт до вмісту
function feTrimUrl(url, px) {
  return new Promise(resolve => {
    const im = new Image(); im.crossOrigin = 'anonymous';
    im.onload = () => {
      const cv = document.createElement('canvas');
      cv.width = im.naturalWidth; cv.height = im.naturalHeight;
      cv.getContext('2d').drawImage(im, 0, 0);
      try {
        const r = feTrimCanvas(cv);
        resolve({ url:r.url, origH:im.naturalHeight });
      } catch (e) { resolve({ url, origH:im.naturalHeight }); }
    };
    im.onerror = () => resolve({ url, origH:FIG_SPRITE_H });
    im.src = feSpx(url, px || FE_SPRITE_PX);
  });
}
async function feAddAccessory(id) {
  const url = (feSM().accessories || {})[id];
  if (!url) return;
  const r = await feTrimUrl(url);
  fabric.Image.fromURL(r.url, img => {
    const c = feC(), d = feDims();
    // нормалізуємо під полотно спрайта 480×590, тому будь-який аксесуар
    // виходить рівно того ж розміру, що й у руці фігурки
    const norm = FIG_SPRITE_H / (r.origH || FIG_SPRITE_H);
    const scale = MM_PER_SPRITE_PX * (FE.baseH / d.hMm) * norm;
    img.set({ left:FE.baseW/2, top:FE.baseH/2, originX:'center', originY:'center',
      scaleX:scale, scaleY:scale,
      // розмір фіксований — щоб було видно, скільки місця займе насправді
      lockScalingX:true, lockScalingY:true, lockUniScaling:true,
      _feKind:'accessory', _feName:'Аксесуар ' + id.replace('L_', '') });
    // Кружки по кутах нічого не роблять — розмір усе одно зафіксований, а на
    // дрібному аксесуарі вони закривають його цілком. Лишаємо тільки поворот.
    img.setControlsVisibility({
      tl:false, tr:false, bl:false, br:false,
      ml:false, mr:false, mt:false, mb:false, mtr:true });
    c.add(img); c.setActiveObject(img); feSafeToFront(); c.requestRenderAll();
    feSnapshot(); feUpdatePrice(); feAfterAdd();
  }, { crossOrigin:'anonymous' });
}

// --- Предмети на фон (велосипед, дитина, мотоцикл тощо) ---
// Список наповнюється у файлі frame-items.js:
//   window.FE_ITEM_LIB = [{ id:'bike', name:'Велосипед', url:'https://…png', price:150 }, …];
// price — скільки предмет додає до вартості рамки (якщо не вказано, береться FE_ITEM_PRICE).
const FE_ITEM_PRICE = 50;   // запасне значення, якщо в файлі не вказано ціну
function feItemLib() { return window.FE_ITEM_LIB || []; }
function feItemById(id) { return feItemLib().find(x => x.id === id) || null; }
// Предмет коштує стільки ж, скільки аксесуар — окремого товару не заводимо.
// Значення price у файлі лишається можливістю зробити виняток.
function feItemPrice(it) { return it && it.price != null ? it.price : FE_PRICE.accessory; }
// Предмети, покладені на фон (поза редактором — з того, що збереглось)
function feBgItemIds() {
  const ed = document.getElementById('fe-editor');
  if (!FE.canvas || !ed || !ed.classList.contains('active')) return FE._bgItems || [];
  return FE.canvas.getObjects().filter(o => o._feKind === 'item').map(o => o._feItem);
}
function fePanelItems() {
  const lib = feItemLib();
  if (!lib.length) {
    return `<p style="font-size:12.5px;line-height:1.6">
      Предмети ще не завантажені. Додайте їх у файл <b>frame-items.js</b>.</p>`;
  }
  const on = feBgItemIds().length;
  let h = `<p style="font-size:12px;line-height:1.55;margin-bottom:10px">
    Предмети кладуться на фон у справжньому розмірі — змінювати його не можна.
    Кожен додає <b style="color:var(--fe-gold)">+${FE_PRICE.accessory} ₴</b>.
    ${on ? `<br>Зараз на фоні: <b>${on}</b> шт.` : ''}</p>`;
  // Показуємо всі одразу: одинадцять плиток у сторінках не потребують.
  h += '<div class="fe-grid">';
  lib.forEach(it => {
    const ready = FE_ITEM_THUMBS[it.id];
    h += `<div class="fe-tile" title="${(it.name || '').replace(/"/g,'&quot;')}"
      onclick="feAddItem('${it.id}')">
      <div class="fe-tile-img fe-item-img" id="fe-ith-${it.id}">${
        ready ? `<img src="${ready}" alt="">` : ''}</div>
      <div class="fe-tile-lbl">${it.name || it.id}</div>
    </div>`;
  });
  h += '</div>';
  setTimeout(feFillItemThumbs, 0);   // обрізані превʼю домальовуємо після панелі
  return h;
}
// Превʼю предметів обрізаємо так само, як при додаванні на фон:
// інакше плитка показує майже саму порожнечу навколо малюнка.
const FE_ITEM_THUMBS = {};
const FE_THUMB_PX = 220;   // джерело для превʼю: менше — швидше
// Кожне превʼю готуємо окремо й одночасно. Раніше цикл чекав на попереднє,
// тому предмети зʼявлялись по одному, тоді як аксесуари — усі разом.
function feFillItemThumbs() {
  feItemLib().forEach(it => feFillItemThumb(it));
}
async function feFillItemThumb(it) {
  if (!it || !it.url || FE_ITEM_THUMBS[it.id]) return;
  if (!document.getElementById('fe-ith-' + it.id)) return;
  try {
    const r = await feTrimUrl(it.url, FE_THUMB_PX);
    FE_ITEM_THUMBS[it.id] = r.url;
    const box = document.getElementById('fe-ith-' + it.id);
    if (box) box.innerHTML = '<img src="' + r.url + '" alt="">';
  } catch (e) {}
}

async function feAddItem(id) {
  const it = feItemById(id);
  if (!it || !it.url) return;
  const r = await feTrimUrl(it.url);
  fabric.Image.fromURL(r.url, img => {
    const c = feC(), d = feDims();
    // той самий перерахунок, що й для аксесуарів: предмет виходить рівно
    // такого розміру, яким буде надрукований
    const norm = it.spritePx ? 1 : FIG_SPRITE_H / (r.origH || FIG_SPRITE_H);
    const scale = MM_PER_SPRITE_PX * (FE.baseH / d.hMm) * norm * (it.scale || 1);
    img.set({ left:FE.baseW/2, top:FE.baseH/2, originX:'center', originY:'center',
      scaleX:scale, scaleY:scale,
      // розмір і поворот фіксовані — предмет не редагується, лише пересувається
      // розмір сталий, але крутити можна — так само, як аксесуар
      lockScalingX:true, lockScalingY:true, lockUniScaling:true,
      _feKind:'item', _feItem:it.id, _feId:'it' + (++FE._idc),
      _feName:it.name || 'Предмет' });
    c.add(img); c.setActiveObject(img); feSafeToFront(); c.requestRenderAll();
    feSyncCaptions(true);   // предмет теж отримує рядок у «Підписах»
    feSnapshot(); feUpdatePrice(); feAfterAdd();
  }, { crossOrigin:'anonymous' });
}

// --- Шаблони ---
const FE_TEMPLATES = [
  { id:'blank',  cat:'Чисті',   name:'Чистий лист', bg:'#FFFFFF', title:'', sub:'', deco:'none' },
  { id:'cream',  cat:'Чисті',   name:'Кремовий',    bg:'#FAF3E7', title:'', sub:'', deco:'none' },
  { id:'dark',   cat:'Чисті',   name:'Темний',      bg:'#1B2433', title:'', sub:'', deco:'none' },
  // Решта фонів — власні, з файлу frame-templates.js.
  // Демонстраційні шаблони прибрані на прохання власника.
];
const FE_TPL_CATS = ['Всі','Чисті','Кохання','Весілля','Сімʼя','День народження','Новий рік','Хобі','Колаж','Веселі','Різне','Мої фони'];
let feTplCat = 'Всі';

// мініатюра шаблону: справжній вигляд, а не просто назва
// Мініатюри для готових фонів із JSON малюємо один раз і запамʼятовуємо
const FE_TPL_THUMBS = {};
// Малюємо превʼю по черзі, а не всі разом: інакше телефон намагається
// відрендерити півтора десятка важких фонів одночасно й підвисає.
const FE_THUMB_Q = [];
function feThumbQueue(t) {
  if (FE_TPL_THUMBS[t.id] !== undefined) return;
  if (FE_THUMB_Q.some(x => x.id === t.id)) return;
  FE_THUMB_Q.push(t);
  feThumbPump();
}
function feThumbPump() {
  if (FE._thumbBusy) return;
  const t = FE_THUMB_Q.shift();
  if (!t) return;
  FE._thumbBusy = true;

  // Якщо фон не встиг намалюватись (важкий, мало памʼяті) — не тримаємо чергу
  // вічно: показуємо просто колір фону й беремося за наступний.
  let done = false;
  const next = () => {
    if (done) return; done = true;
    clearTimeout(tm);
    FE._thumbBusy = false;
    setTimeout(feThumbPump, 40);
  };
  const tm = setTimeout(() => {
    document.querySelectorAll(`[data-tplthumb="${t.id}"]`).forEach(el => {
      el.classList.remove('fe-tpl-wait');
      el.innerHTML = '';
    });
    next();
  }, 7000);

  setTimeout(() => feTplRenderThumb(t, next), 0);
}
function feTplRenderThumb(t, whenDone) {
  if (FE_TPL_THUMBS[t.id] !== undefined) { if (whenDone) whenDone(); return; }
  FE_TPL_THUMBS[t.id] = null;                 // щоб не запускати двічі
  let objs;
  try { objs = JSON.parse(t.json); } catch (e) { if (whenDone) whenDone(); return; }
  const W = FE.baseW || 950, H = FE.baseH || 950, S = 220;

  // спершу дочікуємось шрифтів, які використані у фоні — інакше в мініатюрі
  // написи малюються стандартним шрифтом
  const fams = new Set();
  const scanF = o => {
    if (!o) return;
    if (o.fontFamily) fams.add(String(o.fontFamily).split(',')[0].trim().replace(/["']/g, ''));
    if (o.objects) o.objects.forEach(scanF);
  };
  objs.forEach(scanF);
  const ready = (document.fonts && fams.size)
    ? Promise.all([...fams].map(f => document.fonts.load(`16px "${f}"`).catch(() => {})))
        .then(() => document.fonts.ready).catch(() => {})
    : Promise.resolve();

  ready.then(() => {
  // кеш метрик міг лишитись від рендеру зі стандартним шрифтом
  if (fabric.util.clearFabricFontCache) fabric.util.clearFabricFontCache();
  const cv = new fabric.StaticCanvas(null, {
    width: Math.round(S * W / Math.max(W, H)),
    height: Math.round(S * H / Math.max(W, H)),
    backgroundColor: t.bg || '#FFFFFF' });
  fabric.util.enlivenObjects(objs, list => {
    list.forEach(o => cv.add(o));
    cv.setZoom(cv.getWidth() / W);

    // Аури зберігаються параметрами без картинки — для мініатюри їх треба
    // домалювати, інакше в превʼю зникає ціле серце чи пляма.
    const soft = list.filter(o => o._feSoft && !(o._element && o._element.naturalWidth));
    const draw = () => {
      cv.renderAll();
      try { FE_TPL_THUMBS[t.id] = cv.toDataURL({ format:'jpeg', quality:0.7 }); } catch (e) {}
      cv.dispose();
      document.querySelectorAll(`[data-tplthumb="${t.id}"]`).forEach(el => {
        if (FE_TPL_THUMBS[t.id]) {
          el.classList.remove('fe-tpl-wait');
          el.innerHTML = `<img src="${FE_TPL_THUMBS[t.id]}" class="fe-tpl-img">`;
        }
      });
      if (whenDone) whenDone();
    };
    if (!soft.length) { draw(); return; }
    Promise.all(soft.map(o => new Promise(res => {
      const s = o._feSoft;
      try { o.setSrc(feSoftDataUrl(s.shape, s.color, s.blur), () => res()); }
      catch (e) { res(); }
    }))).then(draw);
    return;
  });
  });
}
// ---- Разова генерація превʼю для файлу ----
// Малює мініатюри всіх фонів і віддає готовий текст для окремого файлу.
// Після цього превʼю показуються миттєво, без жодного малювання.
async function feMakeThumbs() {
  const list = feAllTemplates().filter(t => t.json && !t.thumb);
  if (!list.length) { alert('Усі фони вже мають готові превʼю.'); return; }

  feToast(`⏳ Готую превʼю: 0 з ${list.length}…`, 60000);
  const out = { ...(window.FE_TPL_THUMBS_PRESET || {}) };
  for (let i = 0; i < list.length; i++) {
    const t = list[i];
    delete FE_TPL_THUMBS[t.id];                     // малюємо наново
    await new Promise(res => feTplRenderThumb(t, res));
    if (FE_TPL_THUMBS[t.id]) out[t.id] = FE_TPL_THUMBS[t.id];
    feToast(`⏳ Готую превʼю: ${i + 1} з ${list.length}…`, 60000);
    await new Promise(r => setTimeout(r, 30));
  }

  const body = Object.keys(out)
    .map(k => `  ${JSON.stringify(k)}: ${JSON.stringify(out[k])},`).join('\n');
  const text = `/* Превʼю фонів — згенеровано редактором. Не редагувати вручну. */\n`
    + `window.FE_TPL_THUMBS_PRESET = {\n${body}\n};\n`;

  const kb = Math.round(text.length / 1024);
  try { await navigator.clipboard.writeText(text); }
  catch (e) { prompt('Скопіюй цей текст:', text); }
  alert(`Готово: ${Object.keys(out).length} превʼю, ${kb} КБ.\n\n`
    + 'Створи в Assets файл frame-thumbs.js і встав туди скопійований текст.');
}

function feTplThumb(t) {
  const preset = (window.FE_TPL_THUMBS_PRESET || {})[t.id];
  if (preset) return `<img src="${preset}" class="fe-tpl-img">`;
  if (t.thumb) return `<img src="${t.thumb}" class="fe-tpl-img">`;
  if (t.json) {
    if (FE_TPL_THUMBS[t.id]) return `<img src="${FE_TPL_THUMBS[t.id]}" class="fe-tpl-img">`;
    feThumbQueue(t);
    return `<div class="fe-tpl-inner fe-tpl-wait" data-tplthumb="${t.id}"><i></i></div>`;
  }
  if (!t.items) {
    // шаблони з title/sub/deco — відтворюємо їхній вигляд
    let h = `<div class="fe-tpl-inner">`;
    if (t.title) h += `<div style="position:absolute;left:50%;top:11%;transform:translate(-50%,-50%);
      width:90%;font-family:Nunito;font-weight:800;font-size:7.5%;color:#C0392B;
      text-align:center;line-height:1.1;white-space:nowrap;overflow:hidden">${t.title}</div>`;
    if (t.sub) h += `<div style="position:absolute;left:50%;top:17.5%;transform:translate(-50%,-50%);
      width:90%;font-family:Inter;font-size:4.5%;color:#374151;text-align:center;
      white-space:nowrap;overflow:hidden">${t.sub}</div>`;
    if (t.deco === 'hearts') {
      h += `<div style="position:absolute;left:16%;top:29%;width:68%;height:42%;
        border:1.5px solid #8B5E3C;border-radius:9%"></div>`;
      [[50,29],[16,38],[84,40],[16,58],[84,60]].forEach((p, i) =>
        h += `<div style="position:absolute;left:${p[0]}%;top:${p[1]}%;transform:translate(-50%,-50%);
          color:${i === 2 ? '#9CA3AF' : '#E53935'};font-size:8%">❤</div>`);
    }
    if (t.deco === 'line') h += `<div style="position:absolute;left:28%;right:28%;top:22%;
      border-top:1.5px solid #1B2433"></div>`;
    if (t.deco === 'stars') [[20,30],[80,33],[28,72],[75,75]].forEach(p =>
      h += `<div style="position:absolute;left:${p[0]}%;top:${p[1]}%;transform:translate(-50%,-50%);
        color:#F4C430;font-size:7%">★</div>`);
    return h + `</div>`;
  }
  let h = `<div class="fe-tpl-inner">`;
  t.items.forEach(it => {
    if (it.t === 'soft') {
      // той самий генератор, що й на полотні — форма точно збігається
      h += `<img src="${feSoftDataUrl(it.shape, it.color, it.blur)}"
        style="position:absolute;left:${it.x*100}%;top:${it.y*100}%;
        width:${it.w*100}%;transform:translate(-50%,-50%);opacity:${it.op ?? 1}">`;
    }
    if (it.t === 'text') {
      h += `<div style="position:absolute;left:${it.x*100}%;top:${it.y*100}%;
        width:${(it.w||0.86)*100}%;transform:translate(-50%,-50%);text-align:center;
        font-family:'${it.font}',sans-serif;font-weight:${it.weight||400};
        font-size:${it.size*100}%;color:${it.fill};line-height:1.1;white-space:nowrap;
        overflow:hidden">${it.text}</div>`;
    }
  });
  return h + `</div>`;
}
function feTplCard(t, big) {
  const sel = FE.template === t.id;
  const dark = t.bg === '#1B2433' || t.bg === '#0E1422';
  const d = feDims();
  return `<div class="fe-tpl ${sel ? 'sel' : ''}"
    style="background:${t.bg};color:${dark ? '#E8ECF4' : '#1B2433'};aspect-ratio:${d.wMm}/${d.hMm}"
    onclick="feApplyTemplate('${t.id}')" title="${t.name}">
    ${feTplThumb(t)}
    ${sel ? '<span class="fe-tpl-ok">✓</span>' : ''}
    ${t.own ? `<span class="fe-tpl-del" onclick="event.stopPropagation();feDelMyTpl('${t.id}')">${feIco('trash')}</span>
      ${feIsAdmin() ? `<span class="fe-tpl-exp" onclick="event.stopPropagation();feExportMyTpl('${t.id}')" title="Експорт">⇪</span>` : ''}
      <span class="fe-tpl-mine">моє</span>` : ''}
  </div>`;
}
// Розбирає вставлений фон. Приймає і повний експорт
// {"name":…,"bg":…,"json":"[…]"}, і сам масив обʼєктів [ … ].
function feTplParse(raw) {
  if (!raw || typeof raw !== 'string') return null;
  const s = raw.trim();
  if (!s || s === 'PASTE_JSON_HERE') return null;

  const ok = txt => { try { const a = JSON.parse(txt); return Array.isArray(a) ? txt : null; }
                      catch (e) { return null; } };

  if (s[0] === '[') { const r = ok(s); if (r) return { json:r }; }

  // Спершу пробуємо прочитати експорт як належить. Раніше першим ішов розбір
  // «руками», і він псував переноси рядків: у тексті замість переходу на новий
  // рядок лишалось літеральне \n, а весь абзац витягувався в один рядок.
  try {
    const o = JSON.parse(s);
    if (o && typeof o.json === 'string') {
      const r = ok(o.json);
      if (r) return { json:r, bg:o.bg || null, thumb:o.thumb || null };
    }
  } catch (e) {}

  // повний експорт: дістаємо колір фону й сам масив
  const bg = (s.match(/"bg"\s*:\s*"([^"]+)"/) || [])[1] || null;
  // готове превʼю, якщо воно вкладене в експорт — тоді малювати не доведеться
  const th = (s.match(/"thumb"\s*:\s*"(data:[^"]+)"/) || [])[1] || null;
  const i = s.indexOf('"json"');
  if (i >= 0) {
    let body = s.slice(s.indexOf(':', i) + 1).trim();
    if (body[0] === '"') body = body.slice(1);
    body = body.replace(/"\s*}\s*$/, '').trim();     // прибираємо хвіст експорту
    let r = ok(body);
    if (!r) r = ok(body.replace(/\\"/g, '"'));       // якщо екранування збереглось
    if (r) return { json:r, bg, thumb:th };
  }
  // остання спроба — весь текст як обʼєкт
  try {
    const o = JSON.parse(s);
    if (o && typeof o.json === 'string') { const r = ok(o.json); if (r) return { json:r, bg:o.bg || null, thumb:o.thumb || null }; }
  } catch (e) {}
  return null;
}
// Готові фони лежать в окремому файлі й важать чимало. Вантажимо його лише
// коли він справді потрібен — інакше на телефоні редактор довго не відкривався.
// Які файли фонів потрібні саме цій рамці. Раніше вантажились усі —
// клієнт із рамкою 12×12 качав і фони для 21×21, яких ніколи не побачить.
// Разом це було близько 14 МБ; тепер їде тільки потрібна частина.
function feTplUrlsFor(size) {
  const map = window.FE_TPL_BY_SIZE || {};
  const list = map[size || FE.size];
  if (list && list.length) return list;
  // Немає розкладки — поводимось як раніше й вантажимо все
  return window.FE_TPL_URLS || (window.FE_TPL_URL ? [window.FE_TPL_URL] : []);
}
// Чи вже приїхали фони для цієї рамки
function feTplReady(size) { return !!(FE._tplLoaded || {})[size || FE.size]; }
function feLoadTemplates(cb) {
  const size = FE.size;
  FE._tplLoaded = FE._tplLoaded || {};
  if (FE._tplLoaded[size]) { if (cb) cb(); return; }

  const urls = feTplUrlsFor(size);
  if (!urls.length) { FE._tplLoaded[size] = true; if (cb) cb(); return; }
  // Уже вантажимо цю ж рамку — просто станемо в чергу
  if (FE._tplLoading === size) { FE._tplCbs.push(cb); return; }
  FE._tplLoading = size;
  FE._tplCbs = [cb];
  const done = () => {
    window.FE_EXTRA_TEMPLATES = window.FE_EXTRA_TEMPLATES || [];
    FE._tplLoaded[size] = true;
    FE._tplLoading = null;
    (FE._tplCbs || []).forEach(f => { if (f) f(); });
    FE._tplCbs = [];
  };
  let left = urls.length;
  const step = () => { if (--left <= 0) done(); };
  urls.forEach(u => {
    const s = document.createElement('script');
    s.src = u;
    s.onload = step;
    s.onerror = step;      // один файл не приїхав — показуємо решту
    document.head.appendChild(s);
  });
}
function feAllTemplates() {
  // готові фони з окремого файлу frame-templates.js — щоб не роздувати редактор
  const extra = [];
  (window.FE_EXTRA_TEMPLATES || []).forEach(t => {
    const p = feTplParse(t.json);
    if (!p) return;
    extra.push({ ...t, json:p.json, bg:t.bg || p.bg || '#FFFFFF', thumb:t.thumb || p.thumb || null });
  });
  return FE_TEMPLATES.concat(extra, FE.myTpl || []);
}
// шаблон показуємо, лише якщо він універсальний або зроблений саме під цю рамку
// Квадратна рамка — «горизонтально/вертикально» для неї не має сенсу
function feSquareSize(id) {
  const s = FE_SIZES.find(x => x.id === id);
  return !!s && s.wMm === s.hMm;
}
function feTplFits(t) {
  // Орієнтацію перевіряємо, лише коли вона в фоні прописана: у квадратних
  // рамок її немає взагалі, а старі фони її не мають і мають лишитись
  // видимими в обох положеннях.
  if (t.orient && t.orient !== FE.orient) return false;
  // sizes — коли фон підходить кільком рамкам (наприклад, усім квадратним)
  if (t.sizes) return t.sizes.includes(FE.size);
  if (!t.size) return true;
  return t.size === FE.size;
}
// Апостроф буває трьох видів — прямий, друкарський і той, що з клавіатури.
// Око різниці не бачить, а порівняння рядків бачить: фон із категорією
// «Сім'я» не потрапляв у вкладку «Сімʼя» й губився серед усіх.
function feCatKey(c) {
  return String(c || '').replace(/[\u0027\u2018\u2019\u02BC\u02B9\u00B4`]/g, '’').trim().toLowerCase();
}
function feTplList() {
  // показуємо лише ті фони, що зроблені саме під цю рамку й орієнтацію
  const all = feAllTemplates().filter(feTplFits);
  return feTplCat === 'Всі' ? all
       : feTplCat === 'Мої фони' ? all.filter(t => t.own)
       : all.filter(t => feCatKey(t.cat) === feCatKey(feTplCat));
}
// Порожні вкладки не показуємо: людина тицяє в «Весілля», бачить порожньо
// й вирішує, що сайт зламаний. Рахуємо по ТІЙ рамці, яку зараз обрано, —
// фон для 12×12 не має вмикати вкладку в рамці 21×21.
function feTplCatsShown() {
  const all = feAllTemplates().filter(feTplFits);
  return FE_TPL_CATS.filter(c => {
    if (c === 'Всі') return true;
    if (c === 'Мої фони') return all.some(t => t.own);
    return all.some(t => feCatKey(t.cat) === feCatKey(c));
  });
}
// Якщо обрана вкладка щойно спорожніла (змінили рамку) — вертаємось до «Всі»
function feTplCatSafe() {
  const shown = feTplCatsShown();
  if (!shown.includes(feTplCat)) feTplCat = 'Всі';
  return shown;
}
function feSetTplCat(c, fromModal) {
  feTplCat = c;
  if (fromModal) feRenderTplModal(); else feRefreshPanel();
}
function fePanelTemplates() {
  // перший захід — підтягуємо файл із фонами й оновлюємо панель, коли прийде
  if (!feTplReady()) {
    feLoadTemplates(() => { feRefreshPanel(); feRenderTplModal(); });
    return `<p style="font-size:12.5px;color:var(--fe-dim);text-align:center;padding:18px 0">
      ⏳ Завантажую фони…</p>`;
  }
  let h = `<button class="fe-btn-full soft" onclick="feOpenTplModal()">${feIco('expand')} Розгорнути на весь екран</button>
    <div class="fe-chips" style="margin:12px 0 10px">`;
  feTplCatSafe().forEach(c => h += `<div class="fe-chip ${feTplCat === c ? 'sel' : ''}"
    onclick="feSetTplCat('${c}')">${c}</div>`);
  h += `</div>`;
  const list = feTplList();
  if (!list.length) return h + `<p style="font-size:12px">Тут поки порожньо. Збережи свою композицію кнопкою нижче.</p>
    <button class="fe-btn-full" onclick="feSaveMyTpl()">💾 Зберегти поточний фон</button>`;
  h += `<div class="fe-grid g2">` + list.map(t => feTplCard(t)).join('') + `</div>`;
  h += `<button class="fe-btn-full" onclick="feSaveMyTpl()">💾 Зберегти поточний фон</button>
    ${(feIsAdmin() && !feIsMobile()) ?
      `<button class="fe-btn-full soft" onclick="feMakeThumbs()">${feIco('templates')} Згенерувати превʼю для файлу</button>` : ''}
    <p style="font-size:11.5px;margin-top:10px;line-height:1.5">
      Шаблон замінює фон і декор — фігурки й підписи залишаються. Один «↶» повертає все як було.</p>`;
  return h;
}
// ---- Повноекранна галерея ----
function feOpenTplModal() {
  feModal('fe-m-tpl');
  feLoadTemplates(() => feRenderTplModal());
  feRenderTplModal();
}
function feRenderTplModal() {
  const cats = document.getElementById('fe-tpl-cats');
  const grid = document.getElementById('fe-tpl-grid');
  if (!cats || !grid) return;
  cats.innerHTML = feTplCatSafe().map(c => `<div class="fe-chip ${feTplCat === c ? 'sel' : ''}"
    onclick="feSetTplCat('${c}',true)">${c}</div>`).join('');
  const list = feTplList();
  grid.innerHTML = list.length ? list.map(t => feTplCard(t, true)).join('')
    : `<p style="grid-column:1/-1;color:var(--fe-dim);font-size:13px">Порожньо.</p>`;
}
// ---- Свої збережені фони ----
function feSaveMyTpl() {
  const c = feC();
  const name = prompt('Назва фону:', 'Мій фон ' + ((FE.myTpl || []).length + 1));
  if (!name) return;
  FE.myTpl = FE.myTpl || [];
  const id = 'my' + Date.now();
  // зберігаємо все, крім фігурок і підписів
  const objs = c.getObjects().filter(o => !o._feSafe && o._feKind !== 'figure' && o._feKind !== 'caption');
  let thumb = null;
  try { thumb = feCapture(true, { format:'jpeg', quality:0.6, mult:0.35 }); } catch (e) {}
  // аури зберігаємо параметрами, а не картинками — інакше фон важить сотні кілобайт
  const json = feStripSoft(JSON.stringify(objs.map(o => o.toObject(FE_KEEP))));
  // Стискаємо ДО збереження: інакше важка версія встигає впертись у ліміт
  // сховища, і фон не зберігається взагалі.
  feToast('⏳ Готую фон…', 8000);
  feOptimizeTplImages(json).then(opt => {
    const finalJson = (opt && opt.length < json.length) ? opt : json;
    FE.myTpl.push({ id, cat:'Мої фони', name, own:true, bg:c.backgroundColor,
      size:FE.size, orient:FE.orient, thumb, json:finalJson, title:'власний' });
    feSaveState();
    feRefreshPanel(); feRenderTplModal();
    const mb = n => (n / 1048576).toFixed(1);
    feToast(finalJson.length < json.length
      ? `Фон збережено · ${mb(json.length)} → ${mb(finalJson.length)} МБ`
      : 'Фон збережено', 3500);
  }).catch(() => {
    FE.myTpl.push({ id, cat:'Мої фони', name, own:true, bg:c.backgroundColor,
      size:FE.size, orient:FE.orient, thumb, json, title:'власний' });
    feSaveState(); feRefreshPanel(); feRenderTplModal();
  });
}
function feDelMyTpl(id) {
  const t = (FE.myTpl || []).find(x => x.id === id);
  feConfirm('Видалити фон «' + ((t && t.name) || id) + '»?', () => feDelMyTplNow(id));
}
function feDelMyTplNow(id) {
  const wasActive = FE.template === id;
  FE.myTpl = (FE.myTpl || []).filter(t => t.id !== id);
  feSaveState();
  // якщо саме цей фон стояв на полотні — прибираємо його
  if (wasActive) { feApplyTemplate('blank'); feToast('Фон видалено'); return; }
  feRefreshPanel(); feRenderTplModal();
}
// Експорт свого фону — щоб додати його як вбудований для всіх клієнтів
// Аура (мʼяка пляма) — це картинка, згенерована з форми, кольору й розмиття.
// Тримати її base64 у файлі шаблонів немає сенсу: він розпухає на сотні кілобайт.
// Тому при експорті прибираємо src, а при відкритті малюємо заново.
function feStripSoft(json) {
  try {
    const arr = JSON.parse(json);
    let cut = 0;
    const walk = o => {
      if (!o) return;
      // Порожній src ламав відновлення: fabric не міг створити картинку і
      // мʼяка пляма просто зникала з готового фону. Кладемо прозорий піксель —
      // він завантажується без помилки, а потім підміняється справжньою плямою.
      if (o._feSoft && o.src && o.src !== FE_PX1) { o.src = FE_PX1; cut++; }
      if (o.objects) o.objects.forEach(walk);
    };
    arr.forEach(walk);
    return cut ? JSON.stringify(arr) : json;
  } catch (e) { return json; }
}
// Малюємо ауру заново з її параметрів, якщо картинка не збережена
// У JSON лягають самі числа: заокруглення, товщина контуру, обрізка. Самі
// по собі вони нічого не малюють — треба ще заново побудувати обвідку,
// маску кутів і бічні маркери обрізки. Чернетка це робила, а от готовий фон —
// ні, тому в збереженому фоні зникав контур і не працювала обрізка.
function feRehydrate(o) {
  if (!o) return;
  feRestoreSoft(o);
  if (o._feSafe) { o.selectable = false; o.evented = false; }
  if (o.type === 'image' && (o._feBr || o._feCt || o._feSa || o._feBl || o._feGray)) feApplyFilters(o);
  if (o._feKind === 'photoframe' && o.type === 'image') feFrameApply(o);
  // Видимість маркерів у збереженому фоні не зберігається — повертаємо її
  // аксесуарам, інакше після відкриття макета кружки зʼявляються знову.
  if (o._feKind === 'accessory' && o.setControlsVisibility) {
    o.setControlsVisibility({
      tl:false, tr:false, bl:false, br:false,
      ml:false, mr:false, mt:false, mb:false, mtr:true });
  }
  if (feImgIsPlain(o)) { feImgCropControls(o); if (o._feRx || o._feBW) feImgApply(o); }
}
// Прозорий піксель — заглушка замість вирізаної мʼякої плями
const FE_PX1 = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';
function feRestoreSoft(o) {
  if (!o || !o._feSoft) return;
  const el = o._element || (o.getElement && o.getElement());
  // заглушка 1×1 теж вважається «немає картинки»
  if (el && el.naturalWidth > 1) return;         // картинка на місці
  const s = o._feSoft;
  // Розмір плями на полотні беремо зі збереженого, а не з нової картинки:
  // setSrc підставляє власні габарити зображення й пляма б стрибнула.
  const W = o.width * (o.scaleX || 1), H = o.height * (o.scaleY || 1);
  o.setSrc(feSoftDataUrl(s.shape, s.color, s.blur), () => {
    if (W > 1 && H > 1 && o.width && o.height) {
      o.set({ scaleX: W / o.width, scaleY: H / o.height });
      o.setCoords();
    }
    feC().requestRenderAll();
  });
}
// Чи є в картинці прозорі пікселі — від цього залежить, можна її стиснути в JPEG
function feHasAlpha(cv) {
  try {
    const d = cv.getContext('2d', { willReadFrequently:true })
      .getImageData(0, 0, cv.width, cv.height).data;
    const step = Math.max(4, Math.floor(d.length / 4 / 20000) * 4);   // вибіркова перевірка
    for (let i = 3; i < d.length; i += step) if (d[i] < 250) return true;
    return false;
  } catch (e) { return true; }
}
// Зменшує вшиті картинки до тієї роздільності, яка реально потрібна для друку.
// Картинка, що займає чверть рамки, не має зберігатись у повному розмірі.
function feOptimizeTplImages(json) {
  let arr;
  try { arr = JSON.parse(json); } catch (e) { return Promise.resolve(json); }

  // Роздільність рахуємо під ТУ рамку, для якої робиться фон, а не під
  // найбільшу можливу — інакше зменшення майже не відбувається.
  let PRINT_MULT = 4.5;
  try {
    const d = feDims();
    // рахуємо від повної ширини рамки — стільки ж, скільки друкується
    const printW = d.wMm / 25.4 * FE_PRINT_DPI;
    PRINT_MULT = Math.max(1.2, printW / Math.max(1, FE.baseW));
  } catch (e) {}
  const jobs = [];
  const walk = o => {
    if (!o) return;
    if (o.objects) o.objects.forEach(walk);
    if (o.type !== 'image' || !o.src || o.src.indexOf('data:') !== 0) return;

    jobs.push(new Promise(done => {
      const im = new Image();
      im.onload = () => {
        try {
          const shownW = (o.width || im.naturalWidth) * Math.abs(o.scaleX || 1);
          // Запас поверх друкованої роздільності: збережений фон потім беруть
          // у роботу далі — знімок можуть посунути й збільшити. Без запасу
          // він виходив помітно гіршим, ніж був у редакторі.
          const need = Math.ceil(shownW * PRINT_MULT * 1.6);
          const natural = im.naturalWidth;
          if (!natural) { done(); return; }
          // Зменшуємо лише коли є що зменшувати: інакше єдиним результатом
          // буде зайве перестискання. Але навіть без зменшення проходимо далі —
          // картинку ще можна перепакувати в легший формат без втрати розміру.
          const k = natural < need * 1.25 ? 1 : Math.max(0.05, need / natural);
          const cv = document.createElement('canvas');
          cv.width = Math.max(1, Math.round(im.naturalWidth * k));
          cv.height = Math.max(1, Math.round(im.naturalHeight * k));
          const ctx = cv.getContext('2d', { willReadFrequently:true });
          ctx.imageSmoothingEnabled = true;
          ctx.imageSmoothingQuality = 'high';
          ctx.drawImage(im, 0, 0, cv.width, cv.height);

          // 0.88 давало видиме «мило» на обличчях — знімок уже стиснений раз
          // при завантаженні, і другий прохід накладався поверх першого
          const base = feHasAlpha(cv) ? cv.toDataURL('image/png')
                                      : cv.toDataURL('image/jpeg', 0.95);
          // PNG із прозорістю (малюнки, написи на прозорому) важить мегабайтами.
          // WebP тримає прозорість так само, а важить у рази менше — беремо
          // його, якщо браузер уміє і якщо виграш справді є.
          let out = base;
          try {
            const webp = cv.toDataURL('image/webp', 0.95);
            if (webp.indexOf('data:image/webp') === 0 && webp.length < base.length * 0.9) out = webp;
          } catch (e) {}
          // Якщо розмір не міняли, міняти формат варто лише заради відчутного
          // виграшу — інакше просто перестиснемо знімок ні за що.
          const gain = k === 1 ? 0.7 : 1;
          if (out && out.length < o.src.length * gain) {
            // обрізка задана в пікселях оригіналу — перераховуємо під новий розмір
            if (o.cropX) o.cropX *= k;
            if (o.cropY) o.cropY *= k;
            // заокруглення кутів теж задане в пікселях знімка
            if (o._feRx) o._feRx *= k;
            if (o.width)  o.width  *= k;
            if (o.height) o.height *= k;
            o.scaleX = (o.scaleX || 1) / k;
            o.scaleY = (o.scaleY || 1) / k;
            o.src = out;
          }
        } catch (e) {}
        done();
      };
      im.onerror = () => done();
      im.src = o.src;
    }));
  };
  arr.forEach(walk);
  return Promise.all(jobs).then(() => JSON.stringify(arr));
}

async function feExportMyTpl(id) {
  const t = (FE.myTpl || []).find(x => x.id === id);
  if (!t) return;
  feToast('⏳ Готую фон — стискаю картинки…', 8000);
  const before = (t.json || '').length;
  let json = feStripSoft(t.json);
  try { json = await feOptimizeTplImages(json); } catch (e) {}
  // вкладаємо готове превʼю — тоді на телефоні воно зʼявляється миттєво
  const data = JSON.stringify({ name:t.name, bg:t.bg, thumb:t.thumb || null, json });
  // Копіюємо ГОТОВИЙ запис для frame-templates.js, а не голий JSON: у ньому
  // повно лапок і скісних рисок, і вручну вставлений у код він рвав рядок.
  // Зворотні лапки терплять усе, треба лише знешкодити самі риски й ` та ${.
  const safe = data.replace(/\\/g, '\\\\').replace(/`/g, '\\`').replace(/\$\{/g, '\\${');
  const idg = 'tpl' + Date.now().toString(36);
  const entry = '  {\n' +
    `    id:    "${idg}",\n` +
    `    cat:   "${(t.cat === 'Мої фони' ? 'Інше' : t.cat) || 'Інше'}",\n` +
    `    name:  "${String(t.name).replace(/"/g, '\\"')}",\n` +
    `    bg:    "${t.bg || '#ffffff'}",\n` +
    `    sizes: ["${t.size || FE.size}"],\n` +
    // У квадратної рамки орієнтації немає — не засмічуємо запис зайвим полем
    (feSquareSize(t.size || FE.size) ? '' :
      `    orient:"${t.orient || FE.orient}",\n`) +
    '    raw:   true,\n' +
    '    json:  `' + safe + '`,\n' +
    '  },';
  const mb = n => (n / 1048576).toFixed(1);
  feToast(`Готово: ${mb(before)} → ${mb(entry.length)} МБ`, 4000);
  navigator.clipboard.writeText(entry)
    .then(() => alert('Скопійовано готовий запис для frame-templates.js.\n\n' +
      'Вставити його треба цілком — разом із фігурними дужками — у список фонів.\n' +
      'Не міняй зворотні лапки ` навколо json на звичайні: код почервоніє.'))
    .catch(() => { prompt('Скопіюй цей текст:', entry); });
}
// Показує «як задумано» — один раз на фон за сеанс, щоб не набридати
// тому, хто просто гортає фони туди-сюди.
function feTplHint(id) {
  const img = FE_TPL_HINTS[id];
  if (!img) return;
  FE._hintSeen = FE._hintSeen || {};
  if (FE._hintSeen[id]) return;
  FE._hintSeen[id] = true;
  const box = document.getElementById('fe-hint-body');
  if (!box) return;
  // вікно вужче за 500 px — оригінал тут ні до чого
  box.innerHTML = `<img src="${feSpx(img, 700)}" alt="">`;
  setTimeout(() => feModal('fe-m-hint'), 260);   // даємо фону промалюватись
}
function feApplyTemplate(id) {
  const t = feAllTemplates().find(x => x.id === id), c = feC();
  if (!t) return;
  FE.template = id;
  feTplHint(id);
  FE.hLock = true;   // весь шаблон — один крок в історії
  c.getObjects().slice().forEach(o => {
    if (!o._feSafe && o._feKind !== 'figure' && o._feKind !== 'caption') c.remove(o);
  });
  c.setBackgroundColor(t.bg, () => c.requestRenderAll());

  // готовий фон із збереженого JSON (власний або вбудований)
  if (t.own || t.raw) {
    try {
      // Фони, збережені раніше, мають у мʼякої плями порожній src — fabric на
      // такому спотикається і пляма зникає. Підставляємо прозорий піксель.
      const raw = JSON.parse(t.json);
      const fix = z => {
        if (!z) return;
        if (z._feSoft && !z.src) z.src = FE_PX1;
        if (z.objects) z.objects.forEach(fix);
      };
      raw.forEach(fix);
      fabric.util.enlivenObjects(raw, objs => {
        objs.forEach(o => { c.add(o); feRehydrate(o); });
        feSafeToFront(); c.requestRenderAll();
        feEnsureFonts();                 // свої шрифти могли ще не завантажитись
        FE.hLock = false; feSnapshot(); feRefreshPanel(); feRenderTplModal();
      });
    } catch (e) { FE.hLock = false; feSnapshot(); }
    return;
  }
  const W = FE.baseW, H = FE.baseH;

  // ---- декларативні елементи ----
  if (t.items) {
    t.items.forEach(it => {
      if (it.t === 'soft') {
        fabric.Image.fromURL(feSoftDataUrl(it.shape, it.color, it.blur), img => {
          img.set({ left:W*it.x, top:H*it.y, originX:'center', originY:'center',
            scaleX:(W*it.w)/img.width, scaleY:(W*it.w)/img.width, opacity:it.op ?? 1,
            _feKind:'soft', _feSoft:{ shape:it.shape, color:it.color, blur:it.blur },
            _feName:'Аура · ' + (it.shape === 'heart' ? 'серце' : 'коло') });
          c.add(img); feSafeToFront(); c.requestRenderAll();
        });
      }
      if (it.t === 'text') {
        c.add(new fabric.Textbox(it.text, { left:W*it.x, top:H*it.y, width:W*(it.w || 0.86),
          originX:'center', originY:'center', textAlign:'center',
          fontFamily:it.font, fontWeight:it.weight || '400', fontSize:Math.round(W*it.size),
          fill:it.fill, stroke:it.stroke || null, strokeWidth:it.sw || 0, paintFirst:'stroke',
          _feKind:'text', _feName:it.text }));
      }
      if (it.t === 'shape') {
        const o = feAsShape(it.shape, W*it.w, W*(it.h || it.w), W*it.x, H*it.y,
          { fill:it.fill, stroke:it.stroke, strokeWidth:it.sw || 0, rx:it.rx || 0 }, it.shape);
        if (o) c.add(o);
      }
    });
    feSafeToFront(); c.requestRenderAll();
    FE.hLock = false; feSnapshot(); feRefreshPanel(); feRenderTplModal();
    return;
  }

  if (t.title) c.add(new fabric.Textbox(t.title, { left:W/2, top:H*0.11, width:W*0.8,
    originX:'center', originY:'center', fontFamily:'Nunito', fontWeight:'800',
    fontSize:Math.round(W*0.075), fill:'#C0392B', textAlign:'center', _feKind:'text', _feName:t.title }));
  if (t.sub) c.add(new fabric.Textbox(t.sub, { left:W/2, top:H*0.175, width:W*0.8,
    originX:'center', originY:'center', fontFamily:'Inter', fontSize:Math.round(W*0.038),
    fill:'#374151', textAlign:'center', _feKind:'text', _feName:t.sub }));
  if (t.deco === 'hearts') {
    c.add(feAsShape('rect', W*0.68, H*0.42, W/2, H*0.5, { fill:'transparent', stroke:'#8B5E3C', strokeWidth:3, rx:22 }, 'Рамка-контур'));
    [[0.5,0.29],[0.16,0.38],[0.84,0.4],[0.16,0.58],[0.84,0.6]].forEach((p, i) =>
      c.add(feAsShape('heart', W*0.055, W*0.055, W*p[0], H*p[1], { fill: i === 2 ? '#9CA3AF' : '#E53935' }, 'Серце')));
  }
  if (t.deco === 'line')  c.add(feAsShape('line', W*0.44, 4, W/2, H*0.22, { fill:'#1B2433', strokeWidth:3 }, 'Лінія'));
  if (t.deco === 'stars') [[0.2,0.3],[0.8,0.33],[0.28,0.72],[0.75,0.75]].forEach(p =>
    c.add(feAsShape('star', W*0.05, W*0.05, W*p[0], H*p[1], { fill:'#F4C430' }, 'Зірка')));
  feSafeToFront(); c.requestRenderAll();
  FE.hLock = false; feSnapshot(); feRefreshPanel(); feRenderTplModal();
}
// створює фігуру з позицією і метаданими
// Лінії, риски та стрілки — усе, що по суті є однією смугою
function feIsLineLike(o) {
  if (!o) return false;
  if (o.type === 'line') return true;
  const id = o._feShape || '';
  return /^(line|lineV|lineDash|arrow|chevron|dblChev|caret|zigzag)/.test(id);
}
function feLineLen(v) {
  const o = feAct(); if (!o) return;
  const w = o.width || 1;
  o.set('scaleX', Math.max(1, +v) / w); o.setCoords(); feAfter();
}
// Товщина, яку видно на екрані. Контури-стрілки намальовані в полі 100×100
// і потім масштабуються, тому «сира» strokeWidth не збігається з видимою —
// саме через це поле здавалось непрацюючим.
function feLineVisThick(o) {
  if (!o) return 0;
  const k = o.strokeUniform ? 1 : (Math.abs(o.scaleY || 1) || 1);
  return Math.max(0.5, (o.strokeWidth || 0) * k);
}
function feLineThick(v) {
  const o = feAct(); if (!o) return;
  const k = o.strokeUniform ? 1 : (Math.abs(o.scaleY || 1) || 1);
  o.set({ strokeWidth: Math.max(0.5, (+v) / k) });
  // без кольору обведення товщина нічого не змінить
  if (!o.stroke || o.stroke === 'none') o.set('stroke', feHex(o.fill) || '#1B2433');
  o.setCoords(); feAfter();
}
function feLineAngle(a) {
  const o = feAct(); if (!o) return;
  o.set('angle', a); o.setCoords(); feAfter(); feRefreshPanel();
}
function feAsShape(id, w, h, x, y, opts, name) {
  const o = feMakeShape(id, w, h, opts || {});
  if (!o) return null;
  o.set({ left:x, top:y, _feKind:'shape', _feName:name || id, _feShape:id });
  return o;
}

// --- Фон ---
function fePanelBg() {
  const tab = FE._bgTab || 'solid';
  let h = `<div class="fe-tabs2">
    <div class="fe-tab2 ${tab === 'solid' ? 'on' : ''}" onclick="feBgTab(this,'solid')">Один колір</div>
    <div class="fe-tab2 ${tab === 'grad' ? 'on' : ''}" onclick="feBgTab(this,'grad')">Градієнт</div></div>
    <div id="fe-bg-solid" style="display:${tab === 'solid' ? '' : 'none'}"><h4>Колір паспарту</h4><div class="fe-colors">`;
  FE_MAT_COLORS.forEach(c => h += `<div class="fe-color" style="background:${c}" onclick="feSetBg('${c}')"></div>`);
  h += `</div><h4>Свій колір</h4>
    <input type="color" class="fe-field" style="height:44px;padding:4px" oninput="feSetBg(this.value)" value="#FFFFFF"></div>
    <div id="fe-bg-grad" style="display:${tab === 'grad' ? '' : 'none'}">
    <div class="fe-gprev-wrap"><div class="fe-lbl">Превʼю</div>
      <div id="fe-g-prev" style="height:44px;border-radius:12px;border:2px solid #000;
        background:linear-gradient(${FE_GRAD_ANGLE}deg,${FE._g1 || '#3B82F6'},${FE._g2 || '#22D3EE'})"></div></div>
    <h4>Готові градієнти</h4><div class="fe-grid g2">`;
  FE_GRADIENTS.forEach((g, i) => h += `<div class="fe-tile" style="aspect-ratio:16/9;
    background:linear-gradient(135deg,${g[0]},${g[1]})" onclick="feSetGradient('${g[0]}','${g[1]}')"></div>`);
  h += `</div><h4>Свій градієнт</h4>
    <div class="fe-two" style="margin-top:0">
      <div><div class="fe-lbl">Колір 1</div>
        <input type="color" class="fe-field" id="fe-g1" style="height:40px;padding:3px;margin:0"
          value="${FE._g1 || '#3B82F6'}" oninput="feGradInput()"></div>
      <div><div class="fe-lbl">Колір 2</div>
        <input type="color" class="fe-field" id="fe-g2" style="height:40px;padding:3px;margin:0"
          value="${FE._g2 || '#22D3EE'}" oninput="feGradInput()"></div>
    </div>
    ${feSlider('Кут', 'fe-g-ang', 0, 360, 5, FE_GRAD_ANGLE, 'feGradAngle', '°')}
    <button class="fe-btn-full" onclick="feApplyCustomGradient()">Застосувати</button></div>`;
  return h;
}
function feGradInput() {
  const a = document.getElementById('fe-g1'), b = document.getElementById('fe-g2');
  if (a && b) { FE._g1 = a.value; FE._g2 = b.value; }
  feGradPreview();
}
function feApplyCustomGradient() {
  const a = document.getElementById('fe-g1'), b = document.getElementById('fe-g2');
  if (a && b) feSetGradient(a.value, b.value);
}
function feGradPreview() {
  const p = document.getElementById('fe-g-prev'); if (!p) return;
  const a = document.getElementById('fe-g1'), b = document.getElementById('fe-g2');
  if (!a || !b) return;
  p.style.background = `linear-gradient(${FE_GRAD_ANGLE}deg, ${a.value}, ${b.value})`;
}
// Піпетка: системна EyeDropper (Chrome) або вибір із полотна
function fePick(cb) {
  if (window.EyeDropper) {
    new EyeDropper().open().then(r => cb(r.sRGBHex)).catch(() => {});
    return;
  }
  FE._pickCb = cb;
  // ховаємо панель — колір шукають на фоні, а не в налаштуваннях
  FE._pickReturn = feActiveTool;
  feClosePanel();
  document.body.classList.add('fe-picking');
  feLoupeShow();
  fePickBind(true);
  feToast('Ведіть по фону — у лупі видно колір. Відпустіть, щоб обрати', 3200);
}

// Власні обробники: події fabric на телефоні для цього ненадійні
function fePickBind(on) {
  const wrap = document.getElementById('fe-canvas-wrap');
  if (!wrap) return;
  if (on) {
    if (FE._pickHandlers) return;
    const move = e => { e.preventDefault(); feLoupeAt(e); };
    const end  = e => {
      const hex = feLoupeAt(e) || FE._pickLast;
      if (hex) fePickApply(hex);
    };
    FE._pickHandlers = { move, end };
    wrap.addEventListener('touchstart', move, { passive:false });
    wrap.addEventListener('touchmove',  move, { passive:false });
    wrap.addEventListener('touchend',   end);
    wrap.addEventListener('mousemove',  move);
    wrap.addEventListener('mousedown',  move);
    wrap.addEventListener('click',      end);
  } else if (FE._pickHandlers) {
    const { move, end } = FE._pickHandlers;
    wrap.removeEventListener('touchstart', move);
    wrap.removeEventListener('touchmove',  move);
    wrap.removeEventListener('touchend',   end);
    wrap.removeEventListener('mousemove',  move);
    wrap.removeEventListener('mousedown',  move);
    wrap.removeEventListener('click',      end);
    FE._pickHandlers = null;
  }
}
// Колір під пальцем/курсором за координатами екрана + рух лупи
function feLoupeAt(e) {
  const c = FE.canvas; if (!c) return null;
  const t = (e.touches && e.touches[0]) || (e.changedTouches && e.changedTouches[0]) || e;
  const cx = t.clientX, cy = t.clientY;
  if (cx == null) return null;

  const el = c.upperCanvasEl || c.lowerCanvasEl;
  const r = el.getBoundingClientRect();
  const x = Math.round((cx - r.left) / r.width  * c.getWidth());
  const y = Math.round((cy - r.top)  / r.height * c.getHeight());

  let hex = null;
  if (x >= 0 && y >= 0 && x < c.getWidth() && y < c.getHeight()) {
    try {
      const d = c.getContext('2d').getImageData(x, y, 1, 1).data;
      hex = '#' + [d[0], d[1], d[2]].map(v => v.toString(16).padStart(2, '0')).join('');
    } catch (err) {}
  }
  const lp = document.getElementById('fe-loupe');
  if (lp) {
    lp.style.left = cx + 'px';
    lp.style.top  = Math.max(46, cy - 70) + 'px';   // над пальцем
    if (hex) {
      lp.querySelector('.fe-loupe-dot').style.background = hex;
      lp.querySelector('.fe-loupe-hex').textContent = hex.toUpperCase();
      FE._pickLast = hex;
    }
  }
  return hex;
}
function fePickApply(hex) {
  const cb = FE._pickCb; if (!cb) return;
  FE._pickCb = null;
  fePickBind(false);
  feLoupeHide();
  document.body.classList.remove('fe-picking');
  cb(hex);
  if (FE._pickReturn) { const t = FE._pickReturn; FE._pickReturn = null; feTool(t); }
}

// ---- Лупа піпетки: показує колір під пальцем/курсором ----
function feLoupeShow() {
  if (document.getElementById('fe-loupe')) return;
  const d = document.createElement('div');
  d.id = 'fe-loupe';
  d.innerHTML = `<span class="fe-loupe-dot"></span><b class="fe-loupe-hex">—</b>`;
  document.body.appendChild(d);
}
function feLoupeHide() {
  const d = document.getElementById('fe-loupe');
  if (d) d.remove();
}
function fePickCancel() {
  FE._pickCb = null;
  fePickBind(false);
  feLoupeHide();
  document.body.classList.remove('fe-picking');
  if (FE._pickReturn) { const t = FE._pickReturn; FE._pickReturn = null; feTool(t); }
}
function feBgTab(el, id) {
  FE._bgTab = id;
  el.parentNode.querySelectorAll('.fe-tab2').forEach(t => t.classList.remove('on'));
  el.classList.add('on');
  document.getElementById('fe-bg-solid').style.display = id === 'solid' ? '' : 'none';
  document.getElementById('fe-bg-grad').style.display  = id === 'grad'  ? '' : 'none';
}
let FE_GRAD_ANGLE = 135;
function feGradAngle(v) { FE_GRAD_ANGLE = +v; feGradPreview(); }
function feSetBg(color) { feC().setBackgroundColor(color, () => feC().requestRenderAll()); feSnapshot(); }
function feSetGradient(c1, c2, live) {
  const rad = (FE_GRAD_ANGLE - 90) * Math.PI / 180;
  const cx = FE.baseW / 2, cy = FE.baseH / 2, r = Math.max(FE.baseW, FE.baseH) / 2;
  const g = new fabric.Gradient({
    type:'linear', gradientUnits:'pixels',
    coords:{ x1:cx - Math.cos(rad)*r, y1:cy - Math.sin(rad)*r, x2:cx + Math.cos(rad)*r, y2:cy + Math.sin(rad)*r },
    colorStops:[{ offset:0, color:c1 }, { offset:1, color:c2 }],
  });
  feC().setBackgroundColor(g, () => feC().requestRenderAll());
  if (!live) feSnapshot();
}

// --- Текст ---
const FE_TEXT_PRESETS = [
  { id:'h1',  name:'Заголовок',     size:.075, w:'800', f:'Nunito' },
  { id:'h2',  name:'Підзаголовок',  size:.05,  w:'700', f:'Nunito' },
  { id:'p',   name:'Текст опису',   size:.034, w:'400', f:'Inter'  },
];
// prev — колір лише для превʼю (щоб темні стилі було видно на тёмній панелі)
const FE_TEXT_STYLES = [
  { name:'Класика',     f:'Montserrat',        w:'900', size:.072, fill:FE_INK,    prev:'#E8ECF4' },
  { name:'Урочистий',   f:'Playfair Display',  w:'700', size:.068, fill:FE_INK,    prev:'#E8ECF4' },
  { name:'Ніжність',    f:'Great Vibes',       w:'400', size:.075, fill:'#C2185B', prev:'#F472B6' },
  { name:'Обведення',   f:'Bebas Neue',        w:'400', size:.075, fill:'#FFFFFF', stroke:FE_INK,    sw:3, upper:true },
  { name:'Обʼємний',    f:'Righteous',         w:'400', size:.07,  fill:'#1E3A8A', stroke:'#FFFFFF', sw:4, prev:'#93C5FD' },
  { name:'Сяйво',       f:'Lobster',           w:'400', size:.062, fill:'#22C55E', shadow:'0 0 14px #22C55E', tileShadow:'0 0 9px #22C55E', glow:true },
  { name:'Ретро',       f:'Oswald',            w:'600', size:.058, fill:'#FB923C', spacing:60, upper:true },
  { name:'Округлий',    f:'Comfortaa',         w:'400', size:.05,  fill:'#374151', prev:'#C7CEDB' },
  { name:'Тонкий',      f:'Inter',             w:'300', size:.046, fill:'#4B5563', spacing:60, prev:'#B9C1D0' },
  { name:'Веселий',     f:'Pacifico',          w:'400', size:.07,  fill:'#EC4899', stroke:'#FFFFFF', sw:3 },
  { name:'Розріджений', f:'Montserrat',        w:'700', size:.05,  fill:'#111827', spacing:120, upper:true, prev:'#E8ECF4' },
  { name:'Акцент',      f:'Bebas Neue',        w:'400', size:.072, fill:'#EF4444', shadow:'2px 3px 0 rgba(0,0,0,.25)', upper:true },
  { name:'Курсив',      f:'Cormorant Garamond',w:'400', size:.052, fill:FE_INK,    italic:true, prev:'#CBD3E1' },
  { name:'Вузький',     f:'Oswald',            w:'300', size:.042, fill:'#065F46', spacing:300, upper:true, prev:'#6EE7B7' },
  { name:'Від руки',    f:'Caveat',            w:'700', size:.068, fill:'#7C3AED', prev:'#C4B5FD' },
  { name:'Святковий',   f:'Pacifico',          w:'400', size:.06,  fill:'#FB923C', shadow:'0 2px 5px rgba(0,0,0,.2)' },
];
// CSS-превʼю для кожного стилю (щоб плитка виглядала як результат)
function feTextTileCss(s) {
  let css = `font-family:'${s.f}',sans-serif;font-weight:${s.w};`;
  if (s.italic)  css += 'font-style:italic;';
  if (s.spacing) css += `letter-spacing:${(s.spacing/100).toFixed(2)}px;`;
  const col = s.prev || s.fill;
  if (col === 'transparent') css += `color:transparent;-webkit-text-stroke:1px ${s.stroke};`;
  else css += `color:${col};`;
  if (s.stroke && col !== 'transparent') css += `-webkit-text-stroke:${(s.sw||1)/2.5}px ${s.stroke};paint-order:stroke fill;`;
  if (s.tileShadow) css += `text-shadow:${s.tileShadow};`;
  else if (s.shadow) css += `text-shadow:${s.shadow};`;
  return css;
}
function fePanelText() {
  // На телефоні поле для набору прибрано: його плутали зі списком шрифтів.
  // Там текст набирають уже на полотні — тап по напису, потім олівець.
  let h = feIsMobile()
    ? `<p style="font-size:12px;color:var(--fe-dim);line-height:1.5;margin-bottom:10px">
        Оберіть стиль — напис зʼявиться на фоні. Щоб змінити слова,
        торкніться його й натисніть ✎ у нижній смузі.</p>`
    : `<input class="fe-field" id="fe-text-input" placeholder="Введіть текст…" value="Ваш текст">`;
  h += `<h4>Швидко додати</h4>`;
  FE_TEXT_PRESETS.forEach(p => h += `<button class="fe-btn-full soft" style="margin-top:5px;text-align:left;
    font-size:${p.id === 'h1' ? '16px' : p.id === 'h2' ? '14px' : '12.5px'};font-weight:${p.w};font-family:${p.f}"
    onclick="feAddPreset('${p.id}')">${p.name}</button>`);
  h += `<h4>Стилі тексту</h4><div class="fe-grid g2">`;
  FE_TEXT_STYLES.forEach((s, i) => h += `<div class="fe-tile fe-tile-txt fe-txtprev"
    style="${feTextTileCss(s)}" onclick="feAddText(${i})">${s.name}</div>`);
  return h + `</div>` + (feIsMobile() ? ''
    : `<p style="font-size:11.5px;margin-top:12px">Подвійний клік по тексту — редагувати. Клік — налаштування.</p>`);
}
function feTextValue() {
  const el = document.getElementById('fe-text-input');
  return ((el && el.value) || 'Ваш текст').trim() || 'Ваш текст';
}
function feAddPreset(id) {
  const p = FE_TEXT_PRESETS.find(x => x.id === id), W = FE.baseW;
  feAddTextObj(feTextValue(), { fontFamily:p.f, fontWeight:feFontWeight(p.f, p.w),
    fontSize:Math.round(W*p.size), fill:FE_INK });
}
function feAddText(i) {
  const s = FE_TEXT_STYLES[i], W = FE.baseW;
  let val = feTextValue();
  if (s.upper) val = val.toUpperCase();
  const o = { fontFamily:s.f, fontWeight:feFontWeight(s.f, s.w), fontSize:Math.round(W*s.size), fill:s.fill,
    stroke:s.stroke || null, strokeWidth:s.stroke ? (s.sw || 1.5) : 0,
    paintFirst:'stroke',
    fontStyle:s.italic ? 'italic' : 'normal', charSpacing:s.spacing || 0 };
  if (s.shadow) o.shadow = s.shadow;
  // Сяйво має світитися кольором самого напису, тому запамʼятовуємо силу
  // розмиття окремо — далі колір перераховується при кожній зміні кольору.
  if (s.glow) o._feGlow = 14;
  feAddTextObj(val, o);
}
function feAddTextObj(val, opts) {
  const c = feC(), W = FE.baseW;
  const t = new fabric.Textbox(val, { left:W/2, top:FE.baseH*0.3, width:W*0.72,
    originX:'center', originY:'center', textAlign:'center', ...opts,
    _feKind:'text', _feName:val });
  c.add(t); c.setActiveObject(t); feSafeToFront(); c.requestRenderAll(); feSnapshot();
  feAfterAdd();
}

// --- Підписи (живі, привʼязані до фігурок) ---
function feFiguresOnCanvas() {
  return FE.canvas ? feC().getObjects().filter(o => o._feKind === 'figure') : [];
}
// Кому взагалі можна дати підпис: зібраним фігуркам і предметам з бібліотеки
function feCaptionables() {
  return FE.canvas
    ? feC().getObjects().filter(o => o._feKind === 'figure' || o._feKind === 'item')
    : [];
}
// Мініатюри фігурок у списку підписів — щоб було видно, кому саме підпис
async function feFillCapThumbs(figs) {
  for (const f of figs) {
    const el = document.getElementById('fe-capth-' + f._feId);
    if (!el) continue;
    if (f._feKind === 'item') {
      const it = feItemById(f._feItem);
      if (it) { el.innerHTML = `<img src="${feSpx(it.url, FE_SPRITE_PX)}" alt="">`; el.classList.add('pic'); }
      continue;
    }
    const src = FE.figures[f._feSrc];
    if (!src) continue;
    const r = await feComposeFigure(src);
    const still = document.getElementById('fe-capth-' + f._feId);
    if (r && still) { still.innerHTML = `<img src="${r.url}" alt="">`; still.classList.add('pic'); }
  }
}
function fePanelCaptions() {
  const figs = feCaptionables();
  if (!figs.length) return `<p style="font-size:12.5px">Спочатку додайте фігурки на полотно.</p>`;
  const s = feCapS();
  let h = `<p style="font-size:12px;line-height:1.55;margin-bottom:12px">
    Імена зʼявляються під фігурками одразу. Усі зміни застосовуються автоматично.</p>`;

  figs.forEach(f => {
    const id = f._feId;
    const n = figs.indexOf(f) + 1;
    h += `<div class="fe-caprow">
      <span class="fe-capnum" id="fe-capth-${id}">${n}</span>
      <textarea class="fe-field fe-capta" rows="1" placeholder="Імʼя"
        onfocus="feCapFocus('${id}', this)" onblur="feCapBlur()"
        oninput="feCapName('${id}', this.value); feCapGrow(this)"
        >${feEsc(FE.captions.names[id] || '')}</textarea></div>`;
  });
  // замість номерів підставляємо самі фігурки
  setTimeout(() => {
    feFillCapThumbs(figs);
    document.querySelectorAll('.fe-capta').forEach(feCapGrow);
  }, 0);

  h += `<h4>Шрифт</h4>
    <div style="display:flex;gap:6px;align-items:center;margin-bottom:9px">
      <div style="flex:1">${feFontSelect(s.font, "feCapFont(this.value)", feCapSampleText())}</div>
      <button class="fe-ibtn ${feFavFonts().includes(s.font) ? 'on' : ''}" title="В обрані"
        onclick="feToggleFav('${s.font}')">${feIco('star')}</button>
    </div>
    <div class="fe-icons">
      <button class="fe-ibtn ${s.weight === '800' ? 'on' : ''}" onclick="feCapSet('weight','${s.weight === '800' ? '600' : '800'}')">${feIco('bold')}</button>
      <button class="fe-ibtn ${s.italic ? 'on' : ''}" onclick="feCapSet('italic',${!s.italic})">${feIco('italic')}</button>
      <button class="fe-ibtn ${s.underline ? 'on' : ''}" onclick="feCapSet('underline',${!s.underline})">${feIco('underline')}</button>
      <button class="fe-ibtn ${s.upper ? 'on' : ''}" onclick="feCapSet('upper',${!s.upper})">${feIco('letterCase')}</button>
      <button class="fe-ibtn ${s.align === 'left' ? 'on' : ''}" onclick="feCapSet('align','left')">${feIco('alignLeft')}</button>
      <button class="fe-ibtn ${s.align === 'center' ? 'on' : ''}" onclick="feCapSet('align','center')">${feIco('alignCenter')}</button>
      <button class="fe-ibtn ${s.align === 'right' ? 'on' : ''}" onclick="feCapSet('align','right')">${feIco('alignRight')}</button>
    </div>
    <div class="fe-two" style="margin-top:10px">
      <div><div class="fe-lbl">Колір</div>
        <div style="display:flex;gap:6px">
          <input type="color" class="fe-field" style="height:40px;padding:3px;margin:0;flex:1"
            value="${s.color}" oninput="feCapColor(this.value)">
          <button class="fe-ibtn" title="Піпетка" onclick="fePick(feCapColor)">${feIco('picker')}</button>
        </div></div>
      <div></div>
    </div>
    ${feSlider('Розмір','fe-cap-size',1.5,8,0.1,s.size,'feCapSize','')}
    ${feSlider('Міжлітерний інтервал','fe-cap-sp',-60,500,10,s.spacing,'feCapSpacing','')}
    ${feSlider('Відступ від фігурки','fe-cap-of',-40,60,1,s.offset,'feCapOffset','%')}
    <label class="fe-check"><input type="checkbox" ${s.oneLine ? 'checked' : ''}
      onchange="feCapSet('oneLine',this.checked)"> Вирівнювати підписи в ряду</label>
    <label class="fe-check"><input type="checkbox" ${s.moveWith ? 'checked' : ''}
      onchange="feCapSet('moveWith',this.checked)"> Рухати підпис разом із фігуркою</label>
    <button class="fe-btn-full soft" onclick="feCapReset()">${feIco('reset')} Скинути налаштування</button>`;
  return h;
}
function feEsc(s) {
  return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
}
// Поле імені росте під кількість рядків — щоб не було внутрішнього скролу
function feCapGrow(el) {
  if (!el) return;
  el.style.height = 'auto';
  el.style.height = Math.min(el.scrollHeight, 120) + 'px';
}
// Клавіатура на телефоні закриває поле, у яке пишуть. Робимо те саме, що й
// для налаштувань тексту: піднімаємо шухляду над клавіатурою й наводимо
// полотно на той підпис, який зараз редагують.
function feCapFocus(id, el) {
  FE._typing = true;
  FE._capEditId = id;
  feCapAim();
  fePanelKb(true, el);
}
function feCapBlur() {
  FE._typing = false;
  FE._capEditId = null;
  FE._lockedSel = null;
  fePanelKb(false);
}
// Наводимо камеру на підпис, який зараз редагують. Поки він порожній,
// свого обʼєкта на полотні немає — тоді дивимось на саму фігурку.
function feCapAim() {
  const c = FE.canvas, id = FE._capEditId;
  if (!c || !id) return;
  const o = c.getObjects().find(x => x._feKind === 'caption' && x._feFigId === id) ||
            c.getObjects().find(x => x._feId === id);
  if (o) { FE._lockedSel = o; if (FE._panelKb) FE._kbObj = o; }
}
function feCapName(id, val) {
  FE.captions.names[id] = val;
  feSyncCaptions();
  feUpdateFontSample(val);   // у списку шрифтів одразу видно введене імʼя
}
// Оновлює зразок у відкритому списку шрифтів, не перемальовуючи панель
function feUpdateFontSample(txt, empty) {
  let s = String(txt || '').replace(/\s+/g, ' ').trim();
  if (s.length > 18) s = s.slice(0, 18) + '…';
  if (!s) s = empty || 'Імʼя';   // текст стерли — повертаємо початковий зразок
  document.querySelectorAll('.fe-fontsel .fe-fo-text').forEach(el => { el.textContent = s; });
}
function feCapSet(k, v)     { feCapS()[k] = v; feSyncCaptions(); feRefreshPanel(); }
function feCapSize(v)       { feCapS().size = +v; feSyncCaptions(); }
function feCapSpacing(v)    { feCapS().spacing = +v; feSyncCaptions(); }
function feCapOffset(v)     { feCapS().offset = +v; feSyncCaptions(); }
// колір — без перемальовування панелі, щоб не рвався drag по палітрі
function feCapColor(v)      { feCapS().color = v; feCapRestyle(); }
function feCapRestyle() {
  const c = FE.canvas; if (!c) return;
  const s = feCapS();
  c.getObjects().filter(o => o._feKind === 'caption')
    .forEach(o => o.set({ fill:s.color }));
  c.requestRenderAll();
}
// Швидке переміщення підписів без перебудови (для плавного drag)
// ctx — готовий розрахунок рядів; only — рухати підпис лише цієї фігурки.
// Обидва потрібні під час перетягування: перерахунок усіх фігурок на кожен
// рух миші робив рух ривкуватим.
function feMoveCaptions(ctx, only) {
  const c = FE.canvas; if (!c) return;
  const caps = c.getObjects().filter(o => o._feKind === 'caption');
  if (!caps.length) return;
  const figs = {};
  feCaptionables().forEach(f => figs[f._feId] = f);
  const cx = ctx || feCapCtx();
  caps.forEach(t => {
    if (only && t._feFigId !== only._feId) return;
    const f = figs[t._feFigId]; if (!f) return;
    t.set(feCapPos(f, cx));
    t.setCoords();
  });
  c.requestRenderAll();
}
function feCapReset()       { FE.captions.s = { ...FE_CAP_DEFAULTS }; feSyncCaptions(); feRefreshPanel(); }

// Перебудовує підписи під поточні фігурки й налаштування
// Позицію підпису рахуємо в ОДНОМУ місці. Раніше формула була двічі —
// у створенні підписів і в їх перенесенні за фігуркою — і друга нічого не
// знала про спільну лінію. Тому вирівняне «розʼїжджалось», щойно фігурку
// пересували, і поверталось на місце лише коли переписати імʼя.
// Вирівнюємо підписи не по всьому полотну, а В МЕЖАХ РЯДУ. Фігурки, що
// стоять приблизно на одному рівні, вважаємо одним рядом — їхні підписи
// стають на спільну лінію. Якщо фігурку навмисно підняли вище або розклали
// у два ряди, кожен ряд отримує свою лінію, і нічого не зʼїжджає.
function feCapCtx() {
  const s = feCapS();
  const ctx = { s, rows:{} };
  if (!s.oneLine) return ctx;

  const list = [];
  let tall = 0;
  feCaptionables().forEach(f => {
    if (!(FE.captions.names[f._feId] || '').trim()) return;
    f.setCoords();
    const r = f.getBoundingRect(true, true);
    list.push({ id:f._feId, bottom:r.top + r.height, h:r.height });
    if (r.height > tall) tall = r.height;
  });
  if (!list.length) return ctx;

  // Поріг «той самий ряд» — третина зросту найвищої фігурки. Собачка поруч
  // із людиною сюди потрапляє, а фігурка, піднята на пів зросту, — вже ні.
  const gap = Math.max(tall * 0.35, 1);
  list.sort((a, b) => a.bottom - b.bottom);
  let row = [list[0]];
  const rows = [row];
  for (let i = 1; i < list.length; i++) {
    if (list[i].bottom - row[row.length - 1].bottom <= gap) row.push(list[i]);
    else { row = [list[i]]; rows.push(row); }
  }
  rows.forEach(r => {
    const bottom = Math.max(...r.map(x => x.bottom));
    const h = Math.max(...r.map(x => x.h));
    r.forEach(x => { ctx.rows[x.id] = { bottom, h }; });
  });
  return ctx;
}
function feCapPos(f, ctx) {
  f.setCoords();
  const row = (ctx.rows || {})[f._feId];
  // Межі рахуємо, лише коли вони справді потрібні: під час перетягування це
  // відбувається на кожен рух миші, і зайвий перерахунок відчувався ривками.
  const b = row ? null : f.getBoundingRect(true, true);
  // центр тіла фігурки (без аксесуарів), а не центр рамки
  const cx = f.left + ((f._feCx != null ? f._feCx : 0.5) - 0.5) * f.getScaledWidth();
  // Відступ беремо від найвищої фігурки ряду: інакше в собачки він виходив
  // дрібнішим, і підписи ставали сходинками навіть на спільній лінії.
  const base = row ? row.bottom : b.top + b.height;
  const hRef = row && row.h ? row.h : b.height;
  return { left:cx, top:base + hRef * (ctx.s.offset / 100) };
}
// Підпис може бути в кілька рядків: «Імʼя» і «Прізвище» окремо читаються
// краще, ніж один довгий рядок під фігуркою. Прибираємо зайві пробіли й
// порожні рядки, щоб випадковий Enter не робив дірку під іменем.
function feCapText(v) {
  return String(v || '').split('\n').map(x => x.trim()).filter(Boolean).join('\n');
}
function feSyncCaptions(skipSnapshot) {
  const c = FE.canvas; if (!c) return;
  const s = feCapS();
  const figs = feCaptionables();
  // видаляємо старі
  c.getObjects().filter(o => o._feKind === 'caption').forEach(o => c.remove(o));

  const ctx = feCapCtx();

  figs.forEach(f => {
    const raw = feCapText(FE.captions.names[f._feId]);
    if (!raw) return;
    const txt = s.upper ? raw.toUpperCase() : raw;
    const pos = feCapPos(f, ctx);
    // fabric.Text підганяє ширину під текст, тому підпис завжди рівно під фігуркою
    const t = new fabric.Text(txt, {
      left: pos.left,
      top:  pos.top,
      originX:'center', originY:'top', textAlign:s.align,
      fontFamily:s.font, fontWeight:feFontWeight(s.font, s.weight),
      fontStyle:s.italic ? 'italic' : 'normal',
      underline:!!s.underline,
      fontSize:Math.round(FE.baseW * s.size / 100),
      charSpacing:s.spacing, fill:s.color,
      selectable:!s.moveWith, evented:!s.moveWith,
      _feKind:'caption', _feFigId:f._feId, _feName:'Підпис: ' + raw.replace(/\n/g, ' '),
      // підпис предмета не ховається разом із фігурками — предмет лишається на фоні
      _feForItem: f._feKind === 'item',
    });
    c.add(t);
  });
  feSafeToFront();
  // Підписи перемальовуються на кожну літеру: якщо камера тримається за
  // старий обʼєкт, після першого ж символу вона дивиться в нікуди.
  feCapAim();
  c.requestRenderAll();
  if (!skipSnapshot) feSnapshot();
}

// --- Файли ---
const FE_UPLOAD_PER_PAGE = 6;
function fePanelFiles() {
  let h = `<button class="fe-btn-full" onclick="fePickPhoto()">${feIco('files')} Завантажити фото</button>
    <input type="file" id="fe-file-input" accept="image/*,.svg" multiple style="display:none" onchange="feUploadImage(event)">`;
  if (!FE.uploads.length) {
    h += `<div class="fe-empty">${feIco('files')}<div>Тут зʼявляться завантажені фото</div></div>`;
  } else {
    h += `<h4>Мої фото (${FE.uploads.length})</h4>`;
    h += fePagedGrid(FE.uploads.map((u, i) => i), FE.uploadPage, FE_UPLOAD_PER_PAGE, 'feUploadPage', i =>
      `<div class="fe-tile ${FE.uploadSel === i ? 'sel' : ''}" title="${FE.uploads[i].name}"
        ontouchstart="feSelectUpload(${i})" onclick="feSelectUpload(${i})">
        <div class="fe-tile-img" style="background:#fff"><img src="${FE.uploads[i].url}"
          style="top:0;height:100%;object-fit:cover;transform:none"></div>
        <button class="fe-tile-x" onclick="event.stopPropagation();feDelUpload(${i})">${feIco('close')}</button>
      </div>`, 3);
  }
  const ready = FE.uploadSel != null && FE.uploads[FE.uploadSel];
  h += `<button class="fe-btn-add ${ready ? 'on' : ''}" onclick="feAddSelectedUpload()">
    ${ready ? feIco('plus') + ' Додати на полотно' : 'Оберіть фото'}</button>`;
  return h;
}
function feSelectUpload(i) {
  if (FE.uploadSel === i) return;   // ontouchstart + onclick не мають спрацьовувати двічі
  FE.uploadSel = i;
  feRefreshPanel();
}
function feAddSelectedUpload() {
  if (FE.uploadSel == null || !FE.uploads[FE.uploadSel]) {
    feToast('Оберіть файл для розміщення'); return;
  }
  const i = FE.uploadSel;
  FE.uploadSel = null;
  feAddUpload(i);
}
function feUploadPage(p) { FE.uploadPage = p; feRefreshPanel(); }
// Фото з телефона — це 12 мегапікселів. У памʼяті таке зображення займає
// близько 48 МБ у розпакованому вигляді, і кількох штук досить, щоб браузер
// на телефоні прибив вкладку. Тому зменшуємо до розумного розміру одразу:
// для друку рамки цього з великим запасом вистачає.
// 2400 px обрано з розрахунку на найбільшу рамку 30×40: її файл для друку
// має 3118 px по ширині, тож навіть фото на весь фон лишається придатним.
const FE_MAX_PHOTO_PX = 2400;
function feDownscale(dataUrl, mime) {
  return new Promise(resolve => {
    const im = new Image();
    im.onload = () => {
      const w = im.naturalWidth, h = im.naturalHeight;
      const long = Math.max(w, h);
      if (!long || long <= FE_MAX_PHOTO_PX) { resolve(dataUrl); return; }
      try {
        const k = FE_MAX_PHOTO_PX / long;
        const cv = document.createElement('canvas');
        cv.width = Math.round(w * k); cv.height = Math.round(h * k);
        const ctx = cv.getContext('2d');
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = 'high';
        ctx.drawImage(im, 0, 0, cv.width, cv.height);
        const out = (mime === 'image/png')
          ? cv.toDataURL('image/png')
          : cv.toDataURL('image/jpeg', 0.92);
        resolve(out && out.length > 1000 ? out : dataUrl);
      } catch (err) { resolve(dataUrl); }
    };
    im.onerror = () => resolve(dataUrl);
    im.src = dataUrl;
  });
}

// Векторні файли з редакторів часто містять невидиму підкладку на весь аркуш
// або порожню рамку — через них рамка виділення виходить набагато більшою за
// сам малюнок. Прибираємо такі елементи й перераховуємо габарити.
function feTrimVector(g) {
  if (!g) return g;

  // 1) прибираємо явно невидимі елементи (підкладки з fill="none" тощо)
  if (g._objects && g._objects.length > 1) {
    // Обережно: «немає заливки» — це лише явні none/transparent. Якщо колір
    // просто не розпізнався (Illustrator виносить його в CSS-класи), fill
    // приходить порожнім — раніше такі елементи ми викидали, і частина
    // малюнка зникала.
    const empty = v => v === 'none' || v === 'transparent';
    const invisible = o => {
      const noFill = empty(o.fill);
      const noStroke = empty(o.stroke) || !o.strokeWidth;
      return o.visible === false || o.opacity === 0 || (noFill && noStroke);
    };
    const junk = g._objects.filter(invisible);
    if (junk.length && junk.length < g._objects.length) {
      try { junk.forEach(o => g.remove(o)); g.addWithUpdate(); } catch (e) {}
    }
  }

  // 2) головне: міряємо, де насправді є непрозорі пікселі, і підганяємо
  //    габарити під них. Так само ми обрізаємо спрайти фігурок.
  try {
    const W = Math.ceil(g.width), H = Math.ceil(g.height);
    if (!W || !H || W * H > 4e6) return g;
    const el = g.toCanvasElement ? g.toCanvasElement() : null;
    if (!el) return g;
    const cw = el.width, ch = el.height;
    const d = el.getContext('2d', { willReadFrequently:true }).getImageData(0, 0, cw, ch).data;

    let minX = cw, minY = ch, maxX = -1, maxY = -1;
    for (let y = 0; y < ch; y++) {
      for (let x = 0; x < cw; x++) {
        if (d[(y * cw + x) * 4 + 3] > 8) {
          if (x < minX) minX = x;
          if (x > maxX) maxX = x;
          if (y < minY) minY = y;
          if (y > maxY) maxY = y;
        }
      }
    }
    if (maxX < 0) return g;                       // нічого не намальовано
    const bw = maxX - minX + 1, bh = maxY - minY + 1;
    if (bw >= cw - 2 && bh >= ch - 2) return g;   // порожнеч і так немає

    // переводимо у координати обʼєкта й зсуваємо вміст у центр
    const kx = W / cw, ky = H / ch;
    const cx = (minX + bw / 2) * kx - W / 2;
    const cy = (minY + bh / 2) * ky - H / 2;
    if (g._objects) g._objects.forEach(o => {
      o.set({ left:o.left - cx, top:o.top - cy }); o.setCoords();
    });
    g.set({ width: bw * kx, height: bh * ky });
    g.setCoords();
  } catch (e) {}
  return g;
}

// Лоток із фото живе, доки людина не почне проєкт спочатку — старі знімки
// самі по собі не зникають, бо до них часто вертаються під час роботи.
// Межа тут лише запобіжна, щоб памʼять телефона не пішла в рознос.
const FE_MAX_UPLOADS = 30;
// Скільки завантажених фото переживає перезавантаження сторінки.
// Раніше лоток не зберігався взагалі — фото зникали, і їх доводилось
// шукати наново. Сховище велике, але не безмежне.
const FE_KEEP_UPLOADS = 20;
function feUploadsToSave() {
  const list = FE.uploads || [];
  return list.slice(-FE_KEEP_UPLOADS).map(u => ({ name:u.name, url:u.url, oid:u.oid }));
}
// Перед вибором фото завжди попереджаємо, що воно поїде на сервер разом
// із замовленням. Людина має розуміти це ДО того, як обрала файл.
function fePickPhoto() { FE._privacyNext = 'fe-file-input'; feModal('fe-m-privacy'); }
function fePrivacyOk() {
  const id = FE._privacyNext || 'fe-file-input';
  FE._privacyNext = null;
  feModalClose();
  const inp = document.getElementById(id);
  if (inp) inp.click();
}
// Мітка знімка: за нею потім видно, які саме фото людина поставила на фон.
// Має бути унікальною і між сеансами — інакше знімок із відновленої чернетки
// міг би злитися з новим, у якого просто той самий порядковий номер.
function feRegOrig(file) {
  if (!file) return null;
  if (!FE._sess) FE._sess = Math.random().toString(36).slice(2, 7);
  return 'up' + FE._sess + '-' + (++FE._idc);
}
function feUploadImage(e) {
  const files = Array.from(e.target.files || []);
  let done = 0;
  files.forEach(file => {
    const r = new FileReader();
    r.onload = ev => {
      // Векторний файл зменшувати нема сенсу й шкідливо: він лишається
      // вектором і не мутніє, а перегін через полотно перетворив би його
      // на звичайну картинку.
      const isSvg = file.type === 'image/svg+xml' || /\.svg$/i.test(file.name || '');
      const prep = isSvg ? Promise.resolve(ev.target.result)
                         : feDownscale(ev.target.result, file.type);
      prep.then(url => {
        FE.uploads.push({ url, name: file.name, oid: feRegOrig(file) });
        // запобіжник від переповнення памʼяті на телефоні
        if (FE.uploads.length > FE_MAX_UPLOADS) FE.uploads.splice(0, FE.uploads.length - FE_MAX_UPLOADS);
        if (++done === files.length) {
          FE.uploadPage = Math.floor((FE.uploads.length - 1) / FE_UPLOAD_PER_PAGE);
          feRefreshPanel();
        }
      });
    };
    r.readAsDataURL(file);
  });
  e.target.value = '';
}
function feDelUpload(i) {
  FE.uploads.splice(i, 1);
  if (FE.uploadSel === i) FE.uploadSel = null;
  else if (FE.uploadSel > i) FE.uploadSel--;
  feRefreshPanel();
}
function feAddUpload(i) {
  const up = FE.uploads[i]; if (!up) return;

  // Векторний файл лишається вектором — не мутніє ні при збільшенні, ні у друці
  if (/^data:image\/svg\+xml/.test(up.url) || /\.svg$/i.test(up.name || '')) {
    const body = up.url.split(',')[1] || '';
    let src;
    try { src = up.url.includes(';base64,') ? decodeURIComponent(escape(atob(body))) : decodeURIComponent(body); }
    catch (e) { src = up.url.includes(';base64,') ? atob(body) : body; }
    fabric.loadSVGFromString(src, (objs, opts) => {
      if (!objs || !objs.length) { feToast('Не вдалося прочитати SVG'); return; }
      const g = feTrimVector(fabric.util.groupSVGElements(objs, opts)), c = feC();
      const sc = Math.min(FE.baseW * 0.45 / (g.width || 100), FE.baseH * 0.45 / (g.height || 100));
      g.set({ left:FE.baseW/2, top:FE.baseH/2, originX:'center', originY:'center',
        scaleX:sc, scaleY:sc, _feKind:'image', _feName:up.name, _feOid:up.oid });
      c.add(g); c.setActiveObject(g); feSafeToFront(); c.requestRenderAll(); feSnapshot();
      feAfterAdd();
    });
    return;
  }

  fabric.Image.fromURL(up.url, img => {
    const c = feC();
    const sc = Math.min(FE.baseW*0.45 / img.width, FE.baseH*0.45 / img.height);
    img.set({ left:FE.baseW/2, top:FE.baseH/2, originX:'center', originY:'center',
      scaleX:sc, scaleY:sc, _feKind:'image', _feName:up.name, _feOid:up.oid });
    feImgCropControls(img);
    c.add(img); c.setActiveObject(img); feSafeToFront(); c.requestRenderAll(); feSnapshot();
    feAfterAdd();
  });
}

// --- Фігури / стрілки / фоторамки ---
function fePanelShapes() {
  let h = feSoftBlock() + `<h4>Фігури</h4><div class="fe-grid">`;
  FE_SHAPES.forEach(s => h += `<div class="fe-tile" title="${s.n}" onclick="feAddShape('${s.id}')">
    <svg viewBox="0 0 100 100" width="30" height="30">${feShapeSvg(s.id, '#EDD05C')}</svg></div>`);
  h += `</div><h4>Рамки для фото</h4>`;
  Object.keys(FE_FRAME_GROUPS).forEach(g => {
    h += `<div class="fe-subh">${g}</div><div class="fe-grid">`;
    FE_FRAME_GROUPS[g].forEach(id => h += `<div class="fe-tile" onclick="feAddPhotoFrame('${id}')">
      <svg viewBox="0 0 100 100" width="32" height="32">${feFramePreviewSvg(id)}</svg></div>`);
    h += `</div>`;
  });
  h += `<p style="font-size:11px;margin:8px 0 0;line-height:1.5">
    Натисни рамку на полотні → «Додати фото». Потім фото всередині можна масштабувати й рухати.</p>`;
  h += `<h4>Стрілки</h4><div class="fe-grid">`;
  FE_ARROWS.forEach(id => h += `<div class="fe-tile" onclick="feAddShape('${id}')">
    <svg viewBox="0 0 100 100" width="28" height="28">${feShapeSvg(id, '#E8ECF4')}</svg></div>`);
  h += `</div><h4>Колір нового елемента</h4>
    <input type="color" id="fe-shape-color" class="fe-field" style="height:44px;padding:4px" value="#000000">`;
  return h;
}
function feAddShape(id) {
  const c = feC(), W = FE.baseW, S = W * 0.16;
  const color = document.getElementById('fe-shape-color')?.value || FE_INK;
  const o = feAsShape(id, S, id === 'line' ? 4 : S, W/2, FE.baseH/2, { fill:color, strokeWidth:4 },
    (FE_SHAPES.find(x => x.id === id) || {}).n || 'Стрілка');
  if (!o) return;
  c.add(o); c.setActiveObject(o); feSafeToFront(); c.requestRenderAll(); feSnapshot();
  feAfterAdd();
}
// --- Порожня фоторамка: SVG «небо + пагорби + сонце», обрізане формою ---
function feAddPhotoFrame(id) {
  const c = feC(), W = FE.baseW, S = Math.round(W * 0.34);
  // заготовка має бути тих же пропорцій, що й сама форма
  const ar = feFrameAspect(id);
  const FW = ar >= 1 ? S : Math.round(S * ar);
  const FH = ar >= 1 ? Math.round(S / ar) : S;
  const g = feBuildFramePlaceholder(id, FW, FH);
  g.set({ left:W/2, top:FE.baseH/2 });
  c.add(g); c.setActiveObject(g); feSafeToFront(); c.requestRenderAll(); feSnapshot();
  feAfterAdd();
}
// Малюнок-заготовку збираємо самі, розміром рівно FW×FH — тоді габарити
// обʼєкта збігаються з формою, а не лишаються квадратом від SVG 100×100.
function feBuildFramePlaceholder(id, FW, FH, rPx) {
  const kx = FW / 100, ky = FH / 100;
  const at = (d, fill) => new fabric.Path(d, {
    fill, originX:'left', originY:'top', left:-FW/2, top:-FH/2, scaleX:kx, scaleY:ky });
  const parts = [
    new fabric.Rect({ width:FW, height:FH, fill:'#CFE3F5',
      originX:'center', originY:'center', left:0, top:0 }),
    at('M0 66l24-18 20 14 22-20 34 26v34H0z', '#8FC98A'),
    at('M0 82l30-16 26 12 44-18v42H0z', '#6FB86C'),
    new fabric.Circle({ radius:9 * Math.min(kx, ky), fill:'#FFFFFF',
      originX:'center', originY:'center', left:(72 - 50) * kx, top:(28 - 50) * ky }),
  ];
  const g = new fabric.Group(parts, {
    originX:'center', originY:'center',
    // без кешу маска перемальовується одразу, коли тягнеш заокруглення
    objectCaching:false,
    _feKind:'photoframe', _feShape:id, _feFW:FW, _feFH:FH, _feRx:rPx || 0,
    _feName:'Рамка для фото' });
  const r = Math.max(0, rPx || 0);
  if (!feIsRectShape(id) || r > 0) {
    const clip = feFrameShapeObj(id, FW, FH, r);
    clip.set({ left:0, top:0, fill:'#000' });
    g.set('clipPath', clip);
  }
  return g;
}
// Заокруглення на порожній заготовці — перебудовуємо її з новим радіусом
// Заокруглення порожньої заготовки — міняємо лише маску, обʼєкт не чіпаємо.
// Перестворення тут ламало перетягування повзунка: він зникав з-під пальця.
function feFrameRxEmpty(v) {
  const o = feAct();
  if (!o || o._feKind !== 'photoframe' || o.type === 'image') return;
  const r = Math.max(0, +v || 0);
  o._feRx = r;
  const shape = o._feShape || 'rect';
  if (!feIsRectShape(shape) || r > 0) {
    const clip = feFrameShapeObj(shape, o._feFW, o._feFH, r);
    clip.set({ left:0, top:0, fill:'#000' });
    o.set('clipPath', clip);
  } else o.set('clipPath', null);
  // група кешує свій вигляд — без цього нова маска не перемальовується
  o.dirty = true;
  if (o._objects) o._objects.forEach(x => { x.dirty = true; });
  feC().requestRenderAll();
  if (!FE._sliding) feSnapshot();
}
// --- Вставка фото у рамку ---
function feFramePickPhoto() {
  const o = feC().getActiveObject(); if (!o) return;
  FE._frameTarget = o;
  FE._privacyNext = 'fe-frame-input';   // те саме попередження, що й для звичайних фото
  feModal('fe-m-privacy');
}
function feFrameLoadPhoto(e) {
  const file = e.target.files[0], target = FE._frameTarget;
  if (!file || !target) return;
  const oid = feRegOrig(file);
  const r = new FileReader();
  r.onload = ev => feDownscale(ev.target.result, file.type).then(src =>
    fabric.Image.fromURL(src, img => {
    const c = feC();
    // реальний розмір рамки на полотні: для картинки — збережений, для заготовки — з масштабу
    const FW = target.type === 'image' ? target._feFW : target.width  * (target.scaleX || 1);
    const FH = target.type === 'image' ? target._feFH : target.height * (target.scaleY || 1);
    img.set({ left:target.left, top:target.top, angle:target.angle || 0,
      originX:'center', originY:'center',
      _feKind:'photoframe', _feShape:target._feShape,
      _feFW:FW, _feFH:FH, _feZoom:1, _feOffX:0, _feOffY:0,
      _feRot:0, _feFrameAngle:target.angle || 0,
      _feAncX:target.left, _feAncY:target.top,
      // заокруглення й контур переносимо зі старої рамки — вони не мають
      // скидатись від того, що людина замінила знімок
      _feRx:target._feRx || 0, _feBW:target._feBW || 0, _feBC:target._feBC || null,
      _feName:'Фото в рамці', _feOid:oid, _feFile:file.name });
    // знімок кладемо в оригінальній роздільності — щоб у друці не мутнів
    img._feFullW = img.width; img._feFullH = img.height;
    // Місце в стосі шарів має зберегтися: рамка могла лежати під іншими
    // обʼєктами, і фото не повинно вискакувати наперед.
    const idx = c.getObjects().indexOf(target);
    c.remove(target); c.add(img);
    if (idx >= 0) img.moveTo(idx);
    feFrameApply(img);
    c.setActiveObject(img);
    feSafeToFront(); c.requestRenderAll(); feSnapshot(); feRefreshPanel();
  }));
  r.readAsDataURL(file);
  e.target.value = '';
  FE._frameTarget = null;
}
// Перерахунок масштабу й обрізки фото всередині рамки
// Рамка й маркери мають збігатися з «вікном» рамки, а не з усім знімком —
// інакше після наближення фото захвати розповзаються на пів полотна
// і перекривають сусідні обʼєкти.
function feFrameApply(o) {
  if (!o || o.type !== 'image') return;
  const el = o._element || (o.getElement && o.getElement());
  const NW = (el && (el.naturalWidth || el.width))  || o.width;
  const NH = (el && (el.naturalHeight || el.height)) || o.height;
  if (!NW || !NH) return;

  if (!o._feId) o._feId = 'pf' + (++FE._idc);
  const FW = o._feFW, FH = o._feFH;
  const zoom = Math.max(1, o._feZoom || 1);
  const sc = Math.max(FW / NW, FH / NH) * zoom;   // «cover» + наближення

  // Видима частина знімка в пікселях оригіналу. Саме її ми вирізаємо,
  // тому габарити обʼєкта = габарити рамки, і виділення збігається з формою.
  const vw = Math.min(NW, FW / sc);
  const vh = Math.min(NH, FH / sc);

  let cx = (NW - vw) / 2 - (o._feOffX || 0) / sc;
  let cy = (NH - vh) / 2 - (o._feOffY || 0) / sc;
  cx = Math.max(0, Math.min(NW - vw, cx));
  cy = Math.max(0, Math.min(NH - vh, cy));
  // зсув могли обмежити краї знімка — повертаємо фактичне значення
  o._feOffX = ((NW - vw) / 2 - cx) * sc;
  o._feOffY = ((NH - vh) / 2 - cy) * sc;
  // скільки взагалі можна посунути знімок у кожен бік (у пікселях полотна)
  o._feSlackX = Math.round((NW - vw) / 2 * sc);
  o._feSlackY = Math.round((NH - vh) / 2 * sc);

  if (o._feAncX == null) { o._feAncX = o.left; o._feAncY = o.top; }

  o.set({ cropX:cx, cropY:cy, width:vw, height:vh,
          scaleX:sc, scaleY:sc, angle:o._feFrameAngle || 0,
          left:o._feAncX, top:o._feAncY });

  // Форма рамки в координатах обʼєкта — вона ж обрізає фото, вона ж малює контур.
  // Тримаємо все в одному обʼєкті, щоб контур не був окремим шаром.
  // Форма в координатах обʼєкта: радіус переводимо через масштаб,
  // щоб на екрані заокруглення лишалось однаковим за будь-якого наближення.
  const shape = o._feShape || 'rect';
  const form = feFrameShapeObj(shape, vw, vh, Math.max(0, o._feRx || 0) / sc);
  form.set({ left:0, top:0, fill:'#000' });
  o._feForm = form;
  o.set('clipPath', (!feIsRectShape(shape) || (o._feRx || 0) > 0) ? form : null);
  feFrameOutline(o, sc);

  o.setCoords();
  feC().requestRenderAll();
}

// ============================================================
// ЗВИЧАЙНЕ ФОТО: обрізка збоку, скруглення, контур
// Кутові маркери, як і були, змінюють розмір цілком.
// Бічні — підрізають фото з того боку, за який тягнеш: протилежний
// край лишається на місці, а зайве просто перестає бути видимим.
// ============================================================
function feImgIsPlain(o) {
  return !!o && o.type === 'image' && o._feKind === 'image';
}
// Скільки пікселів оригіналу приховано з кожного боку
function feImgSrc(o) {
  const el = o._element || (o.getElement && o.getElement());
  return { w: (el && (el.naturalWidth || el.width)) || o.width,
           h: (el && (el.naturalHeight || el.height)) || o.height };
}
// Зсуваємо обʼєкт так, щоб протилежний край лишився на місці
function feImgShift(o, dxLocal, dyLocal) {
  const a = fabric.util.degreesToRadians(o.angle || 0);
  const sx = o.scaleX || 1, sy = o.scaleY || 1;
  const dx = dxLocal * sx, dy = dyLocal * sy;
  o.set({ left: o.left + dx * Math.cos(a) - dy * Math.sin(a),
          top:  o.top  + dx * Math.sin(a) + dy * Math.cos(a) });
}
// Обробник для одного боку: 'l' | 'r' | 't' | 'b'
function feCropHandler(side) {
  return function (eventData, transform, x, y) {
    const o = transform.target;
    if (!feImgIsPlain(o)) return false;
    const src = feImgSrc(o);
    const inv = fabric.util.invertTransform(o.calcTransformMatrix());
    const pt = fabric.util.transformPoint(new fabric.Point(x, y), inv);
    const MIN = 24;   // менше не даємо — інакше фото зникає зовсім

    if (side === 'r' || side === 'l') {
      const half = o.width / 2;
      let nw;
      if (side === 'r') {
        nw = Math.max(MIN, Math.min(src.w - (o.cropX || 0), half + pt.x));
        feImgShift(o, (nw - o.width) / 2, 0);
        o.set('width', nw);
      } else {
        nw = Math.max(MIN, Math.min((o.cropX || 0) + o.width, half - pt.x));
        const cut = o.width - nw;
        o.set({ cropX: Math.max(0, (o.cropX || 0) + cut), width: nw });
        feImgShift(o, cut / 2, 0);   // правий край лишається на місці
      }
    } else {
      const half = o.height / 2;
      let nh;
      if (side === 'b') {
        nh = Math.max(MIN, Math.min(src.h - (o.cropY || 0), half + pt.y));
        feImgShift(o, 0, (nh - o.height) / 2);
        o.set('height', nh);
      } else {
        nh = Math.max(MIN, Math.min((o.cropY || 0) + o.height, half - pt.y));
        const cut = o.height - nh;
        o.set({ cropY: Math.max(0, (o.cropY || 0) + cut), height: nh });
        feImgShift(o, 0, cut / 2);   // нижній край лишається на місці
      }
    }
    o.setCoords();
    feImgApply(o);          // скруглення й контур мають підхопити новий розмір
    return true;
  };
}
// Ставимо бічні маркери-обрізку на конкретне фото
// Кружечки посередині сторін нічого не пояснювали — людина не здогадувалась,
// що за них ріжуть. Малюємо ножиці: дію видно без підказки.
const FE_CROP_SVG =
  '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">' +
  '<path d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z" fill="#1B2433" stroke="#EDD05C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
  '<path d="M8.41998 10.8996C9.48037 10.8996 10.34 10.04 10.34 8.97957C10.34 7.91918 9.48037 7.05957 8.41998 7.05957C7.3596 7.05957 6.5 7.91918 6.5 8.97957C6.5 10.04 7.3596 10.8996 8.41998 10.8996Z" stroke="#EDD05C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
  '<path d="M8.41998 16.9396C9.48037 16.9396 10.34 16.08 10.34 15.0196C10.34 13.9592 9.48037 13.0996 8.41998 13.0996C7.3596 13.0996 6.5 13.9592 6.5 15.0196C6.5 16.08 7.3596 16.9396 8.41998 16.9396Z" stroke="#EDD05C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
  '<path d="M17.4999 8.69922L10.1599 14.1892" stroke="#EDD05C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
  '<path d="M17.4999 15.28L10.1599 9.79004" stroke="#EDD05C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
  '</svg>';
let feCropIcon = null;
function feCropIconImg() {
  if (feCropIcon) return feCropIcon;
  feCropIcon = new Image();
  feCropIcon.onload = () => { if (FE.canvas) FE.canvas.requestRenderAll(); };
  feCropIcon.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(FE_CROP_SVG);
  return feCropIcon;
}
// Іконку не повертаємо разом із рамкою: перевернуті ножиці читаються гірше
// за рівні, а вісь обрізки й так підказує курсор.
function feCropIconRender(ctx, left, top) {
  const img = feCropIconImg();
  const S = 22;
  ctx.save();
  ctx.translate(left, top);
  if (img.complete && img.naturalWidth) {
    ctx.drawImage(img, -S / 2, -S / 2, S, S);
  } else {
    ctx.fillStyle = '#EDD05C';
    ctx.beginPath(); ctx.arc(0, 0, 5, 0, Math.PI * 2); ctx.fill();
  }
  ctx.restore();
}
function feImgCropControls(o) {
  if (!feImgIsPlain(o) || o._feCropCtl) return;
  o._feCropCtl = true;
  o.controls = Object.assign({}, fabric.Image.prototype.controls);
  const sides = { ml:['l', -0.5, 0, 'ew-resize'], mr:['r', 0.5, 0, 'ew-resize'],
                  mt:['t', 0, -0.5, 'ns-resize'], mb:['b', 0, 0.5, 'ns-resize'] };
  Object.keys(sides).forEach(k => {
    const cfg = sides[k];
    o.controls[k] = new fabric.Control({
      x: cfg[1], y: cfg[2],
      cursorStyle: cfg[3],
      actionName: 'crop',
      actionHandler: feCropHandler(cfg[0]),
      render: feCropIconRender,
      sizeX: 30, sizeY: 30,          // область натискання більша за саму іконку
    });
  });
}
// Скруглення кутів і контур для звичайного фото
function feImgApply(o) {
  if (!feImgIsPlain(o)) return;
  const r = Math.max(0, +(o._feRx || 0));
  const w = o.width, h = o.height;
  if (r > 0) {
    o.set('clipPath', new fabric.Rect({
      width:w, height:h, rx:Math.min(r, w/2, h/2), ry:Math.min(r, w/2, h/2),
      originX:'center', originY:'center' }));
  } else o.set('clipPath', null);

  o._feForm = new fabric.Rect({ width:w, height:h,
    rx:Math.min(r, w/2, h/2), ry:Math.min(r, w/2, h/2),
    originX:'center', originY:'center', fill:'#000', stroke:null, strokeWidth:0 });
  feFrameOutline(o, Math.abs(o.scaleX) || 1);
  o.dirty = true;
  feC().requestRenderAll();
}
function feImgRx(v) { const o = feAct(); if (!o) return; o._feRx = +v; feImgApply(o); feAfter(); }
function feImgBW(v) { const o = feAct(); if (!o) return; o._feBW = +v; feImgApply(o); feAfter(); }
function feImgBC(v) { const o = feAct(); if (!o) return; o._feBC = v;  feImgApply(o); feAfter(); }

// ---- Контур малюємо всередині самої рамки, після зображення ----
function feFrameOutline(o, sc) {
  if (!o._feOutlinePatched) {
    o._feOutlinePatched = true;
    const orig = o._render;
    o._render = function (ctx) {
      orig.call(this, ctx);
      const bw = +(this._feBW || 0);
      if (!bw || !this._feForm) return;
      const s = Math.abs(this.scaleX) || 1;
      const line = this._feForm;
      line.set({ fill:'', stroke:this._feBC || '#FFFFFF',
                 strokeWidth: bw / s, strokeUniform:false });
      ctx.save();
      line.render(ctx);
      ctx.restore();
      line.set({ fill:'#000', stroke:null, strokeWidth:0 });
    };
  }
}
function feFrameRx(v) { const o = feAct(); if (!o) return; o._feRx = +v; feFrameApply(o); }
function feFrameBW(v) { const o = feAct(); if (!o) return; o._feBW = +v; feFrameApply(o); }
function feFrameBC(v) { const o = feAct(); if (!o) return; o._feBC = v;  feFrameApply(o); }
// Рамку перетягнули цілком — запамʼятовуємо нове положення вікна
function feFrameSyncAnchor(o) {
  if (!o || o._feKind !== 'photoframe' || o.type !== 'image') return;
  o._feAncX = o.left; o._feAncY = o.top;
}
// ---- Режим «рухати фото всередині рамки» ----
// Замість того щоб тягати саму форму, тягаємо знімок під нею.
function feFramePan(force) {
  const o = feAct();
  if (!o || o._feKind !== 'photoframe') { feToast('Оберіть фоторамку'); return; }
  const on = force != null ? force : !FE._panFrame;
  if (on) {
    FE._panFrame = o;
    o.set({ lockMovementX:true, lockMovementY:true, hasControls:false, hasBorders:false });
    feFrameGuide(o, true);
    document.body.classList.add('fe-panning');
    feToast('✋ Тягніть — фото рухається. Двома пальцями — масштаб', 2800);
  } else {
    if (FE._panFrame) FE._panFrame.set({ lockMovementX:false, lockMovementY:false,
                                         hasControls:true, hasBorders:true });
    feFrameGuide(null, false);
    FE._panFrame = null;
    document.body.classList.remove('fe-panning');
    feSnapshot();
  }
  feC().requestRenderAll();
  feRefreshPanel(); feRenderCtx();
}
function feFramePanOff() { if (FE._panFrame) feFramePan(false); }
// Пунктирна межа вікна рамки — щоб було видно, що саме потрапить у кадр
function feFrameGuide(o, show) {
  const c = feC();
  (c.getObjects() || []).filter(x => x._feGuide).forEach(x => c.remove(x));
  if (!show || !o) { c.requestRenderAll(); return; }
  const g = feFrameShapeObj(o._feShape || 'rect', o._feFW, o._feFH, o._feRx || 0);
  g.set({ left:o._feAncX, top:o._feAncY, originX:'center', originY:'center',
    fill:'', stroke:'#EDD05C', strokeWidth:2, strokeDashArray:[7, 5],
    strokeUniform:true, selectable:false, evented:false,
    excludeFromExport:true, _feGuide:true, _feSafe:true });
  c.add(g); c.bringToFront(g); c.requestRenderAll();
}

function feFrameZoom(v)  { const o = feAct(); if (!o) return; o._feZoom = +v / 100; feFrameApply(o); }
function feFrameOffX(v)  { const o = feAct(); if (!o) return; o._feOffX = +v; feFrameApply(o); }
function feFrameOffY(v)  { const o = feAct(); if (!o) return; o._feOffY = +v; feFrameApply(o); }
function feFrameRot(v)   { const o = feAct(); if (!o) return; o._feRot = +v; feFrameApply(o); }
function feFrameCenter() { const o = feAct(); if (!o) return;
  o._feZoom = 1; o._feOffX = 0; o._feOffY = 0; o._feRot = 0;
  feFrameApply(o); feSnapshot(); feRefreshPanel(); }
// --- Зміна форми рамки ---
function feSetFrameShape(id) {
  const c = feC(), o = c.getActiveObject(); if (!o) return;
  if (o.type === 'image') {
    o._feShape = id; feFrameApply(o);
    c.requestRenderAll(); feSnapshot(); feRefreshPanel();
    return;
  }
  // Порожня заготовка: перебудовуємо її під нову форму, зберігаючи площу
  // й положення. Пропорції беремо з нової форми — інакше панорама лишалась
  // квадратом, а коло стискалось.
  const L = o.left, T = o.top, A = o.angle, OP = o.opacity;
  const area = Math.max(1, (o._feFW || 100) * (o._feFH || 100));
  const ar = feFrameAspect(id);
  const FH = Math.round(Math.sqrt(area / ar));
  const FW = Math.round(FH * ar);

  const g = feBuildFramePlaceholder(id, FW, FH, o._feRx || 0);
  g.set({ left:L, top:T, angle:A, opacity:OP });
  c.remove(o); c.add(g); c.setActiveObject(g);
  feSafeToFront(); c.requestRenderAll(); feSnapshot(); feRefreshPanel(); feRenderCtx();
}

// --- Стікери ---
const FE_STICKERS = [
  { n:'Серце',    svg:'<path d="M32 56C10 40 4 28 4 20 4 10 12 4 20 4c5 0 9 2 12 6 3-4 7-6 12-6 8 0 16 6 16 16 0 8-6 20-28 36z" fill="#E53935"/>' },
  { n:'Контур',   svg:'<path d="M32 56C10 40 4 28 4 20 4 10 12 4 20 4c5 0 9 2 12 6 3-4 7-6 12-6 8 0 16 6 16 16 0 8-6 20-28 36z" fill="none" stroke="#E53935" stroke-width="3"/>' },
  { n:'Зірка',    svg:'<path d="M32 4l8 18 20 2-15 14 4 20-17-10-17 10 4-20L4 24l20-2z" fill="#F4C430"/>' },
  { n:'Іскри',    svg:'<path d="M32 6l5 16 16 5-16 5-5 16-5-16-16-5 16-5z" fill="#7C3AED"/>' },
  { n:'Кільце',   svg:'<ellipse cx="32" cy="32" rx="26" ry="18" fill="none" stroke="#1B2433" stroke-width="2"/>' },
  { n:'Прапорці', svg:'<path d="M4 14h56" stroke="#1B2433" stroke-width="2" fill="none"/><path d="M12 14l6 12 6-12zM28 14l6 12 6-12zM44 14l6 12 6-12z" fill="#E53935"/>' },
  { n:'Кулька',   svg:'<ellipse cx="32" cy="24" rx="14" ry="18" fill="#F472B6"/><path d="M32 42v16" stroke="#1B2433" stroke-width="2"/>' },
  { n:'Хвиля',    svg:'<path d="M4 40c8-12 16 12 24 0s16 12 24 0" fill="none" stroke="#00B4D8" stroke-width="3"/>' },
  { n:'Сонце',    svg:'<circle cx="32" cy="32" r="12" fill="#FCD34D"/><g stroke="#FCD34D" stroke-width="3"><path d="M32 4v8M32 52v8M4 32h8M52 32h8M12 12l6 6M46 46l6 6M52 12l-6 6M18 46l-6 6"/></g>' },
  { n:'Подарунок',svg:'<rect x="8" y="24" width="48" height="32" fill="#7C3AED"/><rect x="28" y="24" width="8" height="32" fill="#FCD34D"/><rect x="4" y="18" width="56" height="10" fill="#8B5CF6"/>' },
  { n:'Крапки',   svg:'<g fill="#E53935"><circle cx="16" cy="32" r="5"/><circle cx="32" cy="32" r="5"/><circle cx="48" cy="32" r="5"/></g>' },
  { n:'Стрічка',  svg:'<path d="M8 20h48l-8 12 8 12H8l8-12z" fill="#22C55E"/>' },
];
// Емодзі-стікери по категоріях
const FE_EMOJI = {
  'Зірки':      '⭐🌟✨💫🌠🔯✴️❇️',
  'Стрічки та бейджі': '🏅🎖️🥇🥈🥉🎗️🔰🏆',
  'Природа':    '🌞⛅🌈🍃🌸🌺🌻🌷🌹💐🌵🌴🌲🌳🍀🍁🌙☀️❄️⛄💧🌊',
  'Смайли':     '😀😃😄😁😆😅😂🤣😊😇🙂😉😍🥰😘😗😋😜🤪😎🤩🥳😏😌🤗🤭🥺😴🤤😪',
  'Емоції':     '❤️🧡💛💚💙💜🖤🤍💖💕💗💓💞💝💘💔❣️💯💥💫💦🔥',
  'Жести':      '👍👎👌✌️🤞🤟🤘👏🙌👐🤲🙏💪👈👉👆👇☝️✊👊🤛🤜🤝✍️',
  'Святкове':   '🎉🎊🎈🎁🎂🍰🎀🎄🎃🎆🎇🎅🤶🥂🍾🍻🎵🎶🎪🎠🕯️🎗️🏆🥳',
  'Тварини':    '🐶🐱🐭🐹🐰🦊🐻🐼🐨🐯🦁🐮🐷🐸🐵🐔🐧🐦🦄🐝🦋🐢🐬🐳🦉🐤🐴🐑',
  'Їжа':        '🍏🍎🍌🍓🍒🍑🍉🍇🍕🍔🍟🌭🍿🍩🍪🍫🍬🍭🍦🍨🧁☕🍺🥤🍳🥗',
  'Подорожі':   '✈️🚗🚕🚙🚌🚓🚑🚒🚲🛵🚂🚀🛸⛵🚢🏠🏡🏰🗼🗽⛰️🏖️🌴🌍🚦🗺️',
  'Спорт':      '⚽🏀🏈⚾🎾🏐🏉🎱🏓🏸🥅🏒🏑🥊🏋️⛳🎣🚴🏄🏊⛷️🎯🎮🎳',
  'Символи':    '⭐🌟✨🌀⚡☄️🔔🎵✅❌❗❓⚠️➕➖✖️➗⬆️⬇️⬅️➡️🔄🔝💎👑🏷️',
};
// Векторні каракулі
const FE_DOODLES = [
  { n:'Хвиля',   svg:'<path d="M4 34c8-14 16 14 24 0s16 14 24 0" fill="none" stroke="#7C3AED" stroke-width="4" stroke-linecap="round"/>' },
  { n:'Дуга',    svg:'<path d="M6 40c14-18 38-18 52 0" fill="none" stroke="#EF4444" stroke-width="4" stroke-linecap="round"/>' },
  { n:'Спіраль', svg:'<path d="M40 32a8 8 0 1 1-9-8 18 18 0 1 1 20 20" fill="none" stroke="#00B4D8" stroke-width="4" stroke-linecap="round"/>' },
  { n:'Промені', svg:'<g stroke="#FB923C" stroke-width="4" stroke-linecap="round"><path d="M32 6v10M32 48v10M6 32h10M48 32h10M14 14l7 7M43 43l7 7M50 14l-7 7M21 43l-7 7"/></g>' },
  { n:'Кільце',  svg:'<path d="M46 20a18 18 0 1 0-4 26" fill="none" stroke="#EC4899" stroke-width="4" stroke-linecap="round"/>' },
  { n:'Пульс',   svg:'<path d="M4 32h12l6-16 8 32 7-20 5 8h18" fill="none" stroke="#22C55E" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>' },
  { n:'Підкрес', svg:'<path d="M6 38c14 8 38 8 52-4" fill="none" stroke="#FCD34D" stroke-width="4" stroke-linecap="round"/>' },
  { n:'Зигзаг',  svg:'<path d="M4 40l14-16 12 12 14-20 16 16" fill="none" stroke="#3B82F6" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>' },
];
// ---- РОЗМИТІ (АУРА) ФІГУРИ ----
const FE_SOFT_SHAPES = {
  circle: (ctx, S) => { ctx.beginPath(); ctx.arc(S/2, S/2, S*0.34, 0, Math.PI*2); ctx.fill(); },
  heart:  (ctx, S) => {
    // ширше й округліше — класична форма
    const k = S / 100;
    ctx.save(); ctx.translate(S*0.5, S*0.52); ctx.scale(k*0.82, k*0.82);
    ctx.beginPath();
    ctx.moveTo(0, 34);
    ctx.bezierCurveTo(-64, -6, -48, -46, -22, -46);
    ctx.bezierCurveTo(-8, -46, 0, -34, 0, -26);
    ctx.bezierCurveTo(0, -34, 8, -46, 22, -46);
    ctx.bezierCurveTo(48, -46, 64, -6, 0, 34);
    ctx.closePath(); ctx.fill(); ctx.restore();
  },
};
// Малює мʼяку розмиту пляму заданої форми й кольору
// Чи вміє canvas розмивати сам (Safari на iOS до 17 — ні)
let _feCtxFilterOk = null;
function feCanvasBlurSupported() {
  if (_feCtxFilterOk !== null) return _feCtxFilterOk;
  try {
    // перевіряємо не властивість, а реальний результат: малюємо квадрат
    // із розмиттям і дивимось, чи «протекла» фарба за його межі
    const cv = document.createElement('canvas');
    cv.width = 40; cv.height = 40;
    const x = cv.getContext('2d', { willReadFrequently: true });
    x.filter = 'blur(6px)';
    x.fillStyle = '#000';
    x.fillRect(14, 14, 12, 12);
    const a = x.getImageData(8, 20, 1, 1).data[3];   // точка поза квадратом
    _feCtxFilterOk = a > 4;
  } catch (e) { _feCtxFilterOk = false; }
  return _feCtxFilterOk;
}
// Роздільне (по осях) box-розмиття альфа-каналу, три проходи ≈ гаусове
function feBoxBlurA(src, S, r) {
  let a = src, b = new Float32Array(S * S);
  for (let pass = 0; pass < 3; pass++) {
    // по горизонталі
    for (let y = 0; y < S; y++) {
      const row = y * S;
      let sum = 0;
      for (let x = -r; x <= r; x++) sum += a[row + Math.min(S - 1, Math.max(0, x))];
      const norm = 1 / (2 * r + 1);
      for (let x = 0; x < S; x++) {
        b[row + x] = sum * norm;
        sum += a[row + Math.min(S - 1, x + r + 1)] - a[row + Math.max(0, x - r)];
      }
    }
    // по вертикалі
    for (let x = 0; x < S; x++) {
      let sum = 0;
      for (let y = -r; y <= r; y++) sum += b[Math.min(S - 1, Math.max(0, y)) * S + x];
      const norm = 1 / (2 * r + 1);
      for (let y = 0; y < S; y++) {
        a[y * S + x] = sum * norm;
        sum += b[Math.min(S - 1, y + r + 1) * S + x] - b[Math.max(0, y - r) * S + x];
      }
    }
  }
  return a;
}
function feSoftDataUrl(shape, color, blur) {
  const S = 420;
  const px = Math.round(S * (blur / 100) * 0.22);
  const cv = document.createElement('canvas');
  cv.width = S; cv.height = S;
  const ctx = cv.getContext('2d', { willReadFrequently: true });

  // Якщо браузер справді вміє розмивати — беремо рідний спосіб, він найякісніший
  if (px > 0 && feCanvasBlurSupported()) {
    ctx.filter = `blur(${px}px)`;
    ctx.fillStyle = color;
    (FE_SOFT_SHAPES[shape] || FE_SOFT_SHAPES.circle)(ctx, S);
    return cv.toDataURL('image/png');
  }
  // Інакше — чисті canvas-операції (Safari на iOS)
  if (px <= 0) {
    ctx.fillStyle = color;
    (FE_SOFT_SHAPES[shape] || FE_SOFT_SHAPES.circle)(ctx, S);
    return cv.toDataURL('image/png');
  }
  // Фігура одноколірна, тож достатньо розмити сам альфа-канал, а колір лишити
  // сталим. Три проходи box blur дають практично той самий результат,
  // що й гаусове розмиття браузера — і працюють однаково скрізь.
  ctx.fillStyle = color;
  (FE_SOFT_SHAPES[shape] || FE_SOFT_SHAPES.circle)(ctx, S);

  const img = ctx.getImageData(0, 0, S, S);
  const d = img.data;
  let a = new Float32Array(S * S);
  for (let i = 0, p = 3; i < a.length; i++, p += 4) a[i] = d[p];
  a = feBoxBlurA(a, S, Math.max(1, Math.round(px)));

  // колір беремо з першого непрозорого пікселя, щоб не парсити hex вручну
  let cr = 0, cg = 0, cb = 0;
  for (let p = 0; p < d.length; p += 4) {
    if (d[p + 3] > 200) { cr = d[p]; cg = d[p + 1]; cb = d[p + 2]; break; }
  }
  for (let i = 0, p = 0; i < a.length; i++, p += 4) {
    d[p] = cr; d[p + 1] = cg; d[p + 2] = cb;
    d[p + 3] = a[i] < 0 ? 0 : (a[i] > 255 ? 255 : a[i]);
  }
  ctx.putImageData(img, 0, 0);
  return cv.toDataURL('image/png');
}
function feAddSoft(shape) {
  const color = document.getElementById('fe-soft-color')?.value || '#FF3D8B';
  const blur = 28;
  fabric.Image.fromURL(feSoftDataUrl(shape, color, blur), img => {
    const c = feC(), S = FE.baseW * 0.5;
    img.set({ left:FE.baseW/2, top:FE.baseH/2, originX:'center', originY:'center',
      scaleX:S/img.width, scaleY:S/img.width,
      _feKind:'soft', _feSoft:{ shape, color, blur }, _feName:'Аура · ' + (shape === 'heart' ? 'серце' : 'коло') });
    c.add(img); c.setActiveObject(img); feSafeToFront(); c.requestRenderAll(); feSnapshot();
    feAfterAdd();
  });
}
function feSoftBlur(v) { feSoftUpdate('blur', v); }
function feSoftUpdate(key, val) {
  const o = feAct(); if (!o || !o._feSoft) return;
  o._feSoft[key] = key === 'blur' ? +val : val;
  const s = o._feSoft;
  o.setSrc(feSoftDataUrl(s.shape, s.color, s.blur), () => {
    feC().requestRenderAll();
    if (!FE._sliding) feSnapshot();
  });
}

// ---- Власна бібліотека стікерів (свої PNG) ----
// Заливаєш картинки у Shopify Files і додаєш сюди посилання по категоріях.
// Свої стікери лежать в окремому файлі assets/frame-stickers.js — щоб
// поповнювати бібліотеку, не чіпаючи код редактора.
function feStickerLib() { return window.FE_STICKER_LIB || {}; }
// Векторні — окремим списком: вони лягають на фон як набір кривих, а не
// як картинка, тому не мутніють ні при збільшенні, ні у друці.
// Список може бути один: чи це вектор, чи картинка — видно з розширення.
// Другий список (FE_STICKER_SVG) лишається робочим для сумісності — якщо в
// ньому щось є, воно просто додається до відповідної категорії.
function feIsSvgUrl(u) { return /\.svg(\?|$)/i.test(String(u || '')); }
// Усі категорії з обох списків, у порядку появи, разом із вмістом
function feStickerAll() {
  const a = feStickerLib(), b = window.FE_STICKER_SVG || {};
  const out = {};
  [a, b].forEach(src => Object.keys(src).forEach(c => {
    if (!Array.isArray(src[c]) || !src[c].length) return;
    out[c] = (out[c] || []).concat(src[c]);
  }));
  return out;
}
async function feAddSvgSticker(url) {
  const c = feC(); if (!c) return;
  fabric.loadSVGFromURL(url, (objs, opts) => {
    if (!objs || !objs.length) { feToast('Не вдалося прочитати SVG'); return; }
    // порожні поля навколо малюнка прибираємо тим самим способом, що й для
    // векторних файлів, які людина вантажить сама
    const g = feTrimVector(fabric.util.groupSVGElements(objs, opts));
    const S = FE.baseW * 0.22;
    const sc = S / Math.max(g.width || 100, g.height || 100);
    g.set({ left:FE.baseW/2, top:FE.baseH/2, originX:'center', originY:'center',
      scaleX:sc, scaleY:sc, _feKind:'sticker', _feName:'Стікер' });
    c.add(g); c.setActiveObject(g); feSafeToFront(); c.requestRenderAll(); feSnapshot();
    feAfterAdd();
  });
}
// Категорії без жодного стікера не показуємо: порожня вкладка лише збиває.
function feStickerCats() {
  const lib = feStickerLib();
  return Object.keys(lib).filter(c => Array.isArray(lib[c]) && lib[c].length);
}
// Превʼю робимо так само, як предметам: обрізаємо прозорі поля, інакше
// малюнок губиться десь у кутку плитки.
const FE_STICKER_THUMBS = {};
function feStickerId(u) {
  let n = 0;
  for (let i = 0; i < u.length; i++) n = (n * 31 + u.charCodeAt(i)) | 0;
  return 'fe-sth-' + Math.abs(n).toString(36);
}
function feFillStickerThumbs() {
  const all = feStickerAll();
  // вектор обрізати не треба — він і так малюється як є
  Object.keys(all).forEach(cat =>
    all[cat].forEach(u => { if (!feIsSvgUrl(u)) feFillStickerThumb(u); }));
}
async function feFillStickerThumb(u) {
  if (!u || FE_STICKER_THUMBS[u]) return;
  const id = feStickerId(u);
  if (!document.getElementById(id)) return;
  try {
    const r = await feTrimUrl(u, FE_THUMB_PX);
    FE_STICKER_THUMBS[u] = r.url;
    const box = document.getElementById(id);
    if (box) box.innerHTML = '<img src="' + r.url + '" alt="">';
  } catch (e) {}
}
async function feAddImgSticker(url) {
  // рамка виділення має йти по самому малюнку, а не по невидимих полях
  const t = await feTrimUrl(url);
  fabric.Image.fromURL(t.url, img => {
    const c = feC(), S = FE.baseW * 0.22;
    img.set({ left:FE.baseW/2, top:FE.baseH/2, originX:'center', originY:'center',
      scaleX:S/img.width, scaleY:S/img.width, _feKind:'sticker', _feName:'Стікер' });
    c.add(img); c.setActiveObject(img); feSafeToFront(); c.requestRenderAll(); feSnapshot();
    feAfterAdd();
  }, { crossOrigin:'anonymous' });
}

// блок мʼяких плям — використовується в панелі «Фігури»
function feSoftBlock() {
  return `<h4>Мʼякі плями (аура)</h4>
    <div class="fe-two" style="margin-top:0">
      <div class="fe-tile" style="aspect-ratio:1" onclick="feAddSoft('circle')">
        <div style="width:80%;height:80%;border-radius:50%;
          background:radial-gradient(circle,#FF3D8B 0%,rgba(255,61,139,.35) 45%,transparent 70%)"></div></div>
      <div class="fe-tile" style="aspect-ratio:1;font-size:34px;color:#FF3D8B;
        filter:blur(3px)" onclick="feAddSoft('heart')">❤</div>
    </div>
    <div class="fe-lbl" style="margin-top:8px">Колір нової плями</div>
    <input type="color" id="fe-soft-color" class="fe-field" style="height:40px;padding:3px" value="#FF3D8B">
    <p style="font-size:11px;margin:6px 0 0;line-height:1.5">
      Після додавання повзунок «Розмиття» перетворює пляму на чітку фігуру й навпаки.</p>
    <div class="fe-sep"></div>`;
}
function fePanelStickers() {
  let h = '';
  // Один прохід по всіх категоріях. Вектор і картинка лежать поруч —
  // розрізняємо їх за розширенням, а не окремими розділами.
  const all = feStickerAll();
  Object.keys(all).forEach(cat => {
    h += `<h4>${cat}</h4><div class="fe-grid">`;
    all[cat].forEach(u => {
      if (feIsSvgUrl(u)) {
        h += `<div class="fe-tile" title="векторний" onclick="feAddSvgSticker('${u}')">
          <div class="fe-tile-img fe-item-img"><img src="${u}" alt=""></div></div>`;
        return;
      }
      const id = feStickerId(u);
      const ready = FE_STICKER_THUMBS[u];
      h += `<div class="fe-tile" onclick="feAddImgSticker('${u}')">
        <div class="fe-tile-img fe-item-img" id="${id}">${ready ? '<img src="' + ready + '" alt="">' : ''}</div></div>`;
    });
    h += `</div>`;
  });
  setTimeout(feFillStickerThumbs, 0);

  h += `<h4>Наші стікери</h4><div class="fe-grid">`;
  FE_STICKERS.forEach((s, i) => h += `<div class="fe-tile" title="${s.n}" onclick="feAddSticker(${i})">
    <svg viewBox="0 0 64 64" width="32" height="32">${s.svg}</svg></div>`);
  h += `</div><h4>Каракулі</h4><div class="fe-grid">`;
  FE_DOODLES.forEach((s, i) => h += `<div class="fe-tile" title="${s.n}" onclick="feAddDoodle(${i})">
    <svg viewBox="0 0 64 64" width="32" height="32">${s.svg}</svg></div>`);
  h += `</div>`;
  Object.keys(FE_EMOJI).forEach(cat => {
    h += `<h4>${cat}</h4><div class="fe-grid g6">`;
    Array.from(FE_EMOJI[cat]).forEach(e => {
      if (e === '️' || e === '‍') return;
      h += `<div class="fe-tile fe-tile-emo" onclick="feAddEmoji('${e}')">${e}</div>`;
    });
    h += `</div>`;
  });
  return h;
}
function feAddDoodle(i) {
  const s = FE_DOODLES[i];
  fabric.loadSVGFromString(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="64" height="64">${s.svg}</svg>`,
    (objs, opts) => {
      const g = fabric.util.groupSVGElements(objs, opts), c = feC(), S = FE.baseW * 0.2;
      g.set({ left:FE.baseW/2, top:FE.baseH/2, originX:'center', originY:'center',
        scaleX:S/64, scaleY:S/64, _feKind:'sticker', _feName:s.n });
      c.add(g); c.setActiveObject(g); feSafeToFront(); c.requestRenderAll(); feSnapshot();
      feAfterAdd();
    });
}
function feAddEmoji(ch) {
  const c = feC();
  const t = new fabric.Text(ch, {
    left:FE.baseW/2, top:FE.baseH/2, originX:'center', originY:'center',
    fontSize:Math.round(FE.baseW * 0.14),
    fontFamily:'"Apple Color Emoji","Segoe UI Emoji","Noto Color Emoji",sans-serif',
    _feKind:'sticker', _feName:'Емодзі ' + ch,
  });
  c.add(t); c.setActiveObject(t); feSafeToFront(); c.requestRenderAll(); feSnapshot();
  feAfterAdd();
}
function feAddSticker(i) {
  const s = FE_STICKERS[i];
  fabric.loadSVGFromString(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="64" height="64">${s.svg}</svg>`,
    (objs, opts) => {
      const g = fabric.util.groupSVGElements(objs, opts), c = feC(), S = FE.baseW * 0.14;
      g.set({ left:FE.baseW/2, top:FE.baseH/2, originX:'center', originY:'center',
        scaleX:S/64, scaleY:S/64, _feKind:'sticker', _feName:s.n });
      c.add(g); c.setActiveObject(g); feSafeToFront(); c.requestRenderAll(); feSnapshot();
      feAfterAdd();
    });
}

// --- Шари ---
function fePanelLayers() {
  const c = FE.canvas; if (!c) return '';
  const objs = c.getObjects().filter(o => !o._feSafe).slice().reverse();
  if (!objs.length) return `<p style="font-size:12.5px">Полотно порожнє.</p>`;
  const act = c.getActiveObject();
  const KIND = { figure:'Фігурка', text:'Текст', shape:'Фігура', sticker:'Стікер', image:'Картинка', photoframe:'Фоторамка' };
  let h = `<p style="font-size:11px;margin-bottom:10px">Верхні шари — зверху списку.</p>`;
  objs.forEach(o => {
    const idx = c.getObjects().indexOf(o);
    h += `<div class="fe-layer ${o === act ? 'sel' : ''}" onclick="feSelectLayer(${idx})">
      <div style="min-width:0"><div class="fe-layer-kind">${KIND[o._feKind] || 'Обʼєкт'}</div>
        <div class="fe-layer-name">${(o._feName || o.text || '—').toString().slice(0, 20)}</div></div>
      <div class="fe-layer-acts">
        <button onclick="event.stopPropagation();feLayerMove(${idx},1)">↑</button>
        <button onclick="event.stopPropagation();feLayerMove(${idx},-1)">↓</button>
        <button onclick="event.stopPropagation();feLayerToggle(${idx})">${o.visible === false ? feIco('eyeOff') : feIco('eye')}</button>
        <button class="${o._feLocked ? 'on' : ''}" title="${o._feLocked ? 'Зняти замок' : 'Зафіксувати'}"
          onclick="event.stopPropagation();feLayerLock(${idx})">${o._feLocked ? feIco('locked') : feIco('unlocked')}</button>
        <button onclick="event.stopPropagation();feLayerDelete(${idx})">${feIco('trash')}</button></div></div>`;
  });
  return h;
}
function feSelectLayer(i){ const o=feC().item(i); if(!o)return; feC().setActiveObject(o);feC().requestRenderAll();feRefreshPanel();feRenderCtx(); }
function feLayerLock(i){ const o=feC().item(i); if(o) feToggleLock(o); }
function feLayerMove(i,d){ const o=feC().item(i); if(!o)return; d>0?o.bringForward():o.sendBackwards(); feSafeToFront(); feC().requestRenderAll(); feSnapshot(); feRefreshPanel(); }
function feLayerToggle(i){ const o=feC().item(i); if(!o)return; o.visible=o.visible===false; feC().requestRenderAll(); feSnapshot(); feRefreshPanel(); }
function feLayerDelete(i){ const o=feC().item(i); if(!o)return; feC().remove(o); feC().requestRenderAll(); feSnapshot(); feRefreshPanel(); }

// ============================================================
// ПАНЕЛЬ НАЛАШТУВАНЬ ОБʼЄКТА
// ============================================================
function fePanelProps() {
  const c = FE.canvas; if (!c) return '';
  const o = c.getActiveObject();
  if (!o) return `<p style="font-size:12.5px;line-height:1.6">Оберіть елемент на полотні — тут зʼявляться його налаштування.</p>`;

  // ---- АКСЕСУАР І ПРЕДМЕТ: тільки дублювати та видалити ----
  if (o._feKind === 'accessory' || o._feKind === 'item') {
    return `<p style="font-size:12.5px;line-height:1.6;margin-bottom:12px">
        ${o._feName || (o._feKind === 'item' ? 'Предмет' : 'Аксесуар')} — розмір фіксований,
        щоб було видно, скільки місця він займе насправді. Перетягуйте його по полю.</p>
      <button class="fe-btn-full" onclick="feDuplicate()">${feIco('toFront')} Дублювати (+${FE_PRICE.accessory} ₴)</button>
      <button class="fe-btn-full danger" onclick="feDeleteActive()">${feIco('trash')} Видалити</button>`;
  }

  // Поле тексту — найперше в панелі: саме по нього приходять, натиснувши олівець
  const isTxt = o._feKind === 'text' || o.type === 'textbox' || o.type === 'i-text';
  let h = '';
  if (isTxt) {
    const T0 = feTextState(o);
    h += `<h4 style="margin-top:0">✎ Текст напису</h4>
      <textarea class="fe-field" id="fe-p-text" rows="2" placeholder="Введіть текст…"
        onfocus="FE._typing=true;fePanelKb(true,this)" onblur="feTextFieldBlur()"
        oninput="feForgetTextSel();feSelNote();feObjSet('text',this.value);feUpdateFontSample(this.value)"
        onselect="feFieldSel(this)" onkeyup="feFieldSel(this)"
        onmouseup="feFieldSel(this)" ontouchend="setTimeout(()=>feFieldSel(this),0)"
        >${(T0.text || '').replace(/</g,'&lt;')}</textarea>
      <div id="fe-sel-note">${feSelNoteHtml(o)}</div>
      <div class="fe-sep"></div>`;
  }

  h += `<h4>Шар / вирівнювання</h4>
    <div class="fe-icons">
      <button class="fe-ibtn" title="Ліворуч"   onclick="feAlign('l')">${feIco('arrowLeft')}</button>
      <button class="fe-ibtn" title="По центру" onclick="feAlign('cx')">${feIco('flipX')}</button>
      <button class="fe-ibtn" title="Праворуч"  onclick="feAlign('r')">${feIco('arrowRight')}</button>
      <button class="fe-ibtn" title="Догори"    onclick="feAlign('t')">${feIco('arrowUp')}</button>
      <button class="fe-ibtn" title="По центру" onclick="feAlign('cy')">${feIco('flipY')}</button>
      <button class="fe-ibtn" title="Донизу"    onclick="feAlign('b')">${feIco('arrowDown')}</button>
    </div>
    <div class="fe-two">
      <button class="fe-btn-full soft" style="margin:0" onclick="feObjLayer(1)">${feIco('toFront')} Наперед</button>
      <button class="fe-btn-full soft" style="margin:0" onclick="feObjLayer(-1)">${feIco('toBack')} Назад</button>
    </div>
    <div class="fe-row" style="margin-top:12px">
      <div class="fe-row-head"><span>Поворот</span></div>
      <div style="display:flex;gap:7px;align-items:center">
        <input class="fe-field" style="margin:0;width:80px" type="number" id="fe-p-ang"
          value="${Math.round(o.angle || 0)}" oninput="feObjSet('angle',+this.value)">
        <span style="font-size:12px;color:var(--fe-dim)">°</span>
        <button class="fe-ibtn" title="Відзеркалити (зліва направо)" onclick="feFlip('x')">${feIco('mirrorX')}</button>
        <button class="fe-ibtn" title="Перевернути (згори вниз)"  onclick="feFlip('y')">${feIco('mirrorY')}</button>
      </div>
    </div>
    ${feSlider('Прозорість','fe-p-op',0,100,1,Math.round((o.opacity ?? 1)*100),'feOpacity','%')}`;

  // ---- ТЕКСТ ----
  if (o._feKind === 'text' || o.type === 'textbox' || o.type === 'i-text') {
    h += `<div class="fe-sep"></div><div id="fe-txt-box">${feTextSectionHtml(o)}</div>`;
  }

  // ---- ЛІНІЇ ТА СТРІЛКИ ----
  // На телефоні тягнути їх за маркери майже неможливо, тому даємо точні поля.
  if (o._feKind === 'shape' && feIsLineLike(o)) {
    const len = Math.round((o.width || 1) * Math.abs(o.scaleX || 1));
    h += `<div class="fe-sep"></div><h4>Лінія</h4>
      ${feSlider('Довжина','fe-p-len',10,Math.round(FE.baseW*1.2),1,len,'feLineLen','px')}
      ${feSlider('Товщина','fe-p-th',1,40,0.5,Math.round(feLineVisThick(o) * 2) / 2,'feLineThick','px')}
      <div class="fe-two" style="margin-top:8px">
        <button class="fe-btn-full soft" style="margin:0" onclick="feLineAngle(0)">— Горизонтально</button>
        <button class="fe-btn-full soft" style="margin:0" onclick="feLineAngle(90)">| Вертикально</button>
      </div>`;
  }

  // ---- ФІГУРА / СТІКЕР ----
  if (o._feKind === 'shape' || o._feKind === 'sticker') {
    h += `<div class="fe-sep"></div>
      <div class="fe-two">
        <div><div class="fe-lbl">Колір</div>
          <input type="color" class="fe-field" style="height:40px;padding:3px;margin:0"
            value="${feHex(o.fill) || '#E53935'}" oninput="feFillDeep(this.value)"></div>
        <div><div class="fe-lbl">Контур</div>
          <input type="color" class="fe-field" style="height:40px;padding:3px;margin:0"
            value="${feHex(o.stroke) || '#1B2433'}" oninput="feStrokeDeep(this.value)"></div>
      </div>
      <button class="fe-btn-full soft" style="margin-top:6px" onclick="feFillNone()">
        ${(!o.fill || o.fill === 'transparent') ? '✓ Без заливки — лише контур' : '◻ Прибрати заливку (лише контур)'}</button>
      ${feSlider('Товщина контуру','fe-p-sw2',0,20,1,(o.strokeWidth||0),'feStrokeWidthDeep','')}`;
    if (o.type === 'rect') h += feSlider('Закруглення кутів','fe-p-rx',0,Math.round(Math.min(o.width,o.height)/2),1,(o.rx||0),'feRx','');
  }

  // ---- МʼЯКА ПЛЯМА ----
  if (o._feSoft) {
    h += `<div class="fe-sep"></div><h4>Мʼяка пляма</h4>
      <div class="fe-lbl">Колір</div>
      <div style="display:flex;gap:6px">
        <input type="color" class="fe-field" style="height:40px;padding:3px;margin:0;flex:1"
          value="${o._feSoft.color}" oninput="feSoftUpdate('color',this.value)">
        <button class="fe-ibtn" title="Піпетка" onclick="fePick(v=>feSoftUpdate('color',v))">${feIco('picker')}</button>
      </div>
      ${feSlider('Розмиття','fe-soft-b',0,60,1,o._feSoft.blur,'feSoftBlur','')}
      <div class="fe-two">
        <button class="fe-btn-full soft" style="margin:0" onclick="feSoftUpdate('shape','circle')">● Коло</button>
        <button class="fe-btn-full soft" style="margin:0" onclick="feSoftUpdate('shape','heart')">❤ Серце</button>
      </div>`;
  }

  // ---- ФОТОРАМКА ----
  if (o._feKind === 'photoframe') {
    h += `<div class="fe-sep"></div>`;
    // Головна дія — одразу вгорі, щоб було очевидно, що сюди вставляють фото
    h += `<button class="fe-btn-full" onclick="feFramePickPhoto()">
      ${feIco('files')} ${o.type === 'image' ? 'Замінити фото' : 'Додати фото'}</button>`;
    if (o.type !== 'image') {
      h += `<div style="margin:6px 0 2px;font-size:11.5px;color:var(--fe-dim);line-height:1.5">
        Це порожня рамка — натисніть, щоб вставити знімок.</div>`;
    }

    // форму міняємо тільки поки рамка порожня — інакше вже вставлене фото
    // довелось би перекроювати під іншу геометрію
    if (o.type === 'image') {
      h += `<div style="margin-top:10px;font-size:11.5px;color:var(--fe-dim);line-height:1.5">
        Форма рамки задана. Щоб змінити її — видаліть рамку й додайте потрібну форму заново.</div>`;
    } else {
      h += `<h4>Форма рамки</h4>`;
      Object.keys(FE_FRAME_GROUPS).forEach(g => {
        h += `<div class="fe-subh">${g}</div><div class="fe-grid">`;
        FE_FRAME_GROUPS[g].forEach(id => h += `<div class="fe-tile ${o._feShape === id ? 'sel' : ''}"
          onclick="feSetFrameShape('${id}')">
          <svg viewBox="0 0 100 100" width="28" height="28">${feFramePreviewSvg(id)}</svg></div>`);
        h += `</div>`;
      });
    }

    // заокруглення живе поруч із контуром — це налаштування самої форми
    const FWc = o._feFW || 100, FHc = o._feFH || 100;
    const rxSlider = feHasCorners(o._feShape || 'rect')
      ? feSlider('Заокруглення кутів','fe-fr-rx',0,
          Math.round(Math.min(FWc, FHc) / 2), 1, Math.round(o._feRx || 0),
          o.type === 'image' ? 'feFrameRx' : 'feFrameRxEmpty', '')
      : '';
    if (o.type !== 'image' && rxSlider) h += `<h4>Форма</h4>` + rxSlider;

    if (o.type === 'image') {
      const panOn = FE._panFrame === o;
      h += `<h4>Фото всередині рамки</h4>
        <button class="fe-btn-full ${panOn ? '' : 'soft'}" onclick="feFramePan()">
          ${panOn ? '✓ Готово — зафіксувати фото' : '✋ Рухати фото всередині'}</button>
        <h4>Контур рамки</h4>
        ${rxSlider}
        ${feSlider('Товщина','fe-fr-bw',0,24,0.5,(+(o._feBW||0)).toFixed(1),'feFrameBW','px')}
        <div class="fe-two"><div><div class="fe-lbl">Колір контуру</div>
          <input type="color" class="fe-field" style="height:40px;padding:3px;margin:0;width:100%"
            value="${o._feBC || '#FFFFFF'}" oninput="feFrameBC(this.value)"></div></div>
        <h4>Фото всередині</h4>
        ${feSlider('Масштаб','fe-fr-z',100,320,1,Math.round((o._feZoom||1)*100),'feFrameZoom','%')}
        ${(() => {
          // межі зсуву = реальний запас знімка за краями рамки
          const rx = o._feSlackX || 0, ry = o._feSlackY || 0;
          const sx = Math.max(1, rx), sy = Math.max(1, ry);
          return feSlider('Зсув ⟷','fe-fr-x',-sx,sx,1,Math.round(o._feOffX||0),'feFrameOffX','',{dis:rx<=1})
            + feSlider('Зсув ↕','fe-fr-y',-sy,sy,1,Math.round(o._feOffY||0),'feFrameOffY','',{dis:ry<=1})
            + ((rx <= 1 || ry <= 1) ? `<div style="font-size:11.5px;color:var(--fe-dim);line-height:1.5;margin:2px 0 6px">
                Сірий повзунок означає, що з цього боку знімок вписаний упритул —
                рухати нема куди. Збільште масштаб, і зʼявиться запас.</div>` : '');
        })()}
        <button class="fe-btn-full soft" onclick="feFrameCenter()">${feIco('reset')} Відцентрувати фото</button>`;
    }
  }

  // ---- ВЕКТОРНА КАРТИНКА (SVG) ----
  if (feIsVector(o)) {
    h += `<div class="fe-sep"></div><h4>Колір малюнка</h4>
      <div class="fe-two"><div><div class="fe-lbl">Залити одним кольором</div>
        <input type="color" class="fe-field" style="height:40px;padding:3px;margin:0;width:100%"
          value="${feSvgCurrentColor(o)}" oninput="feSvgColor(this.value)"></div></div>
      <button class="fe-btn-full soft" onclick="feSvgColorReset()">${feIco('reset')} Повернути рідні кольори</button>
      <div style="margin-top:8px;font-size:11px;color:var(--fe-dim);line-height:1.5">
        Заливка застосується до всіх частин малюнка. Обведення лишиться своїм.</div>`;
  }

  // ---- КАРТИНКА / ФОТО ----
  if (feImgIsPlain(o)) {
    h += `<div class="fe-sep"></div><h4>Форма фото</h4>
      <p style="font-size:11.5px;color:var(--fe-dim);line-height:1.5;margin-bottom:8px">
        Бічні кружечки на фото підрізають його з того боку, за який тягнеш.
        Кутові — змінюють розмір цілком.</p>
      ${feSlider('Скруглення кутів','fe-i-rx',0,300,1,Math.round(o._feRx||0),'feImgRx','px')}
      ${feSlider('Товщина контуру','fe-i-bw',0,40,1,Math.round(o._feBW||0),'feImgBW','px')}
      <div class="fe-two" style="margin-top:6px"><div>
        <div class="fe-lbl">Колір контуру</div>
        <input type="color" class="fe-field" style="height:40px;padding:3px;margin:0;width:100%"
          value="${feHex(o._feBC) || '#FFFFFF'}" oninput="feImgBC(this.value)"></div></div>`;
  }
  if (o.type === 'image' && o._feKind !== 'figure') {
    h += `<div class="fe-sep"></div><h4>Налаштування зображення</h4>
      ${feSlider('Яскравість','fe-f-br',-100,100,1,Math.round((o._feBr||0)*100),'feFilterBr','')}
      ${feSlider('Контраст','fe-f-ct',-100,100,1,Math.round((o._feCt||0)*100),'feFilterCt','')}
      ${feSlider('Насиченість','fe-f-sa',-100,100,1,Math.round((o._feSa||0)*100),'feFilterSa','')}
      ${feSlider('Розмиття','fe-f-bl',0,50,1,Math.round((o._feBl||0)*100),'feFilterBl','',{onRelease:true})}
      <button class="fe-btn-full soft" onclick="feFilterGray()">${o._feGray ? '✓ Чорно-біле' : 'Чорно-біле'}</button>
      <button class="fe-btn-full soft" onclick="feFilterReset()">${feIco('reset')} Скинути фільтри</button>
      <h4>Фон зображення</h4>
      ${feSlider('Чутливість','fe-bg-tol',5,80,1,(FE._bgTol || 28),'feSetBgTol','')}
      <button class="fe-btn-full soft" onclick="feRemoveImgBg()">${feIco('removeBg')} Прибрати фон (за кольором кутів)</button>
      <button class="fe-btn-full soft" onclick="feRestoreImgBg()">${feIco('reset')} Повернути фон</button>`;
  }

  h += `<div class="fe-sep"></div>
    <button class="fe-btn-full soft" onclick="feToggleLock()">
      ${o._feLocked ? feIco('unlocked') + ' Зняти замок' : feIco('locked') + ' Зафіксувати (Ctrl+L)'}</button>
    <button class="fe-btn-full soft" onclick="feDuplicate()">${feIco('toFront')} Дублювати</button>
    <button class="fe-btn-full danger" onclick="feDeleteActive()">${feIco('trash')} Видалити</button>`;
  return h;
}
function feHex(v) { return (typeof v === 'string' && v.startsWith('#')) ? v : null; }

// ---- Векторний малюнок: перефарбовування ----
// SVG після завантаження — це група з фігур, тож колір міняємо в усіх частинах.
function feIsVector(o) {
  // будь-що завантажене як SVG: група, окремий контур або текст у кривих
  return !!o && o.type !== 'image' &&
         (o._feKind === 'image' || o._feKind === 'sticker');
}
// Поточний колір малюнка — беремо з першої зафарбованої частини
function feSvgCurrentColor(o) {
  if (o && o._feSvgColor) return o._feSvgColor;
  let found = null;
  feSvgEach(o, x => {
    if (found || !x.fill || x.fill === 'none' || typeof x.fill !== 'string') return;
    try { found = '#' + new fabric.Color(x.fill).toHex(); } catch (e) {}
  });
  return found || '#EDD05C';
}
function feSvgEach(o, fn) {
  if (!o) return;
  if (o._objects && o._objects.length) o._objects.forEach(x => feSvgEach(x, fn));
  else fn(o);
}
function feSvgColor(v) {
  const o = feAct(); if (!feIsVector(o)) return;
  // запамʼятовуємо рідні кольори, щоб можна було повернути
  if (!o._feSvgOrig) {
    const orig = [];
    feSvgEach(o, x => orig.push({ o:x, fill:x.fill, stroke:x.stroke }));
    o._feSvgOrig = orig;
  }
  o._feSvgColor = v;
  feSvgEach(o, x => { if (x.fill && x.fill !== 'none') x.set('fill', v); });
  feC().requestRenderAll();
  clearTimeout(FE._svgColorT);
  FE._svgColorT = setTimeout(() => { feSnapshot(); }, 350);
}
function feSvgColorReset() {
  const o = feAct(); if (!feIsVector(o) || !o._feSvgOrig) return;
  o._feSvgOrig.forEach(r => r.o.set({ fill:r.fill, stroke:r.stroke }));
  o._feSvgColor = null;
  feC().requestRenderAll(); feSnapshot(); feRefreshPanel(); feRenderCtx();
}
function feAct() { return FE.canvas ? FE.canvas.getActiveObject() : null; }
function feAfter() {
  feC().requestRenderAll();
  if (!FE._sliding) feSnapshot();   // під час перетягування повзунка історію не пишемо
}

const FE_TEXT_KEYS = ['text','fontFamily','fontWeight','fontStyle','underline','linethrough',
  'fontSize','fill','stroke','strokeWidth','charSpacing','lineHeight','textAlign','backgroundColor'];
// Вставлений із іншого місця текст приносить із собою оформлення окремих
// літер. Воно має вищий пріоритет за налаштування всього напису — тому
// розмір чи шрифт «не працювали», доки обʼєкт не перебудується.
function feClearCharStyle(o, k) {
  if (!o || !o.styles || typeof o.styles !== 'object') return;
  Object.keys(o.styles).forEach(line => {
    const l = o.styles[line];
    if (!l) return;
    Object.keys(l).forEach(ch => {
      if (l[ch]) { delete l[ch][k]; if (!Object.keys(l[ch]).length) delete l[ch]; }
    });
    if (!Object.keys(l).length) delete o.styles[line];
  });
}
// Властивості, які можна задати окремим літерам усередині напису.
// «text» і «textAlign» сюди не входять — вони стосуються напису цілком.
const FE_CHAR_KEYS = ['fontFamily','fontWeight','fontStyle','underline','linethrough',
  'fontSize','fill','stroke','strokeWidth','charSpacing','backgroundColor'];

// Слово можна виділити просто в полі «Текст напису»: на телефоні це звична
// дія (подвійний дотик), а тягати виділення по самому полотну — той ще квест.
// Те, що виділили в полі, стає виділенням напису: далі шрифт, розмір і колір
// підуть тільки на нього.
function feFieldSel(ta) {
  const o = feAct() || FE._kbObj || FE._lockedSel;
  if (!o || !ta) return;
  if (!(o._feKind === 'text' || o.type === 'textbox' || o.type === 'i-text')) return;
  const st = ta.selectionStart, en = ta.selectionEnd;
  const sel = (typeof st === 'number' && en > st) ? { o, start:st, end:en } : null;
  const cur = FE._txtSel;
  const same = (!sel && !cur) ||
    (sel && cur && cur.o === o && cur.start === sel.start && cur.end === sel.end);
  if (same) return;
  FE._txtSel = sel;
  // Панель НЕ перемальовуємо: перемальовування скидало синє підсвічування
  // в полі й зривало саме виділення. Міняємо тільки плашку.
  feSelNote();
}
// Налаштування напису — окремим шматком, щоб перемальовувати саме його.
// Перемальовування всієї панелі скидало виділення слова в полі тексту.
function feTextSectionHtml(o) {
  const T = feTextState(o);
  let th = '';

    // Якщо всередині напису щось виділено — показуємо властивості саме
    // виділеного, інакше повзунки й списки показували б чуже значення.
    const _sel = feTextSel(o);
    if (_sel && o.getSelectionStyles) {
      const cs = (o.getSelectionStyles(_sel.start, _sel.end) || [])[0] || {};
      Object.keys(cs).forEach(k => { if (cs[k] !== undefined) T[k] = cs[k]; });
    }
    th += `
      <div style="display:flex;gap:6px;align-items:center">
        <div style="flex:1">${feFontSelect(T.fontFamily, "feSetFont(this.value)",
          _sel ? String(T.text || '').slice(_sel.start, _sel.end) : T.text)}</div>
        <button class="fe-ibtn ${feFavFonts().includes(T.fontFamily) ? 'on' : ''}" title="В обрані"
          onclick="feToggleFav('${T.fontFamily}')">${feIco('star')}</button>
      </div>
      <div style="margin-top:10px">
        <div class="fe-lbl">Товщина шрифту</div>
        <select class="fe-field" style="margin:0" onchange="feObjSet('fontWeight',this.value)">
          ${[['300','300 — тонкий'],['400','400 — звичайний'],['500','500 — середній'],
             ['600','600 — напівжирний'],['700','700 — жирний'],['800','800 — дуже жирний'],
             ['900','900 — найжирніший']].map(([w, n]) =>
            `<option value="${w}" ${String(T.fontWeight) === w ? 'selected' : ''}>${n}</option>`).join('')}
        </select>
        ${feIsSingleWeight(T.fontFamily) ? `
          <div style="margin-top:6px;font-size:11px;color:var(--fe-dim);line-height:1.5">
            У цього шрифту одне накреслення — від 600 браузер домальовує жирність сам,
            і дрібні деталі літер можуть залипати.</div>` : ''}
      </div>
      <div class="fe-icons" style="margin-top:8px">
        <button class="fe-ibtn ${String(T.fontWeight) === '900' ? 'on' : ''}" onclick="feToggleWeight()">${feIco('bold')}</button>
        <button class="fe-ibtn ${T.fontStyle === 'italic' ? 'on' : ''}" onclick="feToggle('fontStyle','italic','normal')">${feIco('italic')}</button>
        <button class="fe-ibtn ${T.underline ? 'on' : ''}" onclick="feToggle('underline',true,false)">${feIco('underline')}</button>
        <button class="fe-ibtn ${T.linethrough ? 'on' : ''}" onclick="feToggle('linethrough',true,false)">${feIco('strike')}</button>
        <button class="fe-ibtn ${(() => { const t = _sel
            ? String(T.text || '').slice(_sel.start, _sel.end)
            : String(T.text || '');
          return t && t === t.toUpperCase() && t !== t.toLowerCase() ? 'on' : ''; })()}"
          title="ВЕЛИКІ / маленькі" onclick="feUpper()">${feIco('letterCase')}</button>
      </div>
      <div class="fe-icons" style="margin-top:6px">
        <button class="fe-ibtn ${T.textAlign === 'left' ? 'on' : ''}"   onclick="feObjSet('textAlign','left');feTxtBox()">${feIco('alignLeft')}</button>
        <button class="fe-ibtn ${T.textAlign === 'center' ? 'on' : ''}" onclick="feObjSet('textAlign','center');feTxtBox()">${feIco('alignCenter')}</button>
        <button class="fe-ibtn ${T.textAlign === 'right' ? 'on' : ''}"  onclick="feObjSet('textAlign','right');feTxtBox()">${feIco('alignRight')}</button>
      </div>
      <button class="fe-btn-full soft" style="margin-top:8px" onclick="feTextTrim()">
        ${feIco('trimSides')} Прибрати порожнє навколо</button>
      ${feSlider('Розмір','fe-p-size',8,Math.round(FE.baseW*0.3),1,Math.round(T.fontSize||30),'feFontSize','px')}
      ${feSlider('Міжрядковий інтервал','fe-p-lh',0.7,2.5,0.02,(T.lineHeight||1.16),'feLineHeight','')}
      ${feSlider('Міжбуквений інтервал','fe-p-cs',-100,600,10,(T.charSpacing||0),'feCharSpacing','')}
      ${feSlider('Вигин','fe-p-cv',-100,100,1,(T.curve||0),'feCurve','')}
      <div class="fe-two" style="margin-top:10px">
        <div><div class="fe-lbl">Колір</div>
          <div style="display:flex;gap:6px">
            <input type="color" class="fe-field" style="height:40px;padding:3px;margin:0;flex:1"
              value="${feHex(T.fill) || '#1B2433'}" oninput="feSetFillLive(this.value)">
            <button class="fe-ibtn" title="Піпетка" onclick="fePick(feSetFillLive)">${feIco('picker')}</button>
          </div></div>
        <div><div class="fe-lbl">Контур</div>
          <div style="display:flex;gap:6px">
            <input type="color" class="fe-field" style="height:40px;padding:3px;margin:0;flex:1"
              value="${feHex(T.stroke) || '#ffffff'}" oninput="feStroke(this.value)">
            <button class="fe-ibtn" title="Піпетка" onclick="fePick(feStroke)">${feIco('picker')}</button>
          </div></div>
      </div>
      ${feSlider('Товщина контуру','fe-p-sw',0,10,0.5,(T.strokeWidth||0),'feStrokeWidth','')}
      <div class="fe-two" style="margin-top:8px">
        <div><div class="fe-lbl">Підкладка</div>
          <input type="color" class="fe-field" style="height:40px;padding:3px;margin:0"
            value="${feHex(T.backgroundColor) || '#FCD34D'}" oninput="feObjSet('backgroundColor',this.value)"></div>
        <button class="fe-btn-full soft" style="margin:0;align-self:end" onclick="feObjSet('backgroundColor','')">Без</button>
      </div>`;

  return th;
}
// Перемалювати тільки налаштування напису: поле тексту й виділення в ньому
// лишаються недоторканими.
function feTxtBox() {
  const box = document.getElementById('fe-txt-box');
  const o = feAct() || FE._kbObj || FE._lockedSel;
  if (!box || !o) return;
  if (!(o._feKind === 'text' || o.type === 'textbox' || o.type === 'i-text')) return;
  box.innerHTML = feTextSectionHtml(o);
}
// Плашка «Змінюємо тільки: …» — лежить одразу під полем тексту
function feSelNoteHtml(o) {
  const sel = feTextSel(o);
  if (!sel) return '';
  const txt = String(o.text || (o._feT && o._feT.text) || '');
  const word = txt.slice(sel.start, sel.end).replace(/</g, '&lt;');
  return '<div style="font-size:11.5px;line-height:1.5;color:var(--fe-gold);'
    + 'background:rgba(237,208,92,.1);border:1px solid rgba(237,208,92,.35);'
    + 'border-radius:8px;padding:8px 9px;margin-top:9px">'
    + 'Змінюємо тільки: <b>«' + word + '»</b>'
    + '<div style="color:var(--fe-dim);font-size:11px;margin-top:4px">'
    + 'Налаштування нижче підуть тільки на це слово</div>'
    + '<button class="fe-ibtn" style="width:auto;padding:0 10px;height:26px;'
    + 'font-size:11.5px;margin-top:7px" onmousedown="event.preventDefault()"'
    + ' onclick="feClearTextSel()">На весь напис</button>'
    + '</div>';
}
function feSelNote() {
  const box = document.getElementById('fe-sel-note');
  const o = feAct() || FE._kbObj || FE._lockedSel;
  if (box) box.innerHTML = o ? feSelNoteHtml(o) : '';
  // Виділили інше слово — налаштування нижче мають показати ЙОГО шрифт,
  // розмір і колір, а не того слова, яке міняли перед цим.
  feTxtBox();
}
function feTextFieldBlur() {
  FE._typing = false;
  fePanelKb(false);
  // Панель тут НЕ перемальовуємо: поле втрачає фокус саме тоді, коли людина
  // тицяє в список шрифтів чи повзунок, і підміна вмісту панелі збивала б
  // натискання — то спрацює, то ні.
  feSelNote();
}
// «На весь напис» у плашці виділення
function feClearTextSel() {
  feForgetTextSel();
  const f = document.getElementById('fe-p-text');
  if (f) try { f.setSelectionRange(f.value.length, f.value.length); } catch (e) {}
  feSelNote();
}
// Чи виділено зараз шматок тексту всередині напису
function feTextSel(o) {
  if (!o) return null;
  // 1) людина зараз редагує напис і щось виділила
  if (o.isEditing && typeof o.selectionStart === 'number' && o.selectionEnd > o.selectionStart) {
    FE._txtSel = { o, start:o.selectionStart, end:o.selectionEnd };
    return { start:o.selectionStart, end:o.selectionEnd };
  }
  // 2) виділення щойно було, але торкання панелі забрало фокус із напису
  //    і редагування завершилось. Без цього зміна шрифту зі списку летіла
  //    на весь напис замість виділеного слова.
  const m = FE._txtSel;
  const txt = String(o.text || (o._feT && o._feT.text) || '');
  if (m && m.o === o && m.end > m.start && m.end <= txt.length) {
    return { start:m.start, end:m.end };
  }
  return null;
}
// Запамʼятоване виділення живе, доки людина не візьметься за інший обʼєкт
// або не почне правити сам текст.
function feForgetTextSel() { FE._txtSel = null; }
// Те саме, що feClearCharStyle, але для збереженого стану напису.
// Вигнутий напис — це група літер, у неї немає власного styles: оформлення
// живе в _feT і переживає перебудову. Без цієї чистки зміна шрифту «на все»
// не діяла на слова, яким колись задали свій шрифт.
function feClearStateCharStyle(st, k) {
  if (!st || !st.styles) return;
  Object.keys(st.styles).forEach(line => {
    const l = st.styles[line];
    if (!l) return;
    Object.keys(l).forEach(ch => {
      if (l[ch]) { delete l[ch][k]; if (!Object.keys(l[ch]).length) delete l[ch]; }
    });
    if (!Object.keys(l).length) delete st.styles[line];
  });
}
// Коли напис тягнуть за кут, fabric міняє масштаб, а не розмір шрифту.
// Через це повзунок «Розмір» показував старе число, а варто було
// підправити текст — напис стрибав до того розміру, що на повзунку.
// Тому одразу після зміни переводимо масштаб у розмір шрифту.
function feBakeTextScale(o) {
  if (!o) return false;
  const t = o.type;
  if (t !== 'textbox' && t !== 'i-text' && t !== 'text') return false;
  const sx = o.scaleX || 1, sy = o.scaleY || 1;
  if (Math.abs(sx - sy) > 0.01) return false;   // нерівномірне — не чіпаємо
  if (Math.abs(sx - 1) < 0.002) return false;
  const k = sx;
  o.set({ fontSize: Math.max(4, Math.round((o.fontSize || 40) * k)), scaleX:1, scaleY:1 });
  if (t === 'textbox') o.set('width', Math.max(20, (o.width || 100) * k));
  if (o.strokeWidth) o.set('strokeWidth', o.strokeWidth * k);
  // розміри окремих слів множимо так само, інакше вони лишились би дрібними
  if (o.styles) {
    Object.keys(o.styles).forEach(line => {
      const L = o.styles[line]; if (!L) return;
      Object.keys(L).forEach(ch => {
        if (L[ch] && L[ch].fontSize) L[ch].fontSize = Math.round(L[ch].fontSize * k);
      });
    });
  }
  if (o.initDimensions) o.initDimensions();
  o.setCoords();
  if (o._feT) { o._feT.fontSize = o.fontSize; o._feT.scaleX = 1; o._feT.scaleY = 1; }
  return true;
}
function feObjSet(k, v) {
  const o = feAct(); if (!o) return;
  // Виділено частину напису — міняємо тільки її.
  // Саме цього бракувало: раніше будь-яка зміна застосовувалась до всього.
  const sel = feTextSel(o);
  // Вигнутий напис — це група літер, у неї немає setSelectionStyles.
  // Тому оформлення виділених знаків пишемо у збережений стан і перебудовуємо.
  if (sel && FE_CHAR_KEYS.includes(k) && !o.setSelectionStyles && o._feT) {
    const st = o._feT;
    st.styles = st.styles || {};
    const lines = String(st.text || '').split('\n');
    let idx = 0;
    lines.forEach((ln, li) => {
      for (let ci = 0; ci < ln.length; ci++, idx++) {
        if (idx < sel.start || idx >= sel.end) continue;
        st.styles[li] = st.styles[li] || {};
        st.styles[li][ci] = { ...(st.styles[li][ci] || {}), [k]: v };
      }
      idx++;   // перенос рядка
    });
    feReplaceText({}, true);
    return;
  }
  if (sel && FE_CHAR_KEYS.includes(k) && o.setSelectionStyles) {
    o.setSelectionStyles({ [k]: v }, sel.start, sel.end);
    o.dirty = true;
    if (o.initDimensions) o.initDimensions();
    feUnwrapText(o);          // слово могло стати ширшим — розсуваємо блок
    o.setCoords();
    feAfter();
    return;
  }
  if (FE_TEXT_KEYS.includes(k)) feClearCharStyle(o, k);
  // вигнутий текст — перебудовуємо
  if (feIsCurved(o) && FE_TEXT_KEYS.includes(k)) {
    feClearStateCharStyle(o._feT, k);      // нічого не виділено — міняємо весь напис
    feReplaceText({ [k]: v });
    return;
  }
  o.set(k, v); o.setCoords();
  if (o._feT) o._feT[k] = v;
  feAfter();
}
function feOpacity(v)   { feObjSet('opacity', +v / 100); }
function feFontSize(v)  { feObjSet('fontSize', +v); }
function feLineHeight(v){ feObjSet('lineHeight', +v); }
function feCharSpacing(v){ feObjSet('charSpacing', +v); }
// Контур тексту йде через feObjSet: тільки так він працює і для виділеного
// слова, і для вигнутого напису (там це група літер, у якої власний stroke
// нічого не малює), і переживає перебудову дуги.
function feStroke(v) {
  const o = feAct(); if (!o) return;
  if (!o.strokeWidth) feObjSet('strokeWidth', 1.5);
  o.set('paintFirst', 'stroke');
  if (o._feT) o._feT.paintFirst = 'stroke';
  feObjSet('stroke', v);
}
// колір без перемальовування панелі (щоб не рвався drag по палітрі)
function feSetFillLive(v) {
  const o = feAct(); if (!o) return;
  const sel = feTextSel(o);
  if (sel && o.setSelectionStyles) {         // фарбуємо лише виділені літери
    o.setSelectionStyles({ fill:v }, sel.start, sel.end);
    o.dirty = true; feC().requestRenderAll();
    return;
  }
  if (feIsCurved(o)) {
    if (o._feT) { o._feT.fill = v; feClearStateCharStyle(o._feT, 'fill'); }
    (o._objects || []).forEach(x => x.set('fill', v));
  } else {
    // нічого не виділено — колір іде на весь напис, тож власні кольори
    // окремих слів прибираємо, інакше вони ігнорували б зміну
    feClearCharStyle(o, 'fill');
    o.set('fill', v);
    o.dirty = true;
    if (o._feT) { o._feT.fill = v; feClearStateCharStyle(o._feT, 'fill'); }
  }
  feGlowSync(o, v);
  feC().requestRenderAll();
}
// Сяйво навколо напису мало жорстко зашитий зелений колір, тому лишалось
// зеленим, хоч би на що людина перефарбувала текст. Перемальовуємо його
// разом із кольором літер.
function feGlowSync(o, v) {
  if (!o || !o._feGlow) return;
  const blur = +o._feGlow || 14;
  const sh = new fabric.Shadow({ color:v, blur, offsetX:0, offsetY:0 });
  if (feIsCurved(o)) {
    (o._objects || []).forEach(x => x.set('shadow', sh));
    if (o._feT) o._feT.shadow = sh;
  } else {
    o.set('shadow', sh);
    if (o._feT) o._feT.shadow = sh;
  }
}
// ---- Вигин тексту: обʼєкт лишається єдиним ----
function feTextState(o) {
  if (o._feT) {
    const st = { ...o._feT };
    // Якщо напис редагували прямо на полотні, у збереженому стані лишався
    // старий текст — саме через це в панелі й у превʼю шрифтів висіло
    // «Ваш текст» замість того, що написано насправді.
    if (o.type !== 'group' && typeof o.text === 'string') st.text = o.text;
    // оформлення окремих літер теж могли змінити просто на полотні
    if (o.type !== 'group' && o.styles) st.styles = feCloneStyles(o.styles);
    // Розмір, масштаб і поворот беремо живі: збережений стан застаріває,
    // щойно людина потягне напис за кут або змінить розмір повзунком.
    st.scaleX = o.scaleX ?? 1; st.scaleY = o.scaleY ?? 1;
    st.angle = o.angle || 0;
    if (o.type !== 'group' && o.fontSize) st.fontSize = o.fontSize;
    // Ширина рамки напису — це те, по чому текст переноситься на рядки.
    // Людина задає її, розтягуючи напис за бічні маркери, і при перебудові
    // (зміна шрифту, жирності окремого слова) вона має зберігатись.
    if (o.type !== 'group' && o.width) st.width = o.width;
    return st;
  }
  return { text:o.text || '', fontFamily:o.fontFamily, fontWeight:o.fontWeight,
    fontStyle:o.fontStyle, underline:!!o.underline, linethrough:!!o.linethrough,
    fontSize:o.fontSize, fill:o.fill, stroke:o.stroke, strokeWidth:o.strokeWidth,
    charSpacing:o.charSpacing || 0, lineHeight:o.lineHeight || 1.16, width:o.width,
    textAlign:o.textAlign || 'center', backgroundColor:o.backgroundColor || '',
    curve:o._feCurve || 0, left:o.left, top:o.top, angle:o.angle || 0, opacity:o.opacity ?? 1,
    // Масштаб треба нести з собою: якщо напис розтягнули за кут, він виглядає
    // більшим за свій розмір у налаштуваннях. Без цього перебудова (зміна
    // шрифту чи вигину) скидала його до початкового — текст різко меншав.
    scaleX:o.scaleX ?? 1, scaleY:o.scaleY ?? 1, flipX:!!o.flipX, flipY:!!o.flipY,
    styles: o.styles ? feCloneStyles(o.styles) : undefined };
}
// Копія оформлення літер — щоб стан не тримав посилання на живий обʼєкт
function feCloneStyles(st) {
  try { return JSON.parse(JSON.stringify(st || {})); } catch (e) { return {}; }
}
// Оформлення літер у вигляді простого списку за позицією в тексті.
// Потрібне для вигнутого напису, де кожна літера — окремий обʼєкт.
function feStylesArray(st) {
  const out = [];
  const lines = String(st.text || '').split('\n');
  let idx = 0;
  lines.forEach((ln, li) => {
    const ls = (st.styles && st.styles[li]) || {};
    for (let ci = 0; ci < ln.length; ci++) out[idx++] = ls[ci] || null;
    if (li < lines.length - 1) out[idx++] = null;   // сам перенос рядка
  });
  return out;
}
function feBuildText(st) {
  const common = { left:st.left, top:st.top, angle:st.angle, opacity:st.opacity,
    scaleX:st.scaleX ?? 1, scaleY:st.scaleY ?? 1, flipX:!!st.flipX, flipY:!!st.flipY,
    originX:'center', originY:'center', _feKind:'text', _feName:st.text, _feT:st, _feCurve:st.curve };
  if (!st.curve) {
    // Ширину беремо зі стану: без цього кожна перебудова скидала її до
    // 72% полотна, і напис, розбитий на три рядки, злипався в один довгий.
    return new fabric.Textbox(st.text, { ...common, width:st.width || FE.baseW * 0.72, textAlign:st.textAlign,
      fontFamily:st.fontFamily, fontWeight:st.fontWeight, fontStyle:st.fontStyle,
      underline:st.underline, linethrough:st.linethrough, fontSize:st.fontSize,
      fill:st.fill, stroke:st.stroke, strokeWidth:st.strokeWidth, paintFirst:'stroke',
      charSpacing:st.charSpacing, lineHeight:st.lineHeight, backgroundColor:st.backgroundColor,
      styles: st.styles ? feCloneStyles(st.styles) : undefined });
  }
  const chars = Array.from(st.text);
  const fs = st.fontSize || 40;
  const dir = st.curve > 0 ? 1 : -1;
  const R = fs * (900 / Math.max(Math.abs(st.curve), 3)) / 10;
  const step = (fs * 0.62 + (st.charSpacing || 0) / 1000 * fs) / R;
  const start = -step * (chars.length - 1) / 2;
  // оформлення окремих літер переносимо на відповідні знаки вигнутого напису
  const perChar = feStylesArray(st);
  const items = chars.map((ch, i) => {
    const a = start + step * i;
    const cs = perChar[i] || {};
    return new fabric.Text(ch, {
      left: Math.sin(a) * R,
      top: -dir * (Math.cos(a) * R - R),
      angle: (a * 180 / Math.PI) * dir,
      originX:'center', originY:'center',
      fontFamily: cs.fontFamily || st.fontFamily,
      fontWeight: cs.fontWeight || st.fontWeight,
      fontStyle:  cs.fontStyle  || st.fontStyle,
      underline:  cs.underline  !== undefined ? cs.underline  : st.underline,
      linethrough:cs.linethrough!== undefined ? cs.linethrough: st.linethrough,
      fontSize:   cs.fontSize   || fs,
      fill:       cs.fill       || st.fill,
      stroke:     cs.stroke     !== undefined ? cs.stroke : st.stroke,
      strokeWidth:cs.strokeWidth!== undefined ? cs.strokeWidth : st.strokeWidth,
      paintFirst:'stroke',
    });
  });
  // розмір, з яким побудовано дугу — потрібен для живого показу при перетягуванні
  return new fabric.Group(items, { ...common, _feBuiltFs: fs });
}
function feReplaceText(changes, force) {
  const c = feC(), o = feAct(); if (!o) return;
  // Нічого не виділено — отже, міняємо весь напис. Прибираємо власні
  // значення окремих слів лише за тими властивостями, які зараз задаємо:
  // шрифт стане спільним, а колір і розмір слів лишаться своїми.
  // Без цього власні шрифти (вони йдуть через перебудову) мінялись тільки
  // в тих словах, яким ніхто не задавав шрифт окремо.
  if (!feTextSel(o)) {
    Object.keys(changes || {}).forEach(k => {
      if (!FE_CHAR_KEYS.includes(k)) return;
      feClearCharStyle(o, k);
      if (o._feT) feClearStateCharStyle(o._feT, k);
    });
  }
  // під час перетягування повзунка обʼєкт не перебудовуємо — інакше повзунок зникає з-під курсора
  if (FE._sliding && !force) {
    o._feT = { ...feTextState(o), ...changes };
    FE._pendingText = true;
    feCurvedLive(o, changes);
    return;
  }
  const st = { ...feTextState(o), ...changes, left:o.left, top:o.top, angle:o.angle };
  if (o._feLiveScale && o._feLiveBase) {        // це був тимчасовий показ розміру
    st.scaleX = o._feLiveBase.x; st.scaleY = o._feLiveBase.y;
    o._feLiveScale = false; o._feLiveBase = null;
  }
  const nu = feBuildText(st);
  FE._rebuilding = true;               // щоб зняття виділення не закрило панель
  if (FE._txtSel && FE._txtSel.o === o) FE._txtSel.o = nu;   // виділення лишається чинним
  c.remove(o); c.add(nu); c.setActiveObject(nu);
  FE._rebuilding = false;
  feSafeToFront(); c.requestRenderAll(); feSnapshot();
}
// Легка зміна вигнутого тексту без перебудови (для плавного перетягування)
function feCurvedLive(o, changes) {
  if (!o || o.type !== 'group' || !o._objects) { feC().requestRenderAll(); return; }
  const map = { fill:'fill', stroke:'stroke', strokeWidth:'strokeWidth',
    fontFamily:'fontFamily', fontWeight:'fontWeight', fontStyle:'fontStyle', underline:'underline' };
  Object.keys(changes).forEach(k => { if (map[k]) o._objects.forEach(x => x.set(k, changes[k])); });
  // Розмір на дузі змінює і радіус, і проміжки — перерахувати це на льоту дорого.
  // Але рівномірне збільшення всієї групи дає точно той самий вигляд,
  // тож поки тягнемо повзунок, просто масштабуємо. Після відпускання
  // напис перебудовується по-справжньому, з масштабом 1.
  if (changes.fontSize && o._feBuiltFs) {
    const k = (+changes.fontSize) / o._feBuiltFs;
    if (isFinite(k) && k > 0) {
      // множимо на власний масштаб напису, щоб не втратити розтягування за кут
      const base = o._feLiveBase || (o._feLiveBase = { x:o.scaleX ?? 1, y:o.scaleY ?? 1 });
      o.set({ scaleX:base.x * k, scaleY:base.y * k });
      o._feLiveScale = true;
    }
  }
  feC().requestRenderAll();
}
// Після відпускання повзунка добудовуємо остаточний вигляд
function feCommitPendingText() {
  if (!FE._pendingText) return;
  FE._pendingText = false;
  FE._curveCenter = null;
  const o = feAct();
  if (!o) { FE._curvePending = null; return; }
  // значення вигину, накопичене під час перетягування
  if (FE._curvePending != null) {
    const v = FE._curvePending; FE._curvePending = null;
    feReplaceText({ curve: v }, true);
    return;
  }
  if (o._feT) feReplaceText({});
}
// ---- Живий вигин: переставляємо самі літери, обʼєкт не перестворюємо ----
// Позиції рахуються тією ж формулою, що й у feBuildText, тож результат
// збігається з фінальною перебудовою на відпусканні повзунка.
function feCurveLive(o, curve) {
  if (!o || o.type !== 'group' || !o._objects || !curve) return false;
  const st = o._feT;
  if (!st) return false;
  const chars = Array.from(st.text || '');
  if (o._objects.length !== chars.length) return false;

  try {
    // центр напису має лишатись на місці, поки міняється кривизна
    if (!FE._curveCenter) FE._curveCenter = o.getCenterPoint();

    const fs = st.fontSize || 40;
    const dir = curve > 0 ? 1 : -1;
    const R = fs * (900 / Math.max(Math.abs(curve), 3)) / 10;
    const step = (fs * 0.62 + (st.charSpacing || 0) / 1000 * fs) / R;
    const start = -step * (chars.length - 1) / 2;

    o._objects.forEach((t, i) => {
      const a = start + step * i;
      t.set({ left: Math.sin(a) * R,
              top: -dir * (Math.cos(a) * R - R),
              angle: (a * 180 / Math.PI) * dir });
      t.setCoords();
    });

    o.addWithUpdate();                                   // перерахувати габарити
    o.setPositionByOrigin(FE._curveCenter, 'center', 'center');
    o.setCoords();

    o._feCurve = curve;
    st.curve = curve;
    st.left = o.left; st.top = o.top;
    feC().requestRenderAll();
    return true;
  } catch (e) { return false; }
}
// Готує напис до живого гнуття — викликається щойно взялись за повзунок
function feCurvePrepare(v) {
  const o = feAct();
  if (!o || FE._curveConverted) return;
  FE._curveConverted = true;
  FE._curveCenter = null;
  if (o.type === 'group' && o._feT) return;      // уже вигнутий — нічого робити
  // ВАЖЛИВО: FE._sliding не скидаємо. Інакше після перебудови панель
  // перемальовується, повзунок зникає з-під пальця — і перше перетягування
  // просто губиться. Прапорець force і так дозволяє перебудову.
  feReplaceText({ curve: (+v) || 1 }, true);
}
function feCurve(v) {
  const val = +v;
  const o = feAct();
  if (FE._sliding) {
    FE._curvePending = val;                      // точне значення — на відпускання
    FE._pendingText = true;
    // Біля нуля напис формально «рівний», але обʼєкт перебудовувати не можна —
    // інакше на переході через 0 усе завмирає. Гнемо майже непомітно.
    if (val !== 0) FE._curveSign = val > 0 ? 1 : -1;
    const liveVal = (val === 0) ? (FE._curveSign || 1) * 0.01 : val;
    if (feCurveLive(o, liveVal)) return;
    feCurvePrepare(val);                         // не встигли підготувати — робимо тут
    feCurveLive(feAct(), liveVal);
    return;
  }
  FE._curveCenter = null;
  FE._curvePending = null;
  feReplaceText({ curve: val }, true);
  FE._pendingText = false;
}
function feIsCurved(o) { return o && o.type === 'group' && o._feCurve; }
function feStrokeWidth(v) {
  const o = feAct();
  // Товщина без кольору нічого не малює: контур був «увімкнений», але
  // прозорий, і здавалося, що повзунок зламаний. Ставимо колір за
  // замовчуванням, щойно товщина стає більшою за нуль.
  if (o && +v > 0 && !feCurVal(o, 'stroke')) {
    o.set('paintFirst', 'stroke');
    if (o._feT) o._feT.paintFirst = 'stroke';
    feObjSet('stroke', '#FFFFFF');
  }
  feObjSet('strokeWidth', +v);
}
// Поточне значення властивості: якщо виділено слово — його власне, а не
// загальне для всього напису. Без цього перемикачі жирного чи закресленого
// не гасли: у самого напису значення лишалось «вимкнено», і кожне натискання
// вмикало його знову.
function feCurVal(o, k) {
  const sel = feTextSel(o);
  if (sel && o.getSelectionStyles) {
    const cs = (o.getSelectionStyles(sel.start, sel.end) || [])[0] || {};
    if (cs[k] !== undefined) return cs[k];
  }
  if (sel && feIsCurved(o)) {
    // у вигнутого напису оформлення літер лежить у збереженому стані
    const cs = (feStylesArray(feTextState(o)) || [])[sel.start] || {};
    if (cs[k] !== undefined) return cs[k];
  }
  return feIsCurved(o) ? feTextState(o)[k] : o[k];
}
function feToggle(k, on, off) {
  const o = feAct(); if (!o) return;
  const cur = feCurVal(o, k);
  feObjSet(k, cur === on ? off : on); feTxtBox();
}
function feToggleWeight() {
  const o = feAct(); if (!o) return;
  const w = String(feCurVal(o, 'fontWeight') ?? feTextState(o).fontWeight);
  feObjSet('fontWeight', w === '900' ? '400' : '900'); feTxtBox();
}
function feUpper() {
  const o = feAct(); if (!o) return;
  const t = feTextState(o).text || ''; if (!t) return;
  // Виділили слово — міняємо регістр тільки йому, як і решта налаштувань.
  const sel = feTextSel(o);
  if (sel) {
    const w = t.slice(sel.start, sel.end);
    const nu = (w === w.toUpperCase()) ? w.toLowerCase() : w.toUpperCase();
    feObjSet('text', t.slice(0, sel.start) + nu + t.slice(sel.end));
    const f = document.getElementById('fe-p-text');
    if (f) f.value = t.slice(0, sel.start) + nu + t.slice(sel.end);
    feSelNote();
    return;
  }
  feObjSet('text', t === t.toUpperCase() ? t.toLowerCase() : t.toUpperCase());
  const f2 = document.getElementById('fe-p-text');
  if (f2) f2.value = feTextState(o).text || '';
  feTxtBox();
}
function feRx(v) { const o = feAct(); if (!o) return; o.set({ rx:+v, ry:+v }); feAfter(); }
// Порожня фігура — тільки контур. Саме так зроблені рамки-обводки
// у вбудованих шаблонах, тож тепер це можна повторити вручну.
function feFillNone() {
  const o = feAct(); if (!o) return;
  const empty = !o.fill || o.fill === 'transparent';
  if (empty) {
    o.set('fill', feHex(o.stroke) || '#E53935');
  } else {
    o.set({ fill:'transparent',
            stroke: feHex(o.stroke) || feHex(o.fill) || '#1B2433',
            strokeWidth: o.strokeWidth || 3,
            strokeUniform: true });
  }
  if (o.type === 'group') o.getObjects().forEach(x => x.set('fill', o.fill));
  feAfter(); feRefreshPanel(); feRenderCtx();
}
// колір для груп (стікери) — рекурсивно
function feFillDeep(v) {
  const o = feAct(); if (!o) return;
  if (o.type === 'group') o.getObjects().forEach(x => { if (x.fill && x.fill !== 'transparent') x.set('fill', v); });
  else o.set('fill', v);
  feAfter();
}
function feStrokeDeep(v) {
  const o = feAct(); if (!o) return;
  if (o.type === 'group') o.getObjects().forEach(x => { if (x.stroke) x.set('stroke', v); });
  else o.set({ stroke:v, strokeWidth:o.strokeWidth || 2 });
  feAfter();
}
function feStrokeWidthDeep(v) {
  const o = feAct(); if (!o) return;
  if (o.type === 'group') o.getObjects().forEach(x => x.set('strokeWidth', +v));
  else o.set('strokeWidth', +v);
  feAfter();
}
function feAlign(a) {
  const o = feAct(); if (!o) return;
  const b = o.getBoundingRect(true);
  if (a === 'l')  o.set('left', o.left - b.left);
  if (a === 'r')  o.set('left', o.left + (FE.baseW - (b.left + b.width)));
  if (a === 'cx') o.set('left', o.left + (FE.baseW/2 - (b.left + b.width/2)));
  if (a === 't')  o.set('top',  o.top - b.top);
  if (a === 'b')  o.set('top',  o.top + (FE.baseH - (b.top + b.height)));
  if (a === 'cy') o.set('top',  o.top + (FE.baseH/2 - (b.top + b.height/2)));
  o.setCoords(); feAfter();
}
function feFlip(ax) { const o = feAct(); if (!o) return; o.set(ax === 'x' ? 'flipX' : 'flipY', !(ax === 'x' ? o.flipX : o.flipY)); feAfter(); }
function feObjLayer(d) { const o = feAct(); if (!o) return; d > 0 ? o.bringForward() : o.sendBackwards(); feSafeToFront(); feAfter(); }
// Фігурки, предмети й підписи живуть на першому екрані: там їх додають,
// там же вони потрапляють у розрахунок ціни. Дубль на полотні обійшов би
// і лічильник, і ціну — тому копіювати їх не можна ні кнопкою, ні клавішами.
function feNoCopy(o) {
  if (!o) return false;
  const k = o._feKind;
  if (k === 'figure' || k === 'item' || k === 'caption') return true;
  // у виділенні кількох обʼєктів досить одного такого
  if (o.type === 'activeSelection' && o.getObjects)
    return o.getObjects().some(x => feNoCopy(x));
  return false;
}
function feDuplicate() {
  const o = feAct(); if (!o) return;
  if (feNoCopy(o)) { feToast('Фігурки й предмети додаються на першому екрані'); return; }
  o.clone(cl => { FE.clipboard = cl; fePaste(); }, FE_KEEP);
}
// дії з фігуркою
function feHideActiveFigure() {
  const o = feAct(); if (!o || o._feKind !== 'figure') return;
  o.set('visible', false);
  feC().getObjects().filter(x => x._feKind === 'caption' && x._feFigId === o._feId)
    .forEach(x => x.set('visible', false));
  feC().discardActiveObject(); feC().requestRenderAll(); feSnapshot();
}
function feRemoveActiveFigure() {
  const o = feAct(); if (!o || o._feKind !== 'figure') return;
  const i = o._feSrc;
  if (i != null && FE.figures[i]) FE.figures[i]._placed = null;
  delete FE.captions.names[o._feId];
  feC().remove(o);
  feC().getObjects().filter(x => x._feKind === 'caption' && x._feFigId === o._feId)
    .forEach(x => feC().remove(x));
  feC().discardActiveObject(); feC().requestRenderAll(); feSnapshot();
}
// Повертає фігуркам заблокований стан після відновлення з JSON
function feFixFigures() {
  const c = FE.canvas; if (!c) return;
  c.getObjects().forEach(o => {
    if (o._feKind === 'figure') {
      o.set({ lockScalingX:true, lockScalingY:true, lockRotation:true,
              hasControls:false, hasBorders:false, lockUniScaling:true });
      o.setCoords();
    }
    if (o._feKind === 'caption') {
      const s = feCapS();
      o.set({ selectable:!s.moveWith, evented:!s.moveWith });
    }
    // аксесуар і предмет після відновлення теж не можна розтягувати
    if (o._feKind === 'accessory' || o._feKind === 'item') {
      o.set({ lockScalingX:true, lockScalingY:true, lockUniScaling:true });
      o.setCoords();
    }
  });
}
// Затягує фігурки всередину видимої зони (після зміни розміру/орієнтації)
function feClampFigures() {
  const c = FE.canvas; if (!c) return;
  const i = feInsetPx();
  feFiguresOnCanvas().forEach(o => {
    const b = o.getBoundingRect(true, true);
    let dx = 0, dy = 0;
    if (b.left < i.x) dx = i.x - b.left;
    if (b.left + b.width > FE.baseW - i.x) dx = (FE.baseW - i.x) - (b.left + b.width);
    if (b.top < i.y) dy = i.y - b.top;
    if (b.top + b.height > FE.baseH - i.y) dy = (FE.baseH - i.y) - (b.top + b.height);
    if (dx || dy) { o.set({ left:o.left + dx, top:o.top + dy }); o.setCoords(); }
    const idx = o._feSrc;
    if (idx != null && FE.figures[idx]) { FE.figures[idx]._px = o.left / FE.baseW; FE.figures[idx]._py = o.top / FE.baseH; }
  });
  c.requestRenderAll();
}
// Просте підтвердження: питаємо, показуємо вікно, чекаємо відповіді.
// Потрібне там, де дію не повернути одним рухом — видалення обʼєкта чи фону.
let _feConfirmCb = null;
function feConfirm(text, onYes) {
  _feConfirmCb = onYes;
  const box = document.getElementById('fe-confirm-text');
  if (box) box.textContent = text;
  feModal('fe-m-confirm');
}
function feConfirmYes() {
  const cb = _feConfirmCb; _feConfirmCb = null;
  feModalClose();
  if (typeof cb === 'function') cb();
}
function feDeleteActive() {
  const c = feC(), o = c.getActiveObject(); if (!o) return;
  // фігурки додаються й видаляються тільки на першому екрані
  if (o._feKind === 'figure') { feToast('Фігурки змінюються на першому екрані'); return; }
  const many = o.type === 'activeSelection';
  feConfirm(many ? 'Видалити виділені обʼєкти?' : 'Видалити виділений обʼєкт?',
            () => feDeleteActiveNow());
}
function feDeleteActiveNow() {
  const c = feC(), o = c.getActiveObject(); if (!o) return;
  if (o.type === 'activeSelection') {
    // видаляємо все одним записом в історію, щоб «назад» повернуло все разом
    FE.hLock = true;
    o.forEachObject(x => { if (x._feKind !== 'figure') c.remove(x); });
    FE.hLock = false;
  } else c.remove(o);
  feCtxMenuClose();
  c.discardActiveObject(); c.requestRenderAll(); feSnapshot(); feRefreshPanel();
}
// фільтри зображення
// Фільтри рахуються по всіх пікселях знімка — на телефоні це помітно важко.
// Поки тягнуть повзунок, застосовуємо не частіше ніж раз на 140 мс,
// а фінальне значення — одразу після відпускання.
function feApplyFiltersLive(o) {
  if (!FE._sliding || !feIsMobile()) { feApplyFilters(o); return; }
  clearTimeout(FE._filtT);
  FE._filtT = setTimeout(() => feApplyFilters(o), 140);
}
function feApplyFilters(o) {
  clearTimeout(FE._filtT);
  o.filters = [];
  if (o._feBr) o.filters.push(new fabric.Image.filters.Brightness({ brightness:o._feBr }));
  if (o._feCt) o.filters.push(new fabric.Image.filters.Contrast({ contrast:o._feCt }));
  if (o._feSa) o.filters.push(new fabric.Image.filters.Saturation({ saturation:o._feSa }));
  if (o._feBl) o.filters.push(new fabric.Image.filters.Blur({ blur:o._feBl }));
  if (o._feGray) o.filters.push(new fabric.Image.filters.Grayscale());
  o.applyFilters(); feC().requestRenderAll();
}
function feFilterBr(v){ const o=feAct(); if(!o)return; o._feBr=+v/100; feApplyFiltersLive(o); }
function feFilterCt(v){ const o=feAct(); if(!o)return; o._feCt=+v/100; feApplyFiltersLive(o); }
function feFilterSa(v){ const o=feAct(); if(!o)return; o._feSa=+v/100; feApplyFiltersLive(o); }
// Розмиття — найважчий фільтр: воно перебирає сусідні пікселі по всьому знімку.
// Тому застосовуємо його один раз, коли повзунок відпустили, і попереджаємо,
// що йде обробка — інакше здається, ніби редактор завис.
function feFilterBl(v) {
  const o = feAct(); if (!o) return;
  o._feBl = +v / 100;
  if (!o._feBl) { feApplyFilters(o); return; }
  feToast('⏳ Застосовую розмиття…', 6000);
  // даємо браузеру намалювати підказку, і аж тоді рахуємо
  setTimeout(() => { feApplyFilters(o); feToast('Готово'); }, 50);
}
function feFilterGray(){ const o=feAct(); if(!o)return; o._feGray=!o._feGray; feApplyFilters(o); feSnapshot(); feRefreshPanel(); }
function feFilterReset(){ const o=feAct(); if(!o)return; o._feBr=o._feCt=o._feSa=o._feBl=0; o._feGray=false; feApplyFilters(o); feSnapshot(); feRefreshPanel(); }

// ---- Прибирання однотонного фону зображення ----
function feSetBgTol(v) { FE._bgTol = +v; }
function feRemoveImgBg() {
  const o = feAct();
  if (!o || o.type !== 'image') return;
  const src = o._feOrigSrc || (o._element && o._element.src) || o.getSrc();
  if (!o._feOrigSrc) o._feOrigSrc = src;

  const im = new Image();
  im.crossOrigin = 'anonymous';
  im.onload = () => {
    const cv = document.createElement('canvas');
    cv.width = im.naturalWidth; cv.height = im.naturalHeight;
    const ctx = cv.getContext('2d', { willReadFrequently: true });
    ctx.drawImage(im, 0, 0);
    let d;
    try { d = ctx.getImageData(0, 0, cv.width, cv.height); }
    catch (e) { alert('Не вдалося обробити це зображення (обмеження браузера).'); return; }
    const p = d.data, W = cv.width, H = cv.height;
    // еталон — середній колір чотирьох кутів
    const corner = i => [p[i], p[i+1], p[i+2]];
    const cs = [0, (W-1)*4, (H-1)*W*4, ((H-1)*W + W-1)*4].map(corner);
    const ref = [0,1,2].map(k => Math.round(cs.reduce((s,c) => s + c[k], 0) / cs.length));
    const tol = (FE._bgTol || 28) * 2.55 * 1.4;
    for (let i = 0; i < p.length; i += 4) {
      const dist = Math.sqrt((p[i]-ref[0])**2 + (p[i+1]-ref[1])**2 + (p[i+2]-ref[2])**2);
      if (dist < tol) p[i+3] = 0;
      else if (dist < tol * 1.35) p[i+3] = Math.round(p[i+3] * (dist - tol) / (tol * 0.35));
    }
    ctx.putImageData(d, 0, 0);
    o.setSrc(cv.toDataURL('image/png'), () => {
      feApplyFilters(o);
      feC().requestRenderAll(); feSnapshot(); feToast('Фон прибрано');
    }, { crossOrigin:'anonymous' });
  };
  im.onerror = () => alert('Не вдалося завантажити зображення');
  im.src = src;
}
function feRestoreImgBg() {
  const o = feAct();
  if (!o || o.type !== 'image' || !o._feOrigSrc) return;
  o.setSrc(o._feOrigSrc, () => { feApplyFilters(o); feC().requestRenderAll(); feSnapshot(); },
    { crossOrigin:'anonymous' });
}

// ============================================================
// ІСТОРІЯ
// ============================================================
const FE_KEEP = ['_feKind','_feName','_feSafe','_feShape','_feBr','_feCt','_feSa','_feBl','_feGray',
  '_feId','_feFigId','_feSrc','_feT','_feCurve','_feFW','_feFH','_feZoom','_feOffX','_feOffY',
  '_feCx','_feSoft','_feRot','_feFrameAngle','_feAncX','_feAncY','_feRx','_feBW','_feBC','_feSvgColor',
  '_feItem','_feForItem','_feSig','_feBuiltFs','cropX','cropY','_feOid','_feFile','_feGlow',
  '_feLocked','selectable','hoverCursor','objectCaching',
  'lockMovementX','lockMovementY','lockScalingX','lockScalingY','lockRotation','hasControls'];
function feSnapshot() {
  if (!FE.canvas || FE.hLock) return;
  FE.history = FE.history.slice(0, FE.hIndex + 1);
  FE.history.push(JSON.stringify(FE.canvas.toJSON(FE_KEEP)));
  if (FE.history.length > 60) FE.history.shift();
  FE.hIndex = FE.history.length - 1;
  FE._dirty = true;
  feUpdateHistBtns();
  feSaveState();
}
// попередження при спробі залишити сторінку з незбереженим фоном
// Відкладений запис налаштувань не має загубитись, якщо сторінку закривають.
window.addEventListener('pagehide', () => {
  if (!FE._setupSaveT) return;
  clearTimeout(FE._setupSaveT); FE._setupSaveT = null;
  try { feIdbSet(FE_SAVE_KEY, FE._draft); } catch (e) {}
});
window.addEventListener('beforeunload', e => {
  const ed = document.getElementById('fe-editor');
  if (FE.canvas && ed && ed.classList.contains('active') && feDirty()) {
    e.preventDefault(); e.returnValue = '';
  }
});
// Дочікуємось шрифтів і перемальовуємо: інакше на телефоні текст встигає
// намалюватись стандартним шрифтом ще до того, як завантажиться свій.
// Напис, у якому автор не ставив переносів, має лишатись одним рядком.
// Якщо на цьому пристрої шрифт ширший (наприклад, свій ще не завантажився
// при створенні макета), Textbox мовчки переносить слова — і напис «розʼїжджається».
function feUnwrapText(x) {
  if (!x || x.type !== 'textbox' || !x.text) return;
  // Ручні переноси більше не заважають: рахуємо найдовше слово по всіх рядках
  try {
    // Блок має вміщати НАЙДОВШЕ СЛОВО, а не весь напис. Раніше міряли текст
    // одним рядком і розсували блок під нього — тому напис, який людина
    // навмисно розбила на три рядки, після зміни шрифту слова витягувався
    // в один довгий рядок через увесь фон.
    x.initDimensions();
    const need = Math.ceil((x.dynamicMinWidth || 0) * 1.04) + 6;
    if (!need || need <= x.width) return;                    // і так вміщається

    // Розширення блоку зсуває напис. Замість формул міряємо реальні межі
    // до і після — так компенсація правильна за будь-якого повороту,
    // орієнтації та вирівнювання.
    const align = x.textAlign || 'left';
    x.setCoords();
    const b1 = x.getBoundingRect(true, true);

    x.set('width', need);
    x.initDimensions(); x.setCoords();
    const b2 = x.getBoundingRect(true, true);

    const edge = (r) => align === 'right'  ? r.left + r.width
                      : align === 'center' ? r.left + r.width / 2
                      : r.left;
    const dx = edge(b1) - edge(b2);
    if (Math.abs(dx) > 0.5) { x.set('left', (x.left || 0) + dx); x.setCoords(); }
  } catch (e) {}
}

function feEnsureFonts(cb) {
  const c = FE.canvas;
  if (!c || !document.fonts) { if (cb) cb(); return; }
  const fams = new Set();
  const scan = o => {
    if (!o) return;
    if (o.fontFamily) fams.add(String(o.fontFamily).split(',')[0].trim().replace(/["']/g, ''));
    if (o._objects) o._objects.forEach(scan);
  };
  c.getObjects().forEach(scan);
  const jobs = [...fams].map(f =>
    document.fonts.load(`16px "${f}"`).catch(() => {}));
  Promise.all(jobs).then(() => document.fonts.ready).then(() => {
    if (fabric.util.clearFabricFontCache) fabric.util.clearFabricFontCache();
    c.getObjects().forEach(o => {
      const fix = x => {
        if (x.initDimensions) x.initDimensions();
        feUnwrapText(x);
        x.dirty = true;              // інакше напис малюється зі старого кешу
        if (x._objects) x._objects.forEach(fix);
      };
      fix(o); o.setCoords();
    });
    c.requestRenderAll();
    // Safari інколи повідомляє про готовність шрифтів раніше, ніж застосовує їх,
    // а на телефоні файл шрифту може вантажитись довше за секунду.
    // Тому переміряємо кілька разів і додатково — коли браузер сам скаже,
    // що дозавантажив шрифти.
    [400, 1200, 2500, 4000].forEach(ms => setTimeout(() => feRemeasureText(), ms));
    if (document.fonts && !FE._fontsHooked) {
      FE._fontsHooked = true;
      try {
        document.fonts.addEventListener('loadingdone', () => feRemeasureText());
      } catch (e) {}
    }
    if (cb) cb();
  }).catch(() => { if (cb) cb(); });
}
// Перерахувати всі написи під уже завантажені шрифти
function feRemeasureText() {
  const c = FE.canvas; if (!c) return;
  if (fabric.util.clearFabricFontCache) fabric.util.clearFabricFontCache();
  c.getObjects().forEach(o => {
    const fix = x => {
      if (x.initDimensions) x.initDimensions();
      feUnwrapText(x);
      x.dirty = true;
      if (x._objects) x._objects.forEach(fix);
    };
    fix(o); o.setCoords();
  });
  c.requestRenderAll();
}
function feRestore(json) {
  FE.hLock = true;
  FE.canvas.loadFromJSON(json, () => {
    FE.canvas.getObjects().forEach(o => {
      if (o._feSafe) { o.selectable = false; o.evented = false; }
      if (o.type === 'image' && (o._feBr || o._feCt || o._feSa || o._feBl || o._feGray)) feApplyFilters(o);
      if (o._feKind === 'photoframe' && o.type === 'image') feFrameApply(o);
    });
    feFixFigures(); feEnsureFonts();
    // пунктир не потрапляє в JSON (excludeFromExport) — домальовуємо після відновлення
    if (!FE.canvas.getObjects().some(o => o._feSafe)) feDrawSafeZone();
    feSafeToFront(); feApplyFigsVis(); FE.canvas.requestRenderAll();
    FE.hLock = false; feUpdateHistBtns(); feRefreshPanel(); feRenderTplModal();
  });
}
// ---------- АВТОЗБЕРЕЖЕННЯ ----------
const FE_SAVE_KEY = 'fe_autosave';
function feSaveState() {
  if (!FE.canvas || FE.hLock) return;
  clearTimeout(FE._saveT);
  FE._saveT = setTimeout(() => {
    // Раз на кілька секунд оновлюємо й картинку рамки — щоб після
    // перезавантаження на першому екрані було видно саме поточну роботу,
    // а не стан на момент останнього «Зберегти».
    const ed = document.getElementById('fe-editor');
    // поки людина щось тримає, тягне повзунок чи друкує — не втручаємось
    const busy = FE._sliding || FE._typing || FE._panFrame ||
                 (FE.canvas && FE.canvas.getActiveObject());
    if (!busy && ed && ed.classList.contains('active') && Date.now() - (FE._pvAt || 0) > 6000) {
      FE._pvAt = Date.now();
      try { FE._bgPreview = feCapture(true, { format:'jpeg', quality:0.6, mult:0.4 }); } catch (e) {}
    }
    feStashLayout();
    // Лоток завантажених фото у сховище не пишемо: та сама картинка вже лежить
    // і в макеті, і у власному фоні — тобто займала місце тричі.
    const base = () => ({
      v: 2, size:FE.size, color:FE.color, orient:FE.orient,
      layouts: FE.layouts || {},
      bgSaved: FE.bgSaved || {},
      myTpl: FE.myTpl || [],
      uploads: feUploadsToSave(),
      figures: FE.figures,
      at: Date.now(),
    });

    // Пробуємо зберегти якнайповніше. Порядок поступок навмисний:
    // чернетка фону (layouts) найцінніша, тому її відкидаємо в останню чергу.
    const plans = [
      { name:'full', prep: d => d },
      { name:'no-uploads', prep: d => { d.uploads = []; return d; } },
      { name:'no-thumbs', prep: d => { (d.myTpl || []).forEach(t => { t.thumb = null; }); return d; } },
      { name:'this-frame-only', prep: d => {
          const key = FE.size + '_' + FE.orient;
          const keep = {};
          if (d.layouts && d.layouts[key]) keep[key] = d.layouts[key];
          d.layouts = keep; return d;
        } },
      { name:'no-my-tpl', prep: d => { (d.myTpl || []).forEach(t => { t.thumb = null; }); d.myTpl = []; return d; } },
      { name:'no-layouts', prep: d => { d.layouts = {}; d.myTpl = []; return d; } },
    ];

    // Спершу пробуємо велике сховище — туди чернетка з фото влазить цілком.
    const full = base();
    feIdbSet(FE_SAVE_KEY, full).then(() => {
      FE._draft = full;
      // Автозбереження мовчазне. Раніше кожні 15 секунд вискакувало
      // «Чернетку збережено» — воно нічого корисного не повідомляло.
      // Скарги лишаються тільки на реальні проблеми зі сховищем (нижче).
    }).catch(() => feSaveStateFallback(base, plans));
  }, 600);
}
// Запасний шлях для браузерів без IndexedDB: тиснемо дані під ліміт localStorage
function feSaveStateFallback(base, plans) {
    let done = null;
    for (const p of plans) {
      try {
        const d = p.prep(base());
        localStorage.setItem(FE_SAVE_KEY, JSON.stringify(d));
        FE._draft = d;
        done = p.name; break;
      } catch (e) {}
    }

    if (done === 'full' || done === 'no-uploads' || done === 'no-thumbs' || done === 'this-frame-only') return;
    // Далі — випадки, коли частина даних не влізла. Мовчати тут не можна:
    // саме через тихе відкидання макета фон «зникав» після перезавантаження.
    if (FE._quotaWarned) return;
    FE._quotaWarned = true;
    if (done === 'no-my-tpl') {
      feToast('⚠ Сховище повне: чернетку збережено, але список «Мої фони» — ні', 6000);
    } else if (done === 'no-layouts') {
      feToast('⚠ Сховище повне: фон не збережеться після перезавантаження. '
        + 'Збережіть його як «Мій фон» або зменшіть картинки.', 7000);
    } else {
      feToast('⚠ Не вдалося зберегти чернетку: сховище переповнене', 6000);
    }
}
// Стартовий діалог: продовжити роботу чи почати спочатку
function feAskStart() {
  const s = feSize();
  const info = document.getElementById('fe-start-info');
  if (info) {
    const wip = FE.figures.length ? 0 : feWipFigs().length;
    info.textContent = `Останнє: рамка ${s.name}, ` +
      `${FE.orient === 'landscape' ? 'горизонтальна' : 'вертикальна'}, ` +
      `фігурок — ${FE.figures.length + wip}` +
      (wip ? ' (не завершені)' : '');
  }
  feModal('fe-m-start');
}
function feStartAnswer(cont) {
  feModalClose();
  if (cont) {
    // Підхоплюємо незавершену фігурку: людина щойно погодилась продовжити,
    // тож немає сенсу змушувати її заново відкривати конструктор.
    if (!FE.figures.length) {
      const wip = feWipFigs();
      if (wip.length) {
        FE.figures = wip.slice(0, feMaxFigs());
        FE._frameOk = true;
        FE._maxStep = Math.max(FE._maxStep || 0, 2);
        feLDel(FE_WIP_KEY);
        feSaveSetup();
      }
    }
    feInitSetup(); feToast('Продовжуємо');
  }
  else feResetAll();
}

// Гарний діалог замість системного confirm
function feAskRestore() {
  return new Promise(resolve => {
    FE._askCb = resolve;
    feModal('fe-m-restore');
  });
}
function feRestoreAnswer(yes) {
  feModalClose();
  const cb = FE._askCb; FE._askCb = null;
  if (cb) cb(!!yes);
}
// ============================================================
// СХОВИЩЕ ЧЕРНЕТКИ
// ============================================================
// localStorage дає лише ~5 МБ на весь сайт — фон із вшитими картинками плюс
// фото туди просто не влазять. IndexedDB дає на порядки більше і зберігає
// дані як є, без перетворення на текст. Тому чернетка живе саме там,
// а localStorage лишається запасним варіантом для старих браузерів.
const FE_IDB_DB = 'minibrick', FE_IDB_STORE = 'draft';
function feIdb() {
  return new Promise((res, rej) => {
    if (!window.indexedDB) { rej(); return; }
    const r = indexedDB.open(FE_IDB_DB, 1);
    r.onupgradeneeded = () => {
      const db = r.result;
      if (!db.objectStoreNames.contains(FE_IDB_STORE)) db.createObjectStore(FE_IDB_STORE);
    };
    r.onsuccess = () => res(r.result);
    r.onerror = () => rej(r.error);
  });
}
function feIdbSet(key, val) {
  return feIdb().then(db => new Promise((res, rej) => {
    const tx = db.transaction(FE_IDB_STORE, 'readwrite');
    tx.objectStore(FE_IDB_STORE).put(val, key);
    tx.oncomplete = () => res(true);
    tx.onerror = () => rej(tx.error);
  }));
}
function feIdbGet(key) {
  return feIdb().then(db => new Promise((res, rej) => {
    const tx = db.transaction(FE_IDB_STORE, 'readonly');
    const q = tx.objectStore(FE_IDB_STORE).get(key);
    q.onsuccess = () => res(q.result || null);
    q.onerror = () => rej(q.error);
  }));
}
function feIdbDel(key) {
  return feIdb().then(db => new Promise(res => {
    const tx = db.transaction(FE_IDB_STORE, 'readwrite');
    tx.objectStore(FE_IDB_STORE).delete(key);
    tx.oncomplete = () => res(true);
    tx.onerror = () => res(false);
  })).catch(() => {});
}
// Одноразове читання при старті: спершу нове сховище, потім старе
function feDraftLoad() {
  return feIdbGet(FE_SAVE_KEY).then(v => {
    if (v) { FE._draft = v; return v; }
    let old = null;
    try { old = JSON.parse(localStorage.getItem(FE_SAVE_KEY) || 'null'); } catch (e) {}
    FE._draft = old;
    if (old) feIdbSet(FE_SAVE_KEY, old).catch(() => {});   // переносимо стару чернетку
    return old;
  }).catch(() => {
    try { FE._draft = JSON.parse(localStorage.getItem(FE_SAVE_KEY) || 'null'); } catch (e) { FE._draft = null; }
    return FE._draft;
  });
}
function feLoadState() {
  if (FE._draft !== undefined) return FE._draft;
  try { return JSON.parse(localStorage.getItem(FE_SAVE_KEY) || 'null'); } catch (e) { return null; }
}
function feClearState() {
  FE._draft = null;
  feLDel(FE_SAVE_KEY);
  feIdbDel(FE_SAVE_KEY);
}
function feToast(msg, ms) {
  let t = document.getElementById('fe-toast');
  if (!t) {
    t = document.createElement('div');
    t.id = 'fe-toast';
    document.body.appendChild(t);
  }
  // емодзі на початку лишаємо як є, інакше додаємо галочку
  t.textContent = /^[\p{Emoji_Presentation}☀-➿]/u.test(msg) ? msg : '✓ ' + msg;
  t.classList.add('show');
  clearTimeout(FE._toastT);
  FE._toastT = setTimeout(() => t.classList.remove('show'), ms || 1600);
}

function feUndo() {
  if (FE.hIndex > 0) { FE.hIndex--; FE.template = null; feRestore(FE.history[FE.hIndex]); }
}
function feRedo() {
  if (FE.hIndex < FE.history.length - 1) { FE.hIndex++; FE.template = null; feRestore(FE.history[FE.hIndex]); }
}
function feUpdateHistBtns() {
  const u = document.getElementById('fe-undo'), r = document.getElementById('fe-redo');
  if (u) u.disabled = FE.hIndex <= 0;
  if (r) r.disabled = FE.hIndex >= FE.history.length - 1;
}

// ============================================================
// ЗУМ
// ============================================================
function feApplyZoom() {
  const c = FE.canvas; if (!c) return;
  c.setZoom(FE.zoom);
  c.setDimensions({ width:FE.baseW * FE.zoom, height:FE.baseH * FE.zoom });
  c.calcOffset();
  c.requestRenderAll();
  const pct = Math.round(FE.zoom / FE.fitZoom * 100);
  const v = document.getElementById('fe-zoom-val');
  if (v) v.textContent = pct + '%';
  // плашка скидання — лише коли масштаб відрізняється від вписаного
  const rst = document.getElementById('fe-zoom-reset');
  const p = document.getElementById('fe-zoom-pct');
  if (p) p.textContent = pct + '%';
  // порівнюємо зі стартовим виглядом, а не з «вписати»
  const startPct = Math.round((FE.startZoom || FE.fitZoom) / FE.fitZoom * 100);
  if (rst) rst.classList.toggle('show', Math.abs(pct - startPct) > 3);
}
function feZoom(d) {
  FE.zoom = Math.min(FE.fitZoom * 3, Math.max(FE.fitZoom * 0.4, FE.zoom + FE.fitZoom * d / 100));
  feApplyZoom();
}
function feZoomFit() {
  const stage = document.getElementById('fe-stage');
  // на телефоні знизу — панель інструментів + контекстна смуга, зверху — бар
  const pad = window.innerWidth <= 768 ? 210 : 170;
  const fit = Math.min((stage.clientWidth - pad) / FE.baseW, (stage.clientHeight - pad) / FE.baseH);
  // на телефоні базовий вигляд ближчий — і саме він вважається 100%
  FE.fitZoom = fit * (window.innerWidth <= 860 ? feStartFactor() : 1);
  FE.zoom = FE.fitZoom; fePanReset(); feApplyZoom();
}
// Наскільки ближче показуємо полотно на телефоні під кожен розмір рамки
// Відсотки задані відносно попереднього базового вигляду (він був ×1.6),
// тож множимо на нього — і саме цей масштаб стає новим «100%».
const FE_ZOOM_BASE = 1.6;
const FE_START_ZOOM = {
  '12x12': { portrait:1.10, landscape:1.10 },
  '15x21': { portrait:1.15, landscape:1.25 },
  '21x21': { portrait:1.25, landscape:1.25 },
  '21x30': { portrait:1.15, landscape:1.25 },
  '30x40': { portrait:1.25, landscape:1.25 },
};
function feStartFactor() {
  const s = FE_START_ZOOM[FE.size] || { portrait:1.15, landscape:1.15 };
  const k = s[FE.orient === 'landscape' ? 'landscape' : 'portrait'] || 1.15;
  return FE_ZOOM_BASE * k;
}
// Стартовий вигляд: базовий масштаб, трохи вище центру
function feZoomStart() {
  feZoomFit();
  FE.startZoom = FE.fitZoom;
  if (window.innerWidth > 860) return;
  // Центруємо полотно у вільній смузі між верхнім баром і нижніми панелями,
  // щоб знизу нічого не з'їдалось більше, ніж зверху.
  const stage = document.getElementById('fe-stage');
  const TOP = 58, BOTTOM = 150;
  if (stage && stage.clientHeight) {
    const band = (TOP + (window.innerHeight - BOTTOM)) / 2;
    const center = stage.getBoundingClientRect().top + stage.clientHeight / 2;
    FE.panY = Math.round(band - center);
  } else {
    FE.panY = -Math.round(window.innerHeight * 0.06);
  }
  fePanApply();
}
// На телефоні поява/зникнення адресного рядка теж кидає resize —
// перераховуємо тільки коли реально змінилась ширина (поворот екрана).
let _feLastW = window.innerWidth;
window.addEventListener('resize', () => {
  const ed = document.getElementById('fe-editor');
  if (!FE.canvas || !ed || !ed.classList.contains('active')) { _feLastW = window.innerWidth; return; }
  if (window.innerWidth === _feLastW && window.innerWidth <= 860) return;
  _feLastW = window.innerWidth;
  feZoomStart();
});

// --- Зум двома пальцями (телефон) ---
(function fePinchZoom() {
  const ready = () => {
    const stage = document.getElementById('fe-stage');
    if (!stage) return setTimeout(ready, 200);
    let startDist = 0, startZoom = 1, mx = 0, my = 0, px = 0, py = 0;
    const dist = t => Math.hypot(
      t[0].clientX - t[1].clientX, t[0].clientY - t[1].clientY);
    const mid = t => ({ x:(t[0].clientX + t[1].clientX) / 2,
                        y:(t[0].clientY + t[1].clientY) / 2 });

    stage.addEventListener('touchstart', e => {
      if (e.touches.length !== 2) return;
      startDist = dist(e.touches); startZoom = FE.zoom;
      const m = mid(e.touches); mx = m.x; my = m.y;
      px = FE.panX || 0; py = FE.panY || 0;
      if (FE._panFrame) FE._panZoom0 = FE._panFrame._feZoom || 1;
    }, { passive:true });

    stage.addEventListener('touchmove', e => {
      if (e.touches.length !== 2 || !startDist) return;
      e.preventDefault();
      const k = dist(e.touches) / startDist;
      // у режимі рамки двома пальцями масштабуємо саме фото всередині
      if (FE._panFrame) {
        const o = FE._panFrame;
        o._feZoom = Math.min(3.2, Math.max(1, (FE._panZoom0 || 1) * k));
        feFrameApply(o);
        return;
      }
      FE.zoom = Math.min(FE.fitZoom * 3, Math.max(FE.fitZoom * 0.4, startZoom * k));
      // двома пальцями водночас і рухаємо полотно
      const m = mid(e.touches);
      FE.panX = px + (m.x - mx);
      FE.panY = py + (m.y - my);
      feApplyZoom(); fePanApply();
    }, { passive:false });

    stage.addEventListener('touchend', e => {
      if (e.touches.length < 2) startDist = 0;
    }, { passive:true });
  };
  ready();
})();

// --- Панорама сцени (тягнути фон) + зум колесом ---
(function feStageNav() {
  const ready = () => {
    const stage = document.getElementById('fe-stage');
    if (!stage) return setTimeout(ready, 200);
    let drag = false, sx = 0, sy = 0, ox = 0, oy = 0;

    stage.addEventListener('mousedown', e => {
      // тягнемо тільки за порожню зону навколо полотна
      if (e.target !== stage && e.target.id !== 'fe-canvas-wrap') return;
      drag = true; sx = e.clientX; sy = e.clientY;
      ox = FE.panX || 0; oy = FE.panY || 0;
      stage.style.cursor = 'grabbing';
    });
    window.addEventListener('mousemove', e => {
      if (!drag) return;
      FE.panX = ox + (e.clientX - sx);
      FE.panY = oy + (e.clientY - sy);
      fePanApply();
    });
    window.addEventListener('mouseup', () => { drag = false; stage.style.cursor = ''; });

    // Керування як в Illustrator: саме колесо гортає фон угору-вниз,
    // Ctrl — вліво-вправо, Alt — масштаб. Раніше колесо одразу міняло
    // масштаб, і прокрутити високу рамку було нічим.
    stage.addEventListener('wheel', e => {
      if (!FE.canvas) return;
      e.preventDefault();
      if (e.altKey) { feZoom(e.deltaY < 0 ? 8 : -8); return; }
      const d = e.deltaY || e.deltaX;
      if (e.ctrlKey || e.metaKey || e.shiftKey) FE.panX = (FE.panX || 0) - d;
      else                                     FE.panY = (FE.panY || 0) - d;
      fePanApply();
    }, { passive:false });
  };
  ready();
})();
function fePanApply() {
  const w = document.getElementById('fe-canvas-wrap');
  if (!w) return;
  const x = FE.panX || 0, y = FE.panY || 0;
  w.style.transform = (x || y) ? `translate(${x}px, ${y}px)` : '';
  // без цього fabric рахує кліки по старих координатах
  if (FE.canvas) FE.canvas.calcOffset();
}
function fePanReset() { FE.panX = 0; FE.panY = 0; fePanApply(); }

// ============================================================
// ПОДІЇ
// ============================================================
// ---- Напрямні вирівнювання (як у графічних редакторах) ----
const FE_SNAP = 7;   // відстань спрацювання, пікселів ЕКРАНА (не полотна)
// Найменший проміжок, який ще має сенс вирівнювати, у міліметрах друку
const FE_MIN_GAP_MM = 5;
// Кнопка-вимикач напрямних у контекстній смузі. Світиться, поки прилипання діє.
function feSnapBtn() {
  return '<button class="fe-ctx-btn ' + (FE._snapOff ? '' : 'main') + '"'
    + ' title="' + (FE._snapOff ? 'Увімкнути прилипання' : 'Вимкнути прилипання')
    + '" onclick="feSnapToggle()">🧲</button>';
}
// Поставити обране на спільну лінію з найближчим сусідом — по низу.
// На телефоні пальцем цього не досягти, а це найчастіша потреба:
// фігурки й тваринки різного зросту мають стояти на одній землі.
function feAlignBottom() {
  const c = FE.canvas, o = feAct() || FE._lockedSel;
  if (!c || !o || o._feSafe) return;
  o.setCoords();
  const b = o.getBoundingRect(true, true);
  const mine = b.top + b.height;
  let best = null;
  c.getObjects().forEach(x => {
    if (x === o || x._feSafe || x.visible === false) return;
    if (x._feKind === 'caption') return;        // підпис їде за фігуркою
    const r = x.getBoundingRect(true, true);
    const line = r.top + r.height;
    const d = Math.abs(line - mine);
    if (best === null || d < best.d) best = { d, line };
  });
  if (!best) { feToast('Немає з ким рівняти — на фоні лише цей обʼєкт'); return; }
  o.set('top', o.top + (best.line - mine));
  o.setCoords();
  feMoveCaptions();
  c.requestRenderAll();
  feSnapshot();
  feToast('Поставлено на одну лінію');
}
function feSnapToggle() {
  FE._snapOff = !FE._snapOff;
  FE._guides = null; FE._gaps = null;
  if (FE.canvas) FE.canvas.requestRenderAll();
  feRenderCtx();
  feSyncSnapBtn();
  feToast(FE._snapOff ? 'Прилипання вимкнено — ставте будь-де'
                      : 'Прилипання увімкнено — обʼєкти рівняються по сусідах');
}
// Магніт у верхній смузі (компʼютер). Світиться, поки прилипання діє.
function feSyncSnapBtn() {
  const b = document.getElementById('fe-snap-btn');
  if (!b) return;
  b.classList.toggle('on', !FE._snapOff);
  b.title = FE._snapOff ? 'Прилипання вимкнено — увімкнути'
                        : 'Прилипання увімкнено — вимкнути';
}
function feSnapGuides(t) {
  const c = FE.canvas; if (!c || !t) return;
  // Вимкнути прилипання можна двома шляхами: затиснути Alt (тимчасово)
  // або перемикачем у панелі точного розміщення — на телефоні клавіш немає.
  if (FE._noSnap || FE._snapOff) { FE._guides = null; FE._gaps = null; return; }
  t.setCoords();
  const b = t.getBoundingRect(true, true);
  const my = { l:b.left, c:b.left + b.width/2, r:b.left + b.width,
               t:b.top,  m:b.top + b.height/2, b:b.top + b.height };

  // Поріг тримаємо однаковим на екрані. Інакше при наближенні рамки
  // обʼєкт «примерзав» до лінії, а на телефоні прилипання майже не діяло.
  // Пальцем у 7 пікселів не влучити — палець і сам тремтить ширше. Тому на
  // дотику поріг удвічі більший, а нижній край ловиться ще раніше за решту:
  // саме по ньому рівняють фігурки з тваринками, і саме він має ловитись сам.
  const zoom = c.getZoom() || 1;
  // саме дотик, а не просто вузьке вікно: на компʼютері миша влучає точно
  const touch = feIsMobile() && (navigator.maxTouchPoints || 0) > 0;
  const snap  = FE_SNAP * (touch ? 2 : 1) / zoom;
  const snapB = snap * (touch ? 1.7 : 1.4);

  // Цілі — центр полотна, безпечна зона та інші обʼєкти. Поки тягнемо один
  // обʼєкт, решта не рухається, тож рахуємо їх ОДИН раз за перетягування.
  // Раніше межі всіх обʼєктів перераховувались на кожен рух миші — на
  // телефоні це й давало ривки.
  const T = feSnapTargets(t);

  // Прилипли — тримаємось лінії, доки не відійдемо вдвічі далі порога.
  // Без цього обʼєкт на межі то чіплявся, то зривався: курсор веде в один
  // бік, прилипання смикає назад — саме це й відчувалось як сіпання.
  const hold = (vals, held) => {
    if (held == null) return null;
    let d = null;
    vals.forEach(val => {
      const diff = held - val;
      if (Math.abs(diff) <= snap * 2 && (d === null || Math.abs(diff) < Math.abs(d))) d = diff;
    });
    return d === null ? null : { d, at:held };
  };
  // Один прохід: край обʼєкта проти ліній ТОГО САМОГО роду.
  // Раніше будь-який мій край ловився за будь-яку чужу лінію — низ фігурки
  // чіплявся за голову сусідньої, і воно постійно перескакувало.
  const pass = (pairs, lim) => {
    const max = lim || snap;
    let d = null, at = null;
    pairs.forEach(([val, list]) => list.forEach(g => {
      const diff = g - val;
      if (Math.abs(diff) <= max && (d === null || Math.abs(diff) < Math.abs(d))) { d = diff; at = g; }
    }));
    return d === null ? null : { d, at };
  };
  const first = (...tries) => { for (const r of tries) if (r) return r; return { d:null, at:null }; };

  const X = first(
    hold([my.l, my.c, my.r], FE._heldX),
    // ліве до лівого, центр до центру, праве до правого
    pass([[my.l, T.L], [my.c, T.C], [my.r, T.R]]),
    // центр полотна й безпечна зона — до будь-якого краю
    pass([[my.l, T.vAny], [my.c, T.vAny], [my.r, T.vAny]])
  );
  const Y = first(
    hold([my.b], FE._heldY),
    hold([my.t, my.m], FE._heldY),
    // НИЗ МАЄ ПЕРЕВАГУ: фігурки й тваринки стоять на спільній лінії,
    // і рівняти їх треба по ногах, а не по маківці — навіть якщо верх
    // випадково опинився ближче.
    pass([[my.b, T.B]], snapB),
    pass([[my.t, T.T], [my.m, T.M]]),
    pass([[my.t, T.hAny], [my.m, T.hAny], [my.b, T.hAny]])
  );
  FE._heldX = X.at; FE._heldY = Y.at;

  const guides = [];
  // Центр полотна показуємо окремим кольором і підписом: інакше не зрозуміло,
  // це просто край сусіда чи справді середина рамки.
  if (X.d !== null) {
    t.set('left', t.left + X.d);
    guides.push({ v:X.at, mid: Math.abs(X.at - FE.baseW / 2) < 0.5 });
  }
  if (Y.d !== null) {
    t.set('top', t.top + Y.d);
    guides.push({ h:Y.at, mid: Math.abs(Y.at - FE.baseH / 2) < 0.5 });
  }
  if (guides.length) t.setCoords();
  FE._guides = guides;
  feEqualGaps(t);
}
// Рівні проміжки. Коли обʼєкт стоїть між двома сусідами на однаковій
// відстані — показуємо це стрілками з розміром, як в Illustrator, і
// притягуємо рівно в середину.
function feEqualGaps(t) {
  FE._gaps = null;
  const c = FE.canvas; if (!c) return;
  const zoom = c.getZoom() || 1;
  const snap = FE_SNAP / zoom;
  // Проміжок у пів-сантиметра ще можна назвати відступом, а от 1–2 мм між
  // обʼєктами, що майже накладаються, — це не композиція, а шум. Рівняти по
  // ньому не треба: саме через це не виходило покласти серце на цифру —
  // його тягнуло вирівняти мікрозазор із сусідньою цифрою.
  const minGap = FE_MIN_GAP_MM * (FE.baseH / (feDims().hMm || 1));
  const b = t.getBoundingRect(true, true);

  const others = [];
  c.getObjects().forEach(o => {
    if (o === t || o._feSafe || o.visible === false) return;
    if (o._feKind === 'caption') return;          // підписи їдуть за фігурками
    others.push(o.getBoundingRect(true, true));
  });
  if (others.length < 2) return;

  const out = [];
  // --- по горизонталі: сусіди зліва й справа, що перетинаються по висоті ---
  const rowMates = others.filter(r => r.top < b.top + b.height && r.top + r.height > b.top);
  const left  = rowMates.filter(r => r.left + r.width <= b.left + 1)
                        .sort((a, z) => (z.left + z.width) - (a.left + a.width))[0];
  const right = rowMates.filter(r => r.left >= b.left + b.width - 1)
                        .sort((a, z) => a.left - z.left)[0];
  if (left && right) {
    const gl = b.left - (left.left + left.width);
    const gr = right.left - (b.left + b.width);
    // Поріг рахуємо по тому, наскільки треба посунути обʼєкт, — так само,
    // як у звичайному прилипанні. Різниця проміжків удвічі більша за зсув.
    const shift = (gr - gl) / 2;
    if (gl > minGap && gr > minGap && Math.abs(shift) <= snap) {
      t.set('left', t.left + shift); t.setCoords();
      const nb = t.getBoundingRect(true, true);
      const gap = (gl + gr) / 2;
      const y = Math.max(b.top, Math.max(left.top, right.top)) +
                Math.min(b.height, Math.min(left.height, right.height)) / 2;
      out.push({ x1:left.left + left.width, x2:nb.left, y, size:gap });
      out.push({ x1:nb.left + nb.width, x2:right.left, y, size:gap });
    }
  }
  // --- такий самий проміжок, як у сусідньої пари ---
  // Приклад: стоять «фігурка — тваринка» з проміжком 12 мм. Тягнемо третю
  // праворуч від тваринки — вона чіпляється рівно на ті самі 12 мм, і видно
  // обидві відстані. Працює й тоді, коли з другого боку взагалі нікого немає.
  if (!out.length) {
    const rowSorted = rowMates.slice().sort((a, z) => a.left - z.left);
    const pairH = (near, far, side) => {
      if (!near || !far) return false;
      const gPrev = side === 'left'
        ? near.left - (far.left + far.width)      // проміжок між двома сусідами
        : far.left - (near.left + near.width);
      if (gPrev <= minGap) return false;   // мікрозазор — не орієнтир
      const mine = side === 'left'
        ? b.left - (near.left + near.width)
        : near.left - (b.left + b.width);
      const shift = side === 'left' ? gPrev - mine : mine - gPrev;
      if (Math.abs(shift) > snap) return false;
      t.set('left', t.left + shift); t.setCoords();
      const nb = t.getBoundingRect(true, true);
      const y = Math.max(b.top, near.top) + Math.min(b.height, near.height) / 2;
      if (side === 'left') {
        out.push({ x1:far.left + far.width, x2:near.left, y, size:gPrev });
        out.push({ x1:near.left + near.width, x2:nb.left, y, size:gPrev });
      } else {
        out.push({ x1:nb.left + nb.width, x2:near.left, y, size:gPrev });
        out.push({ x1:near.left + near.width, x2:far.left, y, size:gPrev });
      }
      return true;
    };
    if (left) {
      const i = rowSorted.indexOf(left);
      pairH(left, rowSorted[i - 1], 'left');
    }
    if (!out.length && right) {
      const i = rowSorted.indexOf(right);
      pairH(right, rowSorted[i + 1], 'right');
    }
  }
  // --- по вертикалі: сусіди згори й знизу, що перетинаються по ширині ---
  const colMates = others.filter(r => r.left < b.left + b.width && r.left + r.width > b.left);
  const up   = colMates.filter(r => r.top + r.height <= b.top + 1)
                       .sort((a, z) => (z.top + z.height) - (a.top + a.height))[0];
  const down = colMates.filter(r => r.top >= b.top + b.height - 1)
                       .sort((a, z) => a.top - z.top)[0];
  if (up && down) {
    const gu = b.top - (up.top + up.height);
    const gd = down.top - (b.top + b.height);
    const shift = (gd - gu) / 2;
    if (gu > minGap && gd > minGap && Math.abs(shift) <= snap) {
      t.set('top', t.top + shift); t.setCoords();
      const nb = t.getBoundingRect(true, true);
      const gap = (gu + gd) / 2;
      const x = Math.max(b.left, Math.max(up.left, down.left)) +
                Math.min(b.width, Math.min(up.width, down.width)) / 2;
      out.push({ y1:up.top + up.height, y2:nb.top, x, size:gap });
      out.push({ y1:nb.top + nb.height, y2:down.top, x, size:gap });
    }
  }
  // те саме по вертикалі
  if (!out.some(g => g.y1 != null)) {
    const colSorted = colMates.slice().sort((a, z) => a.top - z.top);
    const pairV = (near, far, side) => {
      if (!near || !far) return false;
      const gPrev = side === 'up'
        ? near.top - (far.top + far.height)
        : far.top - (near.top + near.height);
      if (gPrev <= minGap) return false;   // мікрозазор — не орієнтир
      const mine = side === 'up'
        ? b.top - (near.top + near.height)
        : near.top - (b.top + b.height);
      const shift = side === 'up' ? gPrev - mine : mine - gPrev;
      if (Math.abs(shift) > snap) return false;
      t.set('top', t.top + shift); t.setCoords();
      const nb = t.getBoundingRect(true, true);
      const x = Math.max(b.left, near.left) + Math.min(b.width, near.width) / 2;
      if (side === 'up') {
        out.push({ y1:far.top + far.height, y2:near.top, x, size:gPrev });
        out.push({ y1:near.top + near.height, y2:nb.top, x, size:gPrev });
      } else {
        out.push({ y1:nb.top + nb.height, y2:near.top, x, size:gPrev });
        out.push({ y1:near.top + near.height, y2:far.top, x, size:gPrev });
      }
      return true;
    };
    if (up) {
      const i = colSorted.indexOf(up);
      pairV(up, colSorted[i - 1], 'up');
    }
    if (!out.some(g => g.y1 != null) && down) {
      const i = colSorted.indexOf(down);
      pairV(down, colSorted[i + 1], 'down');
    }
  }
  if (out.length) FE._gaps = out;
}
// Пікселі полотна → міліметри на друці
function fePxToMm(px) {
  const d = feDims();
  return FE.baseH ? px * (d.hMm / FE.baseH) : 0;
}
// Лінії, до яких прилипаємо. Живуть рівно одне перетягування.
function feSnapTargets(t) {
  if (FE._snapT) return FE._snapT;
  const c = FE.canvas;
  const i = feInsetPx();
  // Лінії розкладені по ролях: низ окремо від верху й середини. Це потрібно,
  // щоб рівняти «низ до низу», а не низ однієї фігурки до голови іншої.
  const T = { L:[], C:[], R:[], T:[], M:[], B:[],
              vAny:[FE.baseW/2, i.x, FE.baseW - i.x],
              hAny:[FE.baseH/2, i.y, FE.baseH - i.y] };
  c.getObjects().forEach(o => {
    if (o === t || o._feSafe || o.visible === false) return;
    // Підпис їде за своєю фігуркою — як окрема ціль він тільки заважає:
    // його межі стоять упритул до фігурки й дають зайві лінії поруч.
    if (o._feKind === 'caption' && o._feFigId) return;
    const r = o.getBoundingRect(true, true);
    T.L.push(r.left); T.C.push(r.left + r.width/2); T.R.push(r.left + r.width);
    T.T.push(r.top);  T.M.push(r.top + r.height/2); T.B.push(r.top + r.height);
  });
  FE._snapT = T;
  return FE._snapT;
}
function feSnapForget() {
  FE._snapT = null; FE._heldX = null; FE._heldY = null; FE._gaps = null; FE._colT = null;
}

// ============================================================
// ФІЗИЧНІ ДЕТАЛІ НЕ НАКЛАДАЮТЬСЯ
// ============================================================
// Фігурки, тваринки, діти й готові фігурки клеяться на фон окремими
// деталями — накластися одна на одну вони просто не можуть. Люди ж
// присувають їх упритул і далі, думаючи, що так вміститься більше,
// і малюють те, чого не отримають.
//
// Тому не забороняємо рух, а ВИШТОВХУЄМО: рахуємо, наскільки деталь
// зайшла в сусіда, і повертаємо рівно на цю глибину — по тій осі, де
// зайшла менше. Тоді вона ковзає вздовж сусіда, як по стінці, а не
// смикається на місці (саме через смикання довелось колись відкотити
// перше прилипання).
const FE_TOUCH_MM = 1.5;   // на стільки дозволяємо зайти — щоб можна було ставити впритул
const FE_COL_KINDS = ['figure', 'item'];

// Межі сусідів рахуємо ОДИН раз за перетягування: поки тягнемо одну
// деталь, решта стоїть на місці.
function feColTargets(t) {
  if (FE._colT) return FE._colT;
  FE._colT = FE.canvas.getObjects()
    .filter(o => o !== t && o.visible !== false && FE_COL_KINDS.includes(o._feKind))
    .map(o => o.getBoundingRect(true, true));
  return FE._colT;
}
function feCollide(t) {
  const c = FE.canvas;
  if (!c || !t || !FE_COL_KINDS.includes(t._feKind)) return;
  const others = feColTargets(t);
  if (!others.length) return;
  const tol = FE_TOUCH_MM * (FE.baseH / (feDims().hMm || 1));

  // Кілька проходів: виштовхнули з одного сусіда — могли впертись у другого.
  for (let pass = 0; pass < 3; pass++) {
    t.setCoords();
    const b = t.getBoundingRect(true, true);
    let hit = null, worst = 0;
    for (const r of others) {
      const ox = Math.min(b.left + b.width, r.left + r.width) - Math.max(b.left, r.left) - tol;
      const oy = Math.min(b.top + b.height, r.top + r.height) - Math.max(b.top, r.top) - tol;
      if (ox <= 0 || oy <= 0) continue;              // не перетинаються
      const depth = Math.min(ox, oy);
      if (depth > worst) { worst = depth; hit = { r, ox, oy, b }; }
    }
    if (!hit) return;
    const { r, ox, oy, b: bb } = hit;
    // Виходимо по тій осі, де зайшли менше — так шлях назовні найкоротший
    if (ox < oy) {
      const mine = bb.left + bb.width / 2, his = r.left + r.width / 2;
      t.set('left', t.left + (mine < his ? -ox : ox));
    } else {
      const mine = bb.top + bb.height / 2, his = r.top + r.height / 2;
      t.set('top', t.top + (mine < his ? -oy : oy));
    }
  }
  t.setCoords();
}

// Ловимо помилки панелі, щоб вони не ламали роботу полотна
function feSafe(fn) {
  return function () {
    try { return fn.apply(this, arguments); }
    catch (err) {
      console.error('[frame-editor]', err);
      const b = document.getElementById('fe-panel-body');
      if (b) b.innerHTML = `<p style="color:#FF4757;font-size:12px;line-height:1.6">
        Помилка панелі:<br>${(err && err.message) || err}</p>`;
    }
  };
}
function feBindCanvas() {
  const c = FE.canvas;
  ['object:modified','object:added','object:removed'].forEach(ev =>
    c.on(ev, e => {
      if (!e.target || !e.target._feSafe) {
        // Перевіряємо лише те, що людина зробила руками. Щойно доданий обʼєкт
        // ще не встиг набути остаточних розмірів — фото в рамці, наприклад,
        // обрізається одразу після додавання.
        if (ev === 'object:modified') {
          if (e.target && feBakeTextScale(e.target)) { c.requestRenderAll(); feRefreshPanel(); }
          if (e.target && feKeepOnCanvas(e.target)) {
            c.requestRenderAll();
            feToast('Обʼєкт повернуто на фон');
          }
          feSafeWarn(e.target);
        }
        feSnapshot();
      }
      if (e.target && e.target._feKind === 'accessory') { FE._bgAcc = feBgAccCount(); feUpdatePrice(); }
      if (e.target && e.target._feKind === 'item') { FE._bgItems = feBgItemIds(); feUpdatePrice(); }
    }));
  // На компʼютері виділення одразу відкриває налаштування (як було),
  // на телефоні — лише оновлює контекстну смугу.
  const onSel = () => {
    feFramePanOff();
    // взяли інший обʼєкт — старе виділення всередині напису більше не діє
    if (!FE._txtSel || FE._txtSel.o !== c.getActiveObject()) feForgetTextSel();
    // у груповому виділенні з фігуркою масштабування теж заборонено —
    // інакше через групу можна було обійти заборону для однієї фігурки
    const a = c.getActiveObject();
    if (a && a.type === 'activeSelection') {
      // ні фігурки, ні зафіксовані не потрапляють у групове виділення:
      // інакше групу можна крутити й масштабувати, а з нею і їх
      const drop = a.getObjects().filter(o => o._feLocked || o._feKind === 'figure');
      if (drop.length) {
        drop.forEach(o => a.removeWithUpdate(o));
        if (a.getObjects().length < 2) {
          const rest = a.getObjects()[0];
          c.discardActiveObject();
          if (rest) c.setActiveObject(rest);
          c.requestRenderAll();
          return;
        }
      }
      // Аксесуари й предмети друкуються в натуральну величину, тому
      // розтягувати їх не можна. Поодинці це заборонено, але через групове
      // виділення заборону обходили — тепер група з таким обʼєктом
      // лише пересувається, без маркерів масштабу й повороту.
      const realSize = a.getObjects().some(o => o._feKind === 'accessory' || o._feKind === 'item');
      a.set({ hasControls:true, hasBorders:true,
              lockScalingX:realSize, lockScalingY:realSize,
              lockUniScaling:realSize, lockRotation:realSize });
      if (realSize && a.setControlsVisibility) {
        a.setControlsVisibility({ tl:false, tr:false, bl:false, br:false,
                                  ml:false, mr:false, mt:false, mb:false, mtr:false });
      }
      c.requestRenderAll();
    }
    if (!feIsMobile()) { feOpenProps(); return; }
    feRenderCtx();
    if (feActiveTool === 'props') feRefreshPanel();
  };
  // виділили інший шматок напису — панель має показати його властивості
  // Дотик до полотна повертає звичайний режим «зміни на весь напис».
  // Робота з панеллю полотна не торкається, тому виділення там живе.
  // Якщо ж людина одразу почне виділяти слово — подія нижче запише його наново.
  c.on('mouse:down', feSafe(() => feForgetTextSel()));
  c.on('text:selection:changed', feSafe(e => {
    const t = e && e.target;
    if (t && t.selectionEnd > t.selectionStart) FE._txtSel = { o:t, start:t.selectionStart, end:t.selectionEnd };
    if (feActiveTool !== 'props') return;
    clearTimeout(FE._selPanelT);
    FE._selPanelT = setTimeout(() => feRefreshPanel(), 120);
  }));
  c.on('selection:created', feSafe(onSel));
  c.on('selection:updated', feSafe(onSel));
  c.on('selection:cleared', feSafe(() => {
    feForgetTextSel();
    // перебудова напису теж знімає виділення — панель при цьому не чіпаємо
    if (FE._rebuilding) return;
    feFramePanOff(); feRenderCtx(); feCloseProps();
  }));
  c.on('mouse:down', feSafe(e => {
    if (FE._pickCb) return;                       // піпетка має власні обробники
    feCtxMenuClose();
    FE._lockedSel = null;
    // початок перетягування фото всередині рамки
    if (FE._panFrame) {
      const p = c.getPointer(e.e);
      FE._panFrom = { x:p.x, y:p.y,
        ox:FE._panFrame._feOffX || 0, oy:FE._panFrame._feOffY || 0 };
    }
  }));
  c.on('mouse:move', feSafe(e => {
    if (FE._pickCb) return;
    if (!FE._panFrame || !FE._panFrom) return;
    const p = c.getPointer(e.e);
    const o = FE._panFrame;
    // рухаємо у бік пальця: обрізку зсуваємо у протилежний
    o._feOffX = FE._panFrom.ox + (p.x - FE._panFrom.x);
    o._feOffY = FE._panFrom.oy + (p.y - FE._panFrom.y);
    feFrameApply(o);
  }));
  c.on('mouse:up', feSafe(() => {
    if (FE._panFrom) { FE._panFrom = null; feSnapshot(); feRefreshPanel(); }
  }));
  // перетягнули рамку цілком — оновлюємо якір вікна
  c.on('object:moving', feSafe(e => { if (!FE._panFrame) feFrameSyncAnchor(e.target); }));
  // тягнемо обʼєкт на полотні — числа в панелі оновлюються наживо
  c.on('object:scaling', feSafe(e => feSyncPanelNums(e && e.target)));
  c.on('object:rotating', feSafe(e => feSyncPanelNums(e && e.target)));
  c.on('object:modified', feSafe(e => {
    if (feActiveTool === 'props') feRefreshPanel();
    if (e && e.target) feCheckOutside(e.target);
    // Пересунули фігурку АБО предмет — перераховуємо підписи. При спільній
    // лінії зсув однієї міняє положення всіх, тому перераховуємо разом.
    const mk = e && e.target && e.target._feKind;
    // Відпустили — тепер можна перерахувати ряди й поставити всі підписи
    FE._capDrag = null;
    feSnapForget();   // наступне перетягування збере лінії прилипання заново
    if ((mk === 'figure' || mk === 'item') && feCapS().moveWith) feMoveCaptions();
    const t0 = e && e.target;
    // «живі кути»: у прямокутника переводимо масштаб у розмір, щоб радіус
    // заокруглення не розтягувався разом із фігурою (як в Illustrator)
    if (t0 && t0.type === 'rect' && (t0.scaleX !== 1 || t0.scaleY !== 1)) {
      t0.set({ width: Math.max(2, t0.width * t0.scaleX),
               height:Math.max(2, t0.height * t0.scaleY),
               scaleX:1, scaleY:1 });
      const lim = Math.min(t0.width, t0.height) / 2;
      if ((t0.rx || 0) > lim) t0.set({ rx:lim, ry:lim });
      t0.setCoords();
    }
    const t = e && e.target;
    if (t && t._feKind === 'photoframe' && t.type === 'image') {
      t._feFrameAngle = t.angle || 0;
      // потягнули за маркер — це новий розмір самої рамки
      t._feFW = Math.max(20, t.width  * t.scaleX);
      t._feFH = Math.max(20, t.height * t.scaleY);
      t._feAncX = t.left; t._feAncY = t.top;
      feFrameApply(t);
    }
  }));
  // підпис їде разом із фігуркою — без перебудови, тому плавно
  c.on('object:moving', feSafe(e => {
    if (!e || !e.target) return;
    feSnapGuides(e.target);
    feCollide(e.target);      // після прилипання: впирання має бути сильнішим
    const k = e.target._feKind;
    if ((k !== 'figure' && k !== 'item') || !feCapS().moveWith) return;
    // Ряди рахуємо ОДИН раз на початку перетягування й далі лише пересуваємо
    // підпис тієї фігурки, яку тягнуть. Решта стане на місце, коли відпустять.
    // Поки тягнуть — підпис просто їде за фігуркою: ніяких рядів і
    // перерахунків, тому рух лишається плавним. Вирівняється, коли відпустять.
    if (!FE._capDrag) FE._capDrag = { s:feCapS(), rows:{} };
    feMoveCaptions(FE._capDrag, e.target);
  }));
  c.on('mouse:up', feSafe(() => {
    FE._guides = null; FE._gaps = null; FE._capDrag = null;
    feSnapForget(); FE._heldX = null; FE._heldY = null;
    c.requestRenderAll();
  }));
  // під час набору тексту зменшуємо полотно, щоб клавіатура його не закривала
  c.on('text:editing:entered', feSafe(e => {
    const t = e && e.target;
    if (t && t.hiddenTextarea) {
      t.hiddenTextarea.style.fontSize = '16px';
      // запасний шлях: поле втратило фокус — клавіатури більше немає
      t.hiddenTextarea.addEventListener('blur',
        () => setTimeout(() => feKeyboardFit(false), 60), { once:true });
    }
    feKeyboardFit(true);
  }));
  c.on('text:editing:exited', feSafe(() => feKeyboardFit(false)));
  // друкують просто на полотні — тримаємо збережений стан і панель у курсі
  c.on('text:changed', feSafe(e => {
    const t = e && e.target; if (!t) return;
    feForgetTextSel();
    if (t._feT) t._feT.text = t.text;
    feUpdateFontSample(t.text, 'Ваш текст');
    const fld = document.getElementById('fe-p-text');
    if (fld && document.activeElement !== fld) fld.value = t.text || '';
  }));
  // малюємо напрямні поверх полотна
  c.on('after:render', () => {
    const hasG = FE._guides && FE._guides.length;
    const hasP = FE._gaps && FE._gaps.length;
    if (!hasG && !hasP) return;
    const ctx = c.contextContainer;
    const z = c.getZoom();
    ctx.save();
    if (hasG) FE._guides.forEach(g => {
      // центр полотна — рожевим і з підписом, решта — звичним золотим
      ctx.strokeStyle = g.mid ? '#FF3D8B' : '#EDD05C';
      ctx.lineWidth = 1;
      ctx.setLineDash(g.mid ? [] : [5, 4]);
      ctx.beginPath();
      if (g.v != null) { ctx.moveTo(g.v * z, 0); ctx.lineTo(g.v * z, FE.baseH * z); }
      else { ctx.moveTo(0, g.h * z); ctx.lineTo(FE.baseW * z, g.h * z); }
      ctx.stroke();
      if (!g.mid) return;
      ctx.setLineDash([]);
      ctx.fillStyle = '#FF3D8B';
      ctx.font = '600 11px Inter, sans-serif';
      if (g.v != null) ctx.fillText('центр', g.v * z + 5, 14);
      else             ctx.fillText('центр', 5, g.h * z - 5);
    });
    if (hasP) {
      ctx.setLineDash([]);
      ctx.strokeStyle = '#FF3D8B';
      ctx.fillStyle = '#FF3D8B';
      ctx.lineWidth = 1;
      ctx.font = '600 11px Inter, sans-serif';
      ctx.textAlign = 'center';
      FE._gaps.forEach(g => {
        const txt = fePxToMm(g.size).toFixed(1) + ' мм';
        ctx.beginPath();
        if (g.x1 != null) {
          const y = g.y * z;
          ctx.moveTo(g.x1 * z, y); ctx.lineTo(g.x2 * z, y);
          // засічки на кінцях, щоб було видно, звідки й доки міряємо
          ctx.moveTo(g.x1 * z, y - 5); ctx.lineTo(g.x1 * z, y + 5);
          ctx.moveTo(g.x2 * z, y - 5); ctx.lineTo(g.x2 * z, y + 5);
          ctx.stroke();
          ctx.fillText(txt, (g.x1 + g.x2) / 2 * z, y - 8);
        } else {
          const x = g.x * z;
          ctx.moveTo(x, g.y1 * z); ctx.lineTo(x, g.y2 * z);
          ctx.moveTo(x - 5, g.y1 * z); ctx.lineTo(x + 5, g.y1 * z);
          ctx.moveTo(x - 5, g.y2 * z); ctx.lineTo(x + 5, g.y2 * z);
          ctx.stroke();
          ctx.fillText(txt, x, (g.y1 + g.y2) / 2 * z - 4);
        }
      });
    }
    ctx.restore();
  });
}

// Alt затиснуто — прилипання не заважає ставити точно
document.addEventListener('keydown', e => { if (e.altKey) FE._noSnap = true; }, true);
document.addEventListener('keyup',   e => { if (!e.altKey) FE._noSnap = false; }, true);
window.addEventListener('blur', () => { FE._noSnap = false; });

document.addEventListener('keydown', e => {
  const ed = document.getElementById('fe-editor');
  if (!FE.canvas || !ed || !ed.classList.contains('active')) return;

  const tag = (e.target.tagName || '').toLowerCase();
  const inField = tag === 'input' || tag === 'textarea' || tag === 'select';
  const ctrl = e.ctrlKey || e.metaKey;
  // e.code не залежить від розкладки: Ctrl+Z працює й на укр/рос клавіатурі
  const K = e.code;

  // Undo/Redo — навіть коли фокус у панелі (крім набору тексту)
  const typing = inField && (tag === 'textarea' || (e.target.type || '') === 'text');
  if (ctrl && !typing && (K === 'KeyZ' || K === 'KeyY')) {
    e.preventDefault();
    (K === 'KeyZ' && !e.shiftKey) ? feUndo() : feRedo();
    return;
  }
  if (inField) return;

  const c = FE.canvas, o = c.getActiveObject();

  // ? — показати підказку
  if (!ctrl && (e.key === '?' || (e.shiftKey && K === 'Slash'))) { feModal('fe-m-keys'); return; }

  if (ctrl && K === 'KeyS') { e.preventDefault(); feDone(); return; }
  if (ctrl && K === 'KeyA') { e.preventDefault();
    c.discardActiveObject();
    c.setActiveObject(new fabric.ActiveSelection(c.getObjects().filter(x => !x._feSafe), { canvas:c }));
    c.requestRenderAll(); return; }
  if (ctrl && K === 'KeyC' && o) {
    if (feNoCopy(o)) { feToast('Фігурки й предмети додаються на першому екрані'); return; }
    o.clone(cl => FE.clipboard = cl, FE_KEEP); return; }
  if (ctrl && K === 'KeyX' && o) { e.preventDefault();
    if (feNoCopy(o)) { feToast('Фігурки й предмети додаються на першому екрані'); return; }
    o.clone(cl => { FE.clipboard = cl; feDeleteActive(); }, FE_KEEP); return; }
  if (ctrl && K === 'KeyV' && FE.clipboard) { e.preventDefault(); fePaste(); return; }
  if (ctrl && K === 'KeyD' && o) { e.preventDefault(); feDuplicate(); return; }
  if (ctrl && K === 'KeyG') { e.preventDefault(); e.shiftKey ? feUngroup() : feGroup(); return; }
  if (ctrl && K === 'KeyL' && o) { e.preventDefault(); feToggleLock(); return; }
  if (ctrl && K === 'BracketRight' && o) { e.preventDefault(); feObjLayer(1); return; }
  if (ctrl && K === 'BracketLeft'  && o) { e.preventDefault(); feObjLayer(-1); return; }

  if (K === 'Delete' || K === 'Backspace') { if (o) { e.preventDefault(); feDeleteActive(); } return; }
  if (K === 'Escape') {
    if (document.querySelector('.fe-modal-bg.open')) { feModalClose(); return; }
    c.discardActiveObject(); c.requestRenderAll(); return;
  }

  const step = e.shiftKey ? 10 : 1;
  const map = { ArrowLeft:['left',-step], ArrowRight:['left',step],
                ArrowUp:['top',-step],   ArrowDown:['top',step] };
  if (map[K] && o) { e.preventDefault();
    o.set(map[K][0], o[map[K][0]] + map[K][1]); o.setCoords(); c.requestRenderAll(); feSnapshot(); }
});
// ---- Групування ----
function feGroup() {
  const c = feC(), a = c.getActiveObject();
  if (!a || a.type !== 'activeSelection') { feToast('Виділіть кілька обʼєктів'); return; }
  const g = a.toGroup();
  g._feKind = 'group'; g._feName = 'Група';
  c.requestRenderAll(); feSnapshot(); feToast('Згруповано');
}
function feUngroup() {
  const c = feC(), a = c.getActiveObject();
  if (!a || a.type !== 'group') { feToast('Оберіть групу'); return; }
  a.toActiveSelection();
  c.requestRenderAll(); feSnapshot(); feToast('Розгруповано');
}
// ---- Замок: обʼєкт лишається видимим, але не рухається ----
// Фігурки, аксесуари й предмети друкуються у сталому розмірі, тому
// розтягувати їх не можна навіть після зняття замка. Раніше зняття
// повертало маркери масштабу всім підряд — і їх можна було розтягнути.
function feApplyKindLocks(o) {
  if (!o) return false;
  const kind = o._feKind;
  if (kind !== 'figure' && kind !== 'accessory' && kind !== 'item') return false;
  // Сталим лишається розмір, а не поворот: аксесуар і предмет крутити можна.
  o.set({ lockScalingX:true, lockScalingY:true, lockUniScaling:true });
  if (kind === 'figure') o.set({ lockRotation:true, hasControls:false, hasBorders:false });
  o.setCoords();
  return true;
}
function feToggleLock(target) {
  const o = target || feAct() || FE._lockedSel; if (!o) return;
  const lock = !o._feLocked;
  // залишається обираним — щоб було видно пунктирну рамку й смугу дій,
  // але не рухається, не масштабується й не обертається
  // Замкнений лишається клікабельним — щоб замок знімався одним дотиком.
  // З групового виділення його прибираємо окремо (див. onSel).
  o.set({ lockMovementX:lock, lockMovementY:lock,
          lockScalingX:lock, lockScalingY:lock, lockRotation:lock,
          hasControls:!lock, selectable:true, evented:true, _feLocked:lock,
          borderColor: lock ? '#8A93A6' : '#EDD05C',
          borderDashArray: lock ? [6, 4] : null,
          hoverCursor: lock ? 'default' : 'move' });
  if (!lock) feApplyKindLocks(o);   // сталий розмір лишається сталим
  const c = feC();
  // Виділення НЕ знімаємо: інакше на компʼютері закривалась панель, а разом
  // із нею й кнопка «Зняти замок» — доводилось клацати повз обʼєкт і назад.
  // Обʼєкт лишається обраним, але не рухається: цим опікуються замки вище.
  FE._lockedSel = lock ? o : null;
  if (lock && c.getActiveObject() !== o) c.setActiveObject(o);
  c.requestRenderAll(); feSnapshot(); feRefreshPanel(); feRenderCtx();
  feToast(lock ? 'Обʼєкт зафіксовано' : 'Замок знято');
}
// Клік по зафіксованому — пояснюємо, як його розблокувати
function feLockedNotice(o) {
  if (!o || !o._feLocked) return false;
  feToast('Обʼєкт зафіксований — зніміть замок у вкладці «Шари», щоб редагувати', 3200);
  return true;
}
function fePaste() {
  const c = feC();
  // запобіжник на випадок, якщо в буфері щось лишилось із давнішої версії
  if (feNoCopy(FE.clipboard)) { FE.clipboard = null; return; }
  FE.clipboard.clone(cl => {
    c.discardActiveObject();
    cl.set({ left:cl.left + 24, top:cl.top + 24, evented:true });
    if (cl.type === 'activeSelection') { cl.canvas = c; cl.forEachObject(o => c.add(o)); cl.setCoords(); }
    else c.add(cl);
    c.setActiveObject(cl); feSafeToFront(); c.requestRenderAll();
    feFixFigures();                    // копії аксесуарів теж не розтягуються
    feSnapshot(); feUpdatePrice();     // копія аксесуара — це ще один аксесуар у рахунку
  }, FE_KEEP);
}

// ============================================================
// МОДАЛКИ
// ============================================================
function feModal(id) {
  document.querySelectorAll('.fe-modal-bg').forEach(m => m.classList.remove('open'));
  document.getElementById(id).classList.add('open');
}
function feModalClose() { document.querySelectorAll('.fe-modal-bg').forEach(m => m.classList.remove('open')); }

// ============================================================
// ГОТОВО
// ============================================================
// Знімок полотна. hideFigs=true — без фігурок і підписів (для превʼю на 1-му екрані)
const feIsIOS = () => /iPad|iPhone|iPod/.test(navigator.userAgent) ||
  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
// Композиція, вставлена в рамку обраного кольору — рівно те, що людина бачить
// у превʼю редактора. Менеджеру одразу видно, якого кольору рамку замовили,
// без заглядання в специфікацію.
function feFramedShot(src) {
  return new Promise((resolve, reject) => {
    const im = new Image();
    im.onload = () => {
      try {
        const col = feColor();
        // Знімок зроблено на всю рамку — те, що заходить під бортик, у превʼю
        // видно не має бути. Тому спершу обрізаємо по видимій зоні.
        const f = feInsetFrac();
        const sx = im.width * f.x, sy = im.height * f.y;
        const sw = im.width - sx * 2, sh = im.height - sy * 2;
        // бортик — 5% від довшої сторони, як у превʼю редактора
        const b = Math.round(Math.max(sw, sh) * 0.05);
        const cv = document.createElement('canvas');
        cv.width = Math.round(sw + b * 2);
        cv.height = Math.round(sh + b * 2);
        const x = cv.getContext('2d');
        x.fillStyle = col.hex;
        x.fillRect(0, 0, cv.width, cv.height);
        x.drawImage(im, sx, sy, sw, sh, b, b, sw, sh);
        // тонка лінія по краю паспарту: біла рамка на білому фоні інакше зникає
        x.strokeStyle = 'rgba(0,0,0,.35)';
        x.lineWidth = Math.max(1, Math.round(b * 0.03));
        x.strokeRect(b + 0.5, b + 0.5, sw - 1, sh - 1);
        if (col.id === 'white') {
          x.strokeStyle = 'rgba(0,0,0,.45)';
          x.strokeRect(0.5, 0.5, cv.width - 1, cv.height - 1);
        }
        resolve(cv.toDataURL('image/jpeg', 0.9));
      } catch (e) { reject(e); }
    };
    im.onerror = () => reject(new Error('framed shot'));
    im.src = src;
  });
}
function feCapture(hideFigs, opts) {
  opts = opts || {};
  const c = feC();
  if (!c) return null;
  // Знімок робиться без рамки виділення, але саме виділення треба повернути:
  // інакше автоматичне превʼю скидало те, що людина щойно взяла в роботу.
  const wasActive = c.getActiveObject();
  c.discardActiveObject();
  const hidden = [];
  // Композиція — це орієнтир для менеджера, як розставлені фігурки. Якщо
  // людина сховала їх для зручності й у такому вигляді надіслала макет,
  // менеджер отримував порожній фон. Тому на час знімка показуємо їх назад.
  const shown = [];
  if (!hideFigs) {
    c.getObjects().forEach(o => {
      const isFig = o._feKind === 'figure' ||
        (o._feKind === 'caption' && !o._feForItem);
      if (isFig && o.visible === false) { shown.push(o); o.visible = true; }
    });
  }
  c.getObjects().forEach(o => {
    // Підпис під фігуркою — це друкований текст на фоні, а не деталь, яку
    // наклеюють. У файл для друку він має потрапити разом із фоном.
    const isFig = o._feKind === 'figure' ||
      (o._feKind === 'caption' && !opts.keepCaptions);
    const isAcc = o._feKind === 'accessory';
    // у файл для друку не йдуть ні фігурки, ні аксесуари — їх наклеюють фізично
    if (o._feSafe || (hideFigs && isFig) || (opts.hideAcc && isAcc)) {
      if (o.visible !== false) { hidden.push(o); o.visible = false; }
    }
  });
  // Fabric малює кожен обʼєкт у внутрішню кеш-картинку, і розмір того кеша
  // обмежений (~2 мегапікселі). При знімку в 300 dpi великий напис або
  // векторний малюнок у ту стелю впирається — і замість того, щоб
  // перемалюватись більшим, він РОЗТЯГУЄТЬСЯ з дрібного кеша. Звідси мило
  // на тексті, SVG і фото. Тому на час знімка кеш вимикаємо: кожен обʼєкт
  // малюється напряму, у повній роздільності.
  const cached = [];
  c.getObjects().forEach(o => {
    if (o.objectCaching !== false) { cached.push(o); o.objectCaching = false; o.dirty = true; }
  });

  const keep = FE.zoom;
  let url = null;
  try {
    FE.zoom = 1; feApplyZoom();
    // Знімок завжди на всю рамку. Раніше файл для друку обрізався по безпечній
    // лінії — виходив на 5 мм менший з кожного боку (для 15×21 це 114×174
    // замість 124×184) і його доводилось розтягувати. Безпечна лінія — це
    // підказка на екрані, куди не класти важливе, а не межа друку.
    const area = { left:0, top:0, width:FE.baseW, height:FE.baseH };
    // dpi — рахуємо множник із реальних міліметрів, щоб отримати друкований розмір
    let mult = opts.mult != null ? opts.mult : (hideFigs ? 0.7 : 2);
    if (opts.dpi) {
      mult = (feDims().wMm / 25.4 * opts.dpi) / area.width;
    }
    // Safari на iOS не може створити canvas більший за ~16.7 млн пікселів —
    // при перевищенні toDataURL мовчки віддає порожній рядок і вивантаження падає.
    const maxPx = feIsIOS() ? 11e6 : 40e6;
    const maxMult = Math.sqrt(maxPx / (area.width * area.height));
    if (mult > maxMult) {
      mult = maxMult;
      FE._dpiCapped = Math.round(mult * area.width / (feDims().wMm / 25.4));
    }
    url = c.toDataURL({
      format: opts.format || 'png',
      quality: opts.quality || 1,
      multiplier: mult,
      ...area });
  } finally {
    // що б не сталося — повертаємо видимість, інакше пунктир зникає назавжди
    FE.zoom = keep; feApplyZoom();
    cached.forEach(o => { o.objectCaching = true; o.dirty = true; });
    hidden.forEach(o => o.visible = true);
    shown.forEach(o => o.visible = false);   // повертаємо як було на екрані
    if (!c.getObjects().some(o => o._feSafe)) feDrawSafeZone();
    // повертаємо виділення, якщо обʼєкт нікуди не подівся
    if (wasActive && c.getObjects().indexOf(wasActive) >= 0) {
      c.setActiveObject(wasActive);
    }
    c.requestRenderAll();
  }
  // порожній або обрізаний результат — краще впасти зрозуміло, ніж слати сміття
  if (!url || url.length < 2000) {
    throw new Error('Не вдалося підготувати зображення — спробуйте меншу рамку або компʼютер');
  }
  return url;
}
// Готово — зберігає композицію й повертає на перший екран
function feDone() {
  const c = feC();
  if (!c) { feBackToSetup(); return; }
  // запамʼятовуємо позиції фігурок і фон для превʼю
  feFiguresOnCanvas().forEach(o => {
    const i = o._feSrc;
    if (i != null && FE.figures[i]) { FE.figures[i]._px = o.left / FE.baseW; FE.figures[i]._py = o.top / FE.baseH; }
  });
  try { FE._bgPreview = feCapture(true); } catch (e) {}
  // Фон вважається оформленим саме тут, за натисканням «Зберегти».
  FE._visitedEditor = true;
  FE.bgSaved = FE.bgSaved || {};
  FE.bgSaved[feLayoutKey()] = 1;
  FE._bgAcc = feBgAccCount(); FE._bgItems = feBgItemIds();
  feSnapshot();
  // свідоме збереження — лишаємо тільки цей макет, макети інших рамок прибираємо
  feStashLayout();
  const keep = feLayoutKey();
  Object.keys(FE.layouts).forEach(k => { if (k !== keep) delete FE.layouts[k]; });
  feSaveState();
  FE._dirty = false;
  feBackToSetup(false, true);
  feUpdatePrice();
  feToast('Фон збережено');
}
// ============================================================
// ФІНАЛ: номер замовлення + вивантаження в Cloudinary
// ============================================================
// Короткий читабельний номер: ДДММ-XXXX
function feMakeOrderCode() {
  const d = new Date();
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const rnd = String(Math.floor(Math.random() * 9000) + 1000);
  return `${dd}${mm}-${rnd}`;
}
function feDataUrlToBlob(dataUrl) {
  const [head, b64] = dataUrl.split(',');
  const mime = head.match(/:(.*?);/)[1];
  const bin = atob(b64);
  const arr = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) arr[i] = bin.charCodeAt(i);
  return new Blob([arr], { type: mime });
}
// ============================================================
// PDF ДЛЯ ДРУКУ — макет у справжньому розмірі на аркуші
// ============================================================
// Друкареві (і собі) зручніше мати готовий аркуш: відкрив, натиснув
// «друк без масштабування» — і розмір уже точний, підганяти нічого.
// Аркуш добираємо автоматично: усе, крім 30×40, влазить на A4.
const FE_SHEETS = [
  { id:'a4', name:'A4', w:210, h:297 },
  { id:'a3', name:'A3', w:297, h:420 },
];
const FE_SHEET_PAD = 8;      // мінімальне поле аркуша, мм
const FE_MARK_GAP  = 2;      // відступ міток різу від краю макета, мм
const FE_MARK_LEN  = 4;      // довжина мітки, мм
const FE_COPY_GAP  = 3;      // проміжок між двома копіями на аркуші, мм
// Верхнє поле для кожного розміру — заміряне на реальному друці.
// Орієнтація не впливає: горизонтальна рамка лягає так само, просто аркуш
// повертається на бік. Немає розміру в списку — беремо загальне поле.
const FE_TOP_MM = {
  '12x12': 6.5,
  '15x21': 7.5,
  '21x21': 5.5,
  '21x30': 13.5,
};
function fePickSheet(wMm, hMm) {
  for (const s of FE_SHEETS) {
    if (wMm <= s.w - FE_SHEET_PAD * 2 && hMm <= s.h - FE_SHEET_PAD * 2) {
      return { ...s, land:false };
    }
    // той самий аркуш, покладений на бік
    if (wMm <= s.h - FE_SHEET_PAD * 2 && hMm <= s.w - FE_SHEET_PAD * 2) {
      return { id:s.id, name:s.name + ' альбомна', w:s.h, h:s.w, land:true };
    }
  }
  return null;   // не влізло — тоді PDF просто не робимо
}
// PNG → JPEG. Перемальовуємо вже готовий знімок, а не збираємо його наново:
// повторний рендер полотна на телефоні коштує дорого, а тут лише один
// декод і один кодек. Прозорість заливаємо білим — папір усе одно білий.
function feToJpeg(dataUrl, q) {
  return new Promise((resolve, reject) => {
    const im = new Image();
    im.onload = () => {
      try {
        const cv = document.createElement('canvas');
        cv.width = im.naturalWidth; cv.height = im.naturalHeight;
        const x = cv.getContext('2d');
        x.fillStyle = '#FFFFFF'; x.fillRect(0, 0, cv.width, cv.height);
        x.drawImage(im, 0, 0);
        resolve({ url: cv.toDataURL('image/jpeg', q || 0.95), w: cv.width, h: cv.height });
      } catch (e) { reject(e); }
    };
    im.onerror = () => reject(new Error('jpeg'));
    im.src = dataUrl;
  });
}
// Мінімальний PDF з однією сторінкою і одним зображенням усередині.
// Сторонньої бібліотеки не тягнемо: JPEG лягає у PDF як є (DCTDecode),
// тобто без перестиснення — що зняли, те й піде на друк.
function fePdfBytes(jpgBytes, iw, ih, sheet, boxes, rot) {
  const PT = 72 / 25.4;
  const f = n => (Math.round(n * 1000) / 1000).toString();
  const sw = sheet.w * PT, sh = sheet.h * PT;
  // у PDF початок координат — лівий НИЖНІЙ кут
  const B = boxes.map(b => ({
    x: b.x * PT, y: (sheet.h - b.y - b.h) * PT, w: b.w * PT, h: b.h * PT,
  }));

  let cs = '';
  B.forEach(b => {
    // Повернутий макет кладемо тією ж матрицею, а не перемальовуємо пікселі:
    // картинка лишається байт у байт тою самою, а розвернути її — задача
    // друкарського рушія. Визначник додатний, тож дзеркала не буде.
    const cm = rot
      ? `0 ${f(b.h)} ${f(-b.w)} 0 ${f(b.x + b.w)} ${f(b.y)} cm`
      : `${f(b.w)} 0 0 ${f(b.h)} ${f(b.x)} ${f(b.y)} cm`;
    cs += `q\n${cm}\n/Im0 Do\nQ\n`;
  });
  cs += '0.4 w\n0 G\n';
  // Лінія різу рівно по краю макета — по ній і ріжуть. Товщина волосяна,
  // тож у роботу вона майже не заходить.
  B.forEach(b => { cs += `${f(b.x)} ${f(b.y)} ${f(b.w)} ${f(b.h)} re S\n`; });
  // Мітки різу — короткі рисочки ЗА межами макета, щоб не лишились на
  // готовій роботі. Пропускаємо ті, що не влізли на аркуш або впали б на
  // сусідній макет: коли їх двоє поруч, між ними місця майже немає.
  const g = FE_MARK_GAP * PT, ln = FE_MARK_LEN * PT;
  const onArt = (x, y) => B.some(b =>
    x > b.x - 0.5 && x < b.x + b.w + 0.5 && y > b.y - 0.5 && y < b.y + b.h + 0.5);
  const seg = (x1, y1, x2, y2) => {
    if (Math.min(x1, x2) < 0 || Math.max(x1, x2) > sw) return;
    if (Math.min(y1, y2) < 0 || Math.max(y1, y2) > sh) return;
    if (onArt(x1, y1) || onArt(x2, y2)) return;
    cs += `${f(x1)} ${f(y1)} m ${f(x2)} ${f(y2)} l S\n`;
  };
  B.forEach(b => {
    [b.y, b.y + b.h].forEach(y => {
      seg(b.x - g - ln, y, b.x - g, y);
      seg(b.x + b.w + g, y, b.x + b.w + g + ln, y);
    });
    [b.x, b.x + b.w].forEach(x => {
      seg(x, b.y - g - ln, x, b.y - g);
      seg(x, b.y + b.h + g, x, b.y + b.h + g + ln);
    });
  });

  const objs = [
    '<</Type/Catalog/Pages 2 0 R>>',
    '<</Type/Pages/Kids[3 0 R]/Count 1>>',
    `<</Type/Page/Parent 2 0 R/MediaBox[0 0 ${f(sw)} ${f(sh)}]` +
      '/Resources<</XObject<</Im0 5 0 R>>>>/Contents 4 0 R>>',
    { stream: cs, dict: `<</Length ${cs.length}>>` },
    { stream: jpgBytes, dict: '<</Type/XObject/Subtype/Image/Width ' + iw +
      '/Height ' + ih + '/ColorSpace/DeviceRGB/BitsPerComponent 8' +
      '/Filter/DCTDecode/Length ' + jpgBytes.length + '>>' },
  ];

  const parts = []; let len = 0;
  const put = p => { parts.push(p); len += p.length; };
  put('%PDF-1.4\n%\xE2\xE3\xCF\xD3\n');
  const offs = [];
  objs.forEach((o, i) => {
    offs.push(len);
    if (typeof o === 'string') { put(`${i+1} 0 obj\n${o}\nendobj\n`); return; }
    put(`${i+1} 0 obj\n${o.dict}\nstream\n`);
    put(o.stream);
    put('\nendstream\nendobj\n');
  });
  const xref = len;
  let x = `xref\n0 ${objs.length + 1}\n0000000000 65535 f \n`;
  offs.forEach(o => { x += String(o).padStart(10, '0') + ' 00000 n \n'; });
  x += `trailer\n<</Size ${objs.length + 1}/Root 1 0 R>>\nstartxref\n${xref}\n%%EOF\n`;
  put(x);

  // склеюємо: рядки — по одному байту на символ, решта — уже байти
  const out = new Uint8Array(len);
  let p = 0;
  parts.forEach(part => {
    if (typeof part === 'string') {
      for (let i = 0; i < part.length; i++) out[p++] = part.charCodeAt(i) & 255;
    } else { out.set(part, p); p += part.length; }
  });
  return out;
}
// Готовий PDF з файлу для друку. Повертає null, якщо аркуш не підібрався.
async function fePrintPdf(printPng) {
  const d = feDims();
  let w = d.wMm, h = d.hMm, rot = false;
  let sheet = fePickSheet(w, h);
  // Якщо покласти макет на бік і після нього на аркуші лишається смуга під
  // ще один такий самий — кладемо на бік. Так на А4 поміщаються два фони
  // 15×21 один під одним, і другий друк не з'їдає новий аркуш.
  if (h > w) {
    const rs = fePickSheet(h, w);
    if (rs && w * 2 <= rs.h - FE_SHEET_PAD * 2) {
      rot = true; sheet = rs;
      const t = w; w = h; h = t;
    }
  }
  if (!sheet) return null;
  const jpg = await feToJpeg(printPng, 0.95);
  const b64 = jpg.url.split(',')[1];
  const bin = atob(b64);
  const bytes = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
  // По центру ширини і впритул до верхнього поля: різати зручніше, коли
  // макет притиснутий до краю аркуша, а не висить посередині.
  // Якщо два однакові макети стають поруч — кладемо обидва. Для 12×12 це
  // рівно те, що треба: з одного аркуша виходить пара, різати за раз.
  const boxes = [];
  const top = FE_TOP_MM[feSize().id] != null ? FE_TOP_MM[feSize().id] : FE_SHEET_PAD;
  const free = sheet.w - FE_SHEET_PAD * 2;
  if (w * 2 + FE_COPY_GAP <= free) {
    const total = w * 2 + FE_COPY_GAP;
    const x0 = (sheet.w - total) / 2;
    boxes.push({ x:x0, y:top, w, h });
    boxes.push({ x:x0 + w + FE_COPY_GAP, y:top, w, h });
  } else {
    boxes.push({ x:(sheet.w - w) / 2, y:top, w, h });
  }
  const pdf = fePdfBytes(bytes, jpg.w, jpg.h, sheet, boxes, rot);
  let s = '';
  for (let i = 0; i < pdf.length; i += 8192) {
    s += String.fromCharCode.apply(null, pdf.subarray(i, i + 8192));
  }
  return { url: 'data:application/pdf;base64,' + btoa(s), sheet };
}

// Одна спроба відправки. body — готовий FormData.
function feCloudSend(url, fd, mb) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('POST', url, true);
    xhr.timeout = 180000;
    xhr.onload = () => {
      if (xhr.status < 200 || xhr.status >= 300) {
        let msg = 'Сервер відхилив файл (' + xhr.status + ')';
        try { const j = JSON.parse(xhr.responseText); if (j.error && j.error.message) msg += ': ' + j.error.message; } catch (e) {}
        reject(new Error(msg)); return;
      }
      try { resolve(JSON.parse(xhr.responseText).secure_url); }
      catch (e) { reject(new Error('Невірна відповідь сервера')); }
    };
    xhr.onerror   = () => reject(new Error('NET'));
    xhr.ontimeout = () => reject(new Error(
      `Завантаження триває задовго (${mb} МБ). Спробуйте при кращому звʼязку.`));
    xhr.send(fd);
  });
}
// Стеля безкоштовного вивантаження в Cloudinary — 10 МБ на файл.
// Беремо з запасом: base64 рахуємо приблизно, та й сервер міряє по-своєму.
const FE_CLOUD_MAX = 10 * 1024 * 1024;
const feDataBytes = u => Math.round((u || '').length * 0.75);
// Завеликий знімок → JPEG. Якість знижуємо по черзі, але щоразу перетискаємо
// з оригіналу, а не з попереднього JPEG — інакше артефакти накладаються.
async function feFitCloud(dataUrl) {
  if (feDataBytes(dataUrl) <= FE_CLOUD_MAX) return dataUrl;
  let best = null;
  for (const q of [0.95, 0.88, 0.8, 0.7]) {
    let j;
    try { j = await feToJpeg(dataUrl, q); }
    catch (e) { break; }
    best = j.url;
    if (feDataBytes(best) <= FE_CLOUD_MAX) return best;
  }
  // навіть найгірша якість не влізла — шлемо що є, хай сервер вирішує
  return best || dataUrl;
}
async function feUploadToCloud(dataUrl, folder, name, ctx, opts) {
  opts = opts || {};
  const cfg = (window.SHOPIFY_CONFIG || {}).cloudinary || {};
  if (!cfg.cloudName) throw new Error('Cloudinary не налаштовано');
  // remote — це вже готове посилання на картинку: Cloudinary забере її сам.
  // Перевірку «схоже на файл» у такому разі не робимо, там короткий рядок.
  if (!opts.remote && (!dataUrl || dataUrl.length < 2000)) {
    throw new Error('Порожній файл — не вдалося підготувати зображення');
  }
  if (opts.remote && !/^https?:\/\//.test(dataUrl || '')) {
    throw new Error('Очікувалось посилання на картинку');
  }

  // Cloudinary не приймає файл більший за 10 МБ і відповідає сухим 400.
  // PNG на 300 dpi для великої рамки в ту стелю впирається, тому такий
  // знімок перекладаємо в JPEG — на друк однаково йде JPEG усередині PDF.
  if (!opts.remote && opts.type !== 'raw') {
    dataUrl = await feFitCloud(dataUrl);
  }

  // PDF іде як raw: у гілці /image/ Cloudinary розбирає його на сторінки
  // й віддає прев'ю, а нам потрібен рівно той файл, що пішов на друк.
  const kind = opts.type || 'image';
  const url = `https://api.cloudinary.com/v1_1/${cfg.cloudName}/${kind}/upload`;
  if (kind === 'raw' && opts.ext && name.slice(-opts.ext.length) !== opts.ext) name += opts.ext;
  const mb = (dataUrl.length * 0.75 / 1048576).toFixed(1);
  const build = (asBlob) => {
    const fd = new FormData();
    if (asBlob) {
      const blob = feDataUrlToBlob(dataUrl);
      const ext = opts.ext || (blob.type.includes('jpeg') ? '.jpg' : '.png');
      fd.append('file', blob, name.slice(-ext.length) === ext ? name : name + ext);
    } else {
      // Cloudinary приймає base64-рядок напряму — у Safari на iOS
      // це надійніше, ніж Blob усередині FormData
      fd.append('file', dataUrl);
    }
    fd.append('upload_preset', cfg.uploadPreset);
    fd.append('folder', folder);
    fd.append('public_id', name);
    if (ctx) fd.append('context', ctx);
    return fd;
  };

  // 1) base64-рядком  2) повтор  3) Blob-ом.
  // Для посилання третій спосіб не годиться: Blob із нього не зробиш.
  const attempts = opts.remote ? [false, false] : [false, false, true];
  let last = null;
  for (let i = 0; i < attempts.length; i++) {
    try { return await feCloudSend(url, build(attempts[i]), mb); }
    catch (e) {
      last = e;
      if (e.message !== 'NET') throw e;          // відмова сервера — повторювати марно
      await new Promise(r => setTimeout(r, 700));
    }
  }
  throw new Error(`Не вдалося передати файл (${mb} МБ). ` +
    `Перевірте інтернет — можливо, заважає VPN, режим економії даних або блокувальник реклами.`);
}
// ============================================================
// СПЕЦИФІКАЦІЯ МАКЕТА
// Картинка «чорний фон, білий текст» із усім, що людина обрала:
// рамка, фон, кожен напис зі шрифтом і кольором, файли, ціна.
// Їде в Cloudinary поруч із макетом — щоб потім можна було
// повторити або підправити роботу, нічого не випитуючи в клієнта.
// ============================================================
function feColInfo(v) {
  if (!v) return 'немає';
  if (typeof v === 'object') {
    const st = (v.colorStops || []).map(x => x.color).join(' → ');
    return 'градієнт ' + (st || '?');
  }
  const hex = feHex(v);
  if (!hex) return String(v);
  const n = parseInt(hex.slice(1), 16);
  return hex.toUpperCase() + ' · RGB ' + [(n >> 16) & 255, (n >> 8) & 255, n & 255].join(', ');
}
// px полотна → міліметри на друці
function feSpecMm(px) {
  const d = feDims();
  const k = FE.baseH ? d.hMm / FE.baseH : 0;
  return k ? (px * k).toFixed(1) + ' мм' : '—';
}
function feSpecLines() {
  const s = feSize(), col = feColor(), d = feDims(), c = feC();
  const L = [];
  const H = t => L.push({ t:'h', v:t });
  const K = (k, v) => L.push({ t:'k', k, v:String(v) });
  const S = () => L.push({ t:'sep' });

  H('MINIBRICK · специфікація макета');
  K('Номер макета', FE.orderCode || '—');
  if ((FE._sendN || 0) > 1) K('Версія', FE._sendN + ' — попередні файли лишились у тій самій теці');
  K('Створено', new Date().toLocaleString('uk-UA'));

  S(); H('Рамка');
  K('Колір рамки', col.name + ' (' + col.id + ')');
  K('Розмір', s.name + ' — ' + d.wMm + '×' + d.hMm + ' мм');
  K('Орієнтація', FE.orient === 'landscape' ? 'горизонтальна' : 'вертикальна');
  K('Файл для друку', Math.round(d.wMm / 25.4 * FE_PRINT_DPI) + '×' +
    Math.round(d.hMm / 25.4 * FE_PRINT_DPI) + ' px, ' + FE_PRINT_DPI + ' dpi');
  K('Полотно редактора', FE.baseW + '×' + FE.baseH + ' px');

  S(); H('Фон');
  K('Заливка', feColInfo(c ? c.backgroundColor : null));
  if (FE.template) {
    const t = (feAllTemplates() || []).find(x => x.id === FE.template);
    K('Готовий фон', (t && (t.name || t.id)) || FE.template);
  }

  // ---- обʼєкти по шарах ----
  const objs = (c ? c.getObjects() : []).filter(o => !o._feSafe);
  let nTxt = 0;
  objs.forEach((o, i) => {
    const kind = o._feKind || o.type;
    if (kind === 'text' || o.type === 'textbox' || o.type === 'i-text' || feIsCurved(o)) {
      const T = feTextState(o);
      S(); H('Напис ' + (++nTxt) + '  (шар ' + (i + 1) + ')');
      K('Текст', T.text || '');
      K('Шрифт', (T.fontFamily || '') + ' · ' + (T.fontWeight || 400) +
        (T.fontStyle === 'italic' ? ' · курсив' : '') +
        (T.underline ? ' · підкреслений' : '') + (T.linethrough ? ' · закреслений' : ''));
      K('Розмір', Math.round(T.fontSize || 0) + ' px ≈ ' + feSpecMm(T.fontSize || 0));
      K('Колір', feColInfo(T.fill));
      K('Контур', T.strokeWidth ? feColInfo(T.stroke) + ' · товщина ' + T.strokeWidth : 'немає');
      if (T.backgroundColor) K('Підкладка', feColInfo(T.backgroundColor));
      K('Вирівнювання', T.textAlign || 'left');
      if (T.charSpacing) K('Міжлітерний', T.charSpacing);
      if (T.lineHeight && T.lineHeight !== 1.16) K('Міжрядковий', T.lineHeight);
      if (T.curve) K('Вигин', T.curve);
      if (Math.round(o.angle || 0)) K('Поворот', Math.round(o.angle) + '°');
      K('Позиція', Math.round(o.left) + ' × ' + Math.round(o.top) + ' px');
      // окремі слова зі своїм оформленням
      feSpecWords(T).forEach(w => K('   слово «' + w.w + '»', w.d));
    } else if (kind === 'image' || kind === 'photoframe') {
      S(); H((kind === 'photoframe' ? 'Фото в рамці' : 'Зображення') + '  (шар ' + (i + 1) + ')');
      K('Файл', o._feFile || o._feName || 'без назви');
      K('Розмір на макеті', Math.round((o.width || 0) * (o.scaleX || 1)) + '×' +
        Math.round((o.height || 0) * (o.scaleY || 1)) + ' px');
      if (Math.round(o.angle || 0)) K('Поворот', Math.round(o.angle) + '°');
      if (o.rx) K('Закруглення кутів', o.rx);
      if (o.strokeWidth) K('Рамка фото', feColInfo(o.stroke) + ' · ' + o.strokeWidth);
    } else if (kind === 'shape' || kind === 'sticker' || kind === 'soft') {
      S(); H((kind === 'shape' ? 'Фігура' : kind === 'sticker' ? 'Стікер' : 'Мʼяка пляма') +
        '  (шар ' + (i + 1) + ')');
      K('Назва', o._feName || o._feShape || '—');
      if (o.fill) K('Заливка', feColInfo(o.fill));
      if (o.strokeWidth) K('Контур', feColInfo(o.stroke) + ' · ' + o.strokeWidth);
    } else if (kind === 'item' || kind === 'accessory') {
      S(); H((kind === 'item' ? 'Предмет' : 'Аксесуар') + '  (шар ' + (i + 1) + ')');
      K('Назва', o._feName || o._feItem || '—');
      K('Позиція', Math.round(o.left) + ' × ' + Math.round(o.top) + ' px');
    }
  });

  // ---- фігурки ----
  S(); H('Фігурки');
  const figs = FE.figures || [];
  if (!figs.length) K('—', 'немає');
  figs.forEach((f, i) => {
    if (f.type === 'animal') { K(String(i + 1), 'Тваринка ' + f.animalType); return; }
    const bits = ['обличчя ' + ((((window.FACES || []).find(x => x.id === f.face)) || {}).label || f.face)];
    if (f.hairType === 'hair') bits.push('зачіска ' + f.hairStyle + ' ' + f.hairColor);
    if (f.hairType === 'hat')  bits.push('убір ' + f.hatStyle);
    if (f.print)    bits.push('принт ' + f.print);
    if (f.accLeft)  bits.push('ліва рука ' + f.accLeft);
    if (f.accRight) bits.push('права рука ' + f.accRight);
    K(String(i + 1), bits.join(', '));
  });

  // ---- підписи під фігурками ----
  const cs = feCapS();
  // у специфікації перенос рядка показуємо як «/», інакше рядок поїде
  const names = Object.values(FE.captions.names || {})
    .map(v => feCapText(v).replace(/\n/g, ' / ')).filter(Boolean);
  if (names.length) {
    S(); H('Підписи під фігурками');
    K('Тексти', names.join(', '));
    K('Шрифт', cs.font + ' · ' + cs.weight + (cs.italic ? ' · курсив' : ''));
    K('Розмір', cs.size + ' мм');
    K('Колір', feColInfo(cs.color));
    K('Вирівнювання', cs.align);
    K('Відступ від фігурки', cs.offset + ' мм');
  }

  // ---- ціна ----
  const { parts, total } = fePriceParts();
  S(); H('Вартість');
  parts.forEach(x => K(x.n, x.v + ' грн'));
  K('РАЗОМ', total + ' грн');
  return L;
}
// Слова, яким задали власне оформлення
function feSpecWords(T) {
  const arr = feStylesArray(T) || [];
  const txt = String(T.text || '');
  const out = [];
  let i = 0;
  while (i < txt.length) {
    const st = arr[i];
    if (!st || !Object.keys(st).length) { i++; continue; }
    const key = JSON.stringify(st);
    let j = i;
    while (j < txt.length && JSON.stringify(arr[j] || {}) === key) j++;
    const bits = [];
    if (st.fontFamily) bits.push('шрифт ' + st.fontFamily);
    if (st.fontWeight) bits.push('вага ' + st.fontWeight);
    if (st.fontStyle === 'italic') bits.push('курсив');
    if (st.underline) bits.push('підкреслений');
    if (st.linethrough) bits.push('закреслений');
    if (st.fontSize) bits.push('розмір ' + Math.round(st.fontSize) + ' px');
    if (st.fill) bits.push('колір ' + feColInfo(st.fill));
    if (st.strokeWidth) bits.push('контур ' + feColInfo(st.stroke) + ' · ' + st.strokeWidth);
    out.push({ w: txt.slice(i, j), d: bits.join(', ') });
    i = j;
  }
  return out;
}
// Малюємо специфікацію картинкою: чорне тло, білий текст
function feSpecSheet() {
  const L = feSpecLines();
  const W = 1240, PAD = 64, LH = 36, KW = 300;
  // спершу розкладаємо по рядках, щоб знати висоту
  const cv = document.createElement('canvas');
  const ctx = cv.getContext('2d');
  const rows = [];
  const wrap = (text, font, width) => {
    ctx.font = font;
    const words = String(text).split(/\s+/);
    const out = []; let line = '';
    words.forEach(w => {
      const probe = line ? line + ' ' + w : w;
      if (ctx.measureText(probe).width > width && line) { out.push(line); line = w; }
      else line = probe;
    });
    out.push(line);
    return out;
  };
  L.forEach(it => {
    if (it.t === 'sep') { rows.push({ t:'sep' }); return; }
    if (it.t === 'h') { rows.push({ t:'h', v:it.v }); return; }
    // довгі значення переносимо, ключ лишається на першому рядку
    const lines = String(it.v).split('\n').reduce((acc, part) =>
      acc.concat(wrap(part, '26px Inter, Arial, sans-serif', W - PAD * 2 - KW)), []);
    lines.forEach((ln, i) => rows.push({ t:'k', k:i ? '' : it.k, v:ln }));
  });
  const H = PAD * 2 + rows.reduce((a, r) => a + (r.t === 'sep' ? LH * 0.9 : r.t === 'h' ? LH * 1.7 : LH), 0);

  cv.width = W; cv.height = Math.ceil(H);
  const g = cv.getContext('2d');
  g.fillStyle = '#000'; g.fillRect(0, 0, W, cv.height);
  let y = PAD;
  rows.forEach(r => {
    if (r.t === 'sep') {
      y += LH * 0.45;
      g.strokeStyle = '#333'; g.lineWidth = 1;
      g.beginPath(); g.moveTo(PAD, y + 0.5); g.lineTo(W - PAD, y + 0.5); g.stroke();
      y += LH * 0.45;
      return;
    }
    if (r.t === 'h') {
      y += LH * 0.6;
      g.fillStyle = '#EDD05C';
      g.font = 'bold 30px Inter, Arial, sans-serif';
      g.fillText(r.v, PAD, y + 26);
      y += LH * 1.1;
      return;
    }
    g.font = '26px Inter, Arial, sans-serif';
    if (r.k) { g.fillStyle = '#8A93A6'; g.fillText(r.k, PAD, y + 26); }
    g.fillStyle = '#FFF';
    g.fillText(r.v, PAD + KW, y + 26);
    y += LH;
  });
  return cv.toDataURL('image/png');
}
// Які знімки клієнта реально стоять на фоні. Ті, що він завантажив і не
// поставив, менеджеру ні до чого — і місце в хмарі економимо.
// Віддаємо ту саму копію, що пішла в макет: важити менше й нічого зайвого
// в памʼяті вкладки не тримаємо.
function feUsedSources() {
  const c = feC(); if (!c) return [];
  const out = [], seen = {};
  c.getObjects().forEach(o => {
    const id = o && o._feOid;
    if (!id || seen[id]) return;
    seen[id] = 1;
    const up = (FE.uploads || []).find(u => u.oid === id);
    const name = (up && up.name) || o._feFile || o._feName || id;
    if (up && up.url) out.push({ name, data: up.url });
    else if (o.type === 'image' && o._element) {
      // знімок вставили в рамку — у списку завантажень його немає
      try { out.push({ name, data: o.toDataURL({ format:'png' }) }); } catch (e) {}
    }
  });
  return out;
}
// Cloudinary не любить пробілів і кирилиці в назві — чистимо, але лишаємо
// впізнаваний хвіст оригінальної назви.
function feSafeFileName(n) {
  return String(n).replace(/\.[^.]+$/, '')
    .replace(/[^a-zA-Z0-9._-]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 40) || 'file';
}
// Опис замовлення — потрапляє в метадані Cloudinary
function feOrderSummary() {
  const s = feSize(), col = feColor(), d = feDims();
  const { parts, total } = fePriceParts();
  const figs = FE.figures.map((f, i) => {
    if (f.type === 'animal') {
      // Покраску за фото менеджер має бачити разом із самими фото
      const cp = f.customPaint
        ? ` + ПОКРАСКА ЗА ФОТО (${(f.paintPhotoUrls || []).filter(Boolean).join(' ') || 'фото не долетіли'})`
        : '';
      return `${i+1}) Тваринка ${f.animalType}${cp}`;
    }
    const bits = [];
    // готове тіло менеджеру треба знати першим — його не збирають по деталях
    if (f.type === 'ready') {
      const rb = (window.READY_FIGS||[]).find(r => r.id === f.readyId);
      bits.push(`ГОТОВА ФІГУРКА №${f.readyId}${rb ? ' — ' + rb.label : ''}`);
    }
    bits.push(`обличчя ${((window.FACES||[]).find(x => x.id === f.face)||{}).label || f.face}`);
    if (f.hairType === 'hair') bits.push(`зачіска ${f.hairStyle} ${f.hairColor}`);
    if (f.hairType === 'hat')  bits.push(`убір ${f.hatStyle}`);
    if (f.print) bits.push(`принт ${f.print}`);
    if (f.accLeft)  bits.push(`ліва ${f.accLeft}`);
    if (f.accRight) bits.push(`права ${f.accRight}`);
    return `${i+1}) ${bits.join(', ')}`;
  });
  const pw = Math.round((d.wMm - SAFE_INSET_MM*2) / 25.4 * FE_PRINT_DPI);
  const ph = Math.round((d.hMm - SAFE_INSET_MM*2) / 25.4 * FE_PRINT_DPI);
  return {
    text:
      `Рамка: ${col.name}, ${s.name} (${d.wMm}×${d.hMm} мм)\n` +
      `Файл для друку: ${pw}×${ph} px, ${FE_PRINT_DPI} dpi\n` +
      `Орієнтація: ${FE.orient === 'landscape' ? 'горизонтальна' : 'вертикальна'}\n\n` +
      `Фігурки:\n${figs.join('\n') || '—'}\n\n` +
      parts.map(p => `${p.n} — ${p.v} ₴`).join('\n') + `\n\nРАЗОМ: ${total} ₴`,
    ctx: `frame=${s.id}|orient=${FE.orient}|color=${col.id}|figures=${FE.figures.length}|total=${total}|ver=${FE._sendN || 1}`,
    total,
  };
}

// data:-рядок → справжній файл. Safari на iOS взагалі не відкриває data:-адреси
// у новій вкладці (звідси чорний екран), а з blob-файлом працює нормально.
function feDataUrlToBlob(url) {
  const [head, body] = String(url).split(',');
  const mime = (head.match(/:(.*?);/) || [])[1] || 'image/jpeg';
  const bin = atob(body);
  const buf = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) buf[i] = bin.charCodeAt(i);
  return new Blob([buf], { type: mime });
}
// Зберегти макет на пристрій (на iOS — після відправки, за натисканням).
// which: 'print' — фон для друку без фігурок, 'full' — композиція з фігурками
function feSaveLocalCopy(which) {
  const c = FE._localCopy; if (!c) return;
  const print = which === 'print';
  const url = print ? c.print : c.url;
  if (!url) { feToast('Файл не готовий'); return; }
  const name = `minibrick-${c.code}${print ? '-fon-druk.png' : '-kompozytsiia.jpg'}`;
  let blob = null;
  try { blob = feDataUrlToBlob(url); } catch (e) {}

  // 1. Рідне «Поділитися» — але ТІЛЬКИ на телефоні, де це єдиний спосіб
  //    покласти картинку в галерею. На компʼютері воно відкривало вікно
  //    Windows «Поділитися» замість звичайного завантаження в «Завантаження».
  const touch = (navigator.maxTouchPoints || 0) > 0 && feIsMobile();
  if (blob && touch && navigator.canShare) {
    try {
      const file = new File([blob], name, { type: blob.type });
      if (navigator.canShare({ files: [file] })) {
        navigator.share({ files: [file] }).catch(() => {});
        return;
      }
    } catch (e) {}
  }
  // 2. Звичайне завантаження файлу
  if (blob) {
    const href = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = href; a.download = name; a.target = '_blank'; a.rel = 'noopener';
    document.body.appendChild(a); a.click(); a.remove();
    if (feIsIOS()) feToast('Утримайте картинку → «Зберегти фото»', 3000);
    setTimeout(() => URL.revokeObjectURL(href), 60000);
    return;
  }
  // 3. Якщо файл зробити не вдалось — як було
  const a = document.createElement('a');
  a.href = url; a.download = name;
  document.body.appendChild(a); a.click(); a.remove();
}
async function feFinalize() {
  if (!FE.canvas) { alert('Спершу оформіть фон — натисніть «Відкрити редактор фону».'); return; }

  const code = FE.orderCode || (FE.orderCode = feMakeOrderCode());
  // Номер макета лишається той самий — він уже в людини на руках. Але файли
  // ідуть окремою версією: Cloudinary не перезаписує те, що вже лежить під
  // тим самим імʼям, і менеджер бачив би старий фон замість виправленого.
  FE._sendN = (FE._sendN || 0) + 1;
  const ver = FE._sendN > 1 ? '-v' + FE._sendN : '';
  const s = feSize(), col = feColor();
  const info = feOrderSummary();

  // ФОН — файл для друку: PNG, 300 dpi, точно по видимій зоні
  FE._dpiCapped = null;
  let bgPrint, full;
  try {
    bgPrint = feCapture(true, { format:'png', dpi:FE_PRINT_DPI, hideAcc:true, keepCaptions:true });
    // КОМПОЗИЦІЯ — орієнтир для менеджера: як розставлені й зібрані фігурки
    full    = feCapture(false, { format:'jpeg', quality:0.9, mult:1.8 });
  } catch (e) {
    alert((e && e.message) || 'Не вдалося підготувати зображення');
    return;
  }
  // якщо телефон не витягнув повні 300 dpi — чесно позначаємо це в замовленні
  if (FE._dpiCapped) {
    info.text += `\n\n⚠ Файл для друку зроблено з телефона у ${FE._dpiCapped} dpi замість ${FE_PRINT_DPI}.`;
    info.ctx += `|dpi=${FE._dpiCapped}`;
  }

  // Файли тримаємо напоготові, але на пристрій кладемо ТІЛЬКИ за натисканням
  // кнопки у вікні замовлення: раніше вони самі падали в «Завантаження»,
  // хоча людина цього не просила.
  FE._localCopy = { url: full, print: bgPrint, code };

  feModal('fe-m-order');
  const box = document.getElementById('fe-order-body');
  box.innerHTML = `<p style="text-align:center">Завантажуємо макет на сервер…</p>
    <div class="fe-order-num">${code}</div>`;

  const folder = 'minibrick-frames/' + code;
  try {
    await feUploadToCloud(bgPrint, folder, 'fon-druk' + ver, info.ctx);
    await feUploadToCloud(full,    folder, 'kompozytsiia' + ver, info.ctx);
    try { await feUploadToCloud(await feFramedShot(full), folder, 'prevyu-ramka' + ver, info.ctx); }
    catch (e) { console.warn('prevyu-ramka', e); }
    // Готовий аркуш на друк. PNG вище лишається як був — це вихідник.
    try {
      const p = await fePrintPdf(bgPrint);
      if (p) await feUploadToCloud(p.url, folder, 'druk-' + p.sheet.id + ver, info.ctx,
        { type:'raw', ext:'.pdf' });
    } catch (e) { console.warn('druk-pdf', e); }
    // Специфікація і вихідні файли — приємний бонус, а не умова замовлення:
    // якщо вони не долетять, макет усе одно вважається прийнятим.
    try { await feUploadToCloud(feSpecSheet(), folder, 'specyfikatsiia' + ver, info.ctx); }
    catch (e) { console.warn('specyfikatsiia', e); }
    const mats = feUsedSources();
    for (let i = 0; i < mats.length; i++) {
      const nm = 'materialy/' + String(i + 1).padStart(2, '0') + '-' +
        feSafeFileName(mats[i].name || ('file' + (i + 1)));
      try { await feUploadToCloud(mats[i].data, folder, nm, info.ctx); }
      catch (e) { console.warn('materialy', e); }
    }
    // Фото улюбленців для покраски тваринок. Конструктор уже поклав їх у
    // Cloudinary, але в спільну купу — а менеджеру потрібно, щоб усе по
    // замовленню лежало в одній папці. Тому кладемо копію поруч із фоном.
    let pn = 0;
    for (let i = 0; i < FE.figures.length; i++) {
      const f = FE.figures[i];
      if (!f || !f.customPaint) continue;
      const urls = (f.paintPhotoUrls || []).filter(u => /^https?:\/\//.test(u));
      for (const u of urls) {
        pn++;
        const nm = 'pokraska/' + String(pn).padStart(2, '0') + '-tvarynka-' + (i + 1);
        try { await feUploadToCloud(u, folder, nm, info.ctx, { remote:true }); }
        catch (e) { console.warn('pokraska', e); }
      }
    }
    box.innerHTML = `
      <p style="text-align:center">${FE._sendN > 1 ? 'Оновлений макет надіслано. Номер той самий:' : 'Ваш номер макета:'}</p>
      <div class="fe-order-num">${code}</div>
      ${FE._sendN > 1 ? `<p style="text-align:center;font-size:12.5px;color:var(--fe-dim)">
        Це версія ${FE._sendN}. Напишіть менеджеру, що надіслали виправлений варіант —
        щоб він узяв у роботу саме його.</p>` : ''}
      <button class="fe-btn-full" onclick="feCopyCode('${code}')">📋 Скопіювати номер</button>
      <button class="fe-btn-full soft" onclick="feSaveLocalCopy('print')">⬇ Фон для друку (без фігурок)</button>
      <button class="fe-btn-full soft" onclick="feSaveLocalCopy('full')">⬇ Композиція (з фігурками)</button>
      ${feContactBlock(code)}
      <div class="fe-sep"></div>
      <pre class="fe-order-sum">${info.text}</pre>`;
    feToast('Макет завантажено ✓');
  } catch (e) {
    // Відправка не вдалась — номер версії повертаємо, щоб повторна спроба
    // не плодила порожніх «v2», «v3» у теці замовлення
    FE._sendN = Math.max(0, (FE._sendN || 1) - 1);
    box.innerHTML = `
      <p style="text-align:center;color:#FF4757">Не вдалося завантажити на сервер:<br>${e.message}</p>
      <p style="text-align:center">Збережіть макет собі й надішліть менеджеру разом із номером.</p>
      <div class="fe-order-num">${code}</div>
      <button class="fe-btn-full" onclick="feSaveLocalCopy('print')">⬇ Фон для друку (без фігурок)</button>
      <button class="fe-btn-full" onclick="feSaveLocalCopy('full')">⬇ Композиція (з фігурками)</button>
      <button class="fe-btn-full soft" onclick="feFinalize()">↻ Спробувати ще раз</button>
      <button class="fe-btn-full soft" onclick="feCopyCode('${code}')">📋 Скопіювати номер</button>
      ${feContactBlock(code)}
      <div class="fe-sep"></div>
      <pre class="fe-order-sum">${info.text}</pre>`;
  }
}
// Куди писати, щоб оформити замовлення
function feContactBlock(code) {
  return `
    <div class="fe-contact">
      <b>Що далі?</b>
      <span>Напишіть нам у Instagram і надішліть цей номер —
        менеджер підтвердить замовлення та розповість про оплату й доставку.</span>
      <div class="fe-contact-btns">
        <a class="fe-cbtn ig" href="https://www.instagram.com/minibrick_ua/" target="_blank">
          📷 Написати в Instagram</a>
      </div>
    </div>`;
}
function feCopyCode(code) {
  navigator.clipboard.writeText(code)
    .then(() => feToast('Номер скопійовано'))
    .catch(() => prompt('Скопіюйте номер:', code));
}

// ============================================================
// ВОРОТА ДОСТУПУ + СТАРТ (у самому кінці)
// ============================================================
// Ворота доступу обробляються inline-скриптом у snippets/frame-editor.liquid,
// щоб діагностика працювала навіть коли якийсь файл не завантажився.
// Заставка на час завантаження. Ховаємо її, коли сторінка готова —
// смужка при цьому просто добігає до кінця, щоб очікування виглядало живим.
function fePreloader() {
  const box = document.getElementById('fe-pre');
  const bar = document.getElementById('fe-pre-bar');
  if (!box) return;
  let w = 0;
  const iv = setInterval(() => {
    w = Math.min(w + Math.random() * 26 + 8, 100);
    if (bar) bar.style.width = w + '%';
    if (w < 100) return;
    clearInterval(iv);
    setTimeout(() => box.classList.add('hidden'), 320);
    setTimeout(() => { if (box.parentNode) box.parentNode.removeChild(box); }, 900);
  }, 240);
}
if (document.readyState === 'complete') fePreloader();
else window.addEventListener('load', fePreloader);

function feUnlock() {
  document.getElementById('fe-gate').style.display = 'none';
  document.getElementById('fe-root').classList.add('active');
  feInitSetup();
}
